
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("5yDiU", function(module, exports) {

$parcel$export(module.exports, "loadSR", () => $2c655dda72104b32$export$435d3fd2e9f36124);
$parcel$export(module.exports, "default", () => $2c655dda72104b32$export$2e2bcd8739ae039);

var $1QvC2 = parcelRequire("1QvC2");

var $flrpX = parcelRequire("flrpX");

var $jcw0u = parcelRequire("jcw0u");

var $g9E9n = parcelRequire("g9E9n");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $ergyj = parcelRequire("ergyj");


var $eusud = parcelRequire("eusud");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2c655dda72104b32$var$sendErrorAnalytics = (id, message, error)=>{
    (0, $jcw0u.default)({
        meta: {
            id: id,
            packageName: 'jira-amplitude-session-replay'
        },
        attributes: {
            message: message
        },
        error: error
    });
};
const $2c655dda72104b32$var$buildSRInitEventPayload = ()=>{
    const sessionReplayProperties = (0, $1QvC2.getSessionReplayProperties)();
    // Convert the Map of accessed feature flags into an object, keeping only flags with values not falsy
    const accessedFeatureFlags = Object.fromEntries([
        ...(0, $flrpX.allFeatureFlagsAccessed)
    ].filter(([, value])=>value));
    const sessionReplayEventPayload = {
        name: 'amplitudeSR initialized',
        attributes: {
            ...sessionReplayProperties,
            ...accessedFeatureFlags
        }
    };
    return sessionReplayEventPayload;
};
const $2c655dda72104b32$var$onSessionIdChange = (analyticsClient)=>{
    (0, $1QvC2.setSessionId)(analyticsClient.getCurrentSessionId());
};
const $2c655dda72104b32$var$AnalyticsConsentKey = 'performanceCookies';
const $2c655dda72104b32$var$loadSRWithConsent = async ()=>{
    const clearResourcesListener = (0, $ergyj.addResourcesListener)(async (resourcesState)=>{
        clearResourcesListener();
        // consent resource definition here jira/src/packages/router-resources/cookie-consent/src/index.tsx
        let cookieConsentsData = resourcesState?.data?.[0, $f92ba51f7e46c4ce$export$c5397b7748ed6c7b]?.[0, $f92ba51f7e46c4ce$export$4a9dd42dbc707155]?.data;
        // this means that user has provided consent via the cookie banner
        // but we do not know if the user has provided consent for analytics
        // so we need to check via ConsentHub API
        // this is not done by default to prevent unnecessary API calls
        if (!cookieConsentsData || !('consents' in cookieConsentsData)) try {
            cookieConsentsData = await (0, $eusud.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        } catch (error) {
            $2c655dda72104b32$var$sendErrorAnalytics('loadSRWithConsent', 'Failed to get cookies consent data', error);
        }
        if (cookieConsentsData && 'consents' in cookieConsentsData && cookieConsentsData.consents && cookieConsentsData.consents.length > 0) {
            const hasCookieConsent = cookieConsentsData.consents.some((consent)=>consent.key === $2c655dda72104b32$var$AnalyticsConsentKey && consent.granted);
            if (hasCookieConsent) $2c655dda72104b32$export$435d3fd2e9f36124();
            else $2c655dda72104b32$var$sendErrorAnalytics('loadSRWithConsent', 'No analytics cookies consent found');
        }
    });
};
const $2c655dda72104b32$export$435d3fd2e9f36124 = async ()=>{
    try {
        const client = (0, $g9E9n.getAnalyticsWebClient)();
        if (client && client.getInstance) {
            const analyticsClient = client.getInstance();
            if (analyticsClient && client.isInitialized && client.isInitialized()) {
                // Configure the SDK and begin collecting replays
                const AMPLITUDE_API_KEY = 'eeecdc90c13797e7eb4d432b0ed5041b';
                await (0, $1QvC2.init)(AMPLITUDE_API_KEY, {
                    deviceId: analyticsClient.getAnonymousId(),
                    sessionId: analyticsClient.getCurrentSessionId(),
                    storeType: 'memory',
                    logLevel: (0, $4R6GH.fg)('jira_amplitude_sr_logs') ? 4 : undefined,
                    optOut: false,
                    // eslint-disable-next-line jira/ff/inline-expVal-params
                    ...(0, $6s1PB.expVal)('jira_amplitude_sr_exp', 'sdkOptions', {})
                }).promise;
                // fire an screen event as operational event can't be ingested in Amplitude
                // Session replay doesn't require that all events in a session have the [Amplitude] Session Replay ID property, only that one event in the session has it
                // https://amplitude.com/docs/session-replay/session-replay-standalone-sdk#some-sessions-dont-include-the-session-replay-id-property
                analyticsClient.sendScreenEvent($2c655dda72104b32$var$buildSRInitEventPayload());
                client.setUpdateAmplitudeSRClient(()=>$2c655dda72104b32$var$onSessionIdChange(analyticsClient));
            }
        }
    } catch (error) {
        $2c655dda72104b32$var$sendErrorAnalytics('loadSR', 'Failed to initialize amplitude session replay', error);
    }
};
const $2c655dda72104b32$var$unloadSR = async ()=>{
    try {
        await (0, $1QvC2.shutdown)();
    } catch (error) {
        $2c655dda72104b32$var$sendErrorAnalytics('unloadSR', 'Failed to shutdown amplitude session replay', error);
    }
};
const $2c655dda72104b32$var$AmplitudeSessionReplay = {
    init: $2c655dda72104b32$var$loadSRWithConsent,
    stop: $2c655dda72104b32$var$unloadSR
};
var $2c655dda72104b32$export$2e2bcd8739ae039 = $2c655dda72104b32$var$AmplitudeSessionReplay;

});
parcelRegister("1QvC2", function(module, exports) {

$parcel$export(module.exports, "init", () => $15832b61c2dfc12d$export$2cd8252107eb640b);
$parcel$export(module.exports, "setSessionId", () => $15832b61c2dfc12d$export$f61b5f0b88be99b3);
$parcel$export(module.exports, "getSessionReplayProperties", () => $15832b61c2dfc12d$export$4ca33d8c0b4ea239);
$parcel$export(module.exports, "shutdown", () => $15832b61c2dfc12d$export$db26221d371d1a5e);

var $1JOzE = parcelRequire("1JOzE");

var $15832b61c2dfc12d$export$2cd8252107eb640b = (0, $1JOzE.default).init, $15832b61c2dfc12d$export$f61b5f0b88be99b3 = (0, $1JOzE.default).setSessionId, $15832b61c2dfc12d$export$b3739caaf2580dd = (0, $1JOzE.default).getSessionId, $15832b61c2dfc12d$export$4ca33d8c0b4ea239 = (0, $1JOzE.default).getSessionReplayProperties, $15832b61c2dfc12d$export$4909b86c8034bf73 = (0, $1JOzE.default).flush, $15832b61c2dfc12d$export$db26221d371d1a5e = (0, $1JOzE.default).shutdown;

});
parcelRegister("1JOzE", function(module, exports) {

$parcel$export(module.exports, "default", () => $1441395b6f293b29$export$2e2bcd8739ae039);

var $8xK6b = parcelRequire("8xK6b");

var $lu7yz = parcelRequire("lu7yz");

var $bCieG = parcelRequire("bCieG");
var $1441395b6f293b29$export$14cabb7f53ef78fa = function(sessionReplay) {
    return function() {
        var config = sessionReplay.config;
        var _a = config || (0, $lu7yz.getDefaultConfig)(), logger = _a.loggerProvider, logLevel = _a.logLevel;
        return {
            logger: logger,
            logLevel: logLevel
        };
    };
};
var $1441395b6f293b29$var$createInstance = function() {
    var sessionReplay = new (0, $bCieG.SessionReplay)();
    return {
        init: (0, $8xK6b.debugWrapper)(sessionReplay.init.bind(sessionReplay), 'init', $1441395b6f293b29$export$14cabb7f53ef78fa(sessionReplay)),
        setSessionId: (0, $8xK6b.debugWrapper)(sessionReplay.setSessionId.bind(sessionReplay), 'setSessionId', $1441395b6f293b29$export$14cabb7f53ef78fa(sessionReplay)),
        getSessionId: (0, $8xK6b.debugWrapper)(sessionReplay.getSessionId.bind(sessionReplay), 'getSessionId', $1441395b6f293b29$export$14cabb7f53ef78fa(sessionReplay)),
        getSessionReplayProperties: (0, $8xK6b.debugWrapper)(sessionReplay.getSessionReplayProperties.bind(sessionReplay), 'getSessionReplayProperties', $1441395b6f293b29$export$14cabb7f53ef78fa(sessionReplay)),
        flush: (0, $8xK6b.debugWrapper)(sessionReplay.flush.bind(sessionReplay), 'flush', $1441395b6f293b29$export$14cabb7f53ef78fa(sessionReplay)),
        shutdown: (0, $8xK6b.debugWrapper)(sessionReplay.shutdown.bind(sessionReplay), 'shutdown', $1441395b6f293b29$export$14cabb7f53ef78fa(sessionReplay))
    };
};
var $1441395b6f293b29$export$2e2bcd8739ae039 = $1441395b6f293b29$var$createInstance();

});
parcelRegister("8xK6b", function(module, exports) {

$parcel$export(module.exports, "debugWrapper", () => $63852a0fcc5771fd$export$bd4b394e2747b144);

var $3VFsf = parcelRequire("3VFsf");

var $7qrLR = parcelRequire("7qrLR");
var $63852a0fcc5771fd$export$da8ad5017022fc09 = function(ignoreDepth) {
    if (ignoreDepth === void 0) ignoreDepth = 0;
    var trace = new Error().stack || '';
    return trace.split('\n').slice(2 + ignoreDepth).map(function(text) {
        return text.trim();
    });
};
var $63852a0fcc5771fd$export$c24a266b7d0d4b26 = function(client) {
    return function() {
        var _a = (0, $3VFsf.__assign)({}, client.config), logger = _a.loggerProvider, logLevel = _a.logLevel;
        return {
            logger: logger,
            logLevel: logLevel
        };
    };
};
var $63852a0fcc5771fd$export$a7dcfccadff29f0 = function(obj, path) {
    var e_1, _a;
    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    path = path.replace(/^\./, ''); // strip a leading dot
    try {
        for(var _b = (0, $3VFsf.__values)(path.split('.')), _c = _b.next(); !_c.done; _c = _b.next()){
            var attr = _c.value;
            if (attr in obj) obj = obj[attr];
            else return;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return obj;
};
var $63852a0fcc5771fd$export$f4ba9ca2e79d2ae9 = function(client, paths) {
    return function() {
        var e_2, _a;
        var res = {};
        try {
            for(var paths_1 = (0, $3VFsf.__values)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
                var path = paths_1_1.value;
                res[path] = $63852a0fcc5771fd$export$a7dcfccadff29f0(client, path);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return res;
    };
};
var $63852a0fcc5771fd$export$bd4b394e2747b144 = function(fn, fnName, getLogConfig, getStates, fnContext) {
    if (fnContext === void 0) fnContext = null;
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _a = getLogConfig(), logger = _a.logger, logLevel = _a.logLevel;
        // return early if possible to reduce overhead
        if (logLevel && logLevel < (0, $7qrLR.LogLevel).Debug || !logLevel || !logger) return fn.apply(fnContext, args);
        var debugContext = {
            type: 'invoke public method',
            name: fnName,
            args: args,
            stacktrace: $63852a0fcc5771fd$export$da8ad5017022fc09(1),
            time: {
                start: new Date().toISOString()
            },
            states: {}
        };
        if (getStates && debugContext.states) debugContext.states.before = getStates();
        var result = fn.apply(fnContext, args);
        if (result && result.promise) // if result is a promise, add the callback
        result.promise.then(function() {
            if (getStates && debugContext.states) debugContext.states.after = getStates();
            if (debugContext.time) debugContext.time.end = new Date().toISOString();
            logger.debug(JSON.stringify(debugContext, null, 2));
        });
        else {
            if (getStates && debugContext.states) debugContext.states.after = getStates();
            if (debugContext.time) debugContext.time.end = new Date().toISOString();
            logger.debug(JSON.stringify(debugContext, null, 2));
        }
        return result;
    };
};

});
parcelRegister("7qrLR", function(module, exports) {

$parcel$export(module.exports, "LogLevel", () => $568080de54508d2e$export$243e62d78d3b544d);
var $568080de54508d2e$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["None"] = 0] = "None";
    LogLevel[LogLevel["Error"] = 1] = "Error";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Debug"] = 4] = "Debug";
})($568080de54508d2e$export$243e62d78d3b544d || ($568080de54508d2e$export$243e62d78d3b544d = {}));

});


parcelRegister("lu7yz", function(module, exports) {

$parcel$export(module.exports, "getDefaultConfig", () => $fa4242e2562c224b$export$ed30944e0fe6ae5c);
$parcel$export(module.exports, "SessionReplayLocalConfig", () => $fa4242e2562c224b$export$1325564c7cad10e0);

var $3VFsf = parcelRequire("3VFsf");

var $8MiuV = parcelRequire("8MiuV");
var $e33eV = parcelRequire("e33eV");
var $d2db4 = parcelRequire("d2db4");
var $7qrLR = parcelRequire("7qrLR");

var $gPQg5 = parcelRequire("gPQg5");

var $6NUoy = parcelRequire("6NUoy");
var $fa4242e2562c224b$export$ed30944e0fe6ae5c = function() {
    return {
        flushMaxRetries: 2,
        logLevel: (0, $7qrLR.LogLevel).Warn,
        loggerProvider: new (0, $d2db4.Logger)(),
        transportProvider: new (0, $e33eV.FetchTransport)()
    };
};
var $fa4242e2562c224b$export$1325564c7cad10e0 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(SessionReplayLocalConfig, _super);
    function SessionReplayLocalConfig(apiKey, options) {
        var _this = this;
        var _a;
        var defaultConfig = $fa4242e2562c224b$export$ed30944e0fe6ae5c();
        _this = _super.call(this, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({
            transportProvider: defaultConfig.transportProvider,
            loggerProvider: new (0, $6NUoy.SafeLoggerProvider)(options.loggerProvider || defaultConfig.loggerProvider)
        }, options), {
            apiKey: apiKey
        })) || this;
        _this.flushMaxRetries = options.flushMaxRetries !== undefined && options.flushMaxRetries <= defaultConfig.flushMaxRetries ? options.flushMaxRetries : defaultConfig.flushMaxRetries;
        _this.apiKey = apiKey;
        _this.sampleRate = options.sampleRate || (0, $gPQg5.DEFAULT_SAMPLE_RATE);
        _this.serverZone = options.serverZone || (0, $gPQg5.DEFAULT_SERVER_ZONE);
        _this.configServerUrl = options.configServerUrl;
        _this.trackServerUrl = options.trackServerUrl;
        _this.shouldInlineStylesheet = options.shouldInlineStylesheet;
        _this.version = options.version;
        _this.performanceConfig = options.performanceConfig;
        _this.storeType = (_a = options.storeType) !== null && _a !== void 0 ? _a : 'idb';
        if (options.privacyConfig) _this.privacyConfig = options.privacyConfig;
        if (options.debugMode) _this.debugMode = options.debugMode;
        if (options.experimental) _this.experimental = options.experimental;
        return _this;
    }
    return SessionReplayLocalConfig;
}((0, $8MiuV.Config));

});
parcelRegister("8MiuV", function(module, exports) {

$parcel$export(module.exports, "Config", () => $664127ad2d88ae07$export$29cd7b75162a9425);

var $hAghI = parcelRequire("hAghI");

var $d2db4 = parcelRequire("d2db4");

var $7qrLR = parcelRequire("7qrLR");
var $664127ad2d88ae07$export$ed30944e0fe6ae5c = function() {
    return {
        flushMaxRetries: 12,
        flushQueueSize: 200,
        flushIntervalMillis: 10000,
        instanceName: '$default_instance',
        logLevel: (0, $7qrLR.LogLevel).Warn,
        loggerProvider: new (0, $d2db4.Logger)(),
        offline: false,
        optOut: false,
        serverUrl: (0, $hAghI.AMPLITUDE_SERVER_URL),
        serverZone: 'US',
        useBatch: false
    };
};
var $664127ad2d88ae07$export$29cd7b75162a9425 = /** @class */ function() {
    function Config(options) {
        var _a, _b, _c, _d;
        this._optOut = false;
        var defaultConfig = $664127ad2d88ae07$export$ed30944e0fe6ae5c();
        this.apiKey = options.apiKey;
        this.flushIntervalMillis = (_a = options.flushIntervalMillis) !== null && _a !== void 0 ? _a : defaultConfig.flushIntervalMillis;
        this.flushMaxRetries = options.flushMaxRetries || defaultConfig.flushMaxRetries;
        this.flushQueueSize = options.flushQueueSize || defaultConfig.flushQueueSize;
        this.instanceName = options.instanceName || defaultConfig.instanceName;
        this.loggerProvider = options.loggerProvider || defaultConfig.loggerProvider;
        this.logLevel = (_b = options.logLevel) !== null && _b !== void 0 ? _b : defaultConfig.logLevel;
        this.minIdLength = options.minIdLength;
        this.plan = options.plan;
        this.ingestionMetadata = options.ingestionMetadata;
        this.offline = options.offline !== undefined ? options.offline : defaultConfig.offline;
        this.optOut = (_c = options.optOut) !== null && _c !== void 0 ? _c : defaultConfig.optOut;
        this.serverUrl = options.serverUrl;
        this.serverZone = options.serverZone || defaultConfig.serverZone;
        this.storageProvider = options.storageProvider;
        this.transportProvider = options.transportProvider;
        this.useBatch = (_d = options.useBatch) !== null && _d !== void 0 ? _d : defaultConfig.useBatch;
        this.loggerProvider.enable(this.logLevel);
        var serverConfig = $664127ad2d88ae07$export$9100f0789d5e1cf2(options.serverUrl, options.serverZone, options.useBatch);
        this.serverZone = serverConfig.serverZone;
        this.serverUrl = serverConfig.serverUrl;
    }
    Object.defineProperty(Config.prototype, "optOut", {
        get: function() {
            return this._optOut;
        },
        set: function(optOut) {
            this._optOut = optOut;
        },
        enumerable: false,
        configurable: true
    });
    return Config;
}();
var $664127ad2d88ae07$export$3c14a5a58c5a65d4 = function(serverZone, useBatch) {
    if (serverZone === 'EU') return useBatch ? (0, $hAghI.EU_AMPLITUDE_BATCH_SERVER_URL) : (0, $hAghI.EU_AMPLITUDE_SERVER_URL);
    return useBatch ? (0, $hAghI.AMPLITUDE_BATCH_SERVER_URL) : (0, $hAghI.AMPLITUDE_SERVER_URL);
};
var $664127ad2d88ae07$export$9100f0789d5e1cf2 = function(serverUrl, serverZone, useBatch) {
    if (serverUrl === void 0) serverUrl = '';
    if (serverZone === void 0) serverZone = $664127ad2d88ae07$export$ed30944e0fe6ae5c().serverZone;
    if (useBatch === void 0) useBatch = $664127ad2d88ae07$export$ed30944e0fe6ae5c().useBatch;
    if (serverUrl) return {
        serverUrl: serverUrl,
        serverZone: undefined
    };
    var _serverZone = [
        'US',
        'EU'
    ].includes(serverZone) ? serverZone : $664127ad2d88ae07$export$ed30944e0fe6ae5c().serverZone;
    return {
        serverZone: _serverZone,
        serverUrl: $664127ad2d88ae07$export$3c14a5a58c5a65d4(_serverZone, useBatch)
    };
};
var $664127ad2d88ae07$export$f7a44070a14bece0 = /** @class */ function() {
    function RequestMetadata() {
        this.sdk = {
            metrics: {
                histogram: {}
            }
        };
    }
    RequestMetadata.prototype.recordHistogram = function(key, value) {
        this.sdk.metrics.histogram[key] = value;
    };
    return RequestMetadata;
}();
var $664127ad2d88ae07$var$HistogramOptions = /** @class */ function() {
    function HistogramOptions() {}
    return HistogramOptions;
}();

});
parcelRegister("hAghI", function(module, exports) {

$parcel$export(module.exports, "AMPLITUDE_PREFIX", () => $ccd26e4336c2b5ae$export$34512634d73abf96);
$parcel$export(module.exports, "STORAGE_PREFIX", () => $ccd26e4336c2b5ae$export$7cc65d02ca2e18ec);
$parcel$export(module.exports, "AMPLITUDE_SERVER_URL", () => $ccd26e4336c2b5ae$export$29e80e090bc2cfd4);
$parcel$export(module.exports, "EU_AMPLITUDE_SERVER_URL", () => $ccd26e4336c2b5ae$export$2fcb1c10f7306bcf);
$parcel$export(module.exports, "AMPLITUDE_BATCH_SERVER_URL", () => $ccd26e4336c2b5ae$export$c567544fea55e004);
$parcel$export(module.exports, "EU_AMPLITUDE_BATCH_SERVER_URL", () => $ccd26e4336c2b5ae$export$68967a892545fca0);
var $ccd26e4336c2b5ae$export$a3f337ba59dc3dca = '-';
var $ccd26e4336c2b5ae$export$34512634d73abf96 = 'AMP';
var $ccd26e4336c2b5ae$export$7cc65d02ca2e18ec = "".concat($ccd26e4336c2b5ae$export$34512634d73abf96, "_unsent");
var $ccd26e4336c2b5ae$export$29e80e090bc2cfd4 = 'https://api2.amplitude.com/2/httpapi';
var $ccd26e4336c2b5ae$export$2fcb1c10f7306bcf = 'https://api.eu.amplitude.com/2/httpapi';
var $ccd26e4336c2b5ae$export$c567544fea55e004 = 'https://api2.amplitude.com/batch';
var $ccd26e4336c2b5ae$export$68967a892545fca0 = 'https://api.eu.amplitude.com/batch';

});

parcelRegister("d2db4", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $97d5af1427167f70$export$efa9a398d6368992);

var $7qrLR = parcelRequire("7qrLR");
var $97d5af1427167f70$var$PREFIX = 'Amplitude Logger ';
var $97d5af1427167f70$export$efa9a398d6368992 = /** @class */ function() {
    function Logger() {
        this.logLevel = (0, $7qrLR.LogLevel).None;
    }
    Logger.prototype.disable = function() {
        this.logLevel = (0, $7qrLR.LogLevel).None;
    };
    Logger.prototype.enable = function(logLevel) {
        if (logLevel === void 0) logLevel = (0, $7qrLR.LogLevel).Warn;
        this.logLevel = logLevel;
    };
    Logger.prototype.log = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, $7qrLR.LogLevel).Verbose) return;
        console.log("".concat($97d5af1427167f70$var$PREFIX, "[Log]: ").concat(args.join(' ')));
    };
    Logger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, $7qrLR.LogLevel).Warn) return;
        console.warn("".concat($97d5af1427167f70$var$PREFIX, "[Warn]: ").concat(args.join(' ')));
    };
    Logger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, $7qrLR.LogLevel).Error) return;
        console.error("".concat($97d5af1427167f70$var$PREFIX, "[Error]: ").concat(args.join(' ')));
    };
    Logger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, $7qrLR.LogLevel).Debug) return;
        // console.debug output is hidden by default in chrome
        console.log("".concat($97d5af1427167f70$var$PREFIX, "[Debug]: ").concat(args.join(' ')));
    };
    return Logger;
}();

});


parcelRegister("e33eV", function(module, exports) {

$parcel$export(module.exports, "FetchTransport", () => $a3a3dbda58d28624$export$2bdee3f9b92f4e82);

var $3VFsf = parcelRequire("3VFsf");

var $aOGzY = parcelRequire("aOGzY");
var $a3a3dbda58d28624$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(FetchTransport, _super);
    function FetchTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FetchTransport.prototype.send = function(serverUrl, payload) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var options, response, responseText;
            return (0, $3VFsf.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        /* istanbul ignore if */ if (typeof fetch === 'undefined') throw new Error('FetchTransport is not supported');
                        options = {
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: '*/*'
                            },
                            body: JSON.stringify(payload),
                            method: 'POST'
                        };
                        return [
                            4 /*yield*/ ,
                            fetch(serverUrl, options)
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 2:
                        responseText = _a.sent();
                        try {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                            return [
                                2 /*return*/ ,
                                this.buildResponse(JSON.parse(responseText))
                            ];
                        } catch (_b) {
                            return [
                                2 /*return*/ ,
                                this.buildResponse({
                                    code: response.status
                                })
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return FetchTransport;
}((0, $aOGzY.BaseTransport));

});
parcelRegister("aOGzY", function(module, exports) {

$parcel$export(module.exports, "BaseTransport", () => $7dff9a3bd1ef5b00$export$74b99d619e90f481);

var $fsuka = parcelRequire("fsuka");
var $7dff9a3bd1ef5b00$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport() {}
    BaseTransport.prototype.send = function(_serverUrl, _payload) {
        return Promise.resolve(null);
    };
    BaseTransport.prototype.buildResponse = function(responseJSON) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        if (typeof responseJSON !== 'object') return null;
        var statusCode = responseJSON.code || 0;
        var status = this.buildStatus(statusCode);
        switch(status){
            case (0, $fsuka.Status).Success:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        eventsIngested: (_a = responseJSON.events_ingested) !== null && _a !== void 0 ? _a : 0,
                        payloadSizeBytes: (_b = responseJSON.payload_size_bytes) !== null && _b !== void 0 ? _b : 0,
                        serverUploadTime: (_c = responseJSON.server_upload_time) !== null && _c !== void 0 ? _c : 0
                    }
                };
            case (0, $fsuka.Status).Invalid:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_d = responseJSON.error) !== null && _d !== void 0 ? _d : '',
                        missingField: (_e = responseJSON.missing_field) !== null && _e !== void 0 ? _e : '',
                        eventsWithInvalidFields: (_f = responseJSON.events_with_invalid_fields) !== null && _f !== void 0 ? _f : {},
                        eventsWithMissingFields: (_g = responseJSON.events_with_missing_fields) !== null && _g !== void 0 ? _g : {},
                        eventsWithInvalidIdLengths: (_h = responseJSON.events_with_invalid_id_lengths) !== null && _h !== void 0 ? _h : {},
                        epsThreshold: (_j = responseJSON.eps_threshold) !== null && _j !== void 0 ? _j : 0,
                        exceededDailyQuotaDevices: (_k = responseJSON.exceeded_daily_quota_devices) !== null && _k !== void 0 ? _k : {},
                        silencedDevices: (_l = responseJSON.silenced_devices) !== null && _l !== void 0 ? _l : [],
                        silencedEvents: (_m = responseJSON.silenced_events) !== null && _m !== void 0 ? _m : [],
                        throttledDevices: (_o = responseJSON.throttled_devices) !== null && _o !== void 0 ? _o : {},
                        throttledEvents: (_p = responseJSON.throttled_events) !== null && _p !== void 0 ? _p : []
                    }
                };
            case (0, $fsuka.Status).PayloadTooLarge:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_q = responseJSON.error) !== null && _q !== void 0 ? _q : ''
                    }
                };
            case (0, $fsuka.Status).RateLimit:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_r = responseJSON.error) !== null && _r !== void 0 ? _r : '',
                        epsThreshold: (_s = responseJSON.eps_threshold) !== null && _s !== void 0 ? _s : 0,
                        throttledDevices: (_t = responseJSON.throttled_devices) !== null && _t !== void 0 ? _t : {},
                        throttledUsers: (_u = responseJSON.throttled_users) !== null && _u !== void 0 ? _u : {},
                        exceededDailyQuotaDevices: (_v = responseJSON.exceeded_daily_quota_devices) !== null && _v !== void 0 ? _v : {},
                        exceededDailyQuotaUsers: (_w = responseJSON.exceeded_daily_quota_users) !== null && _w !== void 0 ? _w : {},
                        throttledEvents: (_x = responseJSON.throttled_events) !== null && _x !== void 0 ? _x : []
                    }
                };
            case (0, $fsuka.Status).Timeout:
            default:
                return {
                    status: status,
                    statusCode: statusCode
                };
        }
    };
    BaseTransport.prototype.buildStatus = function(code) {
        if (code >= 200 && code < 300) return (0, $fsuka.Status).Success;
        if (code === 429) return (0, $fsuka.Status).RateLimit;
        if (code === 413) return (0, $fsuka.Status).PayloadTooLarge;
        if (code === 408) return (0, $fsuka.Status).Timeout;
        if (code >= 400 && code < 500) return (0, $fsuka.Status).Invalid;
        if (code >= 500) return (0, $fsuka.Status).Failed;
        return (0, $fsuka.Status).Unknown;
    };
    return BaseTransport;
}();

});
parcelRegister("fsuka", function(module, exports) {

$parcel$export(module.exports, "Status", () => $b410fe50c14839ce$export$96e9906d6d93a972);
/** The status of an event. */ var $b410fe50c14839ce$export$96e9906d6d93a972;
(function(Status) {
    /** The status could not be determined. */ Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */ Status["Skipped"] = "skipped";
    /** The event was sent successfully. */ Status["Success"] = "success";
    /** A user or device in the payload is currently rate limited and should try again later. */ Status["RateLimit"] = "rate_limit";
    /** The sent payload was too large to be processed. */ Status["PayloadTooLarge"] = "payload_too_large";
    /** The event could not be processed. */ Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */ Status["Failed"] = "failed";
    /** a server or client side error occuring when a request takes too long and is cancelled */ Status["Timeout"] = "Timeout";
    /** NodeJS runtime environment error.. E.g. disconnected from network */ Status["SystemError"] = "SystemError";
})($b410fe50c14839ce$export$96e9906d6d93a972 || ($b410fe50c14839ce$export$96e9906d6d93a972 = {}));

});



parcelRegister("gPQg5", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_SESSION_REPLAY_PROPERTY", () => $c419f23a1bc9db9b$export$49fd18d01e21541e);
$parcel$export(module.exports, "DEFAULT_SAMPLE_RATE", () => $c419f23a1bc9db9b$export$9fc1f2d681a9e609);
$parcel$export(module.exports, "DEFAULT_SERVER_ZONE", () => $c419f23a1bc9db9b$export$a07dea27df63211a);
$parcel$export(module.exports, "SESSION_REPLAY_DEBUG_PROPERTY", () => $c419f23a1bc9db9b$export$1fc5a97179bd467c);
$parcel$export(module.exports, "BLOCK_CLASS", () => $c419f23a1bc9db9b$export$3d34bd3b755f3e47);
$parcel$export(module.exports, "MASK_TEXT_CLASS", () => $c419f23a1bc9db9b$export$1eccb04dd6a71003);
$parcel$export(module.exports, "UNMASK_TEXT_CLASS", () => $c419f23a1bc9db9b$export$b8aa8230c39909d1);
$parcel$export(module.exports, "SESSION_REPLAY_SERVER_URL", () => $c419f23a1bc9db9b$export$77e615153be3f1f);
$parcel$export(module.exports, "SESSION_REPLAY_EU_URL", () => $c419f23a1bc9db9b$export$62355bd2f1f6338f);
$parcel$export(module.exports, "SESSION_REPLAY_STAGING_URL", () => $c419f23a1bc9db9b$export$b733282d152b9193);
$parcel$export(module.exports, "MAX_EVENT_LIST_SIZE_IN_BYTES", () => $c419f23a1bc9db9b$export$1944490bb69e165);
$parcel$export(module.exports, "INTERACTION_MIN_INTERVAL", () => $c419f23a1bc9db9b$export$a5054faf8ee87dba);
$parcel$export(module.exports, "INTERACTION_MAX_INTERVAL", () => $c419f23a1bc9db9b$export$e7aa3e217036e7ed);
$parcel$export(module.exports, "MIN_INTERVAL", () => $c419f23a1bc9db9b$export$98ca9e4f1d0f5a38);
$parcel$export(module.exports, "MAX_INTERVAL", () => $c419f23a1bc9db9b$export$d49aa32d24a98b11);
$parcel$export(module.exports, "KB_SIZE", () => $c419f23a1bc9db9b$export$ec5f9a2b258874ed);
$parcel$export(module.exports, "MAX_URL_LENGTH", () => $c419f23a1bc9db9b$export$ad8ccaa587ef5e2e);
$parcel$export(module.exports, "CustomRRwebEvent", () => $c419f23a1bc9db9b$export$4bb7c5a866f738f3);

var $hAghI = parcelRequire("hAghI");
var $FRUho = parcelRequire("FRUho");
var $c419f23a1bc9db9b$export$42c62f570a53cc49 = '[Amplitude]';
var $c419f23a1bc9db9b$export$49fd18d01e21541e = "".concat($c419f23a1bc9db9b$export$42c62f570a53cc49, " Session Replay ID");
var $c419f23a1bc9db9b$export$c7d032b40f04ffe5 = 'session_start';
var $c419f23a1bc9db9b$export$406b0196920039c5 = 'session_end';
var $c419f23a1bc9db9b$export$9fc1f2d681a9e609 = 0;
var $c419f23a1bc9db9b$export$a07dea27df63211a = (0, $FRUho.ServerZone).US;
var $c419f23a1bc9db9b$export$1fc5a97179bd467c = "".concat($c419f23a1bc9db9b$export$42c62f570a53cc49, " Session Replay Debug");
var $c419f23a1bc9db9b$export$3d34bd3b755f3e47 = 'amp-block';
var $c419f23a1bc9db9b$export$1eccb04dd6a71003 = 'amp-mask';
var $c419f23a1bc9db9b$export$b8aa8230c39909d1 = 'amp-unmask';
var $c419f23a1bc9db9b$export$77e615153be3f1f = 'https://api-sr.amplitude.com/sessions/v2/track';
var $c419f23a1bc9db9b$export$62355bd2f1f6338f = 'https://api-sr.eu.amplitude.com/sessions/v2/track';
var $c419f23a1bc9db9b$export$b733282d152b9193 = 'https://api-sr.stag2.amplitude.com/sessions/v2/track';
var $c419f23a1bc9db9b$export$7cc65d02ca2e18ec = "".concat((0, $hAghI.AMPLITUDE_PREFIX), "_replay_unsent");
var $c419f23a1bc9db9b$export$1944490bb69e165 = 1000000; // 1 MB
var $c419f23a1bc9db9b$export$a5054faf8ee87dba = 30000; // 30 seconds
var $c419f23a1bc9db9b$export$e7aa3e217036e7ed = 60000; // 1 minute
var $c419f23a1bc9db9b$export$98ca9e4f1d0f5a38 = 500; // 500 ms
var $c419f23a1bc9db9b$export$d49aa32d24a98b11 = 10000; // 10 seconds
var $c419f23a1bc9db9b$export$fa92ac0a8a1babf1 = 259200000; // 3 days
var $c419f23a1bc9db9b$export$ec5f9a2b258874ed = 1024;
var $c419f23a1bc9db9b$export$ad8ccaa587ef5e2e = 1000;
var $c419f23a1bc9db9b$export$4bb7c5a866f738f3;
(function(CustomRRwebEvent) {
    CustomRRwebEvent["GET_SR_PROPS"] = "get-sr-props";
    CustomRRwebEvent["DEBUG_INFO"] = "debug-info";
    CustomRRwebEvent["FETCH_REQUEST"] = "fetch-request";
})($c419f23a1bc9db9b$export$4bb7c5a866f738f3 || ($c419f23a1bc9db9b$export$4bb7c5a866f738f3 = {}));

});
parcelRegister("FRUho", function(module, exports) {

$parcel$export(module.exports, "ServerZone", () => $07dda53462be19d9$export$df0bb87b763999e2);
/**
 * @deprecated use ServerZoneType instead
 */ var $07dda53462be19d9$export$df0bb87b763999e2;
(function(ServerZone) {
    ServerZone["US"] = "US";
    ServerZone["EU"] = "EU";
    /**
     * Add for session-replay-browser migration from analytics-type v1.x.
     */ ServerZone["STAGING"] = "STAGING";
})($07dda53462be19d9$export$df0bb87b763999e2 || ($07dda53462be19d9$export$df0bb87b763999e2 = {}));

});


parcelRegister("6NUoy", function(module, exports) {

$parcel$export(module.exports, "SafeLoggerProvider", () => $4f431093907289f2$export$ded309f434800174);
var $4f431093907289f2$export$ded309f434800174 = /** @class */ function() {
    function SafeLoggerProvider(loggerProvider) {
        this.logger = loggerProvider;
        this.log = this.getSafeMethod('log');
        this.warn = this.getSafeMethod('warn');
        this.error = this.getSafeMethod('error');
        this.debug = this.getSafeMethod('debug');
    }
    SafeLoggerProvider.prototype.getSafeMethod = function(method) {
        var _a;
        if (!this.logger) return function() {
        // No-op function fallback
        };
        var fn = this.logger[method];
        if (typeof fn === 'function') {
            var originalFn = (_a = fn.__rrweb_original__) !== null && _a !== void 0 ? _a : fn;
            return originalFn.bind(this.logger);
        }
        return function() {
        // No-op function fallback
        };
    };
    SafeLoggerProvider.prototype.enable = function(logLevel) {
        this.logger.enable(logLevel);
    };
    SafeLoggerProvider.prototype.disable = function() {
        this.logger.disable();
    };
    return SafeLoggerProvider;
}();

});


parcelRegister("bCieG", function(module, exports) {

$parcel$export(module.exports, "SessionReplay", () => $8751638fb10fbec4$export$d9dca5e363d7847f);

var $3VFsf = parcelRequire("3VFsf");

var $5LgWF = parcelRequire("5LgWF");
var $gOnHi = parcelRequire("gOnHi");
var $d2db4 = parcelRequire("d2db4");
var $2J4kS = parcelRequire("2J4kS");

var $aoGcY = parcelRequire("aoGcY");

var $eZeQJ = parcelRequire("eZeQJ");

var $gPQg5 = parcelRequire("gPQg5");

var $8ceUs = parcelRequire("8ceUs");

var $kIB3M = parcelRequire("kIB3M");

var $6Wtbz = parcelRequire("6Wtbz");

var $edqg3 = parcelRequire("edqg3");

var $5TuVb = parcelRequire("5TuVb");

var $iTUaV = parcelRequire("iTUaV");

var $knBOj = parcelRequire("knBOj");

var $dnOCI = parcelRequire("dnOCI");

var $6NUoy = parcelRequire("6NUoy");

var $KxY8j = parcelRequire("KxY8j");

var $8751638fb10fbec4$export$d9dca5e363d7847f = /** @class */ function() {
    function SessionReplay() {
        var _this = this;
        this.name = '@amplitude/session-replay-browser';
        this.recordCancelCallback = null;
        this.eventCount = 0;
        // Visible for testing
        this.pageLeaveFns = [];
        this.teardownEventListeners = function(teardown) {
            var globalScope = (0, $gOnHi.getGlobalScope)();
            if (globalScope) {
                globalScope.removeEventListener('blur', _this.blurListener);
                globalScope.removeEventListener('focus', _this.focusListener);
                !teardown && globalScope.addEventListener('blur', _this.blurListener);
                !teardown && globalScope.addEventListener('focus', _this.focusListener);
                // prefer pagehide to unload events, this is the standard going forward. it is not
                // 100% reliable, but is bfcache-compatible.
                if (globalScope.self && 'onpagehide' in globalScope.self) {
                    globalScope.removeEventListener('pagehide', _this.pageLeaveListener);
                    !teardown && globalScope.addEventListener('pagehide', _this.pageLeaveListener);
                } else {
                    // this has performance implications, but is the only way we can reliably send events
                    // in browser that don't support pagehide.
                    globalScope.removeEventListener('beforeunload', _this.pageLeaveListener);
                    !teardown && globalScope.addEventListener('beforeunload', _this.pageLeaveListener);
                }
            }
        };
        this.blurListener = function() {
            _this.sendEvents();
        };
        this.focusListener = function() {
            // Restart recording on focus to ensure that when user
            // switches tabs, we take a full snapshot
            _this.recordEvents();
        };
        /**
         * This is an instance member so that if init is called multiple times
         * it doesn't add another listener to the page leave event. This is to
         * prevent duplicate listener actions from firing.
         */ this.pageLeaveListener = function(e) {
            _this.pageLeaveFns.forEach(function(fn) {
                fn(e);
            });
        };
        this.addCustomRRWebEvent = function(eventName, eventData, addStorageInfo) {
            if (eventData === void 0) eventData = {};
            if (addStorageInfo === void 0) addStorageInfo = true;
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var debugInfo, config, storageSizeData, e_1;
                return (0, $3VFsf.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            debugInfo = undefined;
                            config = this.config;
                            if (!config) return [
                                3 /*break*/ ,
                                2
                            ];
                            debugInfo = {
                                config: (0, $6Wtbz.getDebugConfig)(config),
                                version: (0, $knBOj.VERSION)
                            };
                            if (!addStorageInfo) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $6Wtbz.getStorageSize)()
                            ];
                        case 1:
                            storageSizeData = _a.sent();
                            debugInfo = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, storageSizeData), debugInfo);
                            _a.label = 2;
                        case 2:
                            // Check first to ensure we are recording
                            if (this.recordCancelCallback) (0, $aoGcY.record).addCustomEvent(eventName, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, eventData), debugInfo));
                            else this.loggerProvider.debug("Not able to add custom replay capture event ".concat(eventName, " due to no ongoing recording."));
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            e_1 = _a.sent();
                            this.loggerProvider.debug('Error while adding custom replay capture event: ', e_1);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.stopRecordingEvents = function() {
            var _a;
            try {
                _this.loggerProvider.log('Session Replay capture stopping.');
                _this.recordCancelCallback && _this.recordCancelCallback();
                _this.recordCancelCallback = null;
                (_a = _this.networkObservers) === null || _a === void 0 || _a.stop();
            } catch (error) {
                var typedError = error;
                _this.loggerProvider.warn("Error occurred while stopping replay capture: ".concat(typedError.toString()));
            }
        };
        this.loggerProvider = new (0, $6NUoy.SafeLoggerProvider)(new (0, $d2db4.Logger)());
    }
    SessionReplay.prototype.init = function(apiKey, options) {
        return (0, $2J4kS.returnWrapper)(this._init(apiKey, options));
    };
    SessionReplay.prototype._init = function(apiKey, options) {
        var _a, _b, _c, _d, _e, _f;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var _g, _h, scrollWatcher, managers, storeType, rrwebEventManager, error_1, typedError, payloadBatcher, interactionEventManager, error_2, typedError;
            return (0, $3VFsf.__generator)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        this.loggerProvider = new (0, $6NUoy.SafeLoggerProvider)(options.loggerProvider || new (0, $d2db4.Logger)());
                        Object.prototype.hasOwnProperty.call(options, 'logLevel') && this.loggerProvider.enable(options.logLevel);
                        this.identifiers = new (0, $iTUaV.SessionIdentifiers)({
                            sessionId: options.sessionId,
                            deviceId: options.deviceId
                        });
                        _g = this;
                        return [
                            4 /*yield*/ ,
                            (0, $eZeQJ.createSessionReplayJoinedConfigGenerator)(apiKey, options)
                        ];
                    case 1:
                        _g.joinedConfigGenerator = _j.sent();
                        _h = this;
                        return [
                            4 /*yield*/ ,
                            this.joinedConfigGenerator.generateJoinedConfig(this.identifiers.sessionId)
                        ];
                    case 2:
                        _h.config = _j.sent();
                        if (options.sessionId && ((_a = this.config.interactionConfig) === null || _a === void 0 ? void 0 : _a.enabled)) {
                            scrollWatcher = (0, $5TuVb.ScrollWatcher).default({
                                sessionId: options.sessionId,
                                type: 'interaction'
                            }, this.config);
                            this.pageLeaveFns = [
                                scrollWatcher.send(this.getDeviceId.bind(this)).bind(scrollWatcher)
                            ];
                            this.scrollHook = scrollWatcher.hook.bind(scrollWatcher);
                        }
                        managers = [];
                        storeType = this.config.storeType;
                        if (storeType === 'idb' && !((_b = (0, $gOnHi.getGlobalScope)()) === null || _b === void 0 ? void 0 : _b.indexedDB)) {
                            storeType = 'memory';
                            this.loggerProvider.warn('Could not use preferred indexedDB storage, reverting to in memory option.');
                        }
                        this.loggerProvider.log("Using ".concat(storeType, " for event storage."));
                        _j.label = 3;
                    case 3:
                        _j.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $8ceUs.createEventsManager)({
                                config: this.config,
                                sessionId: this.identifiers.sessionId,
                                type: 'replay',
                                storeType: storeType
                            })
                        ];
                    case 4:
                        rrwebEventManager = _j.sent();
                        managers.push({
                            name: 'replay',
                            manager: rrwebEventManager
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        error_1 = _j.sent();
                        typedError = error_1;
                        this.loggerProvider.warn("Error occurred while creating replay events manager: ".concat(typedError.toString()));
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        if (!((_c = this.config.interactionConfig) === null || _c === void 0 ? void 0 : _c.enabled)) return [
                            3 /*break*/ ,
                            10
                        ];
                        payloadBatcher = this.config.interactionConfig.batch ? (0, $edqg3.clickBatcher) : (0, $edqg3.clickNonBatcher);
                        _j.label = 7;
                    case 7:
                        _j.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $8ceUs.createEventsManager)({
                                config: this.config,
                                sessionId: this.identifiers.sessionId,
                                type: 'interaction',
                                minInterval: (_d = this.config.interactionConfig.trackEveryNms) !== null && _d !== void 0 ? _d : (0, $gPQg5.INTERACTION_MIN_INTERVAL),
                                maxInterval: (0, $gPQg5.INTERACTION_MAX_INTERVAL),
                                payloadBatcher: payloadBatcher,
                                storeType: storeType
                            })
                        ];
                    case 8:
                        interactionEventManager = _j.sent();
                        managers.push({
                            name: 'interaction',
                            manager: interactionEventManager
                        });
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        error_2 = _j.sent();
                        typedError = error_2;
                        this.loggerProvider.warn("Error occurred while creating interaction events manager: ".concat(typedError.toString()));
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 10:
                        this.eventsManager = new ((0, $kIB3M.MultiEventManager).bind.apply((0, $kIB3M.MultiEventManager), (0, $3VFsf.__spreadArray)([
                            void 0
                        ], (0, $3VFsf.__read)(managers), false)))();
                        // To prevent too many threads.
                        if (this.eventCompressor) this.eventCompressor.terminate();
                        this.eventCompressor = new (0, $dnOCI.EventCompressor)(this.eventsManager, this.config, this.getDeviceId());
                        // Initialize network observers if logging is enabled
                        if ((_f = (_e = this.config.loggingConfig) === null || _e === void 0 ? void 0 : _e.network) === null || _f === void 0 ? void 0 : _f.enabled) this.networkObservers = new (0, $KxY8j.NetworkObservers)();
                        this.loggerProvider.log('Installing @amplitude/session-replay-browser.');
                        this.teardownEventListeners(false);
                        this.initialize(true);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionReplay.prototype.setSessionId = function(sessionId, deviceId) {
        return (0, $2J4kS.returnWrapper)(this.asyncSetSessionId(sessionId, deviceId));
    };
    SessionReplay.prototype.asyncSetSessionId = function(sessionId, deviceId) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var previousSessionId, deviceIdForReplayId, _a;
            return (0, $3VFsf.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        previousSessionId = this.identifiers && this.identifiers.sessionId;
                        if (previousSessionId) this.sendEvents(previousSessionId);
                        deviceIdForReplayId = deviceId || this.getDeviceId();
                        this.identifiers = new (0, $iTUaV.SessionIdentifiers)({
                            sessionId: sessionId,
                            deviceId: deviceIdForReplayId
                        });
                        if (!(this.joinedConfigGenerator && previousSessionId)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this.joinedConfigGenerator.generateJoinedConfig(this.identifiers.sessionId)
                        ];
                    case 1:
                        _a.config = _b.sent();
                        _b.label = 2;
                    case 2:
                        this.recordEvents();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionReplay.prototype.getSessionReplayProperties = function() {
        var _a;
        var config = this.config;
        var identifiers = this.identifiers;
        if (!config || !identifiers) {
            this.loggerProvider.warn('Session replay init has not been called, cannot get session replay properties.');
            return {};
        }
        var shouldRecord = this.getShouldRecord();
        var eventProperties = {};
        if (shouldRecord) {
            eventProperties = (_a = {}, _a[0, $gPQg5.DEFAULT_SESSION_REPLAY_PROPERTY] = identifiers.sessionReplayId ? identifiers.sessionReplayId : null, _a);
            if (config.debugMode) eventProperties[0, $gPQg5.SESSION_REPLAY_DEBUG_PROPERTY] = JSON.stringify({
                appHash: (0, $6Wtbz.generateHashCode)(config.apiKey).toString()
            });
        }
        this.addCustomRRWebEvent((0, $gPQg5.CustomRRwebEvent).GET_SR_PROPS, {
            shouldRecord: shouldRecord,
            eventProperties: eventProperties
        }, this.eventCount === 10);
        if (this.eventCount === 10) this.eventCount = 0;
        this.eventCount++;
        return eventProperties;
    };
    SessionReplay.prototype.sendEvents = function(sessionId) {
        var _a;
        var sessionIdToSend = sessionId || ((_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId);
        var deviceId = this.getDeviceId();
        this.eventsManager && sessionIdToSend && deviceId && this.eventsManager.sendCurrentSequenceEvents({
            sessionId: sessionIdToSend,
            deviceId: deviceId
        });
    };
    SessionReplay.prototype.initialize = function(shouldSendStoredEvents) {
        var _a;
        if (shouldSendStoredEvents === void 0) shouldSendStoredEvents = false;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var deviceId;
            return (0, $3VFsf.__generator)(this, function(_b) {
                if (!((_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId)) {
                    this.loggerProvider.log("Session is not being recorded due to lack of session id.");
                    return [
                        2 /*return*/ ,
                        Promise.resolve()
                    ];
                }
                deviceId = this.getDeviceId();
                if (!deviceId) {
                    this.loggerProvider.log("Session is not being recorded due to lack of device id.");
                    return [
                        2 /*return*/ ,
                        Promise.resolve()
                    ];
                }
                this.eventsManager && shouldSendStoredEvents && this.eventsManager.sendStoredEvents({
                    deviceId: deviceId
                });
                return [
                    2 /*return*/ ,
                    this.recordEvents()
                ];
            });
        });
    };
    SessionReplay.prototype.shouldOptOut = function() {
        var _a, _b;
        var identityStoreOptOut;
        if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.instanceName) {
            var identityStore = (0, $5LgWF.getAnalyticsConnector)(this.config.instanceName).identityStore;
            identityStoreOptOut = identityStore.getIdentity().optOut;
        }
        return identityStoreOptOut !== undefined ? identityStoreOptOut : (_b = this.config) === null || _b === void 0 ? void 0 : _b.optOut;
    };
    SessionReplay.prototype.getShouldRecord = function() {
        if (!this.identifiers || !this.config || !this.identifiers.sessionId) {
            this.loggerProvider.warn("Session is not being recorded due to lack of config, please call sessionReplay.init.");
            return false;
        }
        if (!this.config.captureEnabled) {
            this.loggerProvider.log("Session ".concat(this.identifiers.sessionId, " not being captured due to capture being disabled for project or because the remote config could not be fetched."));
            return false;
        }
        if (this.shouldOptOut()) {
            this.loggerProvider.log("Opting session ".concat(this.identifiers.sessionId, " out of recording due to optOut config."));
            return false;
        }
        var isInSample = (0, $6Wtbz.isSessionInSample)(this.identifiers.sessionId, this.config.sampleRate);
        if (!isInSample) this.loggerProvider.log("Opting session ".concat(this.identifiers.sessionId, " out of recording due to sample rate."));
        return isInSample;
    };
    SessionReplay.prototype.getBlockSelectors = function() {
        var _a, _b, _c;
        // For some reason, this defaults to empty array ([]) if undefined in the compiled script.
        // Empty arrays cause errors when being evaluated in Safari.
        // Force the selector to be undefined if it's an empty array.
        var blockSelector = (_c = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.privacyConfig) === null || _b === void 0 ? void 0 : _b.blockSelector) !== null && _c !== void 0 ? _c : [];
        if (blockSelector.length === 0) return undefined;
        return blockSelector;
    };
    SessionReplay.prototype.getMaskTextSelectors = function() {
        var _a, _b, _c, _d;
        if (((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.privacyConfig) === null || _b === void 0 ? void 0 : _b.defaultMaskLevel) === 'conservative') return '*';
        var maskSelector = (_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.privacyConfig) === null || _d === void 0 ? void 0 : _d.maskSelector;
        if (!maskSelector) return;
        return maskSelector;
    };
    SessionReplay.prototype.getRecordingPlugins = function(loggingConfig) {
        var _a;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var plugins, getRecordConsolePlugin, error_3;
            return (0, $3VFsf.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        plugins = [];
                        if (!((_a = loggingConfig === null || loggingConfig === void 0 ? void 0 : loggingConfig.console) === null || _a === void 0 ? void 0 : _a.enabled)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            (parcelRequire("bcxTD"))
                        ];
                    case 2:
                        getRecordConsolePlugin = _b.sent().getRecordConsolePlugin;
                        plugins.push(getRecordConsolePlugin({
                            level: loggingConfig.console.levels
                        }));
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_3 = _b.sent();
                        this.loggerProvider.warn('Failed to load console plugin:', error_3);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            plugins.length > 0 ? plugins : undefined
                        ];
                }
            });
        });
    };
    SessionReplay.prototype.recordEvents = function() {
        var _a, _b;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var config, shouldRecord, sessionId, privacyConfig, interactionConfig, loggingConfig, hooks, _c, _d, error_4;
            var _e;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        config = this.config;
                        shouldRecord = this.getShouldRecord();
                        sessionId = (_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId;
                        if (!shouldRecord || !sessionId || !config) return [
                            2 /*return*/ 
                        ];
                        this.stopRecordingEvents();
                        (_b = this.networkObservers) === null || _b === void 0 || _b.start(function(event) {
                            _this.addCustomRRWebEvent((0, $gPQg5.CustomRRwebEvent).FETCH_REQUEST, event);
                        });
                        privacyConfig = config.privacyConfig, interactionConfig = config.interactionConfig, loggingConfig = config.loggingConfig;
                        hooks = (interactionConfig === null || interactionConfig === void 0 ? void 0 : interactionConfig.enabled) ? {
                            mouseInteraction: this.eventsManager && (0, $edqg3.clickHook)(this.loggerProvider, {
                                eventsManager: this.eventsManager,
                                sessionId: sessionId,
                                deviceIdFn: this.getDeviceId.bind(this)
                            }),
                            scroll: this.scrollHook
                        } : {};
                        this.loggerProvider.log("Session Replay capture beginning for ".concat(sessionId, "."));
                        _f.label = 1;
                    case 1:
                        _f.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _c = this;
                        _d = (0, $aoGcY.record);
                        _e = {
                            emit: function(event) {
                                if (_this.shouldOptOut()) {
                                    _this.loggerProvider.log("Opting session ".concat(sessionId, " out of recording due to optOut config."));
                                    _this.stopRecordingEvents();
                                    _this.sendEvents();
                                    return;
                                }
                                if (_this.eventCompressor) // Schedule processing during idle time if the browser supports requestIdleCallback
                                _this.eventCompressor.enqueueEvent(event, sessionId);
                            },
                            inlineStylesheet: config.shouldInlineStylesheet,
                            hooks: hooks,
                            maskAllInputs: true,
                            maskTextClass: (0, $gPQg5.MASK_TEXT_CLASS),
                            blockClass: (0, $gPQg5.BLOCK_CLASS),
                            // rrweb only exposes string type through its types, but arrays are also be supported. #class, ['#class', 'id']
                            blockSelector: this.getBlockSelectors(),
                            maskInputFn: (0, $6Wtbz.maskFn)('input', privacyConfig),
                            maskTextFn: (0, $6Wtbz.maskFn)('text', privacyConfig),
                            // rrweb only exposes string type through its types, but arrays are also be supported. since rrweb uses .matches() which supports arrays.
                            maskTextSelector: this.getMaskTextSelectors(),
                            recordCanvas: false,
                            errorHandler: function(error) {
                                var typedError = error;
                                // styled-components relies on this error being thrown and bubbled up, rrweb is otherwise suppressing it
                                if (typedError.message.includes('insertRule') && typedError.message.includes('CSSStyleSheet')) throw typedError;
                                // rrweb does monkey patching on certain window functions such as CSSStyleSheet.proptype.insertRule,
                                // and errors from external clients calling these functions can get suppressed. Styled components depend
                                // on these errors being re-thrown.
                                if (typedError._external_) throw typedError;
                                _this.loggerProvider.warn('Error while capturing replay: ', typedError.toString());
                                // Return true so that we don't clutter user's consoles with internal rrweb errors
                                return true;
                            }
                        };
                        return [
                            4 /*yield*/ ,
                            this.getRecordingPlugins(loggingConfig)
                        ];
                    case 2:
                        _c.recordCancelCallback = _d.apply(void 0, [
                            (_e.plugins = _f.sent(), _e)
                        ]);
                        this.addCustomRRWebEvent((0, $gPQg5.CustomRRwebEvent).DEBUG_INFO);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_4 = _f.sent();
                        this.loggerProvider.warn('Failed to initialize session replay:', error_4);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionReplay.prototype.getDeviceId = function() {
        var _a;
        return (_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.deviceId;
    };
    SessionReplay.prototype.getSessionId = function() {
        var _a;
        return (_a = this.identifiers) === null || _a === void 0 ? void 0 : _a.sessionId;
    };
    SessionReplay.prototype.flush = function(useRetry) {
        var _a;
        if (useRetry === void 0) useRetry = false;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_b) {
                return [
                    2 /*return*/ ,
                    (_a = this.eventsManager) === null || _a === void 0 ? void 0 : _a.flush(useRetry)
                ];
            });
        });
    };
    SessionReplay.prototype.shutdown = function() {
        this.teardownEventListeners(true);
        this.stopRecordingEvents();
        this.sendEvents();
    };
    return SessionReplay;
}();

});
parcelRegister("5LgWF", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsConnector", () => $431e7c80cf11d4bd$export$4e27b19f1b537bc2);

var $acGlN = parcelRequire("acGlN");
var $431e7c80cf11d4bd$export$4e27b19f1b537bc2 = function(instanceName) {
    if (instanceName === void 0) instanceName = '$default_instance';
    return (0, $acGlN.AnalyticsConnector).getInstance(instanceName);
};
var $431e7c80cf11d4bd$export$ae185dd9f76bc0ec = function(userId, instanceName) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    $431e7c80cf11d4bd$export$4e27b19f1b537bc2(instanceName).identityStore.editIdentity().setUserId(userId).commit();
};
var $431e7c80cf11d4bd$export$2bf3e8de34602369 = function(deviceId, instanceName) {
    $431e7c80cf11d4bd$export$4e27b19f1b537bc2(instanceName).identityStore.editIdentity().setDeviceId(deviceId).commit();
};

});
parcelRegister("acGlN", function(module, exports) {

$parcel$export(module.exports, "AnalyticsConnector", () => $76dbe04cc37b2bfe$export$5af12d25e001b77c);
var $76dbe04cc37b2bfe$var$ApplicationContextProviderImpl = /** @class */ function() {
    function ApplicationContextProviderImpl() {}
    ApplicationContextProviderImpl.prototype.getApplicationContext = function() {
        return {
            versionName: this.versionName,
            language: $76dbe04cc37b2bfe$var$getLanguage(),
            platform: 'Web',
            os: undefined,
            deviceModel: undefined
        };
    };
    return ApplicationContextProviderImpl;
}();
var $76dbe04cc37b2bfe$var$getLanguage = function() {
    return typeof navigator !== 'undefined' && (navigator.languages && navigator.languages[0] || navigator.language) || '';
};
var $76dbe04cc37b2bfe$var$EventBridgeImpl = /** @class */ function() {
    function EventBridgeImpl() {
        this.queue = [];
    }
    EventBridgeImpl.prototype.logEvent = function(event) {
        if (!this.receiver) {
            if (this.queue.length < 512) this.queue.push(event);
        } else this.receiver(event);
    };
    EventBridgeImpl.prototype.setEventReceiver = function(receiver) {
        this.receiver = receiver;
        if (this.queue.length > 0) {
            this.queue.forEach(function(event) {
                receiver(event);
            });
            this.queue = [];
        }
    };
    return EventBridgeImpl;
}();
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $76dbe04cc37b2bfe$var$__assign = function() {
    $76dbe04cc37b2bfe$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $76dbe04cc37b2bfe$var$__assign.apply(this, arguments);
};
function $76dbe04cc37b2bfe$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $76dbe04cc37b2bfe$var$__read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
typeof SuppressedError === "function" && SuppressedError;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $76dbe04cc37b2bfe$var$isEqual = function(obj1, obj2) {
    var e_1, _a;
    var primitive = [
        'string',
        'number',
        'boolean',
        'undefined'
    ];
    var typeA = typeof obj1;
    var typeB = typeof obj2;
    if (typeA !== typeB) return false;
    try {
        for(var primitive_1 = $76dbe04cc37b2bfe$var$__values(primitive), primitive_1_1 = primitive_1.next(); !primitive_1_1.done; primitive_1_1 = primitive_1.next()){
            var p = primitive_1_1.value;
            if (p === typeA) return obj1 === obj2;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (primitive_1_1 && !primitive_1_1.done && (_a = primitive_1.return)) _a.call(primitive_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    // check null
    if (obj1 == null && obj2 == null) return true;
    else if (obj1 == null || obj2 == null) return false;
    // if got here - objects
    if (obj1.length !== obj2.length) return false;
    //check if arrays
    var isArrayA = Array.isArray(obj1);
    var isArrayB = Array.isArray(obj2);
    if (isArrayA !== isArrayB) return false;
    if (isArrayA && isArrayB) //arrays
    for(var i = 0; i < obj1.length; i++){
        if (!$76dbe04cc37b2bfe$var$isEqual(obj1[i], obj2[i])) return false;
    }
    else {
        //objects
        var sorted1 = Object.keys(obj1).sort();
        var sorted2 = Object.keys(obj2).sort();
        if (!$76dbe04cc37b2bfe$var$isEqual(sorted1, sorted2)) return false;
        //compare object values
        var result_1 = true;
        Object.keys(obj1).forEach(function(key) {
            if (!$76dbe04cc37b2bfe$var$isEqual(obj1[key], obj2[key])) result_1 = false;
        });
        return result_1;
    }
    return true;
};
var $76dbe04cc37b2bfe$var$ID_OP_SET = '$set';
var $76dbe04cc37b2bfe$var$ID_OP_UNSET = '$unset';
var $76dbe04cc37b2bfe$var$ID_OP_CLEAR_ALL = '$clearAll';
// Polyfill for Object.entries
if (!Object.entries) Object.entries = function(obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);
    while(i--)resArray[i] = [
        ownProps[i],
        obj[ownProps[i]]
    ];
    return resArray;
};
var $76dbe04cc37b2bfe$var$IdentityStoreImpl = /** @class */ function() {
    function IdentityStoreImpl() {
        this.identity = {
            userProperties: {}
        };
        this.listeners = new Set();
    }
    IdentityStoreImpl.prototype.editIdentity = function() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self1 = this;
        var actingUserProperties = $76dbe04cc37b2bfe$var$__assign({}, this.identity.userProperties);
        var actingIdentity = $76dbe04cc37b2bfe$var$__assign($76dbe04cc37b2bfe$var$__assign({}, this.identity), {
            userProperties: actingUserProperties
        });
        return {
            setUserId: function(userId) {
                actingIdentity.userId = userId;
                return this;
            },
            setDeviceId: function(deviceId) {
                actingIdentity.deviceId = deviceId;
                return this;
            },
            setUserProperties: function(userProperties) {
                actingIdentity.userProperties = userProperties;
                return this;
            },
            setOptOut: function(optOut) {
                actingIdentity.optOut = optOut;
                return this;
            },
            updateUserProperties: function(actions) {
                var e_1, _a, e_2, _b, e_3, _c;
                var actingProperties = actingIdentity.userProperties || {};
                try {
                    for(var _d = $76dbe04cc37b2bfe$var$__values(Object.entries(actions)), _e = _d.next(); !_e.done; _e = _d.next()){
                        var _f = $76dbe04cc37b2bfe$var$__read(_e.value, 2), action = _f[0], properties = _f[1];
                        switch(action){
                            case $76dbe04cc37b2bfe$var$ID_OP_SET:
                                try {
                                    for(var _g = (e_2 = void 0, $76dbe04cc37b2bfe$var$__values(Object.entries(properties))), _h = _g.next(); !_h.done; _h = _g.next()){
                                        var _j = $76dbe04cc37b2bfe$var$__read(_h.value, 2), key = _j[0], value = _j[1];
                                        actingProperties[key] = value;
                                    }
                                } catch (e_2_1) {
                                    e_2 = {
                                        error: e_2_1
                                    };
                                } finally{
                                    try {
                                        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                                    } finally{
                                        if (e_2) throw e_2.error;
                                    }
                                }
                                break;
                            case $76dbe04cc37b2bfe$var$ID_OP_UNSET:
                                try {
                                    for(var _k = (e_3 = void 0, $76dbe04cc37b2bfe$var$__values(Object.keys(properties))), _l = _k.next(); !_l.done; _l = _k.next()){
                                        var key = _l.value;
                                        delete actingProperties[key];
                                    }
                                } catch (e_3_1) {
                                    e_3 = {
                                        error: e_3_1
                                    };
                                } finally{
                                    try {
                                        if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                                    } finally{
                                        if (e_3) throw e_3.error;
                                    }
                                }
                                break;
                            case $76dbe04cc37b2bfe$var$ID_OP_CLEAR_ALL:
                                actingProperties = {};
                                break;
                        }
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                actingIdentity.userProperties = actingProperties;
                return this;
            },
            commit: function() {
                self1.setIdentity(actingIdentity);
                return this;
            }
        };
    };
    IdentityStoreImpl.prototype.getIdentity = function() {
        return $76dbe04cc37b2bfe$var$__assign({}, this.identity);
    };
    IdentityStoreImpl.prototype.setIdentity = function(identity) {
        var originalIdentity = $76dbe04cc37b2bfe$var$__assign({}, this.identity);
        this.identity = $76dbe04cc37b2bfe$var$__assign({}, identity);
        if (!$76dbe04cc37b2bfe$var$isEqual(originalIdentity, this.identity)) this.listeners.forEach(function(listener) {
            listener(identity);
        });
    };
    IdentityStoreImpl.prototype.addIdentityListener = function(listener) {
        this.listeners.add(listener);
    };
    IdentityStoreImpl.prototype.removeIdentityListener = function(listener) {
        this.listeners.delete(listener);
    };
    return IdentityStoreImpl;
}();
var $76dbe04cc37b2bfe$var$safeGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof $parcel$global !== 'undefined' ? $parcel$global : self;
var $76dbe04cc37b2bfe$export$5af12d25e001b77c = /** @class */ function() {
    function AnalyticsConnector() {
        this.identityStore = new $76dbe04cc37b2bfe$var$IdentityStoreImpl();
        this.eventBridge = new $76dbe04cc37b2bfe$var$EventBridgeImpl();
        this.applicationContextProvider = new $76dbe04cc37b2bfe$var$ApplicationContextProviderImpl();
    }
    AnalyticsConnector.getInstance = function(instanceName) {
        if (!$76dbe04cc37b2bfe$var$safeGlobal['analyticsConnectorInstances']) $76dbe04cc37b2bfe$var$safeGlobal['analyticsConnectorInstances'] = {};
        if (!$76dbe04cc37b2bfe$var$safeGlobal['analyticsConnectorInstances'][instanceName]) $76dbe04cc37b2bfe$var$safeGlobal['analyticsConnectorInstances'][instanceName] = new AnalyticsConnector();
        return $76dbe04cc37b2bfe$var$safeGlobal['analyticsConnectorInstances'][instanceName];
    };
    return AnalyticsConnector;
}();

});


parcelRegister("gOnHi", function(module, exports) {

$parcel$export(module.exports, "getGlobalScope", () => $c3d3b2ab495fa9df$export$aa55d5ab8e05984f);
/* eslint-disable no-restricted-globals */ /* Only file allowed to access to globalThis, window, self */ var $c3d3b2ab495fa9df$export$aa55d5ab8e05984f = function() {
    // This should only be used for integrations with Amplitude that are not running in a browser environment
    //   We need to specify the name of the global variable as a string to prevent it from being minified
    var ampIntegrationContextName = 'ampIntegrationContext';
    if (typeof globalThis !== 'undefined' && typeof globalThis[ampIntegrationContextName] !== 'undefined') return globalThis[ampIntegrationContextName];
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof window !== 'undefined') return window;
    if (typeof self !== 'undefined') return self;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return undefined;
};

});

parcelRegister("2J4kS", function(module, exports) {

$parcel$export(module.exports, "returnWrapper", () => $1fc325bbe6d96252$export$a2bf1b09e40c274a);
var $1fc325bbe6d96252$export$a2bf1b09e40c274a = function(awaitable) {
    return {
        promise: awaitable || Promise.resolve()
    };
};

});

parcelRegister("aoGcY", function(module, exports) {

$parcel$export(module.exports, "utils", () => $791ce2ee9eb5657b$export$eab97d15b1788b8d);
$parcel$export(module.exports, "record", () => $791ce2ee9eb5657b$export$e5185e241753e543);

var $5k7LC = parcelRequire("5k7LC");
var $791ce2ee9eb5657b$require$Buffer = $5k7LC.Buffer;
var $791ce2ee9eb5657b$var$__defProp = Object.defineProperty;
var $791ce2ee9eb5657b$var$__defNormalProp = (obj, key, value)=>key in obj ? $791ce2ee9eb5657b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $791ce2ee9eb5657b$var$__publicField = (obj, key, value)=>$791ce2ee9eb5657b$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $791ce2ee9eb5657b$var$_a;
var $791ce2ee9eb5657b$var$__defProp$1 = Object.defineProperty;
var $791ce2ee9eb5657b$var$__defNormalProp$1 = (obj, key, value)=>key in obj ? $791ce2ee9eb5657b$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $791ce2ee9eb5657b$var$__publicField$1 = (obj, key, value)=>$791ce2ee9eb5657b$var$__defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
var $791ce2ee9eb5657b$var$NodeType$3 = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($791ce2ee9eb5657b$var$NodeType$3 || {});
const $791ce2ee9eb5657b$var$testableAccessors$1 = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
const $791ce2ee9eb5657b$var$testableMethods$1 = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
const $791ce2ee9eb5657b$var$untaintedBasePrototype$1 = {};
const $791ce2ee9eb5657b$var$isAngularZonePresent$1 = ()=>{
    return !!globalThis.Zone;
};
function $791ce2ee9eb5657b$var$getUntaintedPrototype$1(key) {
    if ($791ce2ee9eb5657b$var$untaintedBasePrototype$1[key]) return $791ce2ee9eb5657b$var$untaintedBasePrototype$1[key];
    const defaultObj = globalThis[key];
    const defaultPrototype = defaultObj.prototype;
    const accessorNames = key in $791ce2ee9eb5657b$var$testableAccessors$1 ? $791ce2ee9eb5657b$var$testableAccessors$1[key] : void 0;
    const isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every((accessor)=>{
        var _a2, _b;
        return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    const methodNames = key in $791ce2ee9eb5657b$var$testableMethods$1 ? $791ce2ee9eb5657b$var$testableMethods$1[key] : void 0;
    const isUntaintedMethods = Boolean(methodNames && methodNames.every(// @ts-expect-error 2345
    (method)=>{
        var _a2;
        return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods && !$791ce2ee9eb5657b$var$isAngularZonePresent$1()) {
        $791ce2ee9eb5657b$var$untaintedBasePrototype$1[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        const iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        const win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        const untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return $791ce2ee9eb5657b$var$untaintedBasePrototype$1[key] = untaintedObject;
    } catch  {
        return defaultPrototype;
    }
}
const $791ce2ee9eb5657b$var$untaintedAccessorCache$1 = {};
function $791ce2ee9eb5657b$var$getUntaintedAccessor$1(key, instance, accessor) {
    var _a2;
    const cacheKey = `${key}.${String(accessor)}`;
    if ($791ce2ee9eb5657b$var$untaintedAccessorCache$1[cacheKey]) return $791ce2ee9eb5657b$var$untaintedAccessorCache$1[cacheKey].call(instance);
    const untaintedPrototype = $791ce2ee9eb5657b$var$getUntaintedPrototype$1(key);
    const untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
    if (!untaintedAccessor) return instance[accessor];
    $791ce2ee9eb5657b$var$untaintedAccessorCache$1[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
const $791ce2ee9eb5657b$var$untaintedMethodCache$1 = {};
function $791ce2ee9eb5657b$var$getUntaintedMethod$1(key, instance, method) {
    const cacheKey = `${key}.${String(method)}`;
    if ($791ce2ee9eb5657b$var$untaintedMethodCache$1[cacheKey]) return $791ce2ee9eb5657b$var$untaintedMethodCache$1[cacheKey].bind(instance);
    const untaintedPrototype = $791ce2ee9eb5657b$var$getUntaintedPrototype$1(key);
    const untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    $791ce2ee9eb5657b$var$untaintedMethodCache$1[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function $791ce2ee9eb5657b$var$childNodes$1(n2) {
    return $791ce2ee9eb5657b$var$getUntaintedAccessor$1("Node", n2, "childNodes");
}
function $791ce2ee9eb5657b$var$parentNode$1(n2) {
    return $791ce2ee9eb5657b$var$getUntaintedAccessor$1("Node", n2, "parentNode");
}
function $791ce2ee9eb5657b$var$parentElement$1(n2) {
    return $791ce2ee9eb5657b$var$getUntaintedAccessor$1("Node", n2, "parentElement");
}
function $791ce2ee9eb5657b$var$textContent$1(n2) {
    return $791ce2ee9eb5657b$var$getUntaintedAccessor$1("Node", n2, "textContent");
}
function $791ce2ee9eb5657b$var$contains$1(n2, other) {
    return $791ce2ee9eb5657b$var$getUntaintedMethod$1("Node", n2, "contains")(other);
}
function $791ce2ee9eb5657b$var$getRootNode$1(n2) {
    return $791ce2ee9eb5657b$var$getUntaintedMethod$1("Node", n2, "getRootNode")();
}
function $791ce2ee9eb5657b$var$host$1(n2) {
    if (!n2 || !("host" in n2)) return null;
    return $791ce2ee9eb5657b$var$getUntaintedAccessor$1("ShadowRoot", n2, "host");
}
function $791ce2ee9eb5657b$var$styleSheets$1(n2) {
    return n2.styleSheets;
}
function $791ce2ee9eb5657b$var$shadowRoot$1(n2) {
    if (!n2 || !("shadowRoot" in n2)) return null;
    return $791ce2ee9eb5657b$var$getUntaintedAccessor$1("Element", n2, "shadowRoot");
}
function $791ce2ee9eb5657b$var$querySelector$1(n2, selectors) {
    return $791ce2ee9eb5657b$var$getUntaintedAccessor$1("Element", n2, "querySelector")(selectors);
}
function $791ce2ee9eb5657b$var$querySelectorAll$1(n2, selectors) {
    return $791ce2ee9eb5657b$var$getUntaintedAccessor$1("Element", n2, "querySelectorAll")(selectors);
}
function $791ce2ee9eb5657b$var$mutationObserverCtor$1() {
    return $791ce2ee9eb5657b$var$getUntaintedPrototype$1("MutationObserver").constructor;
}
const $791ce2ee9eb5657b$var$index$1 = {
    childNodes: $791ce2ee9eb5657b$var$childNodes$1,
    parentNode: $791ce2ee9eb5657b$var$parentNode$1,
    parentElement: $791ce2ee9eb5657b$var$parentElement$1,
    textContent: $791ce2ee9eb5657b$var$textContent$1,
    contains: $791ce2ee9eb5657b$var$contains$1,
    getRootNode: $791ce2ee9eb5657b$var$getRootNode$1,
    host: $791ce2ee9eb5657b$var$host$1,
    styleSheets: $791ce2ee9eb5657b$var$styleSheets$1,
    shadowRoot: $791ce2ee9eb5657b$var$shadowRoot$1,
    querySelector: $791ce2ee9eb5657b$var$querySelector$1,
    querySelectorAll: $791ce2ee9eb5657b$var$querySelectorAll$1,
    mutationObserver: $791ce2ee9eb5657b$var$mutationObserverCtor$1
};
function $791ce2ee9eb5657b$var$isElement(n2) {
    return n2.nodeType === n2.ELEMENT_NODE;
}
function $791ce2ee9eb5657b$var$isShadowRoot(n2) {
    const hostEl = // anchor and textarea elements also have a `host` property
    // but only shadow roots have a `mode` property
    n2 && "host" in n2 && "mode" in n2 && $791ce2ee9eb5657b$var$index$1.host(n2) || null;
    return Boolean(hostEl && "shadowRoot" in hostEl && $791ce2ee9eb5657b$var$index$1.shadowRoot(hostEl) === n2);
}
function $791ce2ee9eb5657b$var$isNativeShadowDom(shadowRoot2) {
    return Object.prototype.toString.call(shadowRoot2) === "[object ShadowRoot]";
}
function $791ce2ee9eb5657b$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $791ce2ee9eb5657b$var$escapeImportStatement(rule2) {
    const { cssText: cssText } = rule2;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule2.href)})`
    ];
    if (rule2.layerName === "") statement.push(`layer`);
    else if (rule2.layerName) statement.push(`layer(${rule2.layerName})`);
    if (rule2.supportsText) statement.push(`supports(${rule2.supportsText})`);
    if (rule2.media.length) statement.push(rule2.media.mediaText);
    return statement.join(" ") + ";";
}
function $791ce2ee9eb5657b$var$stringifyStylesheet(s2) {
    try {
        const rules2 = s2.rules || s2.cssRules;
        if (!rules2) return null;
        let sheetHref = s2.href;
        if (!sheetHref && s2.ownerNode && s2.ownerNode.ownerDocument) sheetHref = s2.ownerNode.ownerDocument.location.href;
        const stringifiedRules = Array.from(rules2, (rule2)=>$791ce2ee9eb5657b$var$stringifyRule(rule2, sheetHref)).join("");
        return $791ce2ee9eb5657b$var$fixBrowserCompatibilityIssuesInCSS(stringifiedRules);
    } catch (error) {
        return null;
    }
}
function $791ce2ee9eb5657b$var$stringifyRule(rule2, sheetHref) {
    if ($791ce2ee9eb5657b$var$isCSSImportRule(rule2)) {
        let importStringified;
        try {
            importStringified = // we can access the imported stylesheet rules directly
            $791ce2ee9eb5657b$var$stringifyStylesheet(rule2.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
            $791ce2ee9eb5657b$var$escapeImportStatement(rule2);
        } catch (error) {
            importStringified = rule2.cssText;
        }
        if (rule2.styleSheet.href) return $791ce2ee9eb5657b$var$absolutifyURLs(importStringified, rule2.styleSheet.href);
        return importStringified;
    } else {
        let ruleStringified = rule2.cssText;
        if ($791ce2ee9eb5657b$var$isCSSStyleRule(rule2) && rule2.selectorText.includes(":")) ruleStringified = $791ce2ee9eb5657b$var$fixSafariColons(ruleStringified);
        if (sheetHref) return $791ce2ee9eb5657b$var$absolutifyURLs(ruleStringified, sheetHref);
        return ruleStringified;
    }
}
function $791ce2ee9eb5657b$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $791ce2ee9eb5657b$var$isCSSImportRule(rule2) {
    return "styleSheet" in rule2;
}
function $791ce2ee9eb5657b$var$isCSSStyleRule(rule2) {
    return "selectorText" in rule2;
}
class $791ce2ee9eb5657b$var$Mirror {
    constructor(){
        $791ce2ee9eb5657b$var$__publicField$1(this, "idNodeMap", /* @__PURE__ */ new Map());
        $791ce2ee9eb5657b$var$__publicField$1(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    getId(n2) {
        var _a2;
        if (!n2) return -1;
        const id = (_a2 = this.getMeta(n2)) == null ? void 0 : _a2.id;
        return id ?? -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n2) {
        const id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) n2.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node2) {
        return this.nodeMetaMap.has(node2);
    }
    add(n2, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    }
    replace(id, n2) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
}
function $791ce2ee9eb5657b$var$createMirror$2() {
    return new $791ce2ee9eb5657b$var$Mirror();
}
function $791ce2ee9eb5657b$var$maskInputValue({ element: element, maskInputOptions: maskInputOptions, tagName: tagName, type: type, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    const actualType = type && $791ce2ee9eb5657b$var$toLowerCase(type);
    if (maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType]) {
        if (maskInputFn) text = maskInputFn(text, element);
        else text = "*".repeat(text.length);
    }
    return text;
}
function $791ce2ee9eb5657b$var$toLowerCase(str) {
    return str.toLowerCase();
}
const $791ce2ee9eb5657b$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $791ce2ee9eb5657b$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x2 = 0; x2 < canvas.width; x2 += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $791ce2ee9eb5657b$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$791ce2ee9eb5657b$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        originalGetImageData.call(ctx, x2, y, Math.min(chunkSize, canvas.width - x2), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $791ce2ee9eb5657b$var$isNodeMetaEqual(a2, b) {
    if (!a2 || !b || a2.type !== b.type) return false;
    if (a2.type === $791ce2ee9eb5657b$var$NodeType$3.Document) return a2.compatMode === b.compatMode;
    else if (a2.type === $791ce2ee9eb5657b$var$NodeType$3.DocumentType) return a2.name === b.name && a2.publicId === b.publicId && a2.systemId === b.systemId;
    else if (a2.type === $791ce2ee9eb5657b$var$NodeType$3.Comment || a2.type === $791ce2ee9eb5657b$var$NodeType$3.Text || a2.type === $791ce2ee9eb5657b$var$NodeType$3.CDATA) return a2.textContent === b.textContent;
    else if (a2.type === $791ce2ee9eb5657b$var$NodeType$3.Element) return a2.tagName === b.tagName && JSON.stringify(a2.attributes) === JSON.stringify(b.attributes) && a2.isSVG === b.isSVG && a2.needBlock === b.needBlock;
    return false;
}
function $791ce2ee9eb5657b$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    $791ce2ee9eb5657b$var$toLowerCase(type) : null;
}
function $791ce2ee9eb5657b$var$extractFileExtension(path, baseURL) {
    let url;
    try {
        url = new URL(path, baseURL ?? window.location.href);
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    return (match == null ? void 0 : match[1]) ?? null;
}
function $791ce2ee9eb5657b$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
const $791ce2ee9eb5657b$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $791ce2ee9eb5657b$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $791ce2ee9eb5657b$var$URL_WWW_MATCH = /^www\..*/i;
const $791ce2ee9eb5657b$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $791ce2ee9eb5657b$var$absolutifyURLs(cssText, href) {
    return (cssText || "").replace($791ce2ee9eb5657b$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($791ce2ee9eb5657b$var$URL_PROTOCOL_MATCH.test(filePath) || $791ce2ee9eb5657b$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($791ce2ee9eb5657b$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$791ce2ee9eb5657b$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
function $791ce2ee9eb5657b$var$normalizeCssString(cssText, _testNoPxNorm = false) {
    if (_testNoPxNorm) return cssText.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "");
    else return cssText.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "").replace(/0px/g, "0");
}
function $791ce2ee9eb5657b$var$splitCssText(cssText, style, _testNoPxNorm = false) {
    const childNodes2 = Array.from(style.childNodes);
    const splits = [];
    let iterCount = 0;
    if (childNodes2.length > 1 && cssText && typeof cssText === "string") {
        let cssTextNorm = $791ce2ee9eb5657b$var$normalizeCssString(cssText, _testNoPxNorm);
        const normFactor = cssTextNorm.length / cssText.length;
        for(let i2 = 1; i2 < childNodes2.length; i2++)if (childNodes2[i2].textContent && typeof childNodes2[i2].textContent === "string") {
            const textContentNorm = $791ce2ee9eb5657b$var$normalizeCssString(childNodes2[i2].textContent, _testNoPxNorm);
            const jLimit = 100;
            let j = 3;
            for(; j < textContentNorm.length; j++){
                if (// keep consuming css identifiers (to get a decent chunk more quickly)
                textContentNorm[j].match(/[a-zA-Z0-9]/) || // substring needs to be unique to this section
                textContentNorm.indexOf(textContentNorm.substring(0, j), 1) !== -1) continue;
                break;
            }
            for(; j < textContentNorm.length; j++){
                let startSubstring = textContentNorm.substring(0, j);
                let cssNormSplits = cssTextNorm.split(startSubstring);
                let splitNorm = -1;
                if (cssNormSplits.length === 2) splitNorm = cssNormSplits[0].length;
                else if (cssNormSplits.length > 2 && cssNormSplits[0] === "" && childNodes2[i2 - 1].textContent !== "") splitNorm = cssTextNorm.indexOf(startSubstring, 1);
                else if (cssNormSplits.length === 1) {
                    startSubstring = startSubstring.substring(0, startSubstring.length - 1);
                    cssNormSplits = cssTextNorm.split(startSubstring);
                    if (cssNormSplits.length <= 1) {
                        splits.push(cssText);
                        return splits;
                    }
                    j = jLimit + 1;
                } else if (j === textContentNorm.length - 1) splitNorm = cssTextNorm.indexOf(startSubstring);
                if (cssNormSplits.length >= 2 && j > jLimit) {
                    const prevTextContent = childNodes2[i2 - 1].textContent;
                    if (prevTextContent && typeof prevTextContent === "string") {
                        const prevMinLength = $791ce2ee9eb5657b$var$normalizeCssString(prevTextContent).length;
                        splitNorm = cssTextNorm.indexOf(startSubstring, prevMinLength);
                    }
                    if (splitNorm === -1) splitNorm = cssNormSplits[0].length;
                }
                if (splitNorm !== -1) {
                    let k = Math.floor(splitNorm / normFactor);
                    for(; k > 0 && k < cssText.length;){
                        iterCount += 1;
                        if (iterCount > 50 * childNodes2.length) {
                            splits.push(cssText);
                            return splits;
                        }
                        const normPart = $791ce2ee9eb5657b$var$normalizeCssString(cssText.substring(0, k), _testNoPxNorm);
                        if (normPart.length === splitNorm) {
                            splits.push(cssText.substring(0, k));
                            cssText = cssText.substring(k);
                            cssTextNorm = cssTextNorm.substring(splitNorm);
                            break;
                        } else if (normPart.length < splitNorm) k += Math.max(1, Math.floor((splitNorm - normPart.length) / normFactor));
                        else k -= Math.max(1, Math.floor((normPart.length - splitNorm) * normFactor));
                    }
                    break;
                }
            }
        }
    }
    splits.push(cssText);
    return splits;
}
function $791ce2ee9eb5657b$var$markCssSplits(cssText, style) {
    return $791ce2ee9eb5657b$var$splitCssText(cssText, style).join("/* rr_split */");
}
let $791ce2ee9eb5657b$var$_id = 1;
const $791ce2ee9eb5657b$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $791ce2ee9eb5657b$var$IGNORED_NODE = -2;
function $791ce2ee9eb5657b$var$genId() {
    return $791ce2ee9eb5657b$var$_id++;
}
function $791ce2ee9eb5657b$var$getValidTagName$1(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $791ce2ee9eb5657b$var$toLowerCase(element.tagName);
    if ($791ce2ee9eb5657b$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
let $791ce2ee9eb5657b$var$canvasService;
let $791ce2ee9eb5657b$var$canvasCtx;
const $791ce2ee9eb5657b$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $791ce2ee9eb5657b$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $791ce2ee9eb5657b$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars2;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($791ce2ee9eb5657b$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($791ce2ee9eb5657b$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $791ce2ee9eb5657b$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $791ce2ee9eb5657b$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c2 = attributeValue.charAt(pos);
                if (c2 === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c2 === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c2 === "(") inParens = true;
                } else if (c2 === ")") inParens = false;
                descriptorsStr += c2;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
const $791ce2ee9eb5657b$var$cachedDocument = /* @__PURE__ */ new WeakMap();
function $791ce2ee9eb5657b$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $791ce2ee9eb5657b$var$getHref(doc, attributeValue);
}
function $791ce2ee9eb5657b$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $791ce2ee9eb5657b$var$getHref(doc, customHref) {
    let a2 = $791ce2ee9eb5657b$var$cachedDocument.get(doc);
    if (!a2) {
        a2 = doc.createElement("a");
        $791ce2ee9eb5657b$var$cachedDocument.set(doc, a2);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a2.setAttribute("href", customHref);
    return a2.href;
}
function $791ce2ee9eb5657b$var$transformAttribute(doc, tagName, name, value) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $791ce2ee9eb5657b$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $791ce2ee9eb5657b$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $791ce2ee9eb5657b$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $791ce2ee9eb5657b$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $791ce2ee9eb5657b$var$absolutifyURLs(value, $791ce2ee9eb5657b$var$getHref(doc));
    else if (tagName === "object" && name === "data") return $791ce2ee9eb5657b$var$absoluteToDoc(doc, value);
    return value;
}
function $791ce2ee9eb5657b$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $791ce2ee9eb5657b$var$_isBlockedElement(element, blockClass, blockSelector) {
    try {
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e2) {}
    return false;
}
function $791ce2ee9eb5657b$var$classMatchesRegex(node2, regex, checkAncestors) {
    if (!node2) return false;
    if (node2.nodeType !== node2.ELEMENT_NODE) {
        if (!checkAncestors) return false;
        return $791ce2ee9eb5657b$var$classMatchesRegex($791ce2ee9eb5657b$var$index$1.parentNode(node2), regex, checkAncestors);
    }
    for(let eIndex = node2.classList.length; eIndex--;){
        const className = node2.classList[eIndex];
        if (regex.test(className)) return true;
    }
    if (!checkAncestors) return false;
    return $791ce2ee9eb5657b$var$classMatchesRegex($791ce2ee9eb5657b$var$index$1.parentNode(node2), regex, checkAncestors);
}
function $791ce2ee9eb5657b$var$needMaskingText(node2, maskTextClass, maskTextSelector, checkAncestors) {
    let el;
    if ($791ce2ee9eb5657b$var$isElement(node2)) {
        el = node2;
        if (!$791ce2ee9eb5657b$var$index$1.childNodes(el).length) return false;
    } else if ($791ce2ee9eb5657b$var$index$1.parentElement(node2) === null) return false;
    else el = $791ce2ee9eb5657b$var$index$1.parentElement(node2);
    try {
        if (typeof maskTextClass === "string") {
            if (checkAncestors) {
                if (el.closest(`.${maskTextClass}`)) return true;
            } else {
                if (el.classList.contains(maskTextClass)) return true;
            }
        } else {
            if ($791ce2ee9eb5657b$var$classMatchesRegex(el, maskTextClass, checkAncestors)) return true;
        }
        if (maskTextSelector) {
            if (checkAncestors) {
                if (el.closest(maskTextSelector)) return true;
            } else {
                if (el.matches(maskTextSelector)) return true;
            }
        }
    } catch (e2) {}
    return false;
}
function $791ce2ee9eb5657b$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $791ce2ee9eb5657b$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $791ce2ee9eb5657b$var$serializeNode(n2, options) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, needsMask: needsMask, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, cssCaptured: cssCaptured = false } = options;
    const rootId = $791ce2ee9eb5657b$var$getRootId(doc, mirror2);
    switch(n2.nodeType){
        case n2.DOCUMENT_NODE:
            if (n2.compatMode !== "CSS1Compat") return {
                type: $791ce2ee9eb5657b$var$NodeType$3.Document,
                childNodes: [],
                compatMode: n2.compatMode
            };
            else return {
                type: $791ce2ee9eb5657b$var$NodeType$3.Document,
                childNodes: []
            };
        case n2.DOCUMENT_TYPE_NODE:
            return {
                type: $791ce2ee9eb5657b$var$NodeType$3.DocumentType,
                name: n2.name,
                publicId: n2.publicId,
                systemId: n2.systemId,
                rootId: rootId
            };
        case n2.ELEMENT_NODE:
            return $791ce2ee9eb5657b$var$serializeElementNode(n2, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId
            });
        case n2.TEXT_NODE:
            return $791ce2ee9eb5657b$var$serializeTextNode(n2, {
                doc: doc,
                needsMask: needsMask,
                maskTextFn: maskTextFn,
                rootId: rootId,
                cssCaptured: cssCaptured
            });
        case n2.CDATA_SECTION_NODE:
            return {
                type: $791ce2ee9eb5657b$var$NodeType$3.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n2.COMMENT_NODE:
            return {
                type: $791ce2ee9eb5657b$var$NodeType$3.Comment,
                textContent: $791ce2ee9eb5657b$var$index$1.textContent(n2) || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $791ce2ee9eb5657b$var$getRootId(doc, mirror2) {
    if (!mirror2.hasNode(doc)) return void 0;
    const docId = mirror2.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function $791ce2ee9eb5657b$var$serializeTextNode(n2, options) {
    const { needsMask: needsMask, maskTextFn: maskTextFn, rootId: rootId, cssCaptured: cssCaptured } = options;
    const parent = $791ce2ee9eb5657b$var$index$1.parentNode(n2);
    const parentTagName = parent && parent.tagName;
    let textContent2 = "";
    const isStyle = parentTagName === "STYLE" ? true : void 0;
    const isScript = parentTagName === "SCRIPT" ? true : void 0;
    if (isScript) textContent2 = "SCRIPT_PLACEHOLDER";
    else if (!cssCaptured) {
        textContent2 = $791ce2ee9eb5657b$var$index$1.textContent(n2);
        if (isStyle && textContent2) textContent2 = $791ce2ee9eb5657b$var$absolutifyURLs(textContent2, $791ce2ee9eb5657b$var$getHref(options.doc));
    }
    if (!isStyle && !isScript && textContent2 && needsMask) textContent2 = maskTextFn ? maskTextFn(textContent2, $791ce2ee9eb5657b$var$index$1.parentElement(n2)) : textContent2.replace(/[\S]/g, "*");
    return {
        type: $791ce2ee9eb5657b$var$NodeType$3.Text,
        textContent: textContent2 || "",
        rootId: rootId
    };
}
function $791ce2ee9eb5657b$var$serializeElementNode(n2, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId } = options;
    const needBlock = $791ce2ee9eb5657b$var$_isBlockedElement(n2, blockClass, blockSelector);
    const tagName = $791ce2ee9eb5657b$var$getValidTagName$1(n2);
    let attributes = {};
    const len = n2.attributes.length;
    for(let i2 = 0; i2 < len; i2++){
        const attr = n2.attributes[i2];
        if (!$791ce2ee9eb5657b$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $791ce2ee9eb5657b$var$transformAttribute(doc, tagName, $791ce2ee9eb5657b$var$toLowerCase(attr.name), attr.value);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s2)=>{
            return s2.href === n2.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $791ce2ee9eb5657b$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = cssText;
        }
    }
    if (tagName === "style" && n2.sheet) {
        let cssText = $791ce2ee9eb5657b$var$stringifyStylesheet(n2.sheet);
        if (cssText) {
            if (n2.childNodes.length > 1) cssText = $791ce2ee9eb5657b$var$markCssSplits(cssText, n2);
            attributes._cssText = cssText;
        }
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select") {
        const value = n2.value;
        const checked = n2.checked;
        if (attributes.type !== "radio" && attributes.type !== "checkbox" && attributes.type !== "submit" && attributes.type !== "button" && value) attributes.value = $791ce2ee9eb5657b$var$maskInputValue({
            element: n2,
            type: $791ce2ee9eb5657b$var$getInputType(n2),
            tagName: tagName,
            value: value,
            maskInputOptions: maskInputOptions,
            maskInputFn: maskInputFn
        });
        else if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n2.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "dialog" && n2.open) attributes.rr_open_mode = n2.matches("dialog:modal") ? "modal" : "non-modal";
    if (tagName === "canvas" && recordCanvas) {
        if (n2.__context === "2d") {
            if (!$791ce2ee9eb5657b$var$is2DCanvasBlank(n2)) attributes.rr_dataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n2)) {
            const canvasDataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n2.width;
            blankCanvas.height = n2.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$791ce2ee9eb5657b$var$canvasService) {
            $791ce2ee9eb5657b$var$canvasService = doc.createElement("canvas");
            $791ce2ee9eb5657b$var$canvasCtx = $791ce2ee9eb5657b$var$canvasService.getContext("2d");
        }
        const image = n2;
        const imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        const priorCrossOrigin = image.crossOrigin;
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $791ce2ee9eb5657b$var$canvasService.width = image.naturalWidth;
                $791ce2ee9eb5657b$var$canvasService.height = image.naturalHeight;
                $791ce2ee9eb5657b$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $791ce2ee9eb5657b$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn(`Cannot inline img src=${imageSrc}! Error: ${err}`);
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        const mediaAttributes = attributes;
        mediaAttributes.rr_mediaState = n2.paused ? "paused" : "played";
        mediaAttributes.rr_mediaCurrentTime = n2.currentTime;
        mediaAttributes.rr_mediaPlaybackRate = n2.playbackRate;
        mediaAttributes.rr_mediaMuted = n2.muted;
        mediaAttributes.rr_mediaLoop = n2.loop;
        mediaAttributes.rr_mediaVolume = n2.volume;
    }
    if (!newlyAddedElement) {
        if (n2.scrollLeft) attributes.rr_scrollLeft = n2.scrollLeft;
        if (n2.scrollTop) attributes.rr_scrollTop = n2.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n2.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n2.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e2) {}
    return {
        type: $791ce2ee9eb5657b$var$NodeType$3.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $791ce2ee9eb5657b$var$isSVGElement(n2) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $791ce2ee9eb5657b$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $791ce2ee9eb5657b$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $791ce2ee9eb5657b$var$NodeType$3.Comment) return true;
    else if (sn.type === $791ce2ee9eb5657b$var$NodeType$3.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $791ce2ee9eb5657b$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "application-name" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.rel) === "icon" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "robots" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "googlebot" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "author" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "generator" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "framework" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "publisher" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "progid" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "verification" || $791ce2ee9eb5657b$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $791ce2ee9eb5657b$var$serializeNodeWithId(n2, options) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, maskTextClass: maskTextClass, maskTextSelector: maskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5e3, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5e3, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false, cssCaptured: cssCaptured = false } = options;
    let { needsMask: needsMask } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    if (!needsMask) {
        const checkAncestors = needsMask === void 0;
        needsMask = $791ce2ee9eb5657b$var$needMaskingText(n2, maskTextClass, maskTextSelector, checkAncestors);
    }
    const _serializedNode = $791ce2ee9eb5657b$var$serializeNode(n2, {
        doc: doc,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        needsMask: needsMask,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement,
        cssCaptured: cssCaptured
    });
    if (!_serializedNode) {
        console.warn(n2, "not serialized");
        return null;
    }
    let id;
    if (mirror2.hasNode(n2)) id = mirror2.getId(n2);
    else if ($791ce2ee9eb5657b$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $791ce2ee9eb5657b$var$NodeType$3.Text && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $791ce2ee9eb5657b$var$IGNORED_NODE;
    else id = $791ce2ee9eb5657b$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror2.add(n2, serializedNode);
    if (id === $791ce2ee9eb5657b$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n2);
    let recordChild = !skipChild;
    if (serializedNode.type === $791ce2ee9eb5657b$var$NodeType$3.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRootEl = $791ce2ee9eb5657b$var$index$1.shadowRoot(n2);
        if (shadowRootEl && $791ce2ee9eb5657b$var$isNativeShadowDom(shadowRootEl)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $791ce2ee9eb5657b$var$NodeType$3.Document || serializedNode.type === $791ce2ee9eb5657b$var$NodeType$3.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $791ce2ee9eb5657b$var$NodeType$3.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror2,
            blockClass: blockClass,
            blockSelector: blockSelector,
            needsMask: needsMask,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn,
            cssCaptured: false
        };
        if (serializedNode.type === $791ce2ee9eb5657b$var$NodeType$3.Element && serializedNode.tagName === "textarea" && serializedNode.attributes.value !== void 0) ;
        else {
            if (serializedNode.type === $791ce2ee9eb5657b$var$NodeType$3.Element && serializedNode.attributes._cssText !== void 0 && typeof serializedNode.attributes._cssText === "string") bypassOptions.cssCaptured = true;
            for (const childN of Array.from($791ce2ee9eb5657b$var$index$1.childNodes(n2))){
                const serializedChildNode = $791ce2ee9eb5657b$var$serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
            }
        }
        let shadowRootEl = null;
        if ($791ce2ee9eb5657b$var$isElement(n2) && (shadowRootEl = $791ce2ee9eb5657b$var$index$1.shadowRoot(n2))) for (const childN of Array.from($791ce2ee9eb5657b$var$index$1.childNodes(shadowRootEl))){
            const serializedChildNode = $791ce2ee9eb5657b$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $791ce2ee9eb5657b$var$isNativeShadowDom(shadowRootEl) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    const parent = $791ce2ee9eb5657b$var$index$1.parentNode(n2);
    if (parent && $791ce2ee9eb5657b$var$isShadowRoot(parent) && $791ce2ee9eb5657b$var$isNativeShadowDom(parent)) serializedNode.isShadow = true;
    if (serializedNode.type === $791ce2ee9eb5657b$var$NodeType$3.Element && serializedNode.tagName === "iframe") $791ce2ee9eb5657b$var$onceIframeLoaded(n2, ()=>{
        const iframeDoc = n2.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $791ce2ee9eb5657b$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n2, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $791ce2ee9eb5657b$var$NodeType$3.Element && serializedNode.tagName === "link" && typeof serializedNode.attributes.rel === "string" && (serializedNode.attributes.rel === "stylesheet" || serializedNode.attributes.rel === "preload" && typeof serializedNode.attributes.href === "string" && $791ce2ee9eb5657b$var$extractFileExtension(serializedNode.attributes.href) === "css")) $791ce2ee9eb5657b$var$onceStylesheetLoaded(n2, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $791ce2ee9eb5657b$var$serializeNodeWithId(n2, {
                doc: doc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n2, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $791ce2ee9eb5657b$var$snapshot(n2, options) {
    const { mirror: mirror2 = new $791ce2ee9eb5657b$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, maskTextClass: maskTextClass = "rr-mask", maskTextSelector: maskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : maskAllInputs === false ? {
        password: true
    } : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? // if true: set of sensible options that should not throw away any information
    {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $791ce2ee9eb5657b$var$serializeNodeWithId(n2, {
        doc: n2,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
const $791ce2ee9eb5657b$var$MEDIA_SELECTOR = /(max|min)-device-(width|height)/;
const $791ce2ee9eb5657b$var$MEDIA_SELECTOR_GLOBAL = new RegExp($791ce2ee9eb5657b$var$MEDIA_SELECTOR.source, "g");
const $791ce2ee9eb5657b$var$mediaSelectorPlugin = {
    postcssPlugin: "postcss-custom-selectors",
    prepare () {
        return {
            postcssPlugin: "postcss-custom-selectors",
            AtRule: function(atrule) {
                if (atrule.params.match($791ce2ee9eb5657b$var$MEDIA_SELECTOR_GLOBAL)) atrule.params = atrule.params.replace($791ce2ee9eb5657b$var$MEDIA_SELECTOR_GLOBAL, "$1-$2");
            }
        };
    }
};
const $791ce2ee9eb5657b$var$pseudoClassPlugin = {
    postcssPlugin: "postcss-hover-classes",
    prepare: function() {
        const fixed = [];
        return {
            Rule: function(rule2) {
                if (fixed.indexOf(rule2) !== -1) return;
                fixed.push(rule2);
                rule2.selectors.forEach(function(selector) {
                    if (selector.includes(":hover")) rule2.selector += ",\n" + selector.replace(/:hover/g, ".\\:hover");
                });
            }
        };
    }
};
function $791ce2ee9eb5657b$var$getDefaultExportFromCjs$1(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function $791ce2ee9eb5657b$var$getAugmentedNamespace$1(n2) {
    if (n2.__esModule) return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
        var a2 = function a22() {
            if (this instanceof a22) return Reflect.construct(f2, arguments, this.constructor);
            return f2.apply(this, arguments);
        };
        a2.prototype = f2.prototype;
    } else a2 = {};
    Object.defineProperty(a2, "__esModule", {
        value: true
    });
    Object.keys(n2).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n2, k);
        Object.defineProperty(a2, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n2[k];
            }
        });
    });
    return a2;
}
var $791ce2ee9eb5657b$var$picocolors_browser$1 = {
    exports: {}
};
var $791ce2ee9eb5657b$var$x$1 = String;
var $791ce2ee9eb5657b$var$create$1 = function() {
    return {
        isColorSupported: false,
        reset: $791ce2ee9eb5657b$var$x$1,
        bold: $791ce2ee9eb5657b$var$x$1,
        dim: $791ce2ee9eb5657b$var$x$1,
        italic: $791ce2ee9eb5657b$var$x$1,
        underline: $791ce2ee9eb5657b$var$x$1,
        inverse: $791ce2ee9eb5657b$var$x$1,
        hidden: $791ce2ee9eb5657b$var$x$1,
        strikethrough: $791ce2ee9eb5657b$var$x$1,
        black: $791ce2ee9eb5657b$var$x$1,
        red: $791ce2ee9eb5657b$var$x$1,
        green: $791ce2ee9eb5657b$var$x$1,
        yellow: $791ce2ee9eb5657b$var$x$1,
        blue: $791ce2ee9eb5657b$var$x$1,
        magenta: $791ce2ee9eb5657b$var$x$1,
        cyan: $791ce2ee9eb5657b$var$x$1,
        white: $791ce2ee9eb5657b$var$x$1,
        gray: $791ce2ee9eb5657b$var$x$1,
        bgBlack: $791ce2ee9eb5657b$var$x$1,
        bgRed: $791ce2ee9eb5657b$var$x$1,
        bgGreen: $791ce2ee9eb5657b$var$x$1,
        bgYellow: $791ce2ee9eb5657b$var$x$1,
        bgBlue: $791ce2ee9eb5657b$var$x$1,
        bgMagenta: $791ce2ee9eb5657b$var$x$1,
        bgCyan: $791ce2ee9eb5657b$var$x$1,
        bgWhite: $791ce2ee9eb5657b$var$x$1
    };
};
$791ce2ee9eb5657b$var$picocolors_browser$1.exports = $791ce2ee9eb5657b$var$create$1();
$791ce2ee9eb5657b$var$picocolors_browser$1.exports.createColors = $791ce2ee9eb5657b$var$create$1;
var $791ce2ee9eb5657b$var$picocolors_browserExports$1 = $791ce2ee9eb5657b$var$picocolors_browser$1.exports;
const $791ce2ee9eb5657b$var$__viteBrowserExternal$2 = {};
const $791ce2ee9eb5657b$var$__viteBrowserExternal$1$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: $791ce2ee9eb5657b$var$__viteBrowserExternal$2
}, Symbol.toStringTag, {
    value: "Module"
}));
const $791ce2ee9eb5657b$var$require$$2$1 = /* @__PURE__ */ $791ce2ee9eb5657b$var$getAugmentedNamespace$1($791ce2ee9eb5657b$var$__viteBrowserExternal$1$1);
let $791ce2ee9eb5657b$var$pico$1 = $791ce2ee9eb5657b$var$picocolors_browserExports$1;
let $791ce2ee9eb5657b$var$terminalHighlight$1$1 = $791ce2ee9eb5657b$var$require$$2$1;
let $791ce2ee9eb5657b$var$CssSyntaxError$3$1 = class CssSyntaxError extends Error {
    constructor(message, line, column, source, file, plugin22){
        super(message);
        this.name = "CssSyntaxError";
        this.reason = message;
        if (file) this.file = file;
        if (source) this.source = source;
        if (plugin22) this.plugin = plugin22;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                this.line = line;
                this.column = column;
            } else {
                this.line = line.line;
                this.column = line.column;
                this.endLine = column.line;
                this.endColumn = column.column;
            }
        }
        this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(this, CssSyntaxError);
    }
    setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    }
    showSourceCode(color) {
        if (!this.source) return "";
        let css = this.source;
        if (color == null) color = $791ce2ee9eb5657b$var$pico$1.isColorSupported;
        if ($791ce2ee9eb5657b$var$terminalHighlight$1$1) {
            if (color) css = $791ce2ee9eb5657b$var$terminalHighlight$1$1(css);
        }
        let lines = css.split(/\r?\n/);
        let start = Math.max(this.line - 3, 0);
        let end = Math.min(this.line + 2, lines.length);
        let maxWidth = String(end).length;
        let mark, aside;
        if (color) {
            let { bold: bold, gray: gray, red: red } = $791ce2ee9eb5657b$var$pico$1.createColors(true);
            mark = (text)=>bold(red(text));
            aside = (text)=>gray(text);
        } else mark = aside = (str)=>str;
        return lines.slice(start, end).map((line, index2)=>{
            let number = start + 1 + index2;
            let gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === this.line) {
                let spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    }
    toString() {
        let code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    }
};
var $791ce2ee9eb5657b$var$cssSyntaxError$1 = $791ce2ee9eb5657b$var$CssSyntaxError$3$1;
$791ce2ee9eb5657b$var$CssSyntaxError$3$1.default = $791ce2ee9eb5657b$var$CssSyntaxError$3$1;
var $791ce2ee9eb5657b$var$symbols$1 = {};
$791ce2ee9eb5657b$var$symbols$1.isClean = Symbol("isClean");
$791ce2ee9eb5657b$var$symbols$1.my = Symbol("my");
const $791ce2ee9eb5657b$var$DEFAULT_RAW$1 = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $791ce2ee9eb5657b$var$capitalize$1(str) {
    return str[0].toUpperCase() + str.slice(1);
}
let $791ce2ee9eb5657b$var$Stringifier$2$1 = class Stringifier {
    constructor(builder){
        this.builder = builder;
    }
    atrule(node2, semicolon) {
        let name = "@" + node2.name;
        let params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") name += node2.raws.afterName;
        else if (params) name += " ";
        if (node2.nodes) this.block(node2, name + params);
        else {
            let end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    }
    beforeAfter(node2, detect) {
        let value;
        if (node2.type === "decl") value = this.raw(node2, null, "beforeDecl");
        else if (node2.type === "comment") value = this.raw(node2, null, "beforeComment");
        else if (detect === "before") value = this.raw(node2, null, "beforeRule");
        else value = this.raw(node2, null, "beforeClose");
        let buf = node2.parent;
        let depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            let indent = this.raw(node2, null, "indent");
            if (indent.length) for(let step = 0; step < depth; step++)value += indent;
        }
        return value;
    }
    block(node2, start) {
        let between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        let after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else after = this.raw(node2, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    }
    body(node2) {
        let last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        let semicolon = this.raw(node2, "semicolon");
        for(let i2 = 0; i2 < node2.nodes.length; i2++){
            let child = node2.nodes[i2];
            let before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i2 || semicolon);
        }
    }
    comment(node2) {
        let left = this.raw(node2, "left", "commentLeft");
        let right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    }
    decl(node2, semicolon) {
        let between = this.raw(node2, "between", "colon");
        let string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) string += node2.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node2);
    }
    document(node2) {
        this.body(node2);
    }
    raw(node2, own, detect) {
        let value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        let parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) return "";
            if (parent && parent.type === "document") return "";
        }
        if (!parent) return $791ce2ee9eb5657b$var$DEFAULT_RAW$1[detect];
        let root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") return root2.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node2, detect);
        else {
            let method = "raw" + $791ce2ee9eb5657b$var$capitalize$1(detect);
            if (this[method]) value = this[method](root2, node2);
            else root2.walk((i2)=>{
                value = i2.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $791ce2ee9eb5657b$var$DEFAULT_RAW$1[detect];
        root2.rawCache[detect] = value;
        return value;
    }
    rawBeforeClose(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && i2.nodes.length > 0) {
                if (typeof i2.raws.after !== "undefined") {
                    value = i2.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeComment(root2, node2) {
        let value;
        root2.walkComments((i2)=>{
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeDecl(root2, node2) {
        let value;
        root2.walkDecls((i2)=>{
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeOpen(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.type !== "decl") {
                value = i2.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawBeforeRule(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
                if (typeof i2.raws.before !== "undefined") {
                    value = i2.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawColon(root2) {
        let value;
        root2.walkDecls((i2)=>{
            if (typeof i2.raws.between !== "undefined") {
                value = i2.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    }
    rawEmptyBody(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && i2.nodes.length === 0) {
                value = i2.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        let value;
        root2.walk((i2)=>{
            let p = i2.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i2.raws.before !== "undefined") {
                    let parts = i2.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    }
    rawSemicolon(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
                value = i2.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawValue(node2, prop) {
        let value = node2[prop];
        let raw = node2.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    }
    root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    }
    rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) this.builder(node2.raws.ownSemicolon, node2, "end");
    }
    stringify(node2, semicolon) {
        if (!this[node2.type]) throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        this[node2.type](node2, semicolon);
    }
};
var $791ce2ee9eb5657b$var$stringifier$1 = $791ce2ee9eb5657b$var$Stringifier$2$1;
$791ce2ee9eb5657b$var$Stringifier$2$1.default = $791ce2ee9eb5657b$var$Stringifier$2$1;
let $791ce2ee9eb5657b$var$Stringifier$1$1 = $791ce2ee9eb5657b$var$stringifier$1;
function $791ce2ee9eb5657b$var$stringify$4$1(node2, builder) {
    let str = new $791ce2ee9eb5657b$var$Stringifier$1$1(builder);
    str.stringify(node2);
}
var $791ce2ee9eb5657b$var$stringify_1$1 = $791ce2ee9eb5657b$var$stringify$4$1;
$791ce2ee9eb5657b$var$stringify$4$1.default = $791ce2ee9eb5657b$var$stringify$4$1;
let { isClean: $791ce2ee9eb5657b$var$isClean$2$1, my: $791ce2ee9eb5657b$var$my$2$1 } = $791ce2ee9eb5657b$var$symbols$1;
let $791ce2ee9eb5657b$var$CssSyntaxError$2$1 = $791ce2ee9eb5657b$var$cssSyntaxError$1;
let $791ce2ee9eb5657b$var$Stringifier2$1 = $791ce2ee9eb5657b$var$stringifier$1;
let $791ce2ee9eb5657b$var$stringify$3$1 = $791ce2ee9eb5657b$var$stringify_1$1;
function $791ce2ee9eb5657b$var$cloneNode$1(obj, parent) {
    let cloned = new obj.constructor();
    for(let i2 in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i2)) continue;
        if (i2 === "proxyCache") continue;
        let value = obj[i2];
        let type = typeof value;
        if (i2 === "parent" && type === "object") {
            if (parent) cloned[i2] = parent;
        } else if (i2 === "source") cloned[i2] = value;
        else if (Array.isArray(value)) cloned[i2] = value.map((j)=>$791ce2ee9eb5657b$var$cloneNode$1(j, cloned));
        else {
            if (type === "object" && value !== null) value = $791ce2ee9eb5657b$var$cloneNode$1(value);
            cloned[i2] = value;
        }
    }
    return cloned;
}
let $791ce2ee9eb5657b$var$Node$4$1 = class Node2 {
    constructor(defaults = {}){
        this.raws = {};
        this[$791ce2ee9eb5657b$var$isClean$2$1] = false;
        this[$791ce2ee9eb5657b$var$my$2$1] = true;
        for(let name in defaults)if (name === "nodes") {
            this.nodes = [];
            for (let node2 of defaults[name])if (typeof node2.clone === "function") this.append(node2.clone());
            else this.append(node2);
        } else this[name] = defaults[name];
    }
    addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            let s2 = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, `$&${s2.input.from}:${s2.start.line}:${s2.start.column}$&`);
        }
        return error;
    }
    after(add) {
        this.parent.insertAfter(this, add);
        return this;
    }
    assign(overrides = {}) {
        for(let name in overrides)this[name] = overrides[name];
        return this;
    }
    before(add) {
        this.parent.insertBefore(this, add);
        return this;
    }
    cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    }
    clone(overrides = {}) {
        let cloned = $791ce2ee9eb5657b$var$cloneNode$1(this);
        for(let name in overrides)cloned[name] = overrides[name];
        return cloned;
    }
    cloneAfter(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    }
    cloneBefore(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    }
    error(message, opts = {}) {
        if (this.source) {
            let { end: end, start: start } = this.rangeBy(opts);
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $791ce2ee9eb5657b$var$CssSyntaxError$2$1(message);
    }
    getProxyProcessor() {
        return {
            get (node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (prop === "root") return ()=>node2.root().toProxy();
                else return node2[prop];
            },
            set (node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node2.markDirty();
                return true;
            }
        };
    }
    markDirty() {
        if (this[$791ce2ee9eb5657b$var$isClean$2$1]) {
            this[$791ce2ee9eb5657b$var$isClean$2$1] = false;
            let next = this;
            while(next = next.parent)next[$791ce2ee9eb5657b$var$isClean$2$1] = false;
        }
    }
    next() {
        if (!this.parent) return void 0;
        let index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    }
    positionBy(opts, stringRepresentation) {
        let pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            let index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    }
    positionInside(index2, stringRepresentation) {
        let string = stringRepresentation || this.toString();
        let column = this.source.start.column;
        let line = this.source.start.line;
        for(let i2 = 0; i2 < index2; i2++)if (string[i2] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    }
    prev() {
        if (!this.parent) return void 0;
        let index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    }
    rangeBy(opts) {
        let start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        let end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            let stringRepresentation = this.toString();
            let index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (typeof opts.endIndex === "number") end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    }
    raw(prop, defaultType) {
        let str = new $791ce2ee9eb5657b$var$Stringifier2$1();
        return str.raw(this, prop, defaultType);
    }
    remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = void 0;
        return this;
    }
    replaceWith(...nodes) {
        if (this.parent) {
            let bookmark = this;
            let foundSelf = false;
            for (let node2 of nodes){
                if (node2 === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else this.parent.insertBefore(bookmark, node2);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    }
    root() {
        let result2 = this;
        while(result2.parent && result2.parent.type !== "document")result2 = result2.parent;
        return result2;
    }
    toJSON(_, inputs) {
        let fixed = {};
        let emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        let inputsNextIndex = 0;
        for(let name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            let value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map((i2)=>{
                if (typeof i2 === "object" && i2.toJSON) return i2.toJSON(null, inputs);
                else return i2;
            });
            else if (typeof value === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                let inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [
            ...inputs.keys()
        ].map((input2)=>input2.toJSON());
        return fixed;
    }
    toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    }
    toString(stringifier2 = $791ce2ee9eb5657b$var$stringify$3$1) {
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        let result2 = "";
        stringifier2(this, (i2)=>{
            result2 += i2;
        });
        return result2;
    }
    warn(result2, text, opts) {
        let data = {
            node: this
        };
        for(let i2 in opts)data[i2] = opts[i2];
        return result2.warn(text, data);
    }
    get proxyOf() {
        return this;
    }
};
var $791ce2ee9eb5657b$var$node$1 = $791ce2ee9eb5657b$var$Node$4$1;
$791ce2ee9eb5657b$var$Node$4$1.default = $791ce2ee9eb5657b$var$Node$4$1;
let $791ce2ee9eb5657b$var$Node$3$1 = $791ce2ee9eb5657b$var$node$1;
let $791ce2ee9eb5657b$var$Declaration$4$1 = class Declaration extends $791ce2ee9eb5657b$var$Node$3$1 {
    constructor(defaults){
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = {
            ...defaults,
            value: String(defaults.value)
        };
        super(defaults);
        this.type = "decl";
    }
    get variable() {
        return this.prop.startsWith("--") || this.prop[0] === "$";
    }
};
var $791ce2ee9eb5657b$var$declaration$1 = $791ce2ee9eb5657b$var$Declaration$4$1;
$791ce2ee9eb5657b$var$Declaration$4$1.default = $791ce2ee9eb5657b$var$Declaration$4$1;
let $791ce2ee9eb5657b$var$urlAlphabet$1 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $791ce2ee9eb5657b$var$customAlphabet$1 = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i2 = size;
        while(i2--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $791ce2ee9eb5657b$var$nanoid$1$1 = (size = 21)=>{
    let id = "";
    let i2 = size;
    while(i2--)id += $791ce2ee9eb5657b$var$urlAlphabet$1[Math.random() * 64 | 0];
    return id;
};
var $791ce2ee9eb5657b$var$nonSecure$1 = {
    nanoid: $791ce2ee9eb5657b$var$nanoid$1$1,
    customAlphabet: $791ce2ee9eb5657b$var$customAlphabet$1
};
let { SourceMapConsumer: $791ce2ee9eb5657b$var$SourceMapConsumer$2$1, SourceMapGenerator: $791ce2ee9eb5657b$var$SourceMapGenerator$2$1 } = $791ce2ee9eb5657b$var$require$$2$1;
let { existsSync: $791ce2ee9eb5657b$var$existsSync$1, readFileSync: $791ce2ee9eb5657b$var$readFileSync$1 } = $791ce2ee9eb5657b$var$require$$2$1;
let { dirname: $791ce2ee9eb5657b$var$dirname$1$1, join: $791ce2ee9eb5657b$var$join$1 } = $791ce2ee9eb5657b$var$require$$2$1;
function $791ce2ee9eb5657b$var$fromBase64$1(str) {
    if ($791ce2ee9eb5657b$require$Buffer) return $791ce2ee9eb5657b$require$Buffer.from(str, "base64").toString();
    else return window.atob(str);
}
let $791ce2ee9eb5657b$var$PreviousMap$2$1 = class PreviousMap {
    constructor(css, opts){
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        let prev = opts.map ? opts.map.prev : void 0;
        let text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $791ce2ee9eb5657b$var$dirname$1$1(this.mapFile);
        if (text) this.text = text;
    }
    consumer() {
        if (!this.consumerCache) this.consumerCache = new $791ce2ee9eb5657b$var$SourceMapConsumer$2$1(this.text);
        return this.consumerCache;
    }
    decodeInline(text) {
        let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        let baseUri = /^data:application\/json;base64,/;
        let charsetUri = /^data:application\/json;charset=utf-?8,/;
        let uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $791ce2ee9eb5657b$var$fromBase64$1(text.substr(RegExp.lastMatch.length));
        let encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    }
    getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(map) {
        if (typeof map !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    }
    loadAnnotation(css) {
        let comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        let start = css.lastIndexOf(comments.pop());
        let end = css.indexOf("*/", start);
        if (start > -1 && end > -1) this.annotation = this.getAnnotationURL(css.substring(start, end));
    }
    loadFile(path) {
        this.root = $791ce2ee9eb5657b$var$dirname$1$1(path);
        if ($791ce2ee9eb5657b$var$existsSync$1(path)) {
            this.mapFile = path;
            return $791ce2ee9eb5657b$var$readFileSync$1(path, "utf-8").toString().trim();
        }
    }
    loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                let prevPath = prev(file);
                if (prevPath) {
                    let map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if (prev instanceof $791ce2ee9eb5657b$var$SourceMapConsumer$2$1) return $791ce2ee9eb5657b$var$SourceMapGenerator$2$1.fromSourceMap(prev).toString();
            else if (prev instanceof $791ce2ee9eb5657b$var$SourceMapGenerator$2$1) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            let map = this.annotation;
            if (file) map = $791ce2ee9eb5657b$var$join$1($791ce2ee9eb5657b$var$dirname$1$1(file), map);
            return this.loadFile(map);
        }
    }
    startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    }
    withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
};
var $791ce2ee9eb5657b$var$previousMap$1 = $791ce2ee9eb5657b$var$PreviousMap$2$1;
$791ce2ee9eb5657b$var$PreviousMap$2$1.default = $791ce2ee9eb5657b$var$PreviousMap$2$1;
let { SourceMapConsumer: $791ce2ee9eb5657b$var$SourceMapConsumer$1$1, SourceMapGenerator: $791ce2ee9eb5657b$var$SourceMapGenerator$1$1 } = $791ce2ee9eb5657b$var$require$$2$1;
let { fileURLToPath: $791ce2ee9eb5657b$var$fileURLToPath$1, pathToFileURL: $791ce2ee9eb5657b$var$pathToFileURL$1$1 } = $791ce2ee9eb5657b$var$require$$2$1;
let { isAbsolute: $791ce2ee9eb5657b$var$isAbsolute$1, resolve: $791ce2ee9eb5657b$var$resolve$1$1 } = $791ce2ee9eb5657b$var$require$$2$1;
let { nanoid: $791ce2ee9eb5657b$var$nanoid$2 } = $791ce2ee9eb5657b$var$nonSecure$1;
let $791ce2ee9eb5657b$var$terminalHighlight$2 = $791ce2ee9eb5657b$var$require$$2$1;
let $791ce2ee9eb5657b$var$CssSyntaxError$1$1 = $791ce2ee9eb5657b$var$cssSyntaxError$1;
let $791ce2ee9eb5657b$var$PreviousMap$1$1 = $791ce2ee9eb5657b$var$previousMap$1;
let $791ce2ee9eb5657b$var$fromOffsetCache$1 = Symbol("fromOffsetCache");
let $791ce2ee9eb5657b$var$sourceMapAvailable$1$1 = Boolean($791ce2ee9eb5657b$var$SourceMapConsumer$1$1 && $791ce2ee9eb5657b$var$SourceMapGenerator$1$1);
let $791ce2ee9eb5657b$var$pathAvailable$1$1 = Boolean($791ce2ee9eb5657b$var$resolve$1$1 && $791ce2ee9eb5657b$var$isAbsolute$1);
let $791ce2ee9eb5657b$var$Input$4$1 = class Input {
    constructor(css, opts = {}){
        if (css === null || typeof css === "undefined" || typeof css === "object" && !css.toString) throw new Error(`PostCSS received ${css} instead of CSS string`);
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$791ce2ee9eb5657b$var$pathAvailable$1$1 || /^\w+:\/\//.test(opts.from) || $791ce2ee9eb5657b$var$isAbsolute$1(opts.from)) this.file = opts.from;
            else this.file = $791ce2ee9eb5657b$var$resolve$1$1(opts.from);
        }
        if ($791ce2ee9eb5657b$var$pathAvailable$1$1 && $791ce2ee9eb5657b$var$sourceMapAvailable$1$1) {
            let map = new $791ce2ee9eb5657b$var$PreviousMap$1$1(this.css, opts);
            if (map.text) {
                this.map = map;
                let file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $791ce2ee9eb5657b$var$nanoid$2(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    error(message, line, column, opts = {}) {
        let result2, endLine, endColumn;
        if (line && typeof line === "object") {
            let start = line;
            let end = column;
            if (typeof start.offset === "number") {
                let pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                let pos = this.fromOffset(end.offset);
                endLine = pos.line;
                endColumn = pos.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            let pos = this.fromOffset(line);
            line = pos.line;
            column = pos.col;
        }
        let origin = this.origin(line, column, endLine, endColumn);
        if (origin) result2 = new $791ce2ee9eb5657b$var$CssSyntaxError$1$1(message, origin.endLine === void 0 ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === void 0 ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result2 = new $791ce2ee9eb5657b$var$CssSyntaxError$1$1(message, endLine === void 0 ? line : {
            column: column,
            line: line
        }, endLine === void 0 ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result2.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($791ce2ee9eb5657b$var$pathToFileURL$1$1) result2.input.url = $791ce2ee9eb5657b$var$pathToFileURL$1$1(this.file).toString();
            result2.input.file = this.file;
        }
        return result2;
    }
    fromOffset(offset) {
        let lastLine, lineToIndex;
        if (!this[$791ce2ee9eb5657b$var$fromOffsetCache$1]) {
            let lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            let prevIndex = 0;
            for(let i2 = 0, l2 = lines.length; i2 < l2; i2++){
                lineToIndex[i2] = prevIndex;
                prevIndex += lines[i2].length + 1;
            }
            this[$791ce2ee9eb5657b$var$fromOffsetCache$1] = lineToIndex;
        } else lineToIndex = this[$791ce2ee9eb5657b$var$fromOffsetCache$1];
        lastLine = lineToIndex[lineToIndex.length - 1];
        let min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            let max = lineToIndex.length - 2;
            let mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    }
    mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $791ce2ee9eb5657b$var$resolve$1$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    }
    origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        let consumer = this.map.consumer();
        let from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        let to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        let fromUrl;
        if ($791ce2ee9eb5657b$var$isAbsolute$1(from.source)) fromUrl = $791ce2ee9eb5657b$var$pathToFileURL$1$1(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $791ce2ee9eb5657b$var$pathToFileURL$1$1(this.map.mapFile));
        let result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($791ce2ee9eb5657b$var$fileURLToPath$1) result2.file = $791ce2ee9eb5657b$var$fileURLToPath$1(fromUrl);
            else throw new Error(`file: protocol is not available in this PostCSS build`);
        }
        let source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    }
    toJSON() {
        let json = {};
        for (let name of [
            "hasBOM",
            "css",
            "file",
            "id"
        ])if (this[name] != null) json[name] = this[name];
        if (this.map) {
            json.map = {
                ...this.map
            };
            if (json.map.consumerCache) json.map.consumerCache = void 0;
        }
        return json;
    }
    get from() {
        return this.file || this.id;
    }
};
var $791ce2ee9eb5657b$var$input$1 = $791ce2ee9eb5657b$var$Input$4$1;
$791ce2ee9eb5657b$var$Input$4$1.default = $791ce2ee9eb5657b$var$Input$4$1;
if ($791ce2ee9eb5657b$var$terminalHighlight$2 && $791ce2ee9eb5657b$var$terminalHighlight$2.registerInput) $791ce2ee9eb5657b$var$terminalHighlight$2.registerInput($791ce2ee9eb5657b$var$Input$4$1);
let { SourceMapConsumer: $791ce2ee9eb5657b$var$SourceMapConsumer$3, SourceMapGenerator: $791ce2ee9eb5657b$var$SourceMapGenerator$3 } = $791ce2ee9eb5657b$var$require$$2$1;
let { dirname: $791ce2ee9eb5657b$var$dirname$2, relative: $791ce2ee9eb5657b$var$relative$1, resolve: $791ce2ee9eb5657b$var$resolve$2, sep: $791ce2ee9eb5657b$var$sep$1 } = $791ce2ee9eb5657b$var$require$$2$1;
let { pathToFileURL: $791ce2ee9eb5657b$var$pathToFileURL$2 } = $791ce2ee9eb5657b$var$require$$2$1;
let $791ce2ee9eb5657b$var$Input$3$1 = $791ce2ee9eb5657b$var$input$1;
let $791ce2ee9eb5657b$var$sourceMapAvailable$2 = Boolean($791ce2ee9eb5657b$var$SourceMapConsumer$3 && $791ce2ee9eb5657b$var$SourceMapGenerator$3);
let $791ce2ee9eb5657b$var$pathAvailable$2 = Boolean($791ce2ee9eb5657b$var$dirname$2 && $791ce2ee9eb5657b$var$resolve$2 && $791ce2ee9eb5657b$var$relative$1 && $791ce2ee9eb5657b$var$sep$1);
let $791ce2ee9eb5657b$var$MapGenerator$2$1 = class MapGenerator {
    constructor(stringify2, root2, opts, cssString){
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
        let content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        let eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    }
    applyPrevMaps() {
        for (let prev of this.previous()){
            let from = this.toUrl(this.path(prev.file));
            let root2 = prev.root || $791ce2ee9eb5657b$var$dirname$2(prev.file);
            let map;
            if (this.mapOpts.sourcesContent === false) {
                map = new $791ce2ee9eb5657b$var$SourceMapConsumer$3(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    }
    clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            let node2;
            for(let i2 = this.root.nodes.length - 1; i2 >= 0; i2--){
                node2 = this.root.nodes[i2];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i2);
            }
        } else if (this.css) this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
    }
    generate() {
        this.clearAnnotation();
        if ($791ce2ee9eb5657b$var$pathAvailable$2 && $791ce2ee9eb5657b$var$sourceMapAvailable$2 && this.isMap()) return this.generateMap();
        else {
            let result2 = "";
            this.stringify(this.root, (i2)=>{
                result2 += i2;
            });
            return [
                result2
            ];
        }
    }
    generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            let prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $791ce2ee9eb5657b$var$SourceMapGenerator$3.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $791ce2ee9eb5657b$var$SourceMapGenerator$3({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    }
    generateString() {
        this.css = "";
        this.map = new $791ce2ee9eb5657b$var$SourceMapGenerator$3({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        let line = 1;
        let column = 1;
        let noSource = "<no source>";
        let mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        let lines, last;
        this.stringify(this.root, (str, node2, type)=>{
            this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node2 && type !== "start") {
                let p = node2.parent || {
                    raws: {}
                };
                let childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        this.map.addMapping(mapping);
                    }
                }
            }
        });
    }
    isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some((i2)=>i2.annotation);
        return true;
    }
    isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        let annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some((i2)=>i2.inline);
        return true;
    }
    isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    }
    isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some((i2)=>i2.withContent());
        return true;
    }
    outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    }
    path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        let cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        let from = this.opts.to ? $791ce2ee9eb5657b$var$dirname$2(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $791ce2ee9eb5657b$var$dirname$2($791ce2ee9eb5657b$var$resolve$2(from, this.mapOpts.annotation));
        let path = $791ce2ee9eb5657b$var$relative$1(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    }
    previous() {
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk((node2)=>{
                if (node2.source && node2.source.input.map) {
                    let map = node2.source.input.map;
                    if (!this.previousMaps.includes(map)) this.previousMaps.push(map);
                }
            });
            else {
                let input2 = new $791ce2ee9eb5657b$var$Input$3$1(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    }
    setSourcesContent() {
        let already = {};
        if (this.root) this.root.walk((node2)=>{
            if (node2.source) {
                let from = node2.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
                    this.map.setSourceContent(fromUrl, node2.source.input.css);
                }
            }
        });
        else if (this.css) {
            let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    }
    sourcePath(node2) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node2.source.input.from);
        else return this.toUrl(this.path(node2.source.input.from));
    }
    toBase64(str) {
        if ($791ce2ee9eb5657b$require$Buffer) return $791ce2ee9eb5657b$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    }
    toFileUrl(path) {
        let cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($791ce2ee9eb5657b$var$pathToFileURL$2) {
            let fileURL = $791ce2ee9eb5657b$var$pathToFileURL$2(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error("`map.absolute` option is not available in this PostCSS build");
    }
    toUrl(path) {
        let cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($791ce2ee9eb5657b$var$sep$1 === "\\") path = path.replace(/\\/g, "/");
        let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    }
};
var $791ce2ee9eb5657b$var$mapGenerator$1 = $791ce2ee9eb5657b$var$MapGenerator$2$1;
let $791ce2ee9eb5657b$var$Node$2$1 = $791ce2ee9eb5657b$var$node$1;
let $791ce2ee9eb5657b$var$Comment$4$1 = class Comment extends $791ce2ee9eb5657b$var$Node$2$1 {
    constructor(defaults){
        super(defaults);
        this.type = "comment";
    }
};
var $791ce2ee9eb5657b$var$comment$1 = $791ce2ee9eb5657b$var$Comment$4$1;
$791ce2ee9eb5657b$var$Comment$4$1.default = $791ce2ee9eb5657b$var$Comment$4$1;
let { isClean: $791ce2ee9eb5657b$var$isClean$1$1, my: $791ce2ee9eb5657b$var$my$1$1 } = $791ce2ee9eb5657b$var$symbols$1;
let $791ce2ee9eb5657b$var$Declaration$3$1 = $791ce2ee9eb5657b$var$declaration$1;
let $791ce2ee9eb5657b$var$Comment$3$1 = $791ce2ee9eb5657b$var$comment$1;
let $791ce2ee9eb5657b$var$Node$1$1 = $791ce2ee9eb5657b$var$node$1;
let $791ce2ee9eb5657b$var$parse$4$1, $791ce2ee9eb5657b$var$Rule$4$1, $791ce2ee9eb5657b$var$AtRule$4$1, $791ce2ee9eb5657b$var$Root$6$1;
function $791ce2ee9eb5657b$var$cleanSource$1(nodes) {
    return nodes.map((i2)=>{
        if (i2.nodes) i2.nodes = $791ce2ee9eb5657b$var$cleanSource$1(i2.nodes);
        delete i2.source;
        return i2;
    });
}
function $791ce2ee9eb5657b$var$markDirtyUp$1(node2) {
    node2[$791ce2ee9eb5657b$var$isClean$1$1] = false;
    if (node2.proxyOf.nodes) for (let i2 of node2.proxyOf.nodes)$791ce2ee9eb5657b$var$markDirtyUp$1(i2);
}
let $791ce2ee9eb5657b$var$Container$7$1 = class Container extends $791ce2ee9eb5657b$var$Node$1$1 {
    append(...children) {
        for (let child of children){
            let nodes = this.normalize(child, this.last);
            for (let node2 of nodes)this.proxyOf.nodes.push(node2);
        }
        this.markDirty();
        return this;
    }
    cleanRaws(keepBetween) {
        super.cleanRaws(keepBetween);
        if (this.nodes) for (let node2 of this.nodes)node2.cleanRaws(keepBetween);
    }
    each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        let iterator = this.getIterator();
        let index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    }
    every(condition) {
        return this.nodes.every(condition);
    }
    getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        let iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    }
    getProxyProcessor() {
        return {
            get (node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (!node2[prop]) return node2[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return (...args)=>{
                    return node2[prop](...args.map((i2)=>{
                        if (typeof i2 === "function") return (child, index2)=>i2(child.toProxy(), index2);
                        else return i2;
                    }));
                };
                else if (prop === "every" || prop === "some") return (cb)=>{
                    return node2[prop]((child, ...other)=>cb(child.toProxy(), ...other));
                };
                else if (prop === "root") return ()=>node2.root().toProxy();
                else if (prop === "nodes") return node2.nodes.map((i2)=>i2.toProxy());
                else if (prop === "first" || prop === "last") return node2[prop].toProxy();
                else return node2[prop];
            },
            set (node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node2.markDirty();
                return true;
            }
        };
    }
    index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    }
    insertAfter(exist, add) {
        let existIndex = this.index(exist);
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for (let node2 of nodes)this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    }
    insertBefore(exist, add) {
        let existIndex = this.index(exist);
        let type = existIndex === 0 ? "prepend" : false;
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for (let node2 of nodes)this.proxyOf.nodes.splice(existIndex, 0, node2);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    }
    normalize(nodes, sample) {
        if (typeof nodes === "string") nodes = $791ce2ee9eb5657b$var$cleanSource$1($791ce2ee9eb5657b$var$parse$4$1(nodes).nodes);
        else if (typeof nodes === "undefined") nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for (let i2 of nodes)if (i2.parent) i2.parent.removeChild(i2, "ignore");
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for (let i2 of nodes)if (i2.parent) i2.parent.removeChild(i2, "ignore");
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $791ce2ee9eb5657b$var$Declaration$3$1(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $791ce2ee9eb5657b$var$Rule$4$1(nodes)
        ];
        else if (nodes.name) nodes = [
            new $791ce2ee9eb5657b$var$AtRule$4$1(nodes)
        ];
        else if (nodes.text) nodes = [
            new $791ce2ee9eb5657b$var$Comment$3$1(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        let processed = nodes.map((i2)=>{
            if (!i2[$791ce2ee9eb5657b$var$my$1$1]) Container.rebuild(i2);
            i2 = i2.proxyOf;
            if (i2.parent) i2.parent.removeChild(i2);
            if (i2[$791ce2ee9eb5657b$var$isClean$1$1]) $791ce2ee9eb5657b$var$markDirtyUp$1(i2);
            if (typeof i2.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i2.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i2.parent = this.proxyOf;
            return i2;
        });
        return processed;
    }
    prepend(...children) {
        children = children.reverse();
        for (let child of children){
            let nodes = this.normalize(child, this.first, "prepend").reverse();
            for (let node2 of nodes)this.proxyOf.nodes.unshift(node2);
            for(let id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    }
    push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    }
    removeAll() {
        for (let node2 of this.proxyOf.nodes)node2.parent = void 0;
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    }
    removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) this.indexes[id] = index2 - 1;
        }
        this.markDirty();
        return this;
    }
    replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls((decl)=>{
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    }
    some(condition) {
        return this.nodes.some(condition);
    }
    walk(callback) {
        return this.each((child, i2)=>{
            let result2;
            try {
                result2 = callback(child, i2);
            } catch (e2) {
                throw child.addToError(e2);
            }
            if (result2 !== false && child.walk) result2 = child.walk(callback);
            return result2;
        });
    }
    walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk((child, i2)=>{
                if (child.type === "atrule") return callback(child, i2);
            });
        }
        if (name instanceof RegExp) return this.walk((child, i2)=>{
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i2);
        });
        return this.walk((child, i2)=>{
            if (child.type === "atrule" && child.name === name) return callback(child, i2);
        });
    }
    walkComments(callback) {
        return this.walk((child, i2)=>{
            if (child.type === "comment") return callback(child, i2);
        });
    }
    walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk((child, i2)=>{
                if (child.type === "decl") return callback(child, i2);
            });
        }
        if (prop instanceof RegExp) return this.walk((child, i2)=>{
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i2);
        });
        return this.walk((child, i2)=>{
            if (child.type === "decl" && child.prop === prop) return callback(child, i2);
        });
    }
    walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk((child, i2)=>{
                if (child.type === "rule") return callback(child, i2);
            });
        }
        if (selector instanceof RegExp) return this.walk((child, i2)=>{
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i2);
        });
        return this.walk((child, i2)=>{
            if (child.type === "rule" && child.selector === selector) return callback(child, i2);
        });
    }
    get first() {
        if (!this.proxyOf.nodes) return void 0;
        return this.proxyOf.nodes[0];
    }
    get last() {
        if (!this.proxyOf.nodes) return void 0;
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
};
$791ce2ee9eb5657b$var$Container$7$1.registerParse = (dependant)=>{
    $791ce2ee9eb5657b$var$parse$4$1 = dependant;
};
$791ce2ee9eb5657b$var$Container$7$1.registerRule = (dependant)=>{
    $791ce2ee9eb5657b$var$Rule$4$1 = dependant;
};
$791ce2ee9eb5657b$var$Container$7$1.registerAtRule = (dependant)=>{
    $791ce2ee9eb5657b$var$AtRule$4$1 = dependant;
};
$791ce2ee9eb5657b$var$Container$7$1.registerRoot = (dependant)=>{
    $791ce2ee9eb5657b$var$Root$6$1 = dependant;
};
var $791ce2ee9eb5657b$var$container$1 = $791ce2ee9eb5657b$var$Container$7$1;
$791ce2ee9eb5657b$var$Container$7$1.default = $791ce2ee9eb5657b$var$Container$7$1;
$791ce2ee9eb5657b$var$Container$7$1.rebuild = (node2)=>{
    if (node2.type === "atrule") Object.setPrototypeOf(node2, $791ce2ee9eb5657b$var$AtRule$4$1.prototype);
    else if (node2.type === "rule") Object.setPrototypeOf(node2, $791ce2ee9eb5657b$var$Rule$4$1.prototype);
    else if (node2.type === "decl") Object.setPrototypeOf(node2, $791ce2ee9eb5657b$var$Declaration$3$1.prototype);
    else if (node2.type === "comment") Object.setPrototypeOf(node2, $791ce2ee9eb5657b$var$Comment$3$1.prototype);
    else if (node2.type === "root") Object.setPrototypeOf(node2, $791ce2ee9eb5657b$var$Root$6$1.prototype);
    node2[$791ce2ee9eb5657b$var$my$1$1] = true;
    if (node2.nodes) node2.nodes.forEach((child)=>{
        $791ce2ee9eb5657b$var$Container$7$1.rebuild(child);
    });
};
let $791ce2ee9eb5657b$var$Container$6$1 = $791ce2ee9eb5657b$var$container$1;
let $791ce2ee9eb5657b$var$LazyResult$4$1, $791ce2ee9eb5657b$var$Processor$3$1;
let $791ce2ee9eb5657b$var$Document$3$1 = class Document2 extends $791ce2ee9eb5657b$var$Container$6$1 {
    constructor(defaults){
        super({
            type: "document",
            ...defaults
        });
        if (!this.nodes) this.nodes = [];
    }
    toResult(opts = {}) {
        let lazy = new $791ce2ee9eb5657b$var$LazyResult$4$1(new $791ce2ee9eb5657b$var$Processor$3$1(), this, opts);
        return lazy.stringify();
    }
};
$791ce2ee9eb5657b$var$Document$3$1.registerLazyResult = (dependant)=>{
    $791ce2ee9eb5657b$var$LazyResult$4$1 = dependant;
};
$791ce2ee9eb5657b$var$Document$3$1.registerProcessor = (dependant)=>{
    $791ce2ee9eb5657b$var$Processor$3$1 = dependant;
};
var $791ce2ee9eb5657b$var$document$1$1 = $791ce2ee9eb5657b$var$Document$3$1;
$791ce2ee9eb5657b$var$Document$3$1.default = $791ce2ee9eb5657b$var$Document$3$1;
let $791ce2ee9eb5657b$var$printed$1 = {};
var $791ce2ee9eb5657b$var$warnOnce$2$1 = function warnOnce(message) {
    if ($791ce2ee9eb5657b$var$printed$1[message]) return;
    $791ce2ee9eb5657b$var$printed$1[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};
let $791ce2ee9eb5657b$var$Warning$2$1 = class Warning {
    constructor(text, opts = {}){
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            let range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(let opt in opts)this[opt] = opts[opt];
    }
    toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    }
};
var $791ce2ee9eb5657b$var$warning$1 = $791ce2ee9eb5657b$var$Warning$2$1;
$791ce2ee9eb5657b$var$Warning$2$1.default = $791ce2ee9eb5657b$var$Warning$2$1;
let $791ce2ee9eb5657b$var$Warning$1$1 = $791ce2ee9eb5657b$var$warning$1;
let $791ce2ee9eb5657b$var$Result$3$1 = class Result {
    constructor(processor2, root2, opts){
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
    toString() {
        return this.css;
    }
    warn(text, opts = {}) {
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        let warning2 = new $791ce2ee9eb5657b$var$Warning$1$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    }
    warnings() {
        return this.messages.filter((i2)=>i2.type === "warning");
    }
    get content() {
        return this.css;
    }
};
var $791ce2ee9eb5657b$var$result$1 = $791ce2ee9eb5657b$var$Result$3$1;
$791ce2ee9eb5657b$var$Result$3$1.default = $791ce2ee9eb5657b$var$Result$3$1;
const $791ce2ee9eb5657b$var$SINGLE_QUOTE$1 = "'".charCodeAt(0);
const $791ce2ee9eb5657b$var$DOUBLE_QUOTE$1 = '"'.charCodeAt(0);
const $791ce2ee9eb5657b$var$BACKSLASH$1 = "\\".charCodeAt(0);
const $791ce2ee9eb5657b$var$SLASH$1 = "/".charCodeAt(0);
const $791ce2ee9eb5657b$var$NEWLINE$1 = "\n".charCodeAt(0);
const $791ce2ee9eb5657b$var$SPACE$1 = " ".charCodeAt(0);
const $791ce2ee9eb5657b$var$FEED$1 = "\f".charCodeAt(0);
const $791ce2ee9eb5657b$var$TAB$1 = "	".charCodeAt(0);
const $791ce2ee9eb5657b$var$CR$1 = "\r".charCodeAt(0);
const $791ce2ee9eb5657b$var$OPEN_SQUARE$1 = "[".charCodeAt(0);
const $791ce2ee9eb5657b$var$CLOSE_SQUARE$1 = "]".charCodeAt(0);
const $791ce2ee9eb5657b$var$OPEN_PARENTHESES$1 = "(".charCodeAt(0);
const $791ce2ee9eb5657b$var$CLOSE_PARENTHESES$1 = ")".charCodeAt(0);
const $791ce2ee9eb5657b$var$OPEN_CURLY$1 = "{".charCodeAt(0);
const $791ce2ee9eb5657b$var$CLOSE_CURLY$1 = "}".charCodeAt(0);
const $791ce2ee9eb5657b$var$SEMICOLON$1 = ";".charCodeAt(0);
const $791ce2ee9eb5657b$var$ASTERISK$1 = "*".charCodeAt(0);
const $791ce2ee9eb5657b$var$COLON$1 = ":".charCodeAt(0);
const $791ce2ee9eb5657b$var$AT$1 = "@".charCodeAt(0);
const $791ce2ee9eb5657b$var$RE_AT_END$1 = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const $791ce2ee9eb5657b$var$RE_WORD_END$1 = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const $791ce2ee9eb5657b$var$RE_BAD_BRACKET$1 = /.[\r\n"'(/\\]/;
const $791ce2ee9eb5657b$var$RE_HEX_ESCAPE$1 = /[\da-f]/i;
var $791ce2ee9eb5657b$var$tokenize$1 = function tokenizer(input2, options = {}) {
    let css = input2.css.valueOf();
    let ignore = options.ignoreErrors;
    let code, next, quote, content, escape;
    let escaped, escapePos, prev, n2, currentToken;
    let length = css.length;
    let pos = 0;
    let buffer = [];
    let returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $791ce2ee9eb5657b$var$NEWLINE$1:
            case $791ce2ee9eb5657b$var$SPACE$1:
            case $791ce2ee9eb5657b$var$TAB$1:
            case $791ce2ee9eb5657b$var$CR$1:
            case $791ce2ee9eb5657b$var$FEED$1:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $791ce2ee9eb5657b$var$SPACE$1 || code === $791ce2ee9eb5657b$var$NEWLINE$1 || code === $791ce2ee9eb5657b$var$TAB$1 || code === $791ce2ee9eb5657b$var$CR$1 || code === $791ce2ee9eb5657b$var$FEED$1);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $791ce2ee9eb5657b$var$OPEN_SQUARE$1:
            case $791ce2ee9eb5657b$var$CLOSE_SQUARE$1:
            case $791ce2ee9eb5657b$var$OPEN_CURLY$1:
            case $791ce2ee9eb5657b$var$CLOSE_CURLY$1:
            case $791ce2ee9eb5657b$var$COLON$1:
            case $791ce2ee9eb5657b$var$SEMICOLON$1:
            case $791ce2ee9eb5657b$var$CLOSE_PARENTHESES$1:
                {
                    let controlChar = String.fromCharCode(code);
                    currentToken = [
                        controlChar,
                        controlChar,
                        pos
                    ];
                    break;
                }
            case $791ce2ee9eb5657b$var$OPEN_PARENTHESES$1:
                prev = buffer.length ? buffer.pop()[1] : "";
                n2 = css.charCodeAt(pos + 1);
                if (prev === "url" && n2 !== $791ce2ee9eb5657b$var$SINGLE_QUOTE$1 && n2 !== $791ce2ee9eb5657b$var$DOUBLE_QUOTE$1 && n2 !== $791ce2ee9eb5657b$var$SPACE$1 && n2 !== $791ce2ee9eb5657b$var$NEWLINE$1 && n2 !== $791ce2ee9eb5657b$var$TAB$1 && n2 !== $791ce2ee9eb5657b$var$FEED$1 && n2 !== $791ce2ee9eb5657b$var$CR$1) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $791ce2ee9eb5657b$var$BACKSLASH$1){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $791ce2ee9eb5657b$var$RE_BAD_BRACKET$1.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $791ce2ee9eb5657b$var$SINGLE_QUOTE$1:
            case $791ce2ee9eb5657b$var$DOUBLE_QUOTE$1:
                quote = code === $791ce2ee9eb5657b$var$SINGLE_QUOTE$1 ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $791ce2ee9eb5657b$var$BACKSLASH$1){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $791ce2ee9eb5657b$var$AT$1:
                $791ce2ee9eb5657b$var$RE_AT_END$1.lastIndex = pos + 1;
                $791ce2ee9eb5657b$var$RE_AT_END$1.test(css);
                if ($791ce2ee9eb5657b$var$RE_AT_END$1.lastIndex === 0) next = css.length - 1;
                else next = $791ce2ee9eb5657b$var$RE_AT_END$1.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $791ce2ee9eb5657b$var$BACKSLASH$1:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $791ce2ee9eb5657b$var$BACKSLASH$1){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $791ce2ee9eb5657b$var$SLASH$1 && code !== $791ce2ee9eb5657b$var$SPACE$1 && code !== $791ce2ee9eb5657b$var$NEWLINE$1 && code !== $791ce2ee9eb5657b$var$TAB$1 && code !== $791ce2ee9eb5657b$var$CR$1 && code !== $791ce2ee9eb5657b$var$FEED$1) {
                    next += 1;
                    if ($791ce2ee9eb5657b$var$RE_HEX_ESCAPE$1.test(css.charAt(next))) {
                        while($791ce2ee9eb5657b$var$RE_HEX_ESCAPE$1.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $791ce2ee9eb5657b$var$SPACE$1) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $791ce2ee9eb5657b$var$SLASH$1 && css.charCodeAt(pos + 1) === $791ce2ee9eb5657b$var$ASTERISK$1) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $791ce2ee9eb5657b$var$RE_WORD_END$1.lastIndex = pos + 1;
                    $791ce2ee9eb5657b$var$RE_WORD_END$1.test(css);
                    if ($791ce2ee9eb5657b$var$RE_WORD_END$1.lastIndex === 0) next = css.length - 1;
                    else next = $791ce2ee9eb5657b$var$RE_WORD_END$1.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};
let $791ce2ee9eb5657b$var$Container$5$1 = $791ce2ee9eb5657b$var$container$1;
let $791ce2ee9eb5657b$var$AtRule$3$1 = class AtRule extends $791ce2ee9eb5657b$var$Container$5$1 {
    constructor(defaults){
        super(defaults);
        this.type = "atrule";
    }
    append(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.append(...children);
    }
    prepend(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.prepend(...children);
    }
};
var $791ce2ee9eb5657b$var$atRule$1 = $791ce2ee9eb5657b$var$AtRule$3$1;
$791ce2ee9eb5657b$var$AtRule$3$1.default = $791ce2ee9eb5657b$var$AtRule$3$1;
$791ce2ee9eb5657b$var$Container$5$1.registerAtRule($791ce2ee9eb5657b$var$AtRule$3$1);
let $791ce2ee9eb5657b$var$Container$4$1 = $791ce2ee9eb5657b$var$container$1;
let $791ce2ee9eb5657b$var$LazyResult$3$1, $791ce2ee9eb5657b$var$Processor$2$1;
let $791ce2ee9eb5657b$var$Root$5$1 = class Root extends $791ce2ee9eb5657b$var$Container$4$1 {
    constructor(defaults){
        super(defaults);
        this.type = "root";
        if (!this.nodes) this.nodes = [];
    }
    normalize(child, sample, type) {
        let nodes = super.normalize(child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for (let node2 of nodes)node2.raws.before = sample.raws.before;
        }
        return nodes;
    }
    removeChild(child, ignore) {
        let index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index2].raws.before;
        return super.removeChild(child);
    }
    toResult(opts = {}) {
        let lazy = new $791ce2ee9eb5657b$var$LazyResult$3$1(new $791ce2ee9eb5657b$var$Processor$2$1(), this, opts);
        return lazy.stringify();
    }
};
$791ce2ee9eb5657b$var$Root$5$1.registerLazyResult = (dependant)=>{
    $791ce2ee9eb5657b$var$LazyResult$3$1 = dependant;
};
$791ce2ee9eb5657b$var$Root$5$1.registerProcessor = (dependant)=>{
    $791ce2ee9eb5657b$var$Processor$2$1 = dependant;
};
var $791ce2ee9eb5657b$var$root$1 = $791ce2ee9eb5657b$var$Root$5$1;
$791ce2ee9eb5657b$var$Root$5$1.default = $791ce2ee9eb5657b$var$Root$5$1;
$791ce2ee9eb5657b$var$Container$4$1.registerRoot($791ce2ee9eb5657b$var$Root$5$1);
let $791ce2ee9eb5657b$var$list$2$1 = {
    comma (string) {
        return $791ce2ee9eb5657b$var$list$2$1.split(string, [
            ","
        ], true);
    },
    space (string) {
        let spaces = [
            " ",
            "\n",
            "	"
        ];
        return $791ce2ee9eb5657b$var$list$2$1.split(string, spaces);
    },
    split (string, separators, last) {
        let array = [];
        let current = "";
        let split = false;
        let func = 0;
        let inQuote = false;
        let prevQuote = "";
        let escape = false;
        for (let letter of string){
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var $791ce2ee9eb5657b$var$list_1$1 = $791ce2ee9eb5657b$var$list$2$1;
$791ce2ee9eb5657b$var$list$2$1.default = $791ce2ee9eb5657b$var$list$2$1;
let $791ce2ee9eb5657b$var$Container$3$1 = $791ce2ee9eb5657b$var$container$1;
let $791ce2ee9eb5657b$var$list$1$1 = $791ce2ee9eb5657b$var$list_1$1;
let $791ce2ee9eb5657b$var$Rule$3$1 = class Rule extends $791ce2ee9eb5657b$var$Container$3$1 {
    constructor(defaults){
        super(defaults);
        this.type = "rule";
        if (!this.nodes) this.nodes = [];
    }
    get selectors() {
        return $791ce2ee9eb5657b$var$list$1$1.comma(this.selector);
    }
    set selectors(values) {
        let match = this.selector ? this.selector.match(/,\s*/) : null;
        let sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
        this.selector = values.join(sep2);
    }
};
var $791ce2ee9eb5657b$var$rule$1 = $791ce2ee9eb5657b$var$Rule$3$1;
$791ce2ee9eb5657b$var$Rule$3$1.default = $791ce2ee9eb5657b$var$Rule$3$1;
$791ce2ee9eb5657b$var$Container$3$1.registerRule($791ce2ee9eb5657b$var$Rule$3$1);
let $791ce2ee9eb5657b$var$Declaration$2$1 = $791ce2ee9eb5657b$var$declaration$1;
let $791ce2ee9eb5657b$var$tokenizer2$1 = $791ce2ee9eb5657b$var$tokenize$1;
let $791ce2ee9eb5657b$var$Comment$2$1 = $791ce2ee9eb5657b$var$comment$1;
let $791ce2ee9eb5657b$var$AtRule$2$1 = $791ce2ee9eb5657b$var$atRule$1;
let $791ce2ee9eb5657b$var$Root$4$1 = $791ce2ee9eb5657b$var$root$1;
let $791ce2ee9eb5657b$var$Rule$2$1 = $791ce2ee9eb5657b$var$rule$1;
const $791ce2ee9eb5657b$var$SAFE_COMMENT_NEIGHBOR$1 = {
    empty: true,
    space: true
};
function $791ce2ee9eb5657b$var$findLastWithPosition$1(tokens) {
    for(let i2 = tokens.length - 1; i2 >= 0; i2--){
        let token = tokens[i2];
        let pos = token[3] || token[2];
        if (pos) return pos;
    }
}
let $791ce2ee9eb5657b$var$Parser$1$1 = class Parser {
    constructor(input2){
        this.input = input2;
        this.root = new $791ce2ee9eb5657b$var$Root$4$1();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    atrule(token) {
        let node2 = new $791ce2ee9eb5657b$var$AtRule$2$1();
        node2.name = token[1].slice(1);
        if (node2.name === "") this.unnamedAtrule(node2, token);
        this.init(node2, token[2]);
        let type;
        let prev;
        let shift;
        let last = false;
        let open = false;
        let params = [];
        let brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    }
    checkMissedSemicolon(tokens) {
        let colon = this.colon(tokens);
        if (colon === false) return;
        let founded = 0;
        let token;
        for(let j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    }
    colon(tokens) {
        let brackets = 0;
        let token, type, prev;
        for (let [i2, element] of tokens.entries()){
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i2;
            }
            prev = token;
        }
        return false;
    }
    comment(token) {
        let node2 = new $791ce2ee9eb5657b$var$Comment$2$1();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        let text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    }
    createTokenizer() {
        this.tokenizer = $791ce2ee9eb5657b$var$tokenizer2$1(this.input);
    }
    decl(tokens, customProperty) {
        let node2 = new $791ce2ee9eb5657b$var$Declaration$2$1();
        this.init(node2, tokens[0][2]);
        let last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || $791ce2ee9eb5657b$var$findLastWithPosition$1(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            let type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        let token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        let firstSpaces = [];
        let next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(let i2 = tokens.length - 1; i2 >= 0; i2--){
            token = tokens[i2];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                let string = this.stringFrom(tokens, i2);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                let cache = tokens.slice(0);
                let str = "";
                for(let j = i2; j > 0; j--){
                    let type = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        let hasWord = tokens.some((i2)=>i2[0] !== "space" && i2[0] !== "comment");
        if (hasWord) {
            node2.raws.between += firstSpaces.map((i2)=>i2[1]).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    }
    doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    emptyRule(token) {
        let node2 = new $791ce2ee9eb5657b$var$Rule$2$1();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    }
    end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    }
    endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            let prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    }
    // Helpers
    getPosition(offset) {
        let pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    }
    init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    }
    other(start) {
        let end = false;
        let type = null;
        let colon = false;
        let bracket = null;
        let brackets = [];
        let customProperty = start[1].startsWith("--");
        let tokens = [];
        let token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    }
    parse() {
        let token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    }
    precheckMissedSemicolon() {}
    raw(node2, prop, tokens, customProperty) {
        let token, type;
        let length = tokens.length;
        let value = "";
        let clean = true;
        let next, prev;
        for(let i2 = 0; i2 < length; i2 += 1){
            token = tokens[i2];
            type = token[0];
            if (type === "space" && i2 === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
                next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
                if (!$791ce2ee9eb5657b$var$SAFE_COMMENT_NEIGHBOR$1[prev] && !$791ce2ee9eb5657b$var$SAFE_COMMENT_NEIGHBOR$1[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            let raw = tokens.reduce((all, i2)=>all + i2[1], "");
            node2.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node2[prop] = value;
    }
    rule(tokens) {
        tokens.pop();
        let node2 = new $791ce2ee9eb5657b$var$Rule$2$1();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    }
    spacesAndCommentsFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    // Errors
    spacesAndCommentsFromStart(tokens) {
        let next;
        let spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    }
    spacesFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    stringFrom(tokens, from) {
        let result2 = "";
        for(let i2 = from; i2 < tokens.length; i2++)result2 += tokens[i2][1];
        tokens.splice(from, tokens.length - from);
        return result2;
    }
    unclosedBlock() {
        let pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    }
    unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    }
    unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    }
    unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    }
    unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
};
var $791ce2ee9eb5657b$var$parser$1 = $791ce2ee9eb5657b$var$Parser$1$1;
let $791ce2ee9eb5657b$var$Container$2$1 = $791ce2ee9eb5657b$var$container$1;
let $791ce2ee9eb5657b$var$Parser2$1 = $791ce2ee9eb5657b$var$parser$1;
let $791ce2ee9eb5657b$var$Input$2$1 = $791ce2ee9eb5657b$var$input$1;
function $791ce2ee9eb5657b$var$parse$3$1(css, opts) {
    let input2 = new $791ce2ee9eb5657b$var$Input$2$1(css, opts);
    let parser2 = new $791ce2ee9eb5657b$var$Parser2$1(input2);
    try {
        parser2.parse();
    } catch (e2) {
        throw e2;
    }
    return parser2.root;
}
var $791ce2ee9eb5657b$var$parse_1$1 = $791ce2ee9eb5657b$var$parse$3$1;
$791ce2ee9eb5657b$var$parse$3$1.default = $791ce2ee9eb5657b$var$parse$3$1;
$791ce2ee9eb5657b$var$Container$2$1.registerParse($791ce2ee9eb5657b$var$parse$3$1);
let { isClean: $791ce2ee9eb5657b$var$isClean$3, my: $791ce2ee9eb5657b$var$my$3 } = $791ce2ee9eb5657b$var$symbols$1;
let $791ce2ee9eb5657b$var$MapGenerator$1$1 = $791ce2ee9eb5657b$var$mapGenerator$1;
let $791ce2ee9eb5657b$var$stringify$2$1 = $791ce2ee9eb5657b$var$stringify_1$1;
let $791ce2ee9eb5657b$var$Container$1$1 = $791ce2ee9eb5657b$var$container$1;
let $791ce2ee9eb5657b$var$Document$2$1 = $791ce2ee9eb5657b$var$document$1$1;
let $791ce2ee9eb5657b$var$warnOnce$1$1 = $791ce2ee9eb5657b$var$warnOnce$2$1;
let $791ce2ee9eb5657b$var$Result$2$1 = $791ce2ee9eb5657b$var$result$1;
let $791ce2ee9eb5657b$var$parse$2$1 = $791ce2ee9eb5657b$var$parse_1$1;
let $791ce2ee9eb5657b$var$Root$3$1 = $791ce2ee9eb5657b$var$root$1;
const $791ce2ee9eb5657b$var$TYPE_TO_CLASS_NAME$1 = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
const $791ce2ee9eb5657b$var$PLUGIN_PROPS$1 = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
const $791ce2ee9eb5657b$var$NOT_VISITORS$1 = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
const $791ce2ee9eb5657b$var$CHILDREN$1 = 0;
function $791ce2ee9eb5657b$var$isPromise$1(obj) {
    return typeof obj === "object" && typeof obj.then === "function";
}
function $791ce2ee9eb5657b$var$getEvents$1(node2) {
    let key = false;
    let type = $791ce2ee9eb5657b$var$TYPE_TO_CLASS_NAME$1[node2.type];
    if (node2.type === "decl") key = node2.prop.toLowerCase();
    else if (node2.type === "atrule") key = node2.name.toLowerCase();
    if (key && node2.append) return [
        type,
        type + "-" + key,
        $791ce2ee9eb5657b$var$CHILDREN$1,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node2.append) return [
        type,
        $791ce2ee9eb5657b$var$CHILDREN$1,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $791ce2ee9eb5657b$var$toStack$1(node2) {
    let events;
    if (node2.type === "document") events = [
        "Document",
        $791ce2ee9eb5657b$var$CHILDREN$1,
        "DocumentExit"
    ];
    else if (node2.type === "root") events = [
        "Root",
        $791ce2ee9eb5657b$var$CHILDREN$1,
        "RootExit"
    ];
    else events = $791ce2ee9eb5657b$var$getEvents$1(node2);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function $791ce2ee9eb5657b$var$cleanMarks$1(node2) {
    node2[$791ce2ee9eb5657b$var$isClean$3] = false;
    if (node2.nodes) node2.nodes.forEach((i2)=>$791ce2ee9eb5657b$var$cleanMarks$1(i2));
    return node2;
}
let $791ce2ee9eb5657b$var$postcss$2$1 = {};
let $791ce2ee9eb5657b$var$LazyResult$2$1 = class LazyResult {
    constructor(processor2, css, opts){
        this.stringified = false;
        this.processed = false;
        let root2;
        if (typeof css === "object" && css !== null && (css.type === "root" || css.type === "document")) root2 = $791ce2ee9eb5657b$var$cleanMarks$1(css);
        else if (css instanceof LazyResult || css instanceof $791ce2ee9eb5657b$var$Result$2$1) {
            root2 = $791ce2ee9eb5657b$var$cleanMarks$1(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            let parser2 = $791ce2ee9eb5657b$var$parse$2$1;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[$791ce2ee9eb5657b$var$my$3]) $791ce2ee9eb5657b$var$Container$1$1.rebuild(root2);
        }
        this.result = new $791ce2ee9eb5657b$var$Result$2$1(processor2, root2, opts);
        this.helpers = {
            ...$791ce2ee9eb5657b$var$postcss$2$1,
            postcss: $791ce2ee9eb5657b$var$postcss$2$1,
            result: this.result
        };
        this.plugins = this.processor.plugins.map((plugin22)=>{
            if (typeof plugin22 === "object" && plugin22.prepare) return {
                ...plugin22,
                ...plugin22.prepare(this.result)
            };
            else return plugin22;
        });
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(error, node2) {
        let plugin22 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin22.postcssPlugin;
                error.setMessage();
            } else plugin22.postcssVersion;
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    }
    prepareVisitors() {
        this.listeners = {};
        let add = (plugin22, type, cb)=>{
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push([
                plugin22,
                cb
            ]);
        };
        for (let plugin22 of this.plugins){
            if (typeof plugin22 === "object") for(let event in plugin22){
                if (!$791ce2ee9eb5657b$var$PLUGIN_PROPS$1[event] && /^[A-Z]/.test(event)) throw new Error(`Unknown event ${event} in ${plugin22.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`);
                if (!$791ce2ee9eb5657b$var$NOT_VISITORS$1[event]) {
                    if (typeof plugin22[event] === "object") {
                        for(let filter in plugin22[event])if (filter === "*") add(plugin22, event, plugin22[event][filter]);
                        else add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                    } else if (typeof plugin22[event] === "function") add(plugin22, event, plugin22[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
        this.plugin = 0;
        for(let i2 = 0; i2 < this.plugins.length; i2++){
            let plugin22 = this.plugins[i2];
            let promise = this.runOnRoot(plugin22);
            if ($791ce2ee9eb5657b$var$isPromise$1(promise)) try {
                await promise;
            } catch (error) {
                throw this.handleError(error);
            }
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root2 = this.result.root;
            while(!root2[$791ce2ee9eb5657b$var$isClean$3]){
                root2[$791ce2ee9eb5657b$var$isClean$3] = true;
                let stack = [
                    $791ce2ee9eb5657b$var$toStack$1(root2)
                ];
                while(stack.length > 0){
                    let promise = this.visitTick(stack);
                    if ($791ce2ee9eb5657b$var$isPromise$1(promise)) try {
                        await promise;
                    } catch (e2) {
                        let node2 = stack[stack.length - 1].node;
                        throw this.handleError(e2, node2);
                    }
                }
            }
            if (this.listeners.OnceExit) for (let [plugin22, visitor] of this.listeners.OnceExit){
                this.result.lastPlugin = plugin22;
                try {
                    if (root2.type === "document") {
                        let roots = root2.nodes.map((subRoot)=>visitor(subRoot, this.helpers));
                        await Promise.all(roots);
                    } else await visitor(root2, this.helpers);
                } catch (e2) {
                    throw this.handleError(e2);
                }
            }
        }
        this.processed = true;
        return this.stringify();
    }
    runOnRoot(plugin22) {
        this.result.lastPlugin = plugin22;
        try {
            if (typeof plugin22 === "object" && plugin22.Once) {
                if (this.result.root.type === "document") {
                    let roots = this.result.root.nodes.map((root2)=>plugin22.Once(root2, this.helpers));
                    if ($791ce2ee9eb5657b$var$isPromise$1(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin22.Once(this.result.root, this.helpers);
            } else if (typeof plugin22 === "function") return plugin22(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    }
    stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        let opts = this.result.opts;
        let str = $791ce2ee9eb5657b$var$stringify$2$1;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        let map = new $791ce2ee9eb5657b$var$MapGenerator$1$1(str, this.result.root, this.result.opts);
        let data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    }
    sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for (let plugin22 of this.plugins){
            let promise = this.runOnRoot(plugin22);
            if ($791ce2ee9eb5657b$var$isPromise$1(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root2 = this.result.root;
            while(!root2[$791ce2ee9eb5657b$var$isClean$3]){
                root2[$791ce2ee9eb5657b$var$isClean$3] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") for (let subRoot of root2.nodes)this.visitSync(this.listeners.OnceExit, subRoot);
                else this.visitSync(this.listeners.OnceExit, root2);
            }
        }
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this.css;
    }
    visitSync(visitors, node2) {
        for (let [plugin22, visitor] of visitors){
            this.result.lastPlugin = plugin22;
            let promise;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) return true;
            if ($791ce2ee9eb5657b$var$isPromise$1(promise)) throw this.getAsyncError();
        }
    }
    visitTick(stack) {
        let visit2 = stack[stack.length - 1];
        let { node: node2, visitors: visitors } = visit2;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            let [plugin22, visitor] = visitors[visit2.visitorIndex];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin22;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2);
            }
        }
        if (visit2.iterator !== 0) {
            let iterator = visit2.iterator;
            let child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[$791ce2ee9eb5657b$var$isClean$3]) {
                    child[$791ce2ee9eb5657b$var$isClean$3] = true;
                    stack.push($791ce2ee9eb5657b$var$toStack$1(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        let events = visit2.events;
        while(visit2.eventIndex < events.length){
            let event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === $791ce2ee9eb5657b$var$CHILDREN$1) {
                if (node2.nodes && node2.nodes.length) {
                    node2[$791ce2ee9eb5657b$var$isClean$3] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    }
    walkSync(node2) {
        node2[$791ce2ee9eb5657b$var$isClean$3] = true;
        let events = $791ce2ee9eb5657b$var$getEvents$1(node2);
        for (let event of events){
            if (event === $791ce2ee9eb5657b$var$CHILDREN$1) {
                if (node2.nodes) node2.each((child)=>{
                    if (!child[$791ce2ee9eb5657b$var$isClean$3]) this.walkSync(child);
                });
            } else {
                let visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    }
    warnings() {
        return this.sync().warnings();
    }
    get content() {
        return this.stringify().content;
    }
    get css() {
        return this.stringify().css;
    }
    get map() {
        return this.stringify().map;
    }
    get messages() {
        return this.sync().messages;
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        return this.sync().root;
    }
    get [Symbol.toStringTag]() {
        return "LazyResult";
    }
};
$791ce2ee9eb5657b$var$LazyResult$2$1.registerPostcss = (dependant)=>{
    $791ce2ee9eb5657b$var$postcss$2$1 = dependant;
};
var $791ce2ee9eb5657b$var$lazyResult$1 = $791ce2ee9eb5657b$var$LazyResult$2$1;
$791ce2ee9eb5657b$var$LazyResult$2$1.default = $791ce2ee9eb5657b$var$LazyResult$2$1;
$791ce2ee9eb5657b$var$Root$3$1.registerLazyResult($791ce2ee9eb5657b$var$LazyResult$2$1);
$791ce2ee9eb5657b$var$Document$2$1.registerLazyResult($791ce2ee9eb5657b$var$LazyResult$2$1);
let $791ce2ee9eb5657b$var$MapGenerator2$1 = $791ce2ee9eb5657b$var$mapGenerator$1;
let $791ce2ee9eb5657b$var$stringify$1$1 = $791ce2ee9eb5657b$var$stringify_1$1;
let $791ce2ee9eb5657b$var$warnOnce2$1 = $791ce2ee9eb5657b$var$warnOnce$2$1;
let $791ce2ee9eb5657b$var$parse$1$1 = $791ce2ee9eb5657b$var$parse_1$1;
const $791ce2ee9eb5657b$var$Result$1$1 = $791ce2ee9eb5657b$var$result$1;
let $791ce2ee9eb5657b$var$NoWorkResult$1$1 = class NoWorkResult {
    constructor(processor2, css, opts){
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        let root2;
        let str = $791ce2ee9eb5657b$var$stringify$1$1;
        this.result = new $791ce2ee9eb5657b$var$Result$1$1(this._processor, root2, this._opts);
        this.result.css = css;
        let self = this;
        Object.defineProperty(this.result, "root", {
            get () {
                return self.root;
            }
        });
        let map = new $791ce2ee9eb5657b$var$MapGenerator2$1(str, root2, this._opts, css);
        if (map.isMap()) {
            let [generatedCSS, generatedMap] = map.generate();
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    sync() {
        if (this.error) throw this.error;
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this._css;
    }
    warnings() {
        return [];
    }
    get content() {
        return this.result.css;
    }
    get css() {
        return this.result.css;
    }
    get map() {
        return this.result.map;
    }
    get messages() {
        return [];
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        if (this._root) return this._root;
        let root2;
        let parser2 = $791ce2ee9eb5657b$var$parse$1$1;
        try {
            root2 = parser2(this._css, this._opts);
        } catch (error) {
            this.error = error;
        }
        if (this.error) throw this.error;
        else {
            this._root = root2;
            return root2;
        }
    }
    get [Symbol.toStringTag]() {
        return "NoWorkResult";
    }
};
var $791ce2ee9eb5657b$var$noWorkResult$1 = $791ce2ee9eb5657b$var$NoWorkResult$1$1;
$791ce2ee9eb5657b$var$NoWorkResult$1$1.default = $791ce2ee9eb5657b$var$NoWorkResult$1$1;
let $791ce2ee9eb5657b$var$NoWorkResult2$1 = $791ce2ee9eb5657b$var$noWorkResult$1;
let $791ce2ee9eb5657b$var$LazyResult$1$1 = $791ce2ee9eb5657b$var$lazyResult$1;
let $791ce2ee9eb5657b$var$Document$1$1 = $791ce2ee9eb5657b$var$document$1$1;
let $791ce2ee9eb5657b$var$Root$2$1 = $791ce2ee9eb5657b$var$root$1;
let $791ce2ee9eb5657b$var$Processor$1$1 = class Processor {
    constructor(plugins = []){
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
    normalize(plugins) {
        let normalized = [];
        for (let i2 of plugins){
            if (i2.postcss === true) i2 = i2();
            else if (i2.postcss) i2 = i2.postcss;
            if (typeof i2 === "object" && Array.isArray(i2.plugins)) normalized = normalized.concat(i2.plugins);
            else if (typeof i2 === "object" && i2.postcssPlugin) normalized.push(i2);
            else if (typeof i2 === "function") normalized.push(i2);
            else if (typeof i2 === "object" && (i2.parse || i2.stringify)) ;
            else throw new Error(i2 + " is not a PostCSS plugin");
        }
        return normalized;
    }
    process(css, opts = {}) {
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $791ce2ee9eb5657b$var$NoWorkResult2$1(this, css, opts);
        else return new $791ce2ee9eb5657b$var$LazyResult$1$1(this, css, opts);
    }
    use(plugin22) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin22
        ]));
        return this;
    }
};
var $791ce2ee9eb5657b$var$processor$1 = $791ce2ee9eb5657b$var$Processor$1$1;
$791ce2ee9eb5657b$var$Processor$1$1.default = $791ce2ee9eb5657b$var$Processor$1$1;
$791ce2ee9eb5657b$var$Root$2$1.registerProcessor($791ce2ee9eb5657b$var$Processor$1$1);
$791ce2ee9eb5657b$var$Document$1$1.registerProcessor($791ce2ee9eb5657b$var$Processor$1$1);
let $791ce2ee9eb5657b$var$Declaration$1$1 = $791ce2ee9eb5657b$var$declaration$1;
let $791ce2ee9eb5657b$var$PreviousMap2$1 = $791ce2ee9eb5657b$var$previousMap$1;
let $791ce2ee9eb5657b$var$Comment$1$1 = $791ce2ee9eb5657b$var$comment$1;
let $791ce2ee9eb5657b$var$AtRule$1$1 = $791ce2ee9eb5657b$var$atRule$1;
let $791ce2ee9eb5657b$var$Input$1$1 = $791ce2ee9eb5657b$var$input$1;
let $791ce2ee9eb5657b$var$Root$1$1 = $791ce2ee9eb5657b$var$root$1;
let $791ce2ee9eb5657b$var$Rule$1$1 = $791ce2ee9eb5657b$var$rule$1;
function $791ce2ee9eb5657b$var$fromJSON$1$1(json, inputs) {
    if (Array.isArray(json)) return json.map((n2)=>$791ce2ee9eb5657b$var$fromJSON$1$1(n2));
    let { inputs: ownInputs, ...defaults } = json;
    if (ownInputs) {
        inputs = [];
        for (let input2 of ownInputs){
            let inputHydrated = {
                ...input2,
                __proto__: $791ce2ee9eb5657b$var$Input$1$1.prototype
            };
            if (inputHydrated.map) inputHydrated.map = {
                ...inputHydrated.map,
                __proto__: $791ce2ee9eb5657b$var$PreviousMap2$1.prototype
            };
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map((n2)=>$791ce2ee9eb5657b$var$fromJSON$1$1(n2, inputs));
    if (defaults.source) {
        let { inputId: inputId, ...source } = defaults.source;
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $791ce2ee9eb5657b$var$Root$1$1(defaults);
    else if (defaults.type === "decl") return new $791ce2ee9eb5657b$var$Declaration$1$1(defaults);
    else if (defaults.type === "rule") return new $791ce2ee9eb5657b$var$Rule$1$1(defaults);
    else if (defaults.type === "comment") return new $791ce2ee9eb5657b$var$Comment$1$1(defaults);
    else if (defaults.type === "atrule") return new $791ce2ee9eb5657b$var$AtRule$1$1(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
var $791ce2ee9eb5657b$var$fromJSON_1$1 = $791ce2ee9eb5657b$var$fromJSON$1$1;
$791ce2ee9eb5657b$var$fromJSON$1$1.default = $791ce2ee9eb5657b$var$fromJSON$1$1;
let $791ce2ee9eb5657b$var$CssSyntaxError2$1 = $791ce2ee9eb5657b$var$cssSyntaxError$1;
let $791ce2ee9eb5657b$var$Declaration2$1 = $791ce2ee9eb5657b$var$declaration$1;
let $791ce2ee9eb5657b$var$LazyResult2$1 = $791ce2ee9eb5657b$var$lazyResult$1;
let $791ce2ee9eb5657b$var$Container2$1 = $791ce2ee9eb5657b$var$container$1;
let $791ce2ee9eb5657b$var$Processor2$1 = $791ce2ee9eb5657b$var$processor$1;
let $791ce2ee9eb5657b$var$stringify$5 = $791ce2ee9eb5657b$var$stringify_1$1;
let $791ce2ee9eb5657b$var$fromJSON$2 = $791ce2ee9eb5657b$var$fromJSON_1$1;
let $791ce2ee9eb5657b$var$Document22 = $791ce2ee9eb5657b$var$document$1$1;
let $791ce2ee9eb5657b$var$Warning2$1 = $791ce2ee9eb5657b$var$warning$1;
let $791ce2ee9eb5657b$var$Comment2$1 = $791ce2ee9eb5657b$var$comment$1;
let $791ce2ee9eb5657b$var$AtRule2$1 = $791ce2ee9eb5657b$var$atRule$1;
let $791ce2ee9eb5657b$var$Result2$1 = $791ce2ee9eb5657b$var$result$1;
let $791ce2ee9eb5657b$var$Input2$1 = $791ce2ee9eb5657b$var$input$1;
let $791ce2ee9eb5657b$var$parse$5 = $791ce2ee9eb5657b$var$parse_1$1;
let $791ce2ee9eb5657b$var$list$3 = $791ce2ee9eb5657b$var$list_1$1;
let $791ce2ee9eb5657b$var$Rule2$1 = $791ce2ee9eb5657b$var$rule$1;
let $791ce2ee9eb5657b$var$Root2$1 = $791ce2ee9eb5657b$var$root$1;
let $791ce2ee9eb5657b$var$Node2$1 = $791ce2ee9eb5657b$var$node$1;
function $791ce2ee9eb5657b$var$postcss$3(...plugins) {
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $791ce2ee9eb5657b$var$Processor2$1(plugins);
}
$791ce2ee9eb5657b$var$postcss$3.plugin = function plugin(name, initializer) {
    let warningPrinted = false;
    function creator(...args) {
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        let transformer = initializer(...args);
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $791ce2ee9eb5657b$var$Processor2$1().version;
        return transformer;
    }
    let cache;
    Object.defineProperty(creator, "postcss", {
        get () {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $791ce2ee9eb5657b$var$postcss$3([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$791ce2ee9eb5657b$var$postcss$3.stringify = $791ce2ee9eb5657b$var$stringify$5;
$791ce2ee9eb5657b$var$postcss$3.parse = $791ce2ee9eb5657b$var$parse$5;
$791ce2ee9eb5657b$var$postcss$3.fromJSON = $791ce2ee9eb5657b$var$fromJSON$2;
$791ce2ee9eb5657b$var$postcss$3.list = $791ce2ee9eb5657b$var$list$3;
$791ce2ee9eb5657b$var$postcss$3.comment = (defaults)=>new $791ce2ee9eb5657b$var$Comment2$1(defaults);
$791ce2ee9eb5657b$var$postcss$3.atRule = (defaults)=>new $791ce2ee9eb5657b$var$AtRule2$1(defaults);
$791ce2ee9eb5657b$var$postcss$3.decl = (defaults)=>new $791ce2ee9eb5657b$var$Declaration2$1(defaults);
$791ce2ee9eb5657b$var$postcss$3.rule = (defaults)=>new $791ce2ee9eb5657b$var$Rule2$1(defaults);
$791ce2ee9eb5657b$var$postcss$3.root = (defaults)=>new $791ce2ee9eb5657b$var$Root2$1(defaults);
$791ce2ee9eb5657b$var$postcss$3.document = (defaults)=>new $791ce2ee9eb5657b$var$Document22(defaults);
$791ce2ee9eb5657b$var$postcss$3.CssSyntaxError = $791ce2ee9eb5657b$var$CssSyntaxError2$1;
$791ce2ee9eb5657b$var$postcss$3.Declaration = $791ce2ee9eb5657b$var$Declaration2$1;
$791ce2ee9eb5657b$var$postcss$3.Container = $791ce2ee9eb5657b$var$Container2$1;
$791ce2ee9eb5657b$var$postcss$3.Processor = $791ce2ee9eb5657b$var$Processor2$1;
$791ce2ee9eb5657b$var$postcss$3.Document = $791ce2ee9eb5657b$var$Document22;
$791ce2ee9eb5657b$var$postcss$3.Comment = $791ce2ee9eb5657b$var$Comment2$1;
$791ce2ee9eb5657b$var$postcss$3.Warning = $791ce2ee9eb5657b$var$Warning2$1;
$791ce2ee9eb5657b$var$postcss$3.AtRule = $791ce2ee9eb5657b$var$AtRule2$1;
$791ce2ee9eb5657b$var$postcss$3.Result = $791ce2ee9eb5657b$var$Result2$1;
$791ce2ee9eb5657b$var$postcss$3.Input = $791ce2ee9eb5657b$var$Input2$1;
$791ce2ee9eb5657b$var$postcss$3.Rule = $791ce2ee9eb5657b$var$Rule2$1;
$791ce2ee9eb5657b$var$postcss$3.Root = $791ce2ee9eb5657b$var$Root2$1;
$791ce2ee9eb5657b$var$postcss$3.Node = $791ce2ee9eb5657b$var$Node2$1;
$791ce2ee9eb5657b$var$LazyResult2$1.registerPostcss($791ce2ee9eb5657b$var$postcss$3);
var $791ce2ee9eb5657b$var$postcss_1$1 = $791ce2ee9eb5657b$var$postcss$3;
$791ce2ee9eb5657b$var$postcss$3.default = $791ce2ee9eb5657b$var$postcss$3;
const $791ce2ee9eb5657b$var$postcss$1$1 = /* @__PURE__ */ $791ce2ee9eb5657b$var$getDefaultExportFromCjs$1($791ce2ee9eb5657b$var$postcss_1$1);
$791ce2ee9eb5657b$var$postcss$1$1.stringify;
$791ce2ee9eb5657b$var$postcss$1$1.fromJSON;
$791ce2ee9eb5657b$var$postcss$1$1.plugin;
$791ce2ee9eb5657b$var$postcss$1$1.parse;
$791ce2ee9eb5657b$var$postcss$1$1.list;
$791ce2ee9eb5657b$var$postcss$1$1.document;
$791ce2ee9eb5657b$var$postcss$1$1.comment;
$791ce2ee9eb5657b$var$postcss$1$1.atRule;
$791ce2ee9eb5657b$var$postcss$1$1.rule;
$791ce2ee9eb5657b$var$postcss$1$1.decl;
$791ce2ee9eb5657b$var$postcss$1$1.root;
$791ce2ee9eb5657b$var$postcss$1$1.CssSyntaxError;
$791ce2ee9eb5657b$var$postcss$1$1.Declaration;
$791ce2ee9eb5657b$var$postcss$1$1.Container;
$791ce2ee9eb5657b$var$postcss$1$1.Processor;
$791ce2ee9eb5657b$var$postcss$1$1.Document;
$791ce2ee9eb5657b$var$postcss$1$1.Comment;
$791ce2ee9eb5657b$var$postcss$1$1.Warning;
$791ce2ee9eb5657b$var$postcss$1$1.AtRule;
$791ce2ee9eb5657b$var$postcss$1$1.Result;
$791ce2ee9eb5657b$var$postcss$1$1.Input;
$791ce2ee9eb5657b$var$postcss$1$1.Rule;
$791ce2ee9eb5657b$var$postcss$1$1.Root;
$791ce2ee9eb5657b$var$postcss$1$1.Node;
const $791ce2ee9eb5657b$var$tagMap = {
    script: "noscript",
    // camel case svg element tag names
    altglyph: "altGlyph",
    altglyphdef: "altGlyphDef",
    altglyphitem: "altGlyphItem",
    animatecolor: "animateColor",
    animatemotion: "animateMotion",
    animatetransform: "animateTransform",
    clippath: "clipPath",
    feblend: "feBlend",
    fecolormatrix: "feColorMatrix",
    fecomponenttransfer: "feComponentTransfer",
    fecomposite: "feComposite",
    feconvolvematrix: "feConvolveMatrix",
    fediffuselighting: "feDiffuseLighting",
    fedisplacementmap: "feDisplacementMap",
    fedistantlight: "feDistantLight",
    fedropshadow: "feDropShadow",
    feflood: "feFlood",
    fefunca: "feFuncA",
    fefuncb: "feFuncB",
    fefuncg: "feFuncG",
    fefuncr: "feFuncR",
    fegaussianblur: "feGaussianBlur",
    feimage: "feImage",
    femerge: "feMerge",
    femergenode: "feMergeNode",
    femorphology: "feMorphology",
    feoffset: "feOffset",
    fepointlight: "fePointLight",
    fespecularlighting: "feSpecularLighting",
    fespotlight: "feSpotLight",
    fetile: "feTile",
    feturbulence: "feTurbulence",
    foreignobject: "foreignObject",
    glyphref: "glyphRef",
    lineargradient: "linearGradient",
    radialgradient: "radialGradient"
};
function $791ce2ee9eb5657b$var$getTagName(n2) {
    let tagName = $791ce2ee9eb5657b$var$tagMap[n2.tagName] ? $791ce2ee9eb5657b$var$tagMap[n2.tagName] : n2.tagName;
    if (tagName === "link" && n2.attributes._cssText) tagName = "style";
    return tagName;
}
function $791ce2ee9eb5657b$var$adaptCssForReplay(cssText, cache) {
    const cachedStyle = cache == null ? void 0 : cache.stylesWithHoverClass.get(cssText);
    if (cachedStyle) return cachedStyle;
    let result2 = cssText;
    try {
        const ast = $791ce2ee9eb5657b$var$postcss$1$1([
            $791ce2ee9eb5657b$var$mediaSelectorPlugin,
            $791ce2ee9eb5657b$var$pseudoClassPlugin
        ]).process(cssText);
        result2 = ast.css;
    } catch (error) {
        console.warn("Failed to adapt css for replay", error);
    }
    cache == null || cache.stylesWithHoverClass.set(cssText, result2);
    return result2;
}
function $791ce2ee9eb5657b$var$createCache() {
    const stylesWithHoverClass = /* @__PURE__ */ new Map();
    return {
        stylesWithHoverClass: stylesWithHoverClass
    };
}
function $791ce2ee9eb5657b$var$applyCssSplits(n2, cssText, hackCss, cache) {
    const childTextNodes = [];
    for (const scn of n2.childNodes)if (scn.type === $791ce2ee9eb5657b$var$NodeType$3.Text) childTextNodes.push(scn);
    const cssTextSplits = cssText.split("/* rr_split */");
    while(cssTextSplits.length > 1 && cssTextSplits.length > childTextNodes.length)cssTextSplits.splice(-2, 2, cssTextSplits.slice(-2).join(""));
    for(let i2 = 0; i2 < childTextNodes.length; i2++){
        const childTextNode = childTextNodes[i2];
        const cssTextSection = cssTextSplits[i2];
        if (childTextNode && cssTextSection) childTextNode.textContent = hackCss ? $791ce2ee9eb5657b$var$adaptCssForReplay(cssTextSection, cache) : cssTextSection;
    }
}
function $791ce2ee9eb5657b$var$buildStyleNode(n2, styleEl, cssText, options) {
    const { doc: doc, hackCss: hackCss, cache: cache } = options;
    if (n2.childNodes.length) $791ce2ee9eb5657b$var$applyCssSplits(n2, cssText, hackCss, cache);
    else {
        if (hackCss) cssText = $791ce2ee9eb5657b$var$adaptCssForReplay(cssText, cache);
        styleEl.appendChild(doc.createTextNode(cssText));
    }
}
function $791ce2ee9eb5657b$var$buildNode(n2, options) {
    var _a2;
    const { doc: doc, hackCss: hackCss, cache: cache } = options;
    switch(n2.type){
        case $791ce2ee9eb5657b$var$NodeType$3.Document:
            return doc.implementation.createDocument(null, "", null);
        case $791ce2ee9eb5657b$var$NodeType$3.DocumentType:
            return doc.implementation.createDocumentType(n2.name || "html", n2.publicId, n2.systemId);
        case $791ce2ee9eb5657b$var$NodeType$3.Element:
            {
                const tagName = $791ce2ee9eb5657b$var$getTagName(n2);
                let node2;
                if (n2.isSVG) node2 = doc.createElementNS("http://www.w3.org/2000/svg", tagName);
                else {
                    if (// If the tag name is a custom element name
                    n2.isCustom && // If the browser supports custom elements
                    ((_a2 = doc.defaultView) == null ? void 0 : _a2.customElements) && // If the custom element hasn't been defined yet
                    !doc.defaultView.customElements.get(n2.tagName)) doc.defaultView.customElements.define(n2.tagName, class extends doc.defaultView.HTMLElement {
                    });
                    node2 = doc.createElement(tagName);
                }
                const specialAttributes = {};
                for(const name in n2.attributes){
                    if (!Object.prototype.hasOwnProperty.call(n2.attributes, name)) continue;
                    let value = n2.attributes[name];
                    if (tagName === "option" && name === "selected" && value === false) continue;
                    if (value === null) continue;
                    if (value === true) value = "";
                    if (name.startsWith("rr_")) {
                        specialAttributes[name] = value;
                        continue;
                    }
                    if (typeof value !== "string") ;
                    else if (tagName === "style" && name === "_cssText") {
                        $791ce2ee9eb5657b$var$buildStyleNode(n2, node2, value, options);
                        continue;
                    } else if (tagName === "textarea" && name === "value") {
                        node2.appendChild(doc.createTextNode(value));
                        n2.childNodes = [];
                        continue;
                    }
                    try {
                        if (n2.isSVG && name === "xlink:href") node2.setAttributeNS("http://www.w3.org/1999/xlink", name, value.toString());
                        else if (name === "onload" || name === "onclick" || name.substring(0, 7) === "onmouse") node2.setAttribute("_" + name, value.toString());
                        else if (tagName === "meta" && n2.attributes["http-equiv"] === "Content-Security-Policy" && name === "content") {
                            node2.setAttribute("csp-content", value.toString());
                            continue;
                        } else if (tagName === "link" && (n2.attributes.rel === "preload" || n2.attributes.rel === "modulepreload") && n2.attributes.as === "script") ;
                        else if (tagName === "link" && n2.attributes.rel === "prefetch" && typeof n2.attributes.href === "string" && n2.attributes.href.endsWith(".js")) ;
                        else if (tagName === "img" && n2.attributes.srcset && n2.attributes.rr_dataURL) node2.setAttribute("rrweb-original-srcset", n2.attributes.srcset);
                        else node2.setAttribute(name, value.toString());
                    } catch (error) {}
                }
                for(const name in specialAttributes){
                    const value = specialAttributes[name];
                    if (tagName === "canvas" && name === "rr_dataURL") {
                        const image = doc.createElement("img");
                        image.onload = ()=>{
                            const ctx = node2.getContext("2d");
                            if (ctx) ctx.drawImage(image, 0, 0, image.width, image.height);
                        };
                        image.src = value.toString();
                        if (node2.RRNodeType) node2.rr_dataURL = value.toString();
                    } else if (tagName === "img" && name === "rr_dataURL") {
                        const image = node2;
                        if (!image.currentSrc.startsWith("data:")) {
                            image.setAttribute("rrweb-original-src", n2.attributes.src);
                            image.src = value.toString();
                        }
                    }
                    if (name === "rr_width") node2.style.setProperty("width", value.toString());
                    else if (name === "rr_height") node2.style.setProperty("height", value.toString());
                    else if (name === "rr_mediaCurrentTime" && typeof value === "number") node2.currentTime = value;
                    else if (name === "rr_mediaState") switch(value){
                        case "played":
                            node2.play().catch((e2)=>console.warn("media playback error", e2));
                            break;
                        case "paused":
                            node2.pause();
                            break;
                    }
                    else if (name === "rr_mediaPlaybackRate" && typeof value === "number") node2.playbackRate = value;
                    else if (name === "rr_mediaMuted" && typeof value === "boolean") node2.muted = value;
                    else if (name === "rr_mediaLoop" && typeof value === "boolean") node2.loop = value;
                    else if (name === "rr_mediaVolume" && typeof value === "number") node2.volume = value;
                    else if (name === "rr_open_mode") node2.setAttribute("rr_open_mode", value);
                }
                if (n2.isShadowHost) {
                    if (!node2.shadowRoot) node2.attachShadow({
                        mode: "open"
                    });
                    else while(node2.shadowRoot.firstChild)node2.shadowRoot.removeChild(node2.shadowRoot.firstChild);
                }
                return node2;
            }
        case $791ce2ee9eb5657b$var$NodeType$3.Text:
            if (n2.isStyle && hackCss) return doc.createTextNode($791ce2ee9eb5657b$var$adaptCssForReplay(n2.textContent, cache));
            return doc.createTextNode(n2.textContent);
        case $791ce2ee9eb5657b$var$NodeType$3.CDATA:
            return doc.createCDATASection(n2.textContent);
        case $791ce2ee9eb5657b$var$NodeType$3.Comment:
            return doc.createComment(n2.textContent);
        default:
            return null;
    }
}
function $791ce2ee9eb5657b$var$buildNodeWithSN(n2, options) {
    const { doc: doc, mirror: mirror2, skipChild: skipChild = false, hackCss: hackCss = true, afterAppend: afterAppend, cache: cache } = options;
    if (mirror2.has(n2.id)) {
        const nodeInMirror = mirror2.getNode(n2.id);
        const meta = mirror2.getMeta(nodeInMirror);
        if ($791ce2ee9eb5657b$var$isNodeMetaEqual(meta, n2)) return mirror2.getNode(n2.id);
    }
    let node2 = $791ce2ee9eb5657b$var$buildNode(n2, {
        doc: doc,
        hackCss: hackCss,
        cache: cache
    });
    if (!node2) return null;
    if (n2.rootId && mirror2.getNode(n2.rootId) !== doc) mirror2.replace(n2.rootId, doc);
    if (n2.type === $791ce2ee9eb5657b$var$NodeType$3.Document) {
        doc.close();
        doc.open();
        if (n2.compatMode === "BackCompat" && n2.childNodes && n2.childNodes[0].type !== $791ce2ee9eb5657b$var$NodeType$3.DocumentType) {
            if (n2.childNodes[0].type === $791ce2ee9eb5657b$var$NodeType$3.Element && "xmlns" in n2.childNodes[0].attributes && n2.childNodes[0].attributes.xmlns === "http://www.w3.org/1999/xhtml") doc.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "">');
            else doc.write('<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "">');
        }
        node2 = doc;
    }
    mirror2.add(node2, n2);
    if ((n2.type === $791ce2ee9eb5657b$var$NodeType$3.Document || n2.type === $791ce2ee9eb5657b$var$NodeType$3.Element) && !skipChild) for (const childN of n2.childNodes){
        const childNode = $791ce2ee9eb5657b$var$buildNodeWithSN(childN, {
            doc: doc,
            mirror: mirror2,
            skipChild: false,
            hackCss: hackCss,
            afterAppend: afterAppend,
            cache: cache
        });
        if (!childNode) {
            console.warn("Failed to rebuild", childN);
            continue;
        }
        if (childN.isShadow && $791ce2ee9eb5657b$var$isElement(node2) && node2.shadowRoot) node2.shadowRoot.appendChild(childNode);
        else if (n2.type === $791ce2ee9eb5657b$var$NodeType$3.Document && childN.type == $791ce2ee9eb5657b$var$NodeType$3.Element) {
            const htmlElement = childNode;
            let body = null;
            htmlElement.childNodes.forEach((child)=>{
                if (child.nodeName === "BODY") body = child;
            });
            if (body) {
                htmlElement.removeChild(body);
                node2.appendChild(childNode);
                htmlElement.appendChild(body);
            } else node2.appendChild(childNode);
        } else node2.appendChild(childNode);
        if (afterAppend) afterAppend(childNode, childN.id);
    }
    return node2;
}
function $791ce2ee9eb5657b$var$visit(mirror2, onVisit) {
    function walk(node2) {
        onVisit(node2);
    }
    for (const id of mirror2.getIds())if (mirror2.has(id)) walk(mirror2.getNode(id));
}
function $791ce2ee9eb5657b$var$handleScroll(node2, mirror2) {
    const n2 = mirror2.getMeta(node2);
    if ((n2 == null ? void 0 : n2.type) !== $791ce2ee9eb5657b$var$NodeType$3.Element) return;
    const el = node2;
    for(const name in n2.attributes){
        if (!(Object.prototype.hasOwnProperty.call(n2.attributes, name) && name.startsWith("rr_"))) continue;
        const value = n2.attributes[name];
        if (name === "rr_scrollLeft") el.scrollLeft = value;
        if (name === "rr_scrollTop") el.scrollTop = value;
    }
}
function $791ce2ee9eb5657b$var$rebuild(n2, options) {
    const { doc: doc, onVisit: onVisit, hackCss: hackCss = true, afterAppend: afterAppend, cache: cache, mirror: mirror2 = new $791ce2ee9eb5657b$var$Mirror() } = options;
    const node2 = $791ce2ee9eb5657b$var$buildNodeWithSN(n2, {
        doc: doc,
        mirror: mirror2,
        skipChild: false,
        hackCss: hackCss,
        afterAppend: afterAppend,
        cache: cache
    });
    $791ce2ee9eb5657b$var$visit(mirror2, (visitedNode)=>{
        if (onVisit) onVisit(visitedNode);
        $791ce2ee9eb5657b$var$handleScroll(visitedNode, mirror2);
    });
    return node2;
}
var $791ce2ee9eb5657b$var$__defProp2 = Object.defineProperty;
var $791ce2ee9eb5657b$var$__defNormalProp2 = (obj, key, value)=>key in obj ? $791ce2ee9eb5657b$var$__defProp2(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $791ce2ee9eb5657b$var$__publicField2 = (obj, key, value)=>$791ce2ee9eb5657b$var$__defNormalProp2(obj, typeof key !== "symbol" ? key + "" : key, value);
var $791ce2ee9eb5657b$var$__defProp22 = Object.defineProperty;
var $791ce2ee9eb5657b$var$__defNormalProp22 = (obj, key, value)=>key in obj ? $791ce2ee9eb5657b$var$__defProp22(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $791ce2ee9eb5657b$var$__publicField22 = (obj, key, value)=>$791ce2ee9eb5657b$var$__defNormalProp22(obj, typeof key !== "symbol" ? key + "" : key, value);
let $791ce2ee9eb5657b$var$Mirror$1 = class Mirror2 {
    constructor(){
        $791ce2ee9eb5657b$var$__publicField22(this, "idNodeMap", /* @__PURE__ */ new Map());
        $791ce2ee9eb5657b$var$__publicField22(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    getId(n2) {
        var _a2;
        if (!n2) return -1;
        const id = (_a2 = this.getMeta(n2)) == null ? void 0 : _a2.id;
        return id ?? -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n2) {
        const id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) n2.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node2) {
        return this.nodeMetaMap.has(node2);
    }
    add(n2, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    }
    replace(id, n2) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
};
function $791ce2ee9eb5657b$var$createMirror$1() {
    return new $791ce2ee9eb5657b$var$Mirror$1();
}
function $791ce2ee9eb5657b$var$getDefaultExportFromCjs(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function $791ce2ee9eb5657b$var$getAugmentedNamespace(n2) {
    if (n2.__esModule) return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
        var a2 = function a22() {
            if (this instanceof a22) return Reflect.construct(f2, arguments, this.constructor);
            return f2.apply(this, arguments);
        };
        a2.prototype = f2.prototype;
    } else a2 = {};
    Object.defineProperty(a2, "__esModule", {
        value: true
    });
    Object.keys(n2).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n2, k);
        Object.defineProperty(a2, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n2[k];
            }
        });
    });
    return a2;
}
var $791ce2ee9eb5657b$var$picocolors_browser = {
    exports: {}
};
var $791ce2ee9eb5657b$var$x = String;
var $791ce2ee9eb5657b$var$create = function() {
    return {
        isColorSupported: false,
        reset: $791ce2ee9eb5657b$var$x,
        bold: $791ce2ee9eb5657b$var$x,
        dim: $791ce2ee9eb5657b$var$x,
        italic: $791ce2ee9eb5657b$var$x,
        underline: $791ce2ee9eb5657b$var$x,
        inverse: $791ce2ee9eb5657b$var$x,
        hidden: $791ce2ee9eb5657b$var$x,
        strikethrough: $791ce2ee9eb5657b$var$x,
        black: $791ce2ee9eb5657b$var$x,
        red: $791ce2ee9eb5657b$var$x,
        green: $791ce2ee9eb5657b$var$x,
        yellow: $791ce2ee9eb5657b$var$x,
        blue: $791ce2ee9eb5657b$var$x,
        magenta: $791ce2ee9eb5657b$var$x,
        cyan: $791ce2ee9eb5657b$var$x,
        white: $791ce2ee9eb5657b$var$x,
        gray: $791ce2ee9eb5657b$var$x,
        bgBlack: $791ce2ee9eb5657b$var$x,
        bgRed: $791ce2ee9eb5657b$var$x,
        bgGreen: $791ce2ee9eb5657b$var$x,
        bgYellow: $791ce2ee9eb5657b$var$x,
        bgBlue: $791ce2ee9eb5657b$var$x,
        bgMagenta: $791ce2ee9eb5657b$var$x,
        bgCyan: $791ce2ee9eb5657b$var$x,
        bgWhite: $791ce2ee9eb5657b$var$x
    };
};
$791ce2ee9eb5657b$var$picocolors_browser.exports = $791ce2ee9eb5657b$var$create();
$791ce2ee9eb5657b$var$picocolors_browser.exports.createColors = $791ce2ee9eb5657b$var$create;
var $791ce2ee9eb5657b$var$picocolors_browserExports = $791ce2ee9eb5657b$var$picocolors_browser.exports;
const $791ce2ee9eb5657b$var$__viteBrowserExternal = {};
const $791ce2ee9eb5657b$var$__viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: $791ce2ee9eb5657b$var$__viteBrowserExternal
}, Symbol.toStringTag, {
    value: "Module"
}));
const $791ce2ee9eb5657b$var$require$$2 = /* @__PURE__ */ $791ce2ee9eb5657b$var$getAugmentedNamespace($791ce2ee9eb5657b$var$__viteBrowserExternal$1);
let $791ce2ee9eb5657b$var$pico = $791ce2ee9eb5657b$var$picocolors_browserExports;
let $791ce2ee9eb5657b$var$terminalHighlight$1 = $791ce2ee9eb5657b$var$require$$2;
let $791ce2ee9eb5657b$var$CssSyntaxError$3 = class CssSyntaxError2 extends Error {
    constructor(message, line, column, source, file, plugin22){
        super(message);
        this.name = "CssSyntaxError";
        this.reason = message;
        if (file) this.file = file;
        if (source) this.source = source;
        if (plugin22) this.plugin = plugin22;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                this.line = line;
                this.column = column;
            } else {
                this.line = line.line;
                this.column = line.column;
                this.endLine = column.line;
                this.endColumn = column.column;
            }
        }
        this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(this, CssSyntaxError2);
    }
    setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    }
    showSourceCode(color) {
        if (!this.source) return "";
        let css = this.source;
        if (color == null) color = $791ce2ee9eb5657b$var$pico.isColorSupported;
        if ($791ce2ee9eb5657b$var$terminalHighlight$1) {
            if (color) css = $791ce2ee9eb5657b$var$terminalHighlight$1(css);
        }
        let lines = css.split(/\r?\n/);
        let start = Math.max(this.line - 3, 0);
        let end = Math.min(this.line + 2, lines.length);
        let maxWidth = String(end).length;
        let mark, aside;
        if (color) {
            let { bold: bold, gray: gray, red: red } = $791ce2ee9eb5657b$var$pico.createColors(true);
            mark = (text)=>bold(red(text));
            aside = (text)=>gray(text);
        } else mark = aside = (str)=>str;
        return lines.slice(start, end).map((line, index2)=>{
            let number = start + 1 + index2;
            let gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === this.line) {
                let spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    }
    toString() {
        let code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    }
};
var $791ce2ee9eb5657b$var$cssSyntaxError = $791ce2ee9eb5657b$var$CssSyntaxError$3;
$791ce2ee9eb5657b$var$CssSyntaxError$3.default = $791ce2ee9eb5657b$var$CssSyntaxError$3;
var $791ce2ee9eb5657b$var$symbols = {};
$791ce2ee9eb5657b$var$symbols.isClean = Symbol("isClean");
$791ce2ee9eb5657b$var$symbols.my = Symbol("my");
const $791ce2ee9eb5657b$var$DEFAULT_RAW = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $791ce2ee9eb5657b$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
let $791ce2ee9eb5657b$var$Stringifier$2 = class Stringifier2 {
    constructor(builder){
        this.builder = builder;
    }
    atrule(node2, semicolon) {
        let name = "@" + node2.name;
        let params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") name += node2.raws.afterName;
        else if (params) name += " ";
        if (node2.nodes) this.block(node2, name + params);
        else {
            let end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    }
    beforeAfter(node2, detect) {
        let value;
        if (node2.type === "decl") value = this.raw(node2, null, "beforeDecl");
        else if (node2.type === "comment") value = this.raw(node2, null, "beforeComment");
        else if (detect === "before") value = this.raw(node2, null, "beforeRule");
        else value = this.raw(node2, null, "beforeClose");
        let buf = node2.parent;
        let depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            let indent = this.raw(node2, null, "indent");
            if (indent.length) for(let step = 0; step < depth; step++)value += indent;
        }
        return value;
    }
    block(node2, start) {
        let between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        let after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else after = this.raw(node2, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    }
    body(node2) {
        let last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        let semicolon = this.raw(node2, "semicolon");
        for(let i2 = 0; i2 < node2.nodes.length; i2++){
            let child = node2.nodes[i2];
            let before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i2 || semicolon);
        }
    }
    comment(node2) {
        let left = this.raw(node2, "left", "commentLeft");
        let right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    }
    decl(node2, semicolon) {
        let between = this.raw(node2, "between", "colon");
        let string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) string += node2.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node2);
    }
    document(node2) {
        this.body(node2);
    }
    raw(node2, own, detect) {
        let value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        let parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) return "";
            if (parent && parent.type === "document") return "";
        }
        if (!parent) return $791ce2ee9eb5657b$var$DEFAULT_RAW[detect];
        let root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") return root2.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node2, detect);
        else {
            let method = "raw" + $791ce2ee9eb5657b$var$capitalize(detect);
            if (this[method]) value = this[method](root2, node2);
            else root2.walk((i2)=>{
                value = i2.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $791ce2ee9eb5657b$var$DEFAULT_RAW[detect];
        root2.rawCache[detect] = value;
        return value;
    }
    rawBeforeClose(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && i2.nodes.length > 0) {
                if (typeof i2.raws.after !== "undefined") {
                    value = i2.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeComment(root2, node2) {
        let value;
        root2.walkComments((i2)=>{
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeDecl(root2, node2) {
        let value;
        root2.walkDecls((i2)=>{
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeOpen(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.type !== "decl") {
                value = i2.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawBeforeRule(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
                if (typeof i2.raws.before !== "undefined") {
                    value = i2.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawColon(root2) {
        let value;
        root2.walkDecls((i2)=>{
            if (typeof i2.raws.between !== "undefined") {
                value = i2.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    }
    rawEmptyBody(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && i2.nodes.length === 0) {
                value = i2.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        let value;
        root2.walk((i2)=>{
            let p = i2.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i2.raws.before !== "undefined") {
                    let parts = i2.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    }
    rawSemicolon(root2) {
        let value;
        root2.walk((i2)=>{
            if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
                value = i2.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawValue(node2, prop) {
        let value = node2[prop];
        let raw = node2.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    }
    root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    }
    rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) this.builder(node2.raws.ownSemicolon, node2, "end");
    }
    stringify(node2, semicolon) {
        if (!this[node2.type]) throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        this[node2.type](node2, semicolon);
    }
};
var $791ce2ee9eb5657b$var$stringifier = $791ce2ee9eb5657b$var$Stringifier$2;
$791ce2ee9eb5657b$var$Stringifier$2.default = $791ce2ee9eb5657b$var$Stringifier$2;
let $791ce2ee9eb5657b$var$Stringifier$1 = $791ce2ee9eb5657b$var$stringifier;
function $791ce2ee9eb5657b$var$stringify$4(node2, builder) {
    let str = new $791ce2ee9eb5657b$var$Stringifier$1(builder);
    str.stringify(node2);
}
var $791ce2ee9eb5657b$var$stringify_1 = $791ce2ee9eb5657b$var$stringify$4;
$791ce2ee9eb5657b$var$stringify$4.default = $791ce2ee9eb5657b$var$stringify$4;
let { isClean: $791ce2ee9eb5657b$var$isClean$2, my: $791ce2ee9eb5657b$var$my$2 } = $791ce2ee9eb5657b$var$symbols;
let $791ce2ee9eb5657b$var$CssSyntaxError$2 = $791ce2ee9eb5657b$var$cssSyntaxError;
let $791ce2ee9eb5657b$var$Stringifier22 = $791ce2ee9eb5657b$var$stringifier;
let $791ce2ee9eb5657b$var$stringify$3 = $791ce2ee9eb5657b$var$stringify_1;
function $791ce2ee9eb5657b$var$cloneNode(obj, parent) {
    let cloned = new obj.constructor();
    for(let i2 in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i2)) continue;
        if (i2 === "proxyCache") continue;
        let value = obj[i2];
        let type = typeof value;
        if (i2 === "parent" && type === "object") {
            if (parent) cloned[i2] = parent;
        } else if (i2 === "source") cloned[i2] = value;
        else if (Array.isArray(value)) cloned[i2] = value.map((j)=>$791ce2ee9eb5657b$var$cloneNode(j, cloned));
        else {
            if (type === "object" && value !== null) value = $791ce2ee9eb5657b$var$cloneNode(value);
            cloned[i2] = value;
        }
    }
    return cloned;
}
let $791ce2ee9eb5657b$var$Node$4 = class Node3 {
    constructor(defaults = {}){
        this.raws = {};
        this[$791ce2ee9eb5657b$var$isClean$2] = false;
        this[$791ce2ee9eb5657b$var$my$2] = true;
        for(let name in defaults)if (name === "nodes") {
            this.nodes = [];
            for (let node2 of defaults[name])if (typeof node2.clone === "function") this.append(node2.clone());
            else this.append(node2);
        } else this[name] = defaults[name];
    }
    addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            let s2 = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, `$&${s2.input.from}:${s2.start.line}:${s2.start.column}$&`);
        }
        return error;
    }
    after(add) {
        this.parent.insertAfter(this, add);
        return this;
    }
    assign(overrides = {}) {
        for(let name in overrides)this[name] = overrides[name];
        return this;
    }
    before(add) {
        this.parent.insertBefore(this, add);
        return this;
    }
    cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    }
    clone(overrides = {}) {
        let cloned = $791ce2ee9eb5657b$var$cloneNode(this);
        for(let name in overrides)cloned[name] = overrides[name];
        return cloned;
    }
    cloneAfter(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    }
    cloneBefore(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    }
    error(message, opts = {}) {
        if (this.source) {
            let { end: end, start: start } = this.rangeBy(opts);
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $791ce2ee9eb5657b$var$CssSyntaxError$2(message);
    }
    getProxyProcessor() {
        return {
            get (node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (prop === "root") return ()=>node2.root().toProxy();
                else return node2[prop];
            },
            set (node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node2.markDirty();
                return true;
            }
        };
    }
    markDirty() {
        if (this[$791ce2ee9eb5657b$var$isClean$2]) {
            this[$791ce2ee9eb5657b$var$isClean$2] = false;
            let next = this;
            while(next = next.parent)next[$791ce2ee9eb5657b$var$isClean$2] = false;
        }
    }
    next() {
        if (!this.parent) return void 0;
        let index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    }
    positionBy(opts, stringRepresentation) {
        let pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            let index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    }
    positionInside(index2, stringRepresentation) {
        let string = stringRepresentation || this.toString();
        let column = this.source.start.column;
        let line = this.source.start.line;
        for(let i2 = 0; i2 < index2; i2++)if (string[i2] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    }
    prev() {
        if (!this.parent) return void 0;
        let index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    }
    rangeBy(opts) {
        let start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        let end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            let stringRepresentation = this.toString();
            let index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (typeof opts.endIndex === "number") end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    }
    raw(prop, defaultType) {
        let str = new $791ce2ee9eb5657b$var$Stringifier22();
        return str.raw(this, prop, defaultType);
    }
    remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = void 0;
        return this;
    }
    replaceWith(...nodes) {
        if (this.parent) {
            let bookmark = this;
            let foundSelf = false;
            for (let node2 of nodes){
                if (node2 === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else this.parent.insertBefore(bookmark, node2);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    }
    root() {
        let result2 = this;
        while(result2.parent && result2.parent.type !== "document")result2 = result2.parent;
        return result2;
    }
    toJSON(_, inputs) {
        let fixed = {};
        let emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        let inputsNextIndex = 0;
        for(let name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            let value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map((i2)=>{
                if (typeof i2 === "object" && i2.toJSON) return i2.toJSON(null, inputs);
                else return i2;
            });
            else if (typeof value === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                let inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [
            ...inputs.keys()
        ].map((input2)=>input2.toJSON());
        return fixed;
    }
    toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    }
    toString(stringifier2 = $791ce2ee9eb5657b$var$stringify$3) {
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        let result2 = "";
        stringifier2(this, (i2)=>{
            result2 += i2;
        });
        return result2;
    }
    warn(result2, text, opts) {
        let data = {
            node: this
        };
        for(let i2 in opts)data[i2] = opts[i2];
        return result2.warn(text, data);
    }
    get proxyOf() {
        return this;
    }
};
var $791ce2ee9eb5657b$var$node = $791ce2ee9eb5657b$var$Node$4;
$791ce2ee9eb5657b$var$Node$4.default = $791ce2ee9eb5657b$var$Node$4;
let $791ce2ee9eb5657b$var$Node$3 = $791ce2ee9eb5657b$var$node;
let $791ce2ee9eb5657b$var$Declaration$4 = class Declaration2 extends $791ce2ee9eb5657b$var$Node$3 {
    constructor(defaults){
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = {
            ...defaults,
            value: String(defaults.value)
        };
        super(defaults);
        this.type = "decl";
    }
    get variable() {
        return this.prop.startsWith("--") || this.prop[0] === "$";
    }
};
var $791ce2ee9eb5657b$var$declaration = $791ce2ee9eb5657b$var$Declaration$4;
$791ce2ee9eb5657b$var$Declaration$4.default = $791ce2ee9eb5657b$var$Declaration$4;
let $791ce2ee9eb5657b$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $791ce2ee9eb5657b$var$customAlphabet = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i2 = size;
        while(i2--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $791ce2ee9eb5657b$var$nanoid$1 = (size = 21)=>{
    let id = "";
    let i2 = size;
    while(i2--)id += $791ce2ee9eb5657b$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
var $791ce2ee9eb5657b$var$nonSecure = {
    nanoid: $791ce2ee9eb5657b$var$nanoid$1,
    customAlphabet: $791ce2ee9eb5657b$var$customAlphabet
};
let { SourceMapConsumer: $791ce2ee9eb5657b$var$SourceMapConsumer$2, SourceMapGenerator: $791ce2ee9eb5657b$var$SourceMapGenerator$2 } = $791ce2ee9eb5657b$var$require$$2;
let { existsSync: $791ce2ee9eb5657b$var$existsSync, readFileSync: $791ce2ee9eb5657b$var$readFileSync } = $791ce2ee9eb5657b$var$require$$2;
let { dirname: $791ce2ee9eb5657b$var$dirname$1, join: $791ce2ee9eb5657b$var$join } = $791ce2ee9eb5657b$var$require$$2;
function $791ce2ee9eb5657b$var$fromBase64(str) {
    if ($791ce2ee9eb5657b$require$Buffer) return $791ce2ee9eb5657b$require$Buffer.from(str, "base64").toString();
    else return window.atob(str);
}
let $791ce2ee9eb5657b$var$PreviousMap$2 = class PreviousMap2 {
    constructor(css, opts){
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        let prev = opts.map ? opts.map.prev : void 0;
        let text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $791ce2ee9eb5657b$var$dirname$1(this.mapFile);
        if (text) this.text = text;
    }
    consumer() {
        if (!this.consumerCache) this.consumerCache = new $791ce2ee9eb5657b$var$SourceMapConsumer$2(this.text);
        return this.consumerCache;
    }
    decodeInline(text) {
        let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        let baseUri = /^data:application\/json;base64,/;
        let charsetUri = /^data:application\/json;charset=utf-?8,/;
        let uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $791ce2ee9eb5657b$var$fromBase64(text.substr(RegExp.lastMatch.length));
        let encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    }
    getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(map) {
        if (typeof map !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    }
    loadAnnotation(css) {
        let comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        let start = css.lastIndexOf(comments.pop());
        let end = css.indexOf("*/", start);
        if (start > -1 && end > -1) this.annotation = this.getAnnotationURL(css.substring(start, end));
    }
    loadFile(path) {
        this.root = $791ce2ee9eb5657b$var$dirname$1(path);
        if ($791ce2ee9eb5657b$var$existsSync(path)) {
            this.mapFile = path;
            return $791ce2ee9eb5657b$var$readFileSync(path, "utf-8").toString().trim();
        }
    }
    loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                let prevPath = prev(file);
                if (prevPath) {
                    let map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if (prev instanceof $791ce2ee9eb5657b$var$SourceMapConsumer$2) return $791ce2ee9eb5657b$var$SourceMapGenerator$2.fromSourceMap(prev).toString();
            else if (prev instanceof $791ce2ee9eb5657b$var$SourceMapGenerator$2) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            let map = this.annotation;
            if (file) map = $791ce2ee9eb5657b$var$join($791ce2ee9eb5657b$var$dirname$1(file), map);
            return this.loadFile(map);
        }
    }
    startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    }
    withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
};
var $791ce2ee9eb5657b$var$previousMap = $791ce2ee9eb5657b$var$PreviousMap$2;
$791ce2ee9eb5657b$var$PreviousMap$2.default = $791ce2ee9eb5657b$var$PreviousMap$2;
let { SourceMapConsumer: $791ce2ee9eb5657b$var$SourceMapConsumer$1, SourceMapGenerator: $791ce2ee9eb5657b$var$SourceMapGenerator$1 } = $791ce2ee9eb5657b$var$require$$2;
let { fileURLToPath: $791ce2ee9eb5657b$var$fileURLToPath, pathToFileURL: $791ce2ee9eb5657b$var$pathToFileURL$1 } = $791ce2ee9eb5657b$var$require$$2;
let { isAbsolute: $791ce2ee9eb5657b$var$isAbsolute, resolve: $791ce2ee9eb5657b$var$resolve$1 } = $791ce2ee9eb5657b$var$require$$2;
let { nanoid: $791ce2ee9eb5657b$var$nanoid } = $791ce2ee9eb5657b$var$nonSecure;
let $791ce2ee9eb5657b$var$terminalHighlight = $791ce2ee9eb5657b$var$require$$2;
let $791ce2ee9eb5657b$var$CssSyntaxError$1 = $791ce2ee9eb5657b$var$cssSyntaxError;
let $791ce2ee9eb5657b$var$PreviousMap$1 = $791ce2ee9eb5657b$var$previousMap;
let $791ce2ee9eb5657b$var$fromOffsetCache = Symbol("fromOffsetCache");
let $791ce2ee9eb5657b$var$sourceMapAvailable$1 = Boolean($791ce2ee9eb5657b$var$SourceMapConsumer$1 && $791ce2ee9eb5657b$var$SourceMapGenerator$1);
let $791ce2ee9eb5657b$var$pathAvailable$1 = Boolean($791ce2ee9eb5657b$var$resolve$1 && $791ce2ee9eb5657b$var$isAbsolute);
let $791ce2ee9eb5657b$var$Input$4 = class Input2 {
    constructor(css, opts = {}){
        if (css === null || typeof css === "undefined" || typeof css === "object" && !css.toString) throw new Error(`PostCSS received ${css} instead of CSS string`);
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$791ce2ee9eb5657b$var$pathAvailable$1 || /^\w+:\/\//.test(opts.from) || $791ce2ee9eb5657b$var$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $791ce2ee9eb5657b$var$resolve$1(opts.from);
        }
        if ($791ce2ee9eb5657b$var$pathAvailable$1 && $791ce2ee9eb5657b$var$sourceMapAvailable$1) {
            let map = new $791ce2ee9eb5657b$var$PreviousMap$1(this.css, opts);
            if (map.text) {
                this.map = map;
                let file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $791ce2ee9eb5657b$var$nanoid(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    error(message, line, column, opts = {}) {
        let result2, endLine, endColumn;
        if (line && typeof line === "object") {
            let start = line;
            let end = column;
            if (typeof start.offset === "number") {
                let pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                let pos = this.fromOffset(end.offset);
                endLine = pos.line;
                endColumn = pos.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            let pos = this.fromOffset(line);
            line = pos.line;
            column = pos.col;
        }
        let origin = this.origin(line, column, endLine, endColumn);
        if (origin) result2 = new $791ce2ee9eb5657b$var$CssSyntaxError$1(message, origin.endLine === void 0 ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === void 0 ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result2 = new $791ce2ee9eb5657b$var$CssSyntaxError$1(message, endLine === void 0 ? line : {
            column: column,
            line: line
        }, endLine === void 0 ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result2.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($791ce2ee9eb5657b$var$pathToFileURL$1) result2.input.url = $791ce2ee9eb5657b$var$pathToFileURL$1(this.file).toString();
            result2.input.file = this.file;
        }
        return result2;
    }
    fromOffset(offset) {
        let lastLine, lineToIndex;
        if (!this[$791ce2ee9eb5657b$var$fromOffsetCache]) {
            let lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            let prevIndex = 0;
            for(let i2 = 0, l2 = lines.length; i2 < l2; i2++){
                lineToIndex[i2] = prevIndex;
                prevIndex += lines[i2].length + 1;
            }
            this[$791ce2ee9eb5657b$var$fromOffsetCache] = lineToIndex;
        } else lineToIndex = this[$791ce2ee9eb5657b$var$fromOffsetCache];
        lastLine = lineToIndex[lineToIndex.length - 1];
        let min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            let max = lineToIndex.length - 2;
            let mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    }
    mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $791ce2ee9eb5657b$var$resolve$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    }
    origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        let consumer = this.map.consumer();
        let from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        let to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        let fromUrl;
        if ($791ce2ee9eb5657b$var$isAbsolute(from.source)) fromUrl = $791ce2ee9eb5657b$var$pathToFileURL$1(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $791ce2ee9eb5657b$var$pathToFileURL$1(this.map.mapFile));
        let result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($791ce2ee9eb5657b$var$fileURLToPath) result2.file = $791ce2ee9eb5657b$var$fileURLToPath(fromUrl);
            else throw new Error(`file: protocol is not available in this PostCSS build`);
        }
        let source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    }
    toJSON() {
        let json = {};
        for (let name of [
            "hasBOM",
            "css",
            "file",
            "id"
        ])if (this[name] != null) json[name] = this[name];
        if (this.map) {
            json.map = {
                ...this.map
            };
            if (json.map.consumerCache) json.map.consumerCache = void 0;
        }
        return json;
    }
    get from() {
        return this.file || this.id;
    }
};
var $791ce2ee9eb5657b$var$input = $791ce2ee9eb5657b$var$Input$4;
$791ce2ee9eb5657b$var$Input$4.default = $791ce2ee9eb5657b$var$Input$4;
if ($791ce2ee9eb5657b$var$terminalHighlight && $791ce2ee9eb5657b$var$terminalHighlight.registerInput) $791ce2ee9eb5657b$var$terminalHighlight.registerInput($791ce2ee9eb5657b$var$Input$4);
let { SourceMapConsumer: $791ce2ee9eb5657b$var$SourceMapConsumer, SourceMapGenerator: $791ce2ee9eb5657b$var$SourceMapGenerator } = $791ce2ee9eb5657b$var$require$$2;
let { dirname: $791ce2ee9eb5657b$var$dirname, relative: $791ce2ee9eb5657b$var$relative, resolve: $791ce2ee9eb5657b$var$resolve, sep: $791ce2ee9eb5657b$var$sep } = $791ce2ee9eb5657b$var$require$$2;
let { pathToFileURL: $791ce2ee9eb5657b$var$pathToFileURL } = $791ce2ee9eb5657b$var$require$$2;
let $791ce2ee9eb5657b$var$Input$3 = $791ce2ee9eb5657b$var$input;
let $791ce2ee9eb5657b$var$sourceMapAvailable = Boolean($791ce2ee9eb5657b$var$SourceMapConsumer && $791ce2ee9eb5657b$var$SourceMapGenerator);
let $791ce2ee9eb5657b$var$pathAvailable = Boolean($791ce2ee9eb5657b$var$dirname && $791ce2ee9eb5657b$var$resolve && $791ce2ee9eb5657b$var$relative && $791ce2ee9eb5657b$var$sep);
let $791ce2ee9eb5657b$var$MapGenerator$2 = class MapGenerator2 {
    constructor(stringify2, root2, opts, cssString){
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
        let content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        let eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    }
    applyPrevMaps() {
        for (let prev of this.previous()){
            let from = this.toUrl(this.path(prev.file));
            let root2 = prev.root || $791ce2ee9eb5657b$var$dirname(prev.file);
            let map;
            if (this.mapOpts.sourcesContent === false) {
                map = new $791ce2ee9eb5657b$var$SourceMapConsumer(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    }
    clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            let node2;
            for(let i2 = this.root.nodes.length - 1; i2 >= 0; i2--){
                node2 = this.root.nodes[i2];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i2);
            }
        } else if (this.css) this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
    }
    generate() {
        this.clearAnnotation();
        if ($791ce2ee9eb5657b$var$pathAvailable && $791ce2ee9eb5657b$var$sourceMapAvailable && this.isMap()) return this.generateMap();
        else {
            let result2 = "";
            this.stringify(this.root, (i2)=>{
                result2 += i2;
            });
            return [
                result2
            ];
        }
    }
    generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            let prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $791ce2ee9eb5657b$var$SourceMapGenerator.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $791ce2ee9eb5657b$var$SourceMapGenerator({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    }
    generateString() {
        this.css = "";
        this.map = new $791ce2ee9eb5657b$var$SourceMapGenerator({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        let line = 1;
        let column = 1;
        let noSource = "<no source>";
        let mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        let lines, last;
        this.stringify(this.root, (str, node2, type)=>{
            this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node2 && type !== "start") {
                let p = node2.parent || {
                    raws: {}
                };
                let childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        this.map.addMapping(mapping);
                    }
                }
            }
        });
    }
    isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some((i2)=>i2.annotation);
        return true;
    }
    isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        let annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some((i2)=>i2.inline);
        return true;
    }
    isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    }
    isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some((i2)=>i2.withContent());
        return true;
    }
    outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    }
    path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        let cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        let from = this.opts.to ? $791ce2ee9eb5657b$var$dirname(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $791ce2ee9eb5657b$var$dirname($791ce2ee9eb5657b$var$resolve(from, this.mapOpts.annotation));
        let path = $791ce2ee9eb5657b$var$relative(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    }
    previous() {
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk((node2)=>{
                if (node2.source && node2.source.input.map) {
                    let map = node2.source.input.map;
                    if (!this.previousMaps.includes(map)) this.previousMaps.push(map);
                }
            });
            else {
                let input2 = new $791ce2ee9eb5657b$var$Input$3(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    }
    setSourcesContent() {
        let already = {};
        if (this.root) this.root.walk((node2)=>{
            if (node2.source) {
                let from = node2.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
                    this.map.setSourceContent(fromUrl, node2.source.input.css);
                }
            }
        });
        else if (this.css) {
            let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    }
    sourcePath(node2) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node2.source.input.from);
        else return this.toUrl(this.path(node2.source.input.from));
    }
    toBase64(str) {
        if ($791ce2ee9eb5657b$require$Buffer) return $791ce2ee9eb5657b$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    }
    toFileUrl(path) {
        let cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($791ce2ee9eb5657b$var$pathToFileURL) {
            let fileURL = $791ce2ee9eb5657b$var$pathToFileURL(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error("`map.absolute` option is not available in this PostCSS build");
    }
    toUrl(path) {
        let cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($791ce2ee9eb5657b$var$sep === "\\") path = path.replace(/\\/g, "/");
        let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    }
};
var $791ce2ee9eb5657b$var$mapGenerator = $791ce2ee9eb5657b$var$MapGenerator$2;
let $791ce2ee9eb5657b$var$Node$2 = $791ce2ee9eb5657b$var$node;
let $791ce2ee9eb5657b$var$Comment$4 = class Comment2 extends $791ce2ee9eb5657b$var$Node$2 {
    constructor(defaults){
        super(defaults);
        this.type = "comment";
    }
};
var $791ce2ee9eb5657b$var$comment = $791ce2ee9eb5657b$var$Comment$4;
$791ce2ee9eb5657b$var$Comment$4.default = $791ce2ee9eb5657b$var$Comment$4;
let { isClean: $791ce2ee9eb5657b$var$isClean$1, my: $791ce2ee9eb5657b$var$my$1 } = $791ce2ee9eb5657b$var$symbols;
let $791ce2ee9eb5657b$var$Declaration$3 = $791ce2ee9eb5657b$var$declaration;
let $791ce2ee9eb5657b$var$Comment$3 = $791ce2ee9eb5657b$var$comment;
let $791ce2ee9eb5657b$var$Node$1 = $791ce2ee9eb5657b$var$node;
let $791ce2ee9eb5657b$var$parse$4, $791ce2ee9eb5657b$var$Rule$4, $791ce2ee9eb5657b$var$AtRule$4, $791ce2ee9eb5657b$var$Root$6;
function $791ce2ee9eb5657b$var$cleanSource(nodes) {
    return nodes.map((i2)=>{
        if (i2.nodes) i2.nodes = $791ce2ee9eb5657b$var$cleanSource(i2.nodes);
        delete i2.source;
        return i2;
    });
}
function $791ce2ee9eb5657b$var$markDirtyUp(node2) {
    node2[$791ce2ee9eb5657b$var$isClean$1] = false;
    if (node2.proxyOf.nodes) for (let i2 of node2.proxyOf.nodes)$791ce2ee9eb5657b$var$markDirtyUp(i2);
}
let $791ce2ee9eb5657b$var$Container$7 = class Container2 extends $791ce2ee9eb5657b$var$Node$1 {
    append(...children) {
        for (let child of children){
            let nodes = this.normalize(child, this.last);
            for (let node2 of nodes)this.proxyOf.nodes.push(node2);
        }
        this.markDirty();
        return this;
    }
    cleanRaws(keepBetween) {
        super.cleanRaws(keepBetween);
        if (this.nodes) for (let node2 of this.nodes)node2.cleanRaws(keepBetween);
    }
    each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        let iterator = this.getIterator();
        let index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    }
    every(condition) {
        return this.nodes.every(condition);
    }
    getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        let iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    }
    getProxyProcessor() {
        return {
            get (node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (!node2[prop]) return node2[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return (...args)=>{
                    return node2[prop](...args.map((i2)=>{
                        if (typeof i2 === "function") return (child, index2)=>i2(child.toProxy(), index2);
                        else return i2;
                    }));
                };
                else if (prop === "every" || prop === "some") return (cb)=>{
                    return node2[prop]((child, ...other)=>cb(child.toProxy(), ...other));
                };
                else if (prop === "root") return ()=>node2.root().toProxy();
                else if (prop === "nodes") return node2.nodes.map((i2)=>i2.toProxy());
                else if (prop === "first" || prop === "last") return node2[prop].toProxy();
                else return node2[prop];
            },
            set (node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node2.markDirty();
                return true;
            }
        };
    }
    index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    }
    insertAfter(exist, add) {
        let existIndex = this.index(exist);
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for (let node2 of nodes)this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    }
    insertBefore(exist, add) {
        let existIndex = this.index(exist);
        let type = existIndex === 0 ? "prepend" : false;
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for (let node2 of nodes)this.proxyOf.nodes.splice(existIndex, 0, node2);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    }
    normalize(nodes, sample) {
        if (typeof nodes === "string") nodes = $791ce2ee9eb5657b$var$cleanSource($791ce2ee9eb5657b$var$parse$4(nodes).nodes);
        else if (typeof nodes === "undefined") nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for (let i2 of nodes)if (i2.parent) i2.parent.removeChild(i2, "ignore");
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for (let i2 of nodes)if (i2.parent) i2.parent.removeChild(i2, "ignore");
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $791ce2ee9eb5657b$var$Declaration$3(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $791ce2ee9eb5657b$var$Rule$4(nodes)
        ];
        else if (nodes.name) nodes = [
            new $791ce2ee9eb5657b$var$AtRule$4(nodes)
        ];
        else if (nodes.text) nodes = [
            new $791ce2ee9eb5657b$var$Comment$3(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        let processed = nodes.map((i2)=>{
            if (!i2[$791ce2ee9eb5657b$var$my$1]) Container2.rebuild(i2);
            i2 = i2.proxyOf;
            if (i2.parent) i2.parent.removeChild(i2);
            if (i2[$791ce2ee9eb5657b$var$isClean$1]) $791ce2ee9eb5657b$var$markDirtyUp(i2);
            if (typeof i2.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i2.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i2.parent = this.proxyOf;
            return i2;
        });
        return processed;
    }
    prepend(...children) {
        children = children.reverse();
        for (let child of children){
            let nodes = this.normalize(child, this.first, "prepend").reverse();
            for (let node2 of nodes)this.proxyOf.nodes.unshift(node2);
            for(let id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    }
    push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    }
    removeAll() {
        for (let node2 of this.proxyOf.nodes)node2.parent = void 0;
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    }
    removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) this.indexes[id] = index2 - 1;
        }
        this.markDirty();
        return this;
    }
    replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls((decl)=>{
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    }
    some(condition) {
        return this.nodes.some(condition);
    }
    walk(callback) {
        return this.each((child, i2)=>{
            let result2;
            try {
                result2 = callback(child, i2);
            } catch (e2) {
                throw child.addToError(e2);
            }
            if (result2 !== false && child.walk) result2 = child.walk(callback);
            return result2;
        });
    }
    walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk((child, i2)=>{
                if (child.type === "atrule") return callback(child, i2);
            });
        }
        if (name instanceof RegExp) return this.walk((child, i2)=>{
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i2);
        });
        return this.walk((child, i2)=>{
            if (child.type === "atrule" && child.name === name) return callback(child, i2);
        });
    }
    walkComments(callback) {
        return this.walk((child, i2)=>{
            if (child.type === "comment") return callback(child, i2);
        });
    }
    walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk((child, i2)=>{
                if (child.type === "decl") return callback(child, i2);
            });
        }
        if (prop instanceof RegExp) return this.walk((child, i2)=>{
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i2);
        });
        return this.walk((child, i2)=>{
            if (child.type === "decl" && child.prop === prop) return callback(child, i2);
        });
    }
    walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk((child, i2)=>{
                if (child.type === "rule") return callback(child, i2);
            });
        }
        if (selector instanceof RegExp) return this.walk((child, i2)=>{
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i2);
        });
        return this.walk((child, i2)=>{
            if (child.type === "rule" && child.selector === selector) return callback(child, i2);
        });
    }
    get first() {
        if (!this.proxyOf.nodes) return void 0;
        return this.proxyOf.nodes[0];
    }
    get last() {
        if (!this.proxyOf.nodes) return void 0;
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
};
$791ce2ee9eb5657b$var$Container$7.registerParse = (dependant)=>{
    $791ce2ee9eb5657b$var$parse$4 = dependant;
};
$791ce2ee9eb5657b$var$Container$7.registerRule = (dependant)=>{
    $791ce2ee9eb5657b$var$Rule$4 = dependant;
};
$791ce2ee9eb5657b$var$Container$7.registerAtRule = (dependant)=>{
    $791ce2ee9eb5657b$var$AtRule$4 = dependant;
};
$791ce2ee9eb5657b$var$Container$7.registerRoot = (dependant)=>{
    $791ce2ee9eb5657b$var$Root$6 = dependant;
};
var $791ce2ee9eb5657b$var$container = $791ce2ee9eb5657b$var$Container$7;
$791ce2ee9eb5657b$var$Container$7.default = $791ce2ee9eb5657b$var$Container$7;
$791ce2ee9eb5657b$var$Container$7.rebuild = (node2)=>{
    if (node2.type === "atrule") Object.setPrototypeOf(node2, $791ce2ee9eb5657b$var$AtRule$4.prototype);
    else if (node2.type === "rule") Object.setPrototypeOf(node2, $791ce2ee9eb5657b$var$Rule$4.prototype);
    else if (node2.type === "decl") Object.setPrototypeOf(node2, $791ce2ee9eb5657b$var$Declaration$3.prototype);
    else if (node2.type === "comment") Object.setPrototypeOf(node2, $791ce2ee9eb5657b$var$Comment$3.prototype);
    else if (node2.type === "root") Object.setPrototypeOf(node2, $791ce2ee9eb5657b$var$Root$6.prototype);
    node2[$791ce2ee9eb5657b$var$my$1] = true;
    if (node2.nodes) node2.nodes.forEach((child)=>{
        $791ce2ee9eb5657b$var$Container$7.rebuild(child);
    });
};
let $791ce2ee9eb5657b$var$Container$6 = $791ce2ee9eb5657b$var$container;
let $791ce2ee9eb5657b$var$LazyResult$4, $791ce2ee9eb5657b$var$Processor$3;
let $791ce2ee9eb5657b$var$Document$3 = class Document23 extends $791ce2ee9eb5657b$var$Container$6 {
    constructor(defaults){
        super({
            type: "document",
            ...defaults
        });
        if (!this.nodes) this.nodes = [];
    }
    toResult(opts = {}) {
        let lazy = new $791ce2ee9eb5657b$var$LazyResult$4(new $791ce2ee9eb5657b$var$Processor$3(), this, opts);
        return lazy.stringify();
    }
};
$791ce2ee9eb5657b$var$Document$3.registerLazyResult = (dependant)=>{
    $791ce2ee9eb5657b$var$LazyResult$4 = dependant;
};
$791ce2ee9eb5657b$var$Document$3.registerProcessor = (dependant)=>{
    $791ce2ee9eb5657b$var$Processor$3 = dependant;
};
var $791ce2ee9eb5657b$var$document$1 = $791ce2ee9eb5657b$var$Document$3;
$791ce2ee9eb5657b$var$Document$3.default = $791ce2ee9eb5657b$var$Document$3;
let $791ce2ee9eb5657b$var$printed = {};
var $791ce2ee9eb5657b$var$warnOnce$2 = function warnOnce2(message) {
    if ($791ce2ee9eb5657b$var$printed[message]) return;
    $791ce2ee9eb5657b$var$printed[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};
let $791ce2ee9eb5657b$var$Warning$2 = class Warning2 {
    constructor(text, opts = {}){
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            let range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(let opt in opts)this[opt] = opts[opt];
    }
    toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    }
};
var $791ce2ee9eb5657b$var$warning = $791ce2ee9eb5657b$var$Warning$2;
$791ce2ee9eb5657b$var$Warning$2.default = $791ce2ee9eb5657b$var$Warning$2;
let $791ce2ee9eb5657b$var$Warning$1 = $791ce2ee9eb5657b$var$warning;
let $791ce2ee9eb5657b$var$Result$3 = class Result2 {
    constructor(processor2, root2, opts){
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
    toString() {
        return this.css;
    }
    warn(text, opts = {}) {
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        let warning2 = new $791ce2ee9eb5657b$var$Warning$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    }
    warnings() {
        return this.messages.filter((i2)=>i2.type === "warning");
    }
    get content() {
        return this.css;
    }
};
var $791ce2ee9eb5657b$var$result = $791ce2ee9eb5657b$var$Result$3;
$791ce2ee9eb5657b$var$Result$3.default = $791ce2ee9eb5657b$var$Result$3;
const $791ce2ee9eb5657b$var$SINGLE_QUOTE = "'".charCodeAt(0);
const $791ce2ee9eb5657b$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
const $791ce2ee9eb5657b$var$BACKSLASH = "\\".charCodeAt(0);
const $791ce2ee9eb5657b$var$SLASH = "/".charCodeAt(0);
const $791ce2ee9eb5657b$var$NEWLINE = "\n".charCodeAt(0);
const $791ce2ee9eb5657b$var$SPACE = " ".charCodeAt(0);
const $791ce2ee9eb5657b$var$FEED = "\f".charCodeAt(0);
const $791ce2ee9eb5657b$var$TAB = "	".charCodeAt(0);
const $791ce2ee9eb5657b$var$CR = "\r".charCodeAt(0);
const $791ce2ee9eb5657b$var$OPEN_SQUARE = "[".charCodeAt(0);
const $791ce2ee9eb5657b$var$CLOSE_SQUARE = "]".charCodeAt(0);
const $791ce2ee9eb5657b$var$OPEN_PARENTHESES = "(".charCodeAt(0);
const $791ce2ee9eb5657b$var$CLOSE_PARENTHESES = ")".charCodeAt(0);
const $791ce2ee9eb5657b$var$OPEN_CURLY = "{".charCodeAt(0);
const $791ce2ee9eb5657b$var$CLOSE_CURLY = "}".charCodeAt(0);
const $791ce2ee9eb5657b$var$SEMICOLON = ";".charCodeAt(0);
const $791ce2ee9eb5657b$var$ASTERISK = "*".charCodeAt(0);
const $791ce2ee9eb5657b$var$COLON = ":".charCodeAt(0);
const $791ce2ee9eb5657b$var$AT = "@".charCodeAt(0);
const $791ce2ee9eb5657b$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const $791ce2ee9eb5657b$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const $791ce2ee9eb5657b$var$RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
const $791ce2ee9eb5657b$var$RE_HEX_ESCAPE = /[\da-f]/i;
var $791ce2ee9eb5657b$var$tokenize = function tokenizer2(input2, options = {}) {
    let css = input2.css.valueOf();
    let ignore = options.ignoreErrors;
    let code, next, quote, content, escape;
    let escaped, escapePos, prev, n2, currentToken;
    let length = css.length;
    let pos = 0;
    let buffer = [];
    let returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $791ce2ee9eb5657b$var$NEWLINE:
            case $791ce2ee9eb5657b$var$SPACE:
            case $791ce2ee9eb5657b$var$TAB:
            case $791ce2ee9eb5657b$var$CR:
            case $791ce2ee9eb5657b$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $791ce2ee9eb5657b$var$SPACE || code === $791ce2ee9eb5657b$var$NEWLINE || code === $791ce2ee9eb5657b$var$TAB || code === $791ce2ee9eb5657b$var$CR || code === $791ce2ee9eb5657b$var$FEED);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $791ce2ee9eb5657b$var$OPEN_SQUARE:
            case $791ce2ee9eb5657b$var$CLOSE_SQUARE:
            case $791ce2ee9eb5657b$var$OPEN_CURLY:
            case $791ce2ee9eb5657b$var$CLOSE_CURLY:
            case $791ce2ee9eb5657b$var$COLON:
            case $791ce2ee9eb5657b$var$SEMICOLON:
            case $791ce2ee9eb5657b$var$CLOSE_PARENTHESES:
                {
                    let controlChar = String.fromCharCode(code);
                    currentToken = [
                        controlChar,
                        controlChar,
                        pos
                    ];
                    break;
                }
            case $791ce2ee9eb5657b$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : "";
                n2 = css.charCodeAt(pos + 1);
                if (prev === "url" && n2 !== $791ce2ee9eb5657b$var$SINGLE_QUOTE && n2 !== $791ce2ee9eb5657b$var$DOUBLE_QUOTE && n2 !== $791ce2ee9eb5657b$var$SPACE && n2 !== $791ce2ee9eb5657b$var$NEWLINE && n2 !== $791ce2ee9eb5657b$var$TAB && n2 !== $791ce2ee9eb5657b$var$FEED && n2 !== $791ce2ee9eb5657b$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $791ce2ee9eb5657b$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $791ce2ee9eb5657b$var$RE_BAD_BRACKET.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $791ce2ee9eb5657b$var$SINGLE_QUOTE:
            case $791ce2ee9eb5657b$var$DOUBLE_QUOTE:
                quote = code === $791ce2ee9eb5657b$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $791ce2ee9eb5657b$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $791ce2ee9eb5657b$var$AT:
                $791ce2ee9eb5657b$var$RE_AT_END.lastIndex = pos + 1;
                $791ce2ee9eb5657b$var$RE_AT_END.test(css);
                if ($791ce2ee9eb5657b$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $791ce2ee9eb5657b$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $791ce2ee9eb5657b$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $791ce2ee9eb5657b$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $791ce2ee9eb5657b$var$SLASH && code !== $791ce2ee9eb5657b$var$SPACE && code !== $791ce2ee9eb5657b$var$NEWLINE && code !== $791ce2ee9eb5657b$var$TAB && code !== $791ce2ee9eb5657b$var$CR && code !== $791ce2ee9eb5657b$var$FEED) {
                    next += 1;
                    if ($791ce2ee9eb5657b$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($791ce2ee9eb5657b$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $791ce2ee9eb5657b$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $791ce2ee9eb5657b$var$SLASH && css.charCodeAt(pos + 1) === $791ce2ee9eb5657b$var$ASTERISK) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $791ce2ee9eb5657b$var$RE_WORD_END.lastIndex = pos + 1;
                    $791ce2ee9eb5657b$var$RE_WORD_END.test(css);
                    if ($791ce2ee9eb5657b$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $791ce2ee9eb5657b$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};
let $791ce2ee9eb5657b$var$Container$5 = $791ce2ee9eb5657b$var$container;
let $791ce2ee9eb5657b$var$AtRule$3 = class AtRule2 extends $791ce2ee9eb5657b$var$Container$5 {
    constructor(defaults){
        super(defaults);
        this.type = "atrule";
    }
    append(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.append(...children);
    }
    prepend(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.prepend(...children);
    }
};
var $791ce2ee9eb5657b$var$atRule = $791ce2ee9eb5657b$var$AtRule$3;
$791ce2ee9eb5657b$var$AtRule$3.default = $791ce2ee9eb5657b$var$AtRule$3;
$791ce2ee9eb5657b$var$Container$5.registerAtRule($791ce2ee9eb5657b$var$AtRule$3);
let $791ce2ee9eb5657b$var$Container$4 = $791ce2ee9eb5657b$var$container;
let $791ce2ee9eb5657b$var$LazyResult$3, $791ce2ee9eb5657b$var$Processor$2;
let $791ce2ee9eb5657b$var$Root$5 = class Root2 extends $791ce2ee9eb5657b$var$Container$4 {
    constructor(defaults){
        super(defaults);
        this.type = "root";
        if (!this.nodes) this.nodes = [];
    }
    normalize(child, sample, type) {
        let nodes = super.normalize(child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for (let node2 of nodes)node2.raws.before = sample.raws.before;
        }
        return nodes;
    }
    removeChild(child, ignore) {
        let index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index2].raws.before;
        return super.removeChild(child);
    }
    toResult(opts = {}) {
        let lazy = new $791ce2ee9eb5657b$var$LazyResult$3(new $791ce2ee9eb5657b$var$Processor$2(), this, opts);
        return lazy.stringify();
    }
};
$791ce2ee9eb5657b$var$Root$5.registerLazyResult = (dependant)=>{
    $791ce2ee9eb5657b$var$LazyResult$3 = dependant;
};
$791ce2ee9eb5657b$var$Root$5.registerProcessor = (dependant)=>{
    $791ce2ee9eb5657b$var$Processor$2 = dependant;
};
var $791ce2ee9eb5657b$var$root = $791ce2ee9eb5657b$var$Root$5;
$791ce2ee9eb5657b$var$Root$5.default = $791ce2ee9eb5657b$var$Root$5;
$791ce2ee9eb5657b$var$Container$4.registerRoot($791ce2ee9eb5657b$var$Root$5);
let $791ce2ee9eb5657b$var$list$2 = {
    comma (string) {
        return $791ce2ee9eb5657b$var$list$2.split(string, [
            ","
        ], true);
    },
    space (string) {
        let spaces = [
            " ",
            "\n",
            "	"
        ];
        return $791ce2ee9eb5657b$var$list$2.split(string, spaces);
    },
    split (string, separators, last) {
        let array = [];
        let current = "";
        let split = false;
        let func = 0;
        let inQuote = false;
        let prevQuote = "";
        let escape = false;
        for (let letter of string){
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var $791ce2ee9eb5657b$var$list_1 = $791ce2ee9eb5657b$var$list$2;
$791ce2ee9eb5657b$var$list$2.default = $791ce2ee9eb5657b$var$list$2;
let $791ce2ee9eb5657b$var$Container$3 = $791ce2ee9eb5657b$var$container;
let $791ce2ee9eb5657b$var$list$1 = $791ce2ee9eb5657b$var$list_1;
let $791ce2ee9eb5657b$var$Rule$3 = class Rule2 extends $791ce2ee9eb5657b$var$Container$3 {
    constructor(defaults){
        super(defaults);
        this.type = "rule";
        if (!this.nodes) this.nodes = [];
    }
    get selectors() {
        return $791ce2ee9eb5657b$var$list$1.comma(this.selector);
    }
    set selectors(values) {
        let match = this.selector ? this.selector.match(/,\s*/) : null;
        let sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
        this.selector = values.join(sep2);
    }
};
var $791ce2ee9eb5657b$var$rule = $791ce2ee9eb5657b$var$Rule$3;
$791ce2ee9eb5657b$var$Rule$3.default = $791ce2ee9eb5657b$var$Rule$3;
$791ce2ee9eb5657b$var$Container$3.registerRule($791ce2ee9eb5657b$var$Rule$3);
let $791ce2ee9eb5657b$var$Declaration$2 = $791ce2ee9eb5657b$var$declaration;
let $791ce2ee9eb5657b$var$tokenizer22 = $791ce2ee9eb5657b$var$tokenize;
let $791ce2ee9eb5657b$var$Comment$2 = $791ce2ee9eb5657b$var$comment;
let $791ce2ee9eb5657b$var$AtRule$2 = $791ce2ee9eb5657b$var$atRule;
let $791ce2ee9eb5657b$var$Root$4 = $791ce2ee9eb5657b$var$root;
let $791ce2ee9eb5657b$var$Rule$2 = $791ce2ee9eb5657b$var$rule;
const $791ce2ee9eb5657b$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $791ce2ee9eb5657b$var$findLastWithPosition(tokens) {
    for(let i2 = tokens.length - 1; i2 >= 0; i2--){
        let token = tokens[i2];
        let pos = token[3] || token[2];
        if (pos) return pos;
    }
}
let $791ce2ee9eb5657b$var$Parser$1 = class Parser2 {
    constructor(input2){
        this.input = input2;
        this.root = new $791ce2ee9eb5657b$var$Root$4();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    atrule(token) {
        let node2 = new $791ce2ee9eb5657b$var$AtRule$2();
        node2.name = token[1].slice(1);
        if (node2.name === "") this.unnamedAtrule(node2, token);
        this.init(node2, token[2]);
        let type;
        let prev;
        let shift;
        let last = false;
        let open = false;
        let params = [];
        let brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    }
    checkMissedSemicolon(tokens) {
        let colon = this.colon(tokens);
        if (colon === false) return;
        let founded = 0;
        let token;
        for(let j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    }
    colon(tokens) {
        let brackets = 0;
        let token, type, prev;
        for (let [i2, element] of tokens.entries()){
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i2;
            }
            prev = token;
        }
        return false;
    }
    comment(token) {
        let node2 = new $791ce2ee9eb5657b$var$Comment$2();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        let text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    }
    createTokenizer() {
        this.tokenizer = $791ce2ee9eb5657b$var$tokenizer22(this.input);
    }
    decl(tokens, customProperty) {
        let node2 = new $791ce2ee9eb5657b$var$Declaration$2();
        this.init(node2, tokens[0][2]);
        let last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || $791ce2ee9eb5657b$var$findLastWithPosition(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            let type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        let token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        let firstSpaces = [];
        let next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(let i2 = tokens.length - 1; i2 >= 0; i2--){
            token = tokens[i2];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                let string = this.stringFrom(tokens, i2);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                let cache = tokens.slice(0);
                let str = "";
                for(let j = i2; j > 0; j--){
                    let type = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        let hasWord = tokens.some((i2)=>i2[0] !== "space" && i2[0] !== "comment");
        if (hasWord) {
            node2.raws.between += firstSpaces.map((i2)=>i2[1]).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    }
    doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    emptyRule(token) {
        let node2 = new $791ce2ee9eb5657b$var$Rule$2();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    }
    end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    }
    endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            let prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    }
    // Helpers
    getPosition(offset) {
        let pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    }
    init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    }
    other(start) {
        let end = false;
        let type = null;
        let colon = false;
        let bracket = null;
        let brackets = [];
        let customProperty = start[1].startsWith("--");
        let tokens = [];
        let token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    }
    parse() {
        let token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    }
    precheckMissedSemicolon() {}
    raw(node2, prop, tokens, customProperty) {
        let token, type;
        let length = tokens.length;
        let value = "";
        let clean = true;
        let next, prev;
        for(let i2 = 0; i2 < length; i2 += 1){
            token = tokens[i2];
            type = token[0];
            if (type === "space" && i2 === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
                next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
                if (!$791ce2ee9eb5657b$var$SAFE_COMMENT_NEIGHBOR[prev] && !$791ce2ee9eb5657b$var$SAFE_COMMENT_NEIGHBOR[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            let raw = tokens.reduce((all, i2)=>all + i2[1], "");
            node2.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node2[prop] = value;
    }
    rule(tokens) {
        tokens.pop();
        let node2 = new $791ce2ee9eb5657b$var$Rule$2();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    }
    spacesAndCommentsFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    // Errors
    spacesAndCommentsFromStart(tokens) {
        let next;
        let spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    }
    spacesFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    stringFrom(tokens, from) {
        let result2 = "";
        for(let i2 = from; i2 < tokens.length; i2++)result2 += tokens[i2][1];
        tokens.splice(from, tokens.length - from);
        return result2;
    }
    unclosedBlock() {
        let pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    }
    unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    }
    unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    }
    unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    }
    unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
};
var $791ce2ee9eb5657b$var$parser = $791ce2ee9eb5657b$var$Parser$1;
let $791ce2ee9eb5657b$var$Container$2 = $791ce2ee9eb5657b$var$container;
let $791ce2ee9eb5657b$var$Parser22 = $791ce2ee9eb5657b$var$parser;
let $791ce2ee9eb5657b$var$Input$2 = $791ce2ee9eb5657b$var$input;
function $791ce2ee9eb5657b$var$parse$3(css, opts) {
    let input2 = new $791ce2ee9eb5657b$var$Input$2(css, opts);
    let parser2 = new $791ce2ee9eb5657b$var$Parser22(input2);
    try {
        parser2.parse();
    } catch (e2) {
        throw e2;
    }
    return parser2.root;
}
var $791ce2ee9eb5657b$var$parse_1 = $791ce2ee9eb5657b$var$parse$3;
$791ce2ee9eb5657b$var$parse$3.default = $791ce2ee9eb5657b$var$parse$3;
$791ce2ee9eb5657b$var$Container$2.registerParse($791ce2ee9eb5657b$var$parse$3);
let { isClean: $791ce2ee9eb5657b$var$isClean, my: $791ce2ee9eb5657b$var$my } = $791ce2ee9eb5657b$var$symbols;
let $791ce2ee9eb5657b$var$MapGenerator$1 = $791ce2ee9eb5657b$var$mapGenerator;
let $791ce2ee9eb5657b$var$stringify$2 = $791ce2ee9eb5657b$var$stringify_1;
let $791ce2ee9eb5657b$var$Container$1 = $791ce2ee9eb5657b$var$container;
let $791ce2ee9eb5657b$var$Document$2 = $791ce2ee9eb5657b$var$document$1;
let $791ce2ee9eb5657b$var$warnOnce$1 = $791ce2ee9eb5657b$var$warnOnce$2;
let $791ce2ee9eb5657b$var$Result$2 = $791ce2ee9eb5657b$var$result;
let $791ce2ee9eb5657b$var$parse$2 = $791ce2ee9eb5657b$var$parse_1;
let $791ce2ee9eb5657b$var$Root$3 = $791ce2ee9eb5657b$var$root;
const $791ce2ee9eb5657b$var$TYPE_TO_CLASS_NAME = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
const $791ce2ee9eb5657b$var$PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
const $791ce2ee9eb5657b$var$NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
const $791ce2ee9eb5657b$var$CHILDREN = 0;
function $791ce2ee9eb5657b$var$isPromise(obj) {
    return typeof obj === "object" && typeof obj.then === "function";
}
function $791ce2ee9eb5657b$var$getEvents(node2) {
    let key = false;
    let type = $791ce2ee9eb5657b$var$TYPE_TO_CLASS_NAME[node2.type];
    if (node2.type === "decl") key = node2.prop.toLowerCase();
    else if (node2.type === "atrule") key = node2.name.toLowerCase();
    if (key && node2.append) return [
        type,
        type + "-" + key,
        $791ce2ee9eb5657b$var$CHILDREN,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node2.append) return [
        type,
        $791ce2ee9eb5657b$var$CHILDREN,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $791ce2ee9eb5657b$var$toStack(node2) {
    let events;
    if (node2.type === "document") events = [
        "Document",
        $791ce2ee9eb5657b$var$CHILDREN,
        "DocumentExit"
    ];
    else if (node2.type === "root") events = [
        "Root",
        $791ce2ee9eb5657b$var$CHILDREN,
        "RootExit"
    ];
    else events = $791ce2ee9eb5657b$var$getEvents(node2);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function $791ce2ee9eb5657b$var$cleanMarks(node2) {
    node2[$791ce2ee9eb5657b$var$isClean] = false;
    if (node2.nodes) node2.nodes.forEach((i2)=>$791ce2ee9eb5657b$var$cleanMarks(i2));
    return node2;
}
let $791ce2ee9eb5657b$var$postcss$2 = {};
let $791ce2ee9eb5657b$var$LazyResult$2 = class LazyResult2 {
    constructor(processor2, css, opts){
        this.stringified = false;
        this.processed = false;
        let root2;
        if (typeof css === "object" && css !== null && (css.type === "root" || css.type === "document")) root2 = $791ce2ee9eb5657b$var$cleanMarks(css);
        else if (css instanceof LazyResult2 || css instanceof $791ce2ee9eb5657b$var$Result$2) {
            root2 = $791ce2ee9eb5657b$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            let parser2 = $791ce2ee9eb5657b$var$parse$2;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[$791ce2ee9eb5657b$var$my]) $791ce2ee9eb5657b$var$Container$1.rebuild(root2);
        }
        this.result = new $791ce2ee9eb5657b$var$Result$2(processor2, root2, opts);
        this.helpers = {
            ...$791ce2ee9eb5657b$var$postcss$2,
            postcss: $791ce2ee9eb5657b$var$postcss$2,
            result: this.result
        };
        this.plugins = this.processor.plugins.map((plugin22)=>{
            if (typeof plugin22 === "object" && plugin22.prepare) return {
                ...plugin22,
                ...plugin22.prepare(this.result)
            };
            else return plugin22;
        });
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(error, node2) {
        let plugin22 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin22.postcssPlugin;
                error.setMessage();
            } else plugin22.postcssVersion;
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    }
    prepareVisitors() {
        this.listeners = {};
        let add = (plugin22, type, cb)=>{
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push([
                plugin22,
                cb
            ]);
        };
        for (let plugin22 of this.plugins){
            if (typeof plugin22 === "object") for(let event in plugin22){
                if (!$791ce2ee9eb5657b$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error(`Unknown event ${event} in ${plugin22.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`);
                if (!$791ce2ee9eb5657b$var$NOT_VISITORS[event]) {
                    if (typeof plugin22[event] === "object") {
                        for(let filter in plugin22[event])if (filter === "*") add(plugin22, event, plugin22[event][filter]);
                        else add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                    } else if (typeof plugin22[event] === "function") add(plugin22, event, plugin22[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
        this.plugin = 0;
        for(let i2 = 0; i2 < this.plugins.length; i2++){
            let plugin22 = this.plugins[i2];
            let promise = this.runOnRoot(plugin22);
            if ($791ce2ee9eb5657b$var$isPromise(promise)) try {
                await promise;
            } catch (error) {
                throw this.handleError(error);
            }
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root2 = this.result.root;
            while(!root2[$791ce2ee9eb5657b$var$isClean]){
                root2[$791ce2ee9eb5657b$var$isClean] = true;
                let stack = [
                    $791ce2ee9eb5657b$var$toStack(root2)
                ];
                while(stack.length > 0){
                    let promise = this.visitTick(stack);
                    if ($791ce2ee9eb5657b$var$isPromise(promise)) try {
                        await promise;
                    } catch (e2) {
                        let node2 = stack[stack.length - 1].node;
                        throw this.handleError(e2, node2);
                    }
                }
            }
            if (this.listeners.OnceExit) for (let [plugin22, visitor] of this.listeners.OnceExit){
                this.result.lastPlugin = plugin22;
                try {
                    if (root2.type === "document") {
                        let roots = root2.nodes.map((subRoot)=>visitor(subRoot, this.helpers));
                        await Promise.all(roots);
                    } else await visitor(root2, this.helpers);
                } catch (e2) {
                    throw this.handleError(e2);
                }
            }
        }
        this.processed = true;
        return this.stringify();
    }
    runOnRoot(plugin22) {
        this.result.lastPlugin = plugin22;
        try {
            if (typeof plugin22 === "object" && plugin22.Once) {
                if (this.result.root.type === "document") {
                    let roots = this.result.root.nodes.map((root2)=>plugin22.Once(root2, this.helpers));
                    if ($791ce2ee9eb5657b$var$isPromise(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin22.Once(this.result.root, this.helpers);
            } else if (typeof plugin22 === "function") return plugin22(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    }
    stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        let opts = this.result.opts;
        let str = $791ce2ee9eb5657b$var$stringify$2;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        let map = new $791ce2ee9eb5657b$var$MapGenerator$1(str, this.result.root, this.result.opts);
        let data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    }
    sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for (let plugin22 of this.plugins){
            let promise = this.runOnRoot(plugin22);
            if ($791ce2ee9eb5657b$var$isPromise(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root2 = this.result.root;
            while(!root2[$791ce2ee9eb5657b$var$isClean]){
                root2[$791ce2ee9eb5657b$var$isClean] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") for (let subRoot of root2.nodes)this.visitSync(this.listeners.OnceExit, subRoot);
                else this.visitSync(this.listeners.OnceExit, root2);
            }
        }
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this.css;
    }
    visitSync(visitors, node2) {
        for (let [plugin22, visitor] of visitors){
            this.result.lastPlugin = plugin22;
            let promise;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) return true;
            if ($791ce2ee9eb5657b$var$isPromise(promise)) throw this.getAsyncError();
        }
    }
    visitTick(stack) {
        let visit2 = stack[stack.length - 1];
        let { node: node2, visitors: visitors } = visit2;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            let [plugin22, visitor] = visitors[visit2.visitorIndex];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin22;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2);
            }
        }
        if (visit2.iterator !== 0) {
            let iterator = visit2.iterator;
            let child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[$791ce2ee9eb5657b$var$isClean]) {
                    child[$791ce2ee9eb5657b$var$isClean] = true;
                    stack.push($791ce2ee9eb5657b$var$toStack(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        let events = visit2.events;
        while(visit2.eventIndex < events.length){
            let event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === $791ce2ee9eb5657b$var$CHILDREN) {
                if (node2.nodes && node2.nodes.length) {
                    node2[$791ce2ee9eb5657b$var$isClean] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    }
    walkSync(node2) {
        node2[$791ce2ee9eb5657b$var$isClean] = true;
        let events = $791ce2ee9eb5657b$var$getEvents(node2);
        for (let event of events){
            if (event === $791ce2ee9eb5657b$var$CHILDREN) {
                if (node2.nodes) node2.each((child)=>{
                    if (!child[$791ce2ee9eb5657b$var$isClean]) this.walkSync(child);
                });
            } else {
                let visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    }
    warnings() {
        return this.sync().warnings();
    }
    get content() {
        return this.stringify().content;
    }
    get css() {
        return this.stringify().css;
    }
    get map() {
        return this.stringify().map;
    }
    get messages() {
        return this.sync().messages;
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        return this.sync().root;
    }
    get [Symbol.toStringTag]() {
        return "LazyResult";
    }
};
$791ce2ee9eb5657b$var$LazyResult$2.registerPostcss = (dependant)=>{
    $791ce2ee9eb5657b$var$postcss$2 = dependant;
};
var $791ce2ee9eb5657b$var$lazyResult = $791ce2ee9eb5657b$var$LazyResult$2;
$791ce2ee9eb5657b$var$LazyResult$2.default = $791ce2ee9eb5657b$var$LazyResult$2;
$791ce2ee9eb5657b$var$Root$3.registerLazyResult($791ce2ee9eb5657b$var$LazyResult$2);
$791ce2ee9eb5657b$var$Document$2.registerLazyResult($791ce2ee9eb5657b$var$LazyResult$2);
let $791ce2ee9eb5657b$var$MapGenerator22 = $791ce2ee9eb5657b$var$mapGenerator;
let $791ce2ee9eb5657b$var$stringify$1 = $791ce2ee9eb5657b$var$stringify_1;
let $791ce2ee9eb5657b$var$warnOnce22 = $791ce2ee9eb5657b$var$warnOnce$2;
let $791ce2ee9eb5657b$var$parse$1 = $791ce2ee9eb5657b$var$parse_1;
const $791ce2ee9eb5657b$var$Result$1 = $791ce2ee9eb5657b$var$result;
let $791ce2ee9eb5657b$var$NoWorkResult$1 = class NoWorkResult2 {
    constructor(processor2, css, opts){
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        let root2;
        let str = $791ce2ee9eb5657b$var$stringify$1;
        this.result = new $791ce2ee9eb5657b$var$Result$1(this._processor, root2, this._opts);
        this.result.css = css;
        let self = this;
        Object.defineProperty(this.result, "root", {
            get () {
                return self.root;
            }
        });
        let map = new $791ce2ee9eb5657b$var$MapGenerator22(str, root2, this._opts, css);
        if (map.isMap()) {
            let [generatedCSS, generatedMap] = map.generate();
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    sync() {
        if (this.error) throw this.error;
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this._css;
    }
    warnings() {
        return [];
    }
    get content() {
        return this.result.css;
    }
    get css() {
        return this.result.css;
    }
    get map() {
        return this.result.map;
    }
    get messages() {
        return [];
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        if (this._root) return this._root;
        let root2;
        let parser2 = $791ce2ee9eb5657b$var$parse$1;
        try {
            root2 = parser2(this._css, this._opts);
        } catch (error) {
            this.error = error;
        }
        if (this.error) throw this.error;
        else {
            this._root = root2;
            return root2;
        }
    }
    get [Symbol.toStringTag]() {
        return "NoWorkResult";
    }
};
var $791ce2ee9eb5657b$var$noWorkResult = $791ce2ee9eb5657b$var$NoWorkResult$1;
$791ce2ee9eb5657b$var$NoWorkResult$1.default = $791ce2ee9eb5657b$var$NoWorkResult$1;
let $791ce2ee9eb5657b$var$NoWorkResult22 = $791ce2ee9eb5657b$var$noWorkResult;
let $791ce2ee9eb5657b$var$LazyResult$1 = $791ce2ee9eb5657b$var$lazyResult;
let $791ce2ee9eb5657b$var$Document$1 = $791ce2ee9eb5657b$var$document$1;
let $791ce2ee9eb5657b$var$Root$2 = $791ce2ee9eb5657b$var$root;
let $791ce2ee9eb5657b$var$Processor$1 = class Processor2 {
    constructor(plugins = []){
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
    normalize(plugins) {
        let normalized = [];
        for (let i2 of plugins){
            if (i2.postcss === true) i2 = i2();
            else if (i2.postcss) i2 = i2.postcss;
            if (typeof i2 === "object" && Array.isArray(i2.plugins)) normalized = normalized.concat(i2.plugins);
            else if (typeof i2 === "object" && i2.postcssPlugin) normalized.push(i2);
            else if (typeof i2 === "function") normalized.push(i2);
            else if (typeof i2 === "object" && (i2.parse || i2.stringify)) ;
            else throw new Error(i2 + " is not a PostCSS plugin");
        }
        return normalized;
    }
    process(css, opts = {}) {
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $791ce2ee9eb5657b$var$NoWorkResult22(this, css, opts);
        else return new $791ce2ee9eb5657b$var$LazyResult$1(this, css, opts);
    }
    use(plugin22) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin22
        ]));
        return this;
    }
};
var $791ce2ee9eb5657b$var$processor = $791ce2ee9eb5657b$var$Processor$1;
$791ce2ee9eb5657b$var$Processor$1.default = $791ce2ee9eb5657b$var$Processor$1;
$791ce2ee9eb5657b$var$Root$2.registerProcessor($791ce2ee9eb5657b$var$Processor$1);
$791ce2ee9eb5657b$var$Document$1.registerProcessor($791ce2ee9eb5657b$var$Processor$1);
let $791ce2ee9eb5657b$var$Declaration$1 = $791ce2ee9eb5657b$var$declaration;
let $791ce2ee9eb5657b$var$PreviousMap22 = $791ce2ee9eb5657b$var$previousMap;
let $791ce2ee9eb5657b$var$Comment$1 = $791ce2ee9eb5657b$var$comment;
let $791ce2ee9eb5657b$var$AtRule$1 = $791ce2ee9eb5657b$var$atRule;
let $791ce2ee9eb5657b$var$Input$1 = $791ce2ee9eb5657b$var$input;
let $791ce2ee9eb5657b$var$Root$1 = $791ce2ee9eb5657b$var$root;
let $791ce2ee9eb5657b$var$Rule$1 = $791ce2ee9eb5657b$var$rule;
function $791ce2ee9eb5657b$var$fromJSON$1(json, inputs) {
    if (Array.isArray(json)) return json.map((n2)=>$791ce2ee9eb5657b$var$fromJSON$1(n2));
    let { inputs: ownInputs, ...defaults } = json;
    if (ownInputs) {
        inputs = [];
        for (let input2 of ownInputs){
            let inputHydrated = {
                ...input2,
                __proto__: $791ce2ee9eb5657b$var$Input$1.prototype
            };
            if (inputHydrated.map) inputHydrated.map = {
                ...inputHydrated.map,
                __proto__: $791ce2ee9eb5657b$var$PreviousMap22.prototype
            };
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map((n2)=>$791ce2ee9eb5657b$var$fromJSON$1(n2, inputs));
    if (defaults.source) {
        let { inputId: inputId, ...source } = defaults.source;
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $791ce2ee9eb5657b$var$Root$1(defaults);
    else if (defaults.type === "decl") return new $791ce2ee9eb5657b$var$Declaration$1(defaults);
    else if (defaults.type === "rule") return new $791ce2ee9eb5657b$var$Rule$1(defaults);
    else if (defaults.type === "comment") return new $791ce2ee9eb5657b$var$Comment$1(defaults);
    else if (defaults.type === "atrule") return new $791ce2ee9eb5657b$var$AtRule$1(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
var $791ce2ee9eb5657b$var$fromJSON_1 = $791ce2ee9eb5657b$var$fromJSON$1;
$791ce2ee9eb5657b$var$fromJSON$1.default = $791ce2ee9eb5657b$var$fromJSON$1;
let $791ce2ee9eb5657b$var$CssSyntaxError22 = $791ce2ee9eb5657b$var$cssSyntaxError;
let $791ce2ee9eb5657b$var$Declaration22 = $791ce2ee9eb5657b$var$declaration;
let $791ce2ee9eb5657b$var$LazyResult22 = $791ce2ee9eb5657b$var$lazyResult;
let $791ce2ee9eb5657b$var$Container22 = $791ce2ee9eb5657b$var$container;
let $791ce2ee9eb5657b$var$Processor22 = $791ce2ee9eb5657b$var$processor;
let $791ce2ee9eb5657b$var$stringify = $791ce2ee9eb5657b$var$stringify_1;
let $791ce2ee9eb5657b$var$fromJSON = $791ce2ee9eb5657b$var$fromJSON_1;
let $791ce2ee9eb5657b$var$Document222 = $791ce2ee9eb5657b$var$document$1;
let $791ce2ee9eb5657b$var$Warning22 = $791ce2ee9eb5657b$var$warning;
let $791ce2ee9eb5657b$var$Comment22 = $791ce2ee9eb5657b$var$comment;
let $791ce2ee9eb5657b$var$AtRule22 = $791ce2ee9eb5657b$var$atRule;
let $791ce2ee9eb5657b$var$Result22 = $791ce2ee9eb5657b$var$result;
let $791ce2ee9eb5657b$var$Input22 = $791ce2ee9eb5657b$var$input;
let $791ce2ee9eb5657b$var$parse = $791ce2ee9eb5657b$var$parse_1;
let $791ce2ee9eb5657b$var$list = $791ce2ee9eb5657b$var$list_1;
let $791ce2ee9eb5657b$var$Rule22 = $791ce2ee9eb5657b$var$rule;
let $791ce2ee9eb5657b$var$Root22 = $791ce2ee9eb5657b$var$root;
let $791ce2ee9eb5657b$var$Node22 = $791ce2ee9eb5657b$var$node;
function $791ce2ee9eb5657b$var$postcss(...plugins) {
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $791ce2ee9eb5657b$var$Processor22(plugins);
}
$791ce2ee9eb5657b$var$postcss.plugin = function plugin2(name, initializer) {
    let warningPrinted = false;
    function creator(...args) {
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        let transformer = initializer(...args);
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $791ce2ee9eb5657b$var$Processor22().version;
        return transformer;
    }
    let cache;
    Object.defineProperty(creator, "postcss", {
        get () {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $791ce2ee9eb5657b$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$791ce2ee9eb5657b$var$postcss.stringify = $791ce2ee9eb5657b$var$stringify;
$791ce2ee9eb5657b$var$postcss.parse = $791ce2ee9eb5657b$var$parse;
$791ce2ee9eb5657b$var$postcss.fromJSON = $791ce2ee9eb5657b$var$fromJSON;
$791ce2ee9eb5657b$var$postcss.list = $791ce2ee9eb5657b$var$list;
$791ce2ee9eb5657b$var$postcss.comment = (defaults)=>new $791ce2ee9eb5657b$var$Comment22(defaults);
$791ce2ee9eb5657b$var$postcss.atRule = (defaults)=>new $791ce2ee9eb5657b$var$AtRule22(defaults);
$791ce2ee9eb5657b$var$postcss.decl = (defaults)=>new $791ce2ee9eb5657b$var$Declaration22(defaults);
$791ce2ee9eb5657b$var$postcss.rule = (defaults)=>new $791ce2ee9eb5657b$var$Rule22(defaults);
$791ce2ee9eb5657b$var$postcss.root = (defaults)=>new $791ce2ee9eb5657b$var$Root22(defaults);
$791ce2ee9eb5657b$var$postcss.document = (defaults)=>new $791ce2ee9eb5657b$var$Document222(defaults);
$791ce2ee9eb5657b$var$postcss.CssSyntaxError = $791ce2ee9eb5657b$var$CssSyntaxError22;
$791ce2ee9eb5657b$var$postcss.Declaration = $791ce2ee9eb5657b$var$Declaration22;
$791ce2ee9eb5657b$var$postcss.Container = $791ce2ee9eb5657b$var$Container22;
$791ce2ee9eb5657b$var$postcss.Processor = $791ce2ee9eb5657b$var$Processor22;
$791ce2ee9eb5657b$var$postcss.Document = $791ce2ee9eb5657b$var$Document222;
$791ce2ee9eb5657b$var$postcss.Comment = $791ce2ee9eb5657b$var$Comment22;
$791ce2ee9eb5657b$var$postcss.Warning = $791ce2ee9eb5657b$var$Warning22;
$791ce2ee9eb5657b$var$postcss.AtRule = $791ce2ee9eb5657b$var$AtRule22;
$791ce2ee9eb5657b$var$postcss.Result = $791ce2ee9eb5657b$var$Result22;
$791ce2ee9eb5657b$var$postcss.Input = $791ce2ee9eb5657b$var$Input22;
$791ce2ee9eb5657b$var$postcss.Rule = $791ce2ee9eb5657b$var$Rule22;
$791ce2ee9eb5657b$var$postcss.Root = $791ce2ee9eb5657b$var$Root22;
$791ce2ee9eb5657b$var$postcss.Node = $791ce2ee9eb5657b$var$Node22;
$791ce2ee9eb5657b$var$LazyResult22.registerPostcss($791ce2ee9eb5657b$var$postcss);
var $791ce2ee9eb5657b$var$postcss_1 = $791ce2ee9eb5657b$var$postcss;
$791ce2ee9eb5657b$var$postcss.default = $791ce2ee9eb5657b$var$postcss;
const $791ce2ee9eb5657b$var$postcss$1 = /* @__PURE__ */ $791ce2ee9eb5657b$var$getDefaultExportFromCjs($791ce2ee9eb5657b$var$postcss_1);
$791ce2ee9eb5657b$var$postcss$1.stringify;
$791ce2ee9eb5657b$var$postcss$1.fromJSON;
$791ce2ee9eb5657b$var$postcss$1.plugin;
$791ce2ee9eb5657b$var$postcss$1.parse;
$791ce2ee9eb5657b$var$postcss$1.list;
$791ce2ee9eb5657b$var$postcss$1.document;
$791ce2ee9eb5657b$var$postcss$1.comment;
$791ce2ee9eb5657b$var$postcss$1.atRule;
$791ce2ee9eb5657b$var$postcss$1.rule;
$791ce2ee9eb5657b$var$postcss$1.decl;
$791ce2ee9eb5657b$var$postcss$1.root;
$791ce2ee9eb5657b$var$postcss$1.CssSyntaxError;
$791ce2ee9eb5657b$var$postcss$1.Declaration;
$791ce2ee9eb5657b$var$postcss$1.Container;
$791ce2ee9eb5657b$var$postcss$1.Processor;
$791ce2ee9eb5657b$var$postcss$1.Document;
$791ce2ee9eb5657b$var$postcss$1.Comment;
$791ce2ee9eb5657b$var$postcss$1.Warning;
$791ce2ee9eb5657b$var$postcss$1.AtRule;
$791ce2ee9eb5657b$var$postcss$1.Result;
$791ce2ee9eb5657b$var$postcss$1.Input;
$791ce2ee9eb5657b$var$postcss$1.Rule;
$791ce2ee9eb5657b$var$postcss$1.Root;
$791ce2ee9eb5657b$var$postcss$1.Node;
var $791ce2ee9eb5657b$var$NodeType$1 = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($791ce2ee9eb5657b$var$NodeType$1 || {});
function $791ce2ee9eb5657b$var$parseCSSText(cssText) {
    const res = {};
    const listDelimiter = /;(?![^(]*\))/g;
    const propertyDelimiter = /:(.+)/;
    const comment2 = /\/\*.*?\*\//g;
    cssText.replace(comment2, "").split(listDelimiter).forEach(function(item) {
        if (item) {
            const tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[$791ce2ee9eb5657b$var$camelize(tmp[0].trim())] = tmp[1].trim());
        }
    });
    return res;
}
function $791ce2ee9eb5657b$var$toCSSText(style) {
    const properties = [];
    for(const name in style){
        const value = style[name];
        if (typeof value !== "string") continue;
        const normalizedName = $791ce2ee9eb5657b$var$hyphenate(name);
        properties.push(`${normalizedName}: ${value};`);
    }
    return properties.join(" ");
}
const $791ce2ee9eb5657b$var$camelizeRE = /-([a-z])/g;
const $791ce2ee9eb5657b$var$CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
const $791ce2ee9eb5657b$var$camelize = (str)=>{
    if ($791ce2ee9eb5657b$var$CUSTOM_PROPERTY_REGEX.test(str)) return str;
    return str.replace($791ce2ee9eb5657b$var$camelizeRE, (_, c2)=>c2 ? c2.toUpperCase() : "");
};
const $791ce2ee9eb5657b$var$hyphenateRE = /\B([A-Z])/g;
const $791ce2ee9eb5657b$var$hyphenate = (str)=>{
    return str.replace($791ce2ee9eb5657b$var$hyphenateRE, "-$1").toLowerCase();
};
class $791ce2ee9eb5657b$var$BaseRRNode {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    constructor(..._args){
        $791ce2ee9eb5657b$var$__publicField2(this, "parentElement", null);
        $791ce2ee9eb5657b$var$__publicField2(this, "parentNode", null);
        $791ce2ee9eb5657b$var$__publicField2(this, "ownerDocument");
        $791ce2ee9eb5657b$var$__publicField2(this, "firstChild", null);
        $791ce2ee9eb5657b$var$__publicField2(this, "lastChild", null);
        $791ce2ee9eb5657b$var$__publicField2(this, "previousSibling", null);
        $791ce2ee9eb5657b$var$__publicField2(this, "nextSibling", null);
        $791ce2ee9eb5657b$var$__publicField2(this, "ELEMENT_NODE", 1);
        $791ce2ee9eb5657b$var$__publicField2(this, "TEXT_NODE", 3);
        $791ce2ee9eb5657b$var$__publicField2(this, "nodeType");
        $791ce2ee9eb5657b$var$__publicField2(this, "nodeName");
        $791ce2ee9eb5657b$var$__publicField2(this, "RRNodeType");
    }
    get childNodes() {
        const childNodes2 = [];
        let childIterator = this.firstChild;
        while(childIterator){
            childNodes2.push(childIterator);
            childIterator = childIterator.nextSibling;
        }
        return childNodes2;
    }
    contains(node2) {
        if (!(node2 instanceof $791ce2ee9eb5657b$var$BaseRRNode)) return false;
        else if (node2.ownerDocument !== this.ownerDocument) return false;
        else if (node2 === this) return true;
        while(node2.parentNode){
            if (node2.parentNode === this) return true;
            node2 = node2.parentNode;
        }
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    appendChild(_newChild) {
        throw new Error(`RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method.`);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    insertBefore(_newChild, _refChild) {
        throw new Error(`RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method.`);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeChild(_node) {
        throw new Error(`RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method.`);
    }
    toString() {
        return "RRNode";
    }
}
class $791ce2ee9eb5657b$var$BaseRRDocument extends $791ce2ee9eb5657b$var$BaseRRNode {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args){
        super(args);
        $791ce2ee9eb5657b$var$__publicField2(this, "nodeType", 9);
        $791ce2ee9eb5657b$var$__publicField2(this, "nodeName", "#document");
        $791ce2ee9eb5657b$var$__publicField2(this, "compatMode", "CSS1Compat");
        $791ce2ee9eb5657b$var$__publicField2(this, "RRNodeType", $791ce2ee9eb5657b$var$NodeType$1.Document);
        $791ce2ee9eb5657b$var$__publicField2(this, "textContent", null);
        this.ownerDocument = this;
    }
    get documentElement() {
        return this.childNodes.find((node2)=>node2.RRNodeType === $791ce2ee9eb5657b$var$NodeType$1.Element && node2.tagName === "HTML") || null;
    }
    get body() {
        var _a2;
        return ((_a2 = this.documentElement) == null ? void 0 : _a2.childNodes.find((node2)=>node2.RRNodeType === $791ce2ee9eb5657b$var$NodeType$1.Element && node2.tagName === "BODY")) || null;
    }
    get head() {
        var _a2;
        return ((_a2 = this.documentElement) == null ? void 0 : _a2.childNodes.find((node2)=>node2.RRNodeType === $791ce2ee9eb5657b$var$NodeType$1.Element && node2.tagName === "HEAD")) || null;
    }
    get implementation() {
        return this;
    }
    get firstElementChild() {
        return this.documentElement;
    }
    appendChild(newChild) {
        const nodeType = newChild.RRNodeType;
        if (nodeType === $791ce2ee9eb5657b$var$NodeType$1.Element || nodeType === $791ce2ee9eb5657b$var$NodeType$1.DocumentType) {
            if (this.childNodes.some((s2)=>s2.RRNodeType === nodeType)) throw new Error(`RRDomException: Failed to execute 'appendChild' on 'RRNode': Only one ${nodeType === $791ce2ee9eb5657b$var$NodeType$1.Element ? "RRElement" : "RRDoctype"} on RRDocument allowed.`);
        }
        const child = $791ce2ee9eb5657b$var$appendChild(this, newChild);
        child.parentElement = null;
        return child;
    }
    insertBefore(newChild, refChild) {
        const nodeType = newChild.RRNodeType;
        if (nodeType === $791ce2ee9eb5657b$var$NodeType$1.Element || nodeType === $791ce2ee9eb5657b$var$NodeType$1.DocumentType) {
            if (this.childNodes.some((s2)=>s2.RRNodeType === nodeType)) throw new Error(`RRDomException: Failed to execute 'insertBefore' on 'RRNode': Only one ${nodeType === $791ce2ee9eb5657b$var$NodeType$1.Element ? "RRElement" : "RRDoctype"} on RRDocument allowed.`);
        }
        const child = $791ce2ee9eb5657b$var$insertBefore(this, newChild, refChild);
        child.parentElement = null;
        return child;
    }
    removeChild(node2) {
        return $791ce2ee9eb5657b$var$removeChild(this, node2);
    }
    open() {
        this.firstChild = null;
        this.lastChild = null;
    }
    close() {}
    /**
   * Adhoc implementation for setting xhtml namespace in rebuilt.ts (rrweb-snapshot).
   * There are two lines used this function:
   * 1. doc.write('\<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" ""\>')
   * 2. doc.write('\<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" ""\>')
   */ write(content) {
        let publicId;
        if (content === '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "">') publicId = "-//W3C//DTD XHTML 1.0 Transitional//EN";
        else if (content === '<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "">') publicId = "-//W3C//DTD HTML 4.0 Transitional//EN";
        if (publicId) {
            const doctype = this.createDocumentType("html", publicId, "");
            this.open();
            this.appendChild(doctype);
        }
    }
    createDocument(_namespace, _qualifiedName, _doctype) {
        return new $791ce2ee9eb5657b$var$BaseRRDocument();
    }
    createDocumentType(qualifiedName, publicId, systemId) {
        const doctype = new $791ce2ee9eb5657b$var$BaseRRDocumentType(qualifiedName, publicId, systemId);
        doctype.ownerDocument = this;
        return doctype;
    }
    createElement(tagName) {
        const element = new $791ce2ee9eb5657b$var$BaseRRElement(tagName);
        element.ownerDocument = this;
        return element;
    }
    createElementNS(_namespaceURI, qualifiedName) {
        return this.createElement(qualifiedName);
    }
    createTextNode(data) {
        const text = new $791ce2ee9eb5657b$var$BaseRRText(data);
        text.ownerDocument = this;
        return text;
    }
    createComment(data) {
        const comment2 = new $791ce2ee9eb5657b$var$BaseRRComment(data);
        comment2.ownerDocument = this;
        return comment2;
    }
    createCDATASection(data) {
        const CDATASection = new $791ce2ee9eb5657b$var$BaseRRCDATASection(data);
        CDATASection.ownerDocument = this;
        return CDATASection;
    }
    toString() {
        return "RRDocument";
    }
}
class $791ce2ee9eb5657b$var$BaseRRDocumentType extends $791ce2ee9eb5657b$var$BaseRRNode {
    constructor(qualifiedName, publicId, systemId){
        super();
        $791ce2ee9eb5657b$var$__publicField2(this, "nodeType", 10);
        $791ce2ee9eb5657b$var$__publicField2(this, "RRNodeType", $791ce2ee9eb5657b$var$NodeType$1.DocumentType);
        $791ce2ee9eb5657b$var$__publicField2(this, "name");
        $791ce2ee9eb5657b$var$__publicField2(this, "publicId");
        $791ce2ee9eb5657b$var$__publicField2(this, "systemId");
        $791ce2ee9eb5657b$var$__publicField2(this, "textContent", null);
        this.name = qualifiedName;
        this.publicId = publicId;
        this.systemId = systemId;
        this.nodeName = qualifiedName;
    }
    toString() {
        return "RRDocumentType";
    }
}
class $791ce2ee9eb5657b$var$BaseRRElement extends $791ce2ee9eb5657b$var$BaseRRNode {
    constructor(tagName){
        super();
        $791ce2ee9eb5657b$var$__publicField2(this, "nodeType", 1);
        $791ce2ee9eb5657b$var$__publicField2(this, "RRNodeType", $791ce2ee9eb5657b$var$NodeType$1.Element);
        $791ce2ee9eb5657b$var$__publicField2(this, "tagName");
        $791ce2ee9eb5657b$var$__publicField2(this, "attributes", {});
        $791ce2ee9eb5657b$var$__publicField2(this, "shadowRoot", null);
        $791ce2ee9eb5657b$var$__publicField2(this, "scrollLeft");
        $791ce2ee9eb5657b$var$__publicField2(this, "scrollTop");
        this.tagName = tagName.toUpperCase();
        this.nodeName = tagName.toUpperCase();
    }
    get textContent() {
        let result2 = "";
        this.childNodes.forEach((node2)=>result2 += node2.textContent);
        return result2;
    }
    set textContent(textContent2) {
        this.firstChild = null;
        this.lastChild = null;
        this.appendChild(this.ownerDocument.createTextNode(textContent2));
    }
    get classList() {
        return new $791ce2ee9eb5657b$var$ClassList(this.attributes.class, (newClassName)=>{
            this.attributes.class = newClassName;
        });
    }
    get id() {
        return this.attributes.id || "";
    }
    get className() {
        return this.attributes.class || "";
    }
    get style() {
        const style = this.attributes.style ? $791ce2ee9eb5657b$var$parseCSSText(this.attributes.style) : {};
        const hyphenateRE2 = /\B([A-Z])/g;
        style.setProperty = (name, value, priority)=>{
            if (hyphenateRE2.test(name)) return;
            const normalizedName = $791ce2ee9eb5657b$var$camelize(name);
            if (!value) delete style[normalizedName];
            else style[normalizedName] = value;
            if (priority === "important") style[normalizedName] += " !important";
            this.attributes.style = $791ce2ee9eb5657b$var$toCSSText(style);
        };
        style.removeProperty = (name)=>{
            if (hyphenateRE2.test(name)) return "";
            const normalizedName = $791ce2ee9eb5657b$var$camelize(name);
            const value = style[normalizedName] || "";
            delete style[normalizedName];
            this.attributes.style = $791ce2ee9eb5657b$var$toCSSText(style);
            return value;
        };
        return style;
    }
    getAttribute(name) {
        if (this.attributes[name] === void 0) return null;
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
    }
    setAttributeNS(_namespace, qualifiedName, value) {
        this.setAttribute(qualifiedName, value);
    }
    removeAttribute(name) {
        delete this.attributes[name];
    }
    appendChild(newChild) {
        return $791ce2ee9eb5657b$var$appendChild(this, newChild);
    }
    insertBefore(newChild, refChild) {
        return $791ce2ee9eb5657b$var$insertBefore(this, newChild, refChild);
    }
    removeChild(node2) {
        return $791ce2ee9eb5657b$var$removeChild(this, node2);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    attachShadow(_init) {
        const shadowRoot2 = this.ownerDocument.createElement("SHADOWROOT");
        this.shadowRoot = shadowRoot2;
        return shadowRoot2;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dispatchEvent(_event) {
        return true;
    }
    toString() {
        let attributeString = "";
        for(const attribute in this.attributes)attributeString += `${attribute}="${this.attributes[attribute]}" `;
        return `${this.tagName} ${attributeString}`;
    }
}
class $791ce2ee9eb5657b$var$BaseRRMediaElement extends $791ce2ee9eb5657b$var$BaseRRElement {
    constructor(){
        super(...arguments);
        $791ce2ee9eb5657b$var$__publicField2(this, "currentTime");
        $791ce2ee9eb5657b$var$__publicField2(this, "volume");
        $791ce2ee9eb5657b$var$__publicField2(this, "paused");
        $791ce2ee9eb5657b$var$__publicField2(this, "muted");
        $791ce2ee9eb5657b$var$__publicField2(this, "playbackRate");
        $791ce2ee9eb5657b$var$__publicField2(this, "loop");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    attachShadow(_init) {
        throw new Error(`RRDomException: Failed to execute 'attachShadow' on 'RRElement': This RRElement does not support attachShadow`);
    }
    play() {
        this.paused = false;
    }
    pause() {
        this.paused = true;
    }
}
class $791ce2ee9eb5657b$var$BaseRRDialogElement extends $791ce2ee9eb5657b$var$BaseRRElement {
    constructor(){
        super(...arguments);
        $791ce2ee9eb5657b$var$__publicField2(this, "tagName", "DIALOG");
        $791ce2ee9eb5657b$var$__publicField2(this, "nodeName", "DIALOG");
    }
    get isModal() {
        return this.getAttribute("rr_open_mode") === "modal";
    }
    get open() {
        return this.getAttribute("open") !== null;
    }
    close() {
        this.removeAttribute("open");
        this.removeAttribute("rr_open_mode");
    }
    show() {
        this.setAttribute("open", "");
        this.setAttribute("rr_open_mode", "non-modal");
    }
    showModal() {
        this.setAttribute("open", "");
        this.setAttribute("rr_open_mode", "modal");
    }
}
class $791ce2ee9eb5657b$var$BaseRRText extends $791ce2ee9eb5657b$var$BaseRRNode {
    constructor(data){
        super();
        $791ce2ee9eb5657b$var$__publicField2(this, "nodeType", 3);
        $791ce2ee9eb5657b$var$__publicField2(this, "nodeName", "#text");
        $791ce2ee9eb5657b$var$__publicField2(this, "RRNodeType", $791ce2ee9eb5657b$var$NodeType$1.Text);
        $791ce2ee9eb5657b$var$__publicField2(this, "data");
        this.data = data;
    }
    get textContent() {
        return this.data;
    }
    set textContent(textContent2) {
        this.data = textContent2;
    }
    toString() {
        return `RRText text=${JSON.stringify(this.data)}`;
    }
}
class $791ce2ee9eb5657b$var$BaseRRComment extends $791ce2ee9eb5657b$var$BaseRRNode {
    constructor(data){
        super();
        $791ce2ee9eb5657b$var$__publicField2(this, "nodeType", 8);
        $791ce2ee9eb5657b$var$__publicField2(this, "nodeName", "#comment");
        $791ce2ee9eb5657b$var$__publicField2(this, "RRNodeType", $791ce2ee9eb5657b$var$NodeType$1.Comment);
        $791ce2ee9eb5657b$var$__publicField2(this, "data");
        this.data = data;
    }
    get textContent() {
        return this.data;
    }
    set textContent(textContent2) {
        this.data = textContent2;
    }
    toString() {
        return `RRComment text=${JSON.stringify(this.data)}`;
    }
}
class $791ce2ee9eb5657b$var$BaseRRCDATASection extends $791ce2ee9eb5657b$var$BaseRRNode {
    constructor(data){
        super();
        $791ce2ee9eb5657b$var$__publicField2(this, "nodeName", "#cdata-section");
        $791ce2ee9eb5657b$var$__publicField2(this, "nodeType", 4);
        $791ce2ee9eb5657b$var$__publicField2(this, "RRNodeType", $791ce2ee9eb5657b$var$NodeType$1.CDATA);
        $791ce2ee9eb5657b$var$__publicField2(this, "data");
        this.data = data;
    }
    get textContent() {
        return this.data;
    }
    set textContent(textContent2) {
        this.data = textContent2;
    }
    toString() {
        return `RRCDATASection data=${JSON.stringify(this.data)}`;
    }
}
class $791ce2ee9eb5657b$var$ClassList {
    constructor(classText, onChange){
        $791ce2ee9eb5657b$var$__publicField2(this, "onChange");
        $791ce2ee9eb5657b$var$__publicField2(this, "classes", []);
        $791ce2ee9eb5657b$var$__publicField2(this, "add", (...classNames)=>{
            for (const item of classNames){
                const className = String(item);
                if (this.classes.indexOf(className) >= 0) continue;
                this.classes.push(className);
            }
            this.onChange && this.onChange(this.classes.join(" "));
        });
        $791ce2ee9eb5657b$var$__publicField2(this, "remove", (...classNames)=>{
            this.classes = this.classes.filter((item)=>classNames.indexOf(item) === -1);
            this.onChange && this.onChange(this.classes.join(" "));
        });
        if (classText) {
            const classes = classText.trim().split(/\s+/);
            this.classes.push(...classes);
        }
        this.onChange = onChange;
    }
}
function $791ce2ee9eb5657b$var$appendChild(parent, newChild) {
    if (newChild.parentNode) newChild.parentNode.removeChild(newChild);
    if (parent.lastChild) {
        parent.lastChild.nextSibling = newChild;
        newChild.previousSibling = parent.lastChild;
    } else {
        parent.firstChild = newChild;
        newChild.previousSibling = null;
    }
    parent.lastChild = newChild;
    newChild.nextSibling = null;
    newChild.parentNode = parent;
    newChild.parentElement = parent;
    newChild.ownerDocument = parent.ownerDocument;
    return newChild;
}
function $791ce2ee9eb5657b$var$insertBefore(parent, newChild, refChild) {
    if (!refChild) return $791ce2ee9eb5657b$var$appendChild(parent, newChild);
    if (refChild.parentNode !== parent) throw new Error("Failed to execute 'insertBefore' on 'RRNode': The RRNode before which the new node is to be inserted is not a child of this RRNode.");
    if (newChild === refChild) return newChild;
    if (newChild.parentNode) newChild.parentNode.removeChild(newChild);
    newChild.previousSibling = refChild.previousSibling;
    refChild.previousSibling = newChild;
    newChild.nextSibling = refChild;
    if (newChild.previousSibling) newChild.previousSibling.nextSibling = newChild;
    else parent.firstChild = newChild;
    newChild.parentElement = parent;
    newChild.parentNode = parent;
    newChild.ownerDocument = parent.ownerDocument;
    return newChild;
}
function $791ce2ee9eb5657b$var$removeChild(parent, child) {
    if (child.parentNode !== parent) throw new Error("Failed to execute 'removeChild' on 'RRNode': The RRNode to be removed is not a child of this RRNode.");
    if (child.previousSibling) child.previousSibling.nextSibling = child.nextSibling;
    else parent.firstChild = child.nextSibling;
    if (child.nextSibling) child.nextSibling.previousSibling = child.previousSibling;
    else parent.lastChild = child.previousSibling;
    child.previousSibling = null;
    child.nextSibling = null;
    child.parentElement = null;
    child.parentNode = null;
    return child;
}
var $791ce2ee9eb5657b$var$NodeType$2 = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["PLACEHOLDER"] = 0] = "PLACEHOLDER";
    NodeType2[NodeType2["ELEMENT_NODE"] = 1] = "ELEMENT_NODE";
    NodeType2[NodeType2["ATTRIBUTE_NODE"] = 2] = "ATTRIBUTE_NODE";
    NodeType2[NodeType2["TEXT_NODE"] = 3] = "TEXT_NODE";
    NodeType2[NodeType2["CDATA_SECTION_NODE"] = 4] = "CDATA_SECTION_NODE";
    NodeType2[NodeType2["ENTITY_REFERENCE_NODE"] = 5] = "ENTITY_REFERENCE_NODE";
    NodeType2[NodeType2["ENTITY_NODE"] = 6] = "ENTITY_NODE";
    NodeType2[NodeType2["PROCESSING_INSTRUCTION_NODE"] = 7] = "PROCESSING_INSTRUCTION_NODE";
    NodeType2[NodeType2["COMMENT_NODE"] = 8] = "COMMENT_NODE";
    NodeType2[NodeType2["DOCUMENT_NODE"] = 9] = "DOCUMENT_NODE";
    NodeType2[NodeType2["DOCUMENT_TYPE_NODE"] = 10] = "DOCUMENT_TYPE_NODE";
    NodeType2[NodeType2["DOCUMENT_FRAGMENT_NODE"] = 11] = "DOCUMENT_FRAGMENT_NODE";
    return NodeType2;
})($791ce2ee9eb5657b$var$NodeType$2 || {});
const $791ce2ee9eb5657b$var$NAMESPACES = {
    svg: "http://www.w3.org/2000/svg",
    "xlink:href": "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/xmlns/"
};
const $791ce2ee9eb5657b$var$SVGTagMap = {
    altglyph: "altGlyph",
    altglyphdef: "altGlyphDef",
    altglyphitem: "altGlyphItem",
    animatecolor: "animateColor",
    animatemotion: "animateMotion",
    animatetransform: "animateTransform",
    clippath: "clipPath",
    feblend: "feBlend",
    fecolormatrix: "feColorMatrix",
    fecomponenttransfer: "feComponentTransfer",
    fecomposite: "feComposite",
    feconvolvematrix: "feConvolveMatrix",
    fediffuselighting: "feDiffuseLighting",
    fedisplacementmap: "feDisplacementMap",
    fedistantlight: "feDistantLight",
    fedropshadow: "feDropShadow",
    feflood: "feFlood",
    fefunca: "feFuncA",
    fefuncb: "feFuncB",
    fefuncg: "feFuncG",
    fefuncr: "feFuncR",
    fegaussianblur: "feGaussianBlur",
    feimage: "feImage",
    femerge: "feMerge",
    femergenode: "feMergeNode",
    femorphology: "feMorphology",
    feoffset: "feOffset",
    fepointlight: "fePointLight",
    fespecularlighting: "feSpecularLighting",
    fespotlight: "feSpotLight",
    fetile: "feTile",
    feturbulence: "feTurbulence",
    foreignobject: "foreignObject",
    glyphref: "glyphRef",
    lineargradient: "linearGradient",
    radialgradient: "radialGradient"
};
let $791ce2ee9eb5657b$var$createdNodeSet = null;
function $791ce2ee9eb5657b$var$diff(oldTree, newTree, replayer, rrnodeMirror = newTree.mirror || newTree.ownerDocument.mirror) {
    oldTree = $791ce2ee9eb5657b$var$diffBeforeUpdatingChildren(oldTree, newTree, replayer, rrnodeMirror);
    $791ce2ee9eb5657b$var$diffChildren(oldTree, newTree, replayer, rrnodeMirror);
    $791ce2ee9eb5657b$var$diffAfterUpdatingChildren(oldTree, newTree, replayer);
}
function $791ce2ee9eb5657b$var$diffBeforeUpdatingChildren(oldTree, newTree, replayer, rrnodeMirror) {
    var _a2;
    if (replayer.afterAppend && !$791ce2ee9eb5657b$var$createdNodeSet) {
        $791ce2ee9eb5657b$var$createdNodeSet = /* @__PURE__ */ new WeakSet();
        setTimeout(()=>{
            $791ce2ee9eb5657b$var$createdNodeSet = null;
        }, 0);
    }
    if (!$791ce2ee9eb5657b$var$sameNodeType(oldTree, newTree)) {
        const calibratedOldTree = $791ce2ee9eb5657b$var$createOrGetNode(newTree, replayer.mirror, rrnodeMirror);
        (_a2 = oldTree.parentNode) == null || _a2.replaceChild(calibratedOldTree, oldTree);
        oldTree = calibratedOldTree;
    }
    switch(newTree.RRNodeType){
        case $791ce2ee9eb5657b$var$NodeType$1.Document:
            if (!$791ce2ee9eb5657b$var$nodeMatching(oldTree, newTree, replayer.mirror, rrnodeMirror)) {
                const newMeta = rrnodeMirror.getMeta(newTree);
                if (newMeta) {
                    replayer.mirror.removeNodeFromMap(oldTree);
                    oldTree.close();
                    oldTree.open();
                    replayer.mirror.add(oldTree, newMeta);
                    $791ce2ee9eb5657b$var$createdNodeSet == null || $791ce2ee9eb5657b$var$createdNodeSet.add(oldTree);
                }
            }
            break;
        case $791ce2ee9eb5657b$var$NodeType$1.Element:
            {
                const oldElement = oldTree;
                const newRRElement = newTree;
                switch(newRRElement.tagName){
                    case "IFRAME":
                        {
                            const oldContentDocument = oldTree.contentDocument;
                            if (!oldContentDocument) break;
                            $791ce2ee9eb5657b$var$diff(oldContentDocument, newTree.contentDocument, replayer, rrnodeMirror);
                            break;
                        }
                }
                if (newRRElement.shadowRoot) {
                    if (!oldElement.shadowRoot) oldElement.attachShadow({
                        mode: "open"
                    });
                    $791ce2ee9eb5657b$var$diffChildren(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    oldElement.shadowRoot, newRRElement.shadowRoot, replayer, rrnodeMirror);
                }
                $791ce2ee9eb5657b$var$diffProps(oldElement, newRRElement, rrnodeMirror);
                break;
            }
    }
    return oldTree;
}
function $791ce2ee9eb5657b$var$diffAfterUpdatingChildren(oldTree, newTree, replayer) {
    var _a2;
    switch(newTree.RRNodeType){
        case $791ce2ee9eb5657b$var$NodeType$1.Document:
            {
                const scrollData = newTree.scrollData;
                scrollData && replayer.applyScroll(scrollData, true);
                break;
            }
        case $791ce2ee9eb5657b$var$NodeType$1.Element:
            {
                const oldElement = oldTree;
                const newRRElement = newTree;
                newRRElement.scrollData && replayer.applyScroll(newRRElement.scrollData, true);
                newRRElement.inputData && replayer.applyInput(newRRElement.inputData);
                switch(newRRElement.tagName){
                    case "AUDIO":
                    case "VIDEO":
                        {
                            const oldMediaElement = oldTree;
                            const newMediaRRElement = newRRElement;
                            if (newMediaRRElement.paused !== void 0) newMediaRRElement.paused ? oldMediaElement.pause() : oldMediaElement.play();
                            if (newMediaRRElement.muted !== void 0) oldMediaElement.muted = newMediaRRElement.muted;
                            if (newMediaRRElement.volume !== void 0) oldMediaElement.volume = newMediaRRElement.volume;
                            if (newMediaRRElement.currentTime !== void 0) oldMediaElement.currentTime = newMediaRRElement.currentTime;
                            if (newMediaRRElement.playbackRate !== void 0) oldMediaElement.playbackRate = newMediaRRElement.playbackRate;
                            if (newMediaRRElement.loop !== void 0) oldMediaElement.loop = newMediaRRElement.loop;
                            break;
                        }
                    case "CANVAS":
                        {
                            const rrCanvasElement = newTree;
                            if (rrCanvasElement.rr_dataURL !== null) {
                                const image = document.createElement("img");
                                image.onload = ()=>{
                                    const ctx = oldElement.getContext("2d");
                                    if (ctx) ctx.drawImage(image, 0, 0, image.width, image.height);
                                };
                                image.src = rrCanvasElement.rr_dataURL;
                            }
                            rrCanvasElement.canvasMutations.forEach((canvasMutation2)=>replayer.applyCanvas(canvasMutation2.event, canvasMutation2.mutation, oldTree));
                            break;
                        }
                    case "STYLE":
                        {
                            const styleSheet = oldElement.sheet;
                            styleSheet && newTree.rules.forEach((data)=>replayer.applyStyleSheetMutation(data, styleSheet));
                            break;
                        }
                    case "DIALOG":
                        {
                            const dialog = oldElement;
                            const rrDialog = newRRElement;
                            const wasOpen = dialog.open;
                            const wasModal = dialog.matches("dialog:modal");
                            const shouldBeOpen = rrDialog.open;
                            const shouldBeModal = rrDialog.isModal;
                            const modalChanged = wasModal !== shouldBeModal;
                            const openChanged = wasOpen !== shouldBeOpen;
                            if (modalChanged || wasOpen && openChanged) dialog.close();
                            if (shouldBeOpen && (openChanged || modalChanged)) try {
                                if (shouldBeModal) dialog.showModal();
                                else dialog.show();
                            } catch (e2) {
                                console.warn(e2);
                            }
                            break;
                        }
                }
                break;
            }
        case $791ce2ee9eb5657b$var$NodeType$1.Text:
        case $791ce2ee9eb5657b$var$NodeType$1.Comment:
        case $791ce2ee9eb5657b$var$NodeType$1.CDATA:
            if (oldTree.textContent !== newTree.data) oldTree.textContent = newTree.data;
            break;
    }
    if ($791ce2ee9eb5657b$var$createdNodeSet == null ? void 0 : $791ce2ee9eb5657b$var$createdNodeSet.has(oldTree)) {
        $791ce2ee9eb5657b$var$createdNodeSet.delete(oldTree);
        (_a2 = replayer.afterAppend) == null || _a2.call(replayer, oldTree, replayer.mirror.getId(oldTree));
    }
}
function $791ce2ee9eb5657b$var$diffProps(oldTree, newTree, rrnodeMirror) {
    const oldAttributes = oldTree.attributes;
    const newAttributes = newTree.attributes;
    for(const name in newAttributes){
        const newValue = newAttributes[name];
        const sn = rrnodeMirror.getMeta(newTree);
        if ((sn == null ? void 0 : sn.isSVG) && $791ce2ee9eb5657b$var$NAMESPACES[name]) oldTree.setAttributeNS($791ce2ee9eb5657b$var$NAMESPACES[name], name, newValue);
        else if (newTree.tagName === "CANVAS" && name === "rr_dataURL") {
            const image = document.createElement("img");
            image.src = newValue;
            image.onload = ()=>{
                const ctx = oldTree.getContext("2d");
                if (ctx) ctx.drawImage(image, 0, 0, image.width, image.height);
            };
        } else if (newTree.tagName === "IFRAME" && name === "srcdoc") continue;
        else try {
            oldTree.setAttribute(name, newValue);
        } catch (err) {
            console.warn(err);
        }
    }
    for (const { name: name } of Array.from(oldAttributes))if (!(name in newAttributes)) oldTree.removeAttribute(name);
    newTree.scrollLeft && (oldTree.scrollLeft = newTree.scrollLeft);
    newTree.scrollTop && (oldTree.scrollTop = newTree.scrollTop);
}
function $791ce2ee9eb5657b$var$diffChildren(oldTree, newTree, replayer, rrnodeMirror) {
    const oldChildren = Array.from(oldTree.childNodes);
    const newChildren = newTree.childNodes;
    if (oldChildren.length === 0 && newChildren.length === 0) return;
    let oldStartIndex = 0, oldEndIndex = oldChildren.length - 1, newStartIndex = 0, newEndIndex = newChildren.length - 1;
    let oldStartNode = oldChildren[oldStartIndex], oldEndNode = oldChildren[oldEndIndex], newStartNode = newChildren[newStartIndex], newEndNode = newChildren[newEndIndex];
    let oldIdToIndex = void 0, indexInOld = void 0;
    while(oldStartIndex <= oldEndIndex && newStartIndex <= newEndIndex){
        if (oldStartNode === void 0) oldStartNode = oldChildren[++oldStartIndex];
        else if (oldEndNode === void 0) oldEndNode = oldChildren[--oldEndIndex];
        else if (// same first node?
        $791ce2ee9eb5657b$var$nodeMatching(oldStartNode, newStartNode, replayer.mirror, rrnodeMirror)) {
            oldStartNode = oldChildren[++oldStartIndex];
            newStartNode = newChildren[++newStartIndex];
        } else if (// same last node?
        $791ce2ee9eb5657b$var$nodeMatching(oldEndNode, newEndNode, replayer.mirror, rrnodeMirror)) {
            oldEndNode = oldChildren[--oldEndIndex];
            newEndNode = newChildren[--newEndIndex];
        } else if (// is the first old node the same as the last new node?
        $791ce2ee9eb5657b$var$nodeMatching(oldStartNode, newEndNode, replayer.mirror, rrnodeMirror)) {
            try {
                oldTree.insertBefore(oldStartNode, oldEndNode.nextSibling);
            } catch (e2) {
                console.warn(e2);
            }
            oldStartNode = oldChildren[++oldStartIndex];
            newEndNode = newChildren[--newEndIndex];
        } else if (// is the last old node the same as the first new node?
        $791ce2ee9eb5657b$var$nodeMatching(oldEndNode, newStartNode, replayer.mirror, rrnodeMirror)) {
            try {
                oldTree.insertBefore(oldEndNode, oldStartNode);
            } catch (e2) {
                console.warn(e2);
            }
            oldEndNode = oldChildren[--oldEndIndex];
            newStartNode = newChildren[++newStartIndex];
        } else {
            if (!oldIdToIndex) {
                oldIdToIndex = {};
                for(let i2 = oldStartIndex; i2 <= oldEndIndex; i2++){
                    const oldChild2 = oldChildren[i2];
                    if (oldChild2 && replayer.mirror.hasNode(oldChild2)) oldIdToIndex[replayer.mirror.getId(oldChild2)] = i2;
                }
            }
            indexInOld = oldIdToIndex[rrnodeMirror.getId(newStartNode)];
            const nodeToMove = oldChildren[indexInOld];
            if (indexInOld !== void 0 && nodeToMove && $791ce2ee9eb5657b$var$nodeMatching(nodeToMove, newStartNode, replayer.mirror, rrnodeMirror)) {
                try {
                    oldTree.insertBefore(nodeToMove, oldStartNode);
                } catch (e2) {
                    console.warn(e2);
                }
                oldChildren[indexInOld] = void 0;
            } else {
                const newNode = $791ce2ee9eb5657b$var$createOrGetNode(newStartNode, replayer.mirror, rrnodeMirror);
                if (oldTree.nodeName === "#document" && oldStartNode && /**
        * Special case 1: one document isn't allowed to have two doctype nodes at the same time, so we need to remove the old one first before inserting the new one.
        * How this case happens: A parent document in the old tree already has a doctype node with an id e.g. #1. A new full snapshot rebuilds the replayer with a new doctype node with another id #2. According to the algorithm, the new doctype node will be inserted before the old one, which is not allowed by the Document standard.
        */ (newNode.nodeType === newNode.DOCUMENT_TYPE_NODE && oldStartNode.nodeType === oldStartNode.DOCUMENT_TYPE_NODE || /**
        * Special case 2: one document isn't allowed to have two HTMLElements at the same time, so we need to remove the old one first before inserting the new one.
        * How this case happens: A mounted iframe element has an automatically created HTML element. We should delete it before inserting a serialized one. Otherwise, an error 'Only one element on document allowed' will be thrown.
        */ newNode.nodeType === newNode.ELEMENT_NODE && oldStartNode.nodeType === oldStartNode.ELEMENT_NODE)) {
                    oldTree.removeChild(oldStartNode);
                    replayer.mirror.removeNodeFromMap(oldStartNode);
                    oldStartNode = oldChildren[++oldStartIndex];
                }
                try {
                    oldTree.insertBefore(newNode, oldStartNode || null);
                } catch (e2) {
                    console.warn(e2);
                }
            }
            newStartNode = newChildren[++newStartIndex];
        }
    }
    if (oldStartIndex > oldEndIndex) {
        const referenceRRNode = newChildren[newEndIndex + 1];
        let referenceNode = null;
        if (referenceRRNode) referenceNode = replayer.mirror.getNode(rrnodeMirror.getId(referenceRRNode));
        for(; newStartIndex <= newEndIndex; ++newStartIndex){
            const newNode = $791ce2ee9eb5657b$var$createOrGetNode(newChildren[newStartIndex], replayer.mirror, rrnodeMirror);
            try {
                oldTree.insertBefore(newNode, referenceNode);
            } catch (e2) {
                console.warn(e2);
            }
        }
    } else if (newStartIndex > newEndIndex) for(; oldStartIndex <= oldEndIndex; oldStartIndex++){
        const node2 = oldChildren[oldStartIndex];
        if (!node2 || node2.parentNode !== oldTree) continue;
        try {
            oldTree.removeChild(node2);
            replayer.mirror.removeNodeFromMap(node2);
        } catch (e2) {
            console.warn(e2);
        }
    }
    let oldChild = oldTree.firstChild;
    let newChild = newTree.firstChild;
    while(oldChild !== null && newChild !== null){
        $791ce2ee9eb5657b$var$diff(oldChild, newChild, replayer, rrnodeMirror);
        oldChild = oldChild.nextSibling;
        newChild = newChild.nextSibling;
    }
}
function $791ce2ee9eb5657b$var$createOrGetNode(rrNode, domMirror, rrnodeMirror) {
    const nodeId = rrnodeMirror.getId(rrNode);
    const sn = rrnodeMirror.getMeta(rrNode);
    let node2 = null;
    if (nodeId > -1) node2 = domMirror.getNode(nodeId);
    if (node2 !== null && $791ce2ee9eb5657b$var$sameNodeType(node2, rrNode)) return node2;
    switch(rrNode.RRNodeType){
        case $791ce2ee9eb5657b$var$NodeType$1.Document:
            node2 = new Document();
            break;
        case $791ce2ee9eb5657b$var$NodeType$1.DocumentType:
            node2 = document.implementation.createDocumentType(rrNode.name, rrNode.publicId, rrNode.systemId);
            break;
        case $791ce2ee9eb5657b$var$NodeType$1.Element:
            {
                let tagName = rrNode.tagName.toLowerCase();
                tagName = $791ce2ee9eb5657b$var$SVGTagMap[tagName] || tagName;
                if (sn && "isSVG" in sn && (sn == null ? void 0 : sn.isSVG)) node2 = document.createElementNS($791ce2ee9eb5657b$var$NAMESPACES["svg"], tagName);
                else node2 = document.createElement(rrNode.tagName);
                break;
            }
        case $791ce2ee9eb5657b$var$NodeType$1.Text:
            node2 = document.createTextNode(rrNode.data);
            break;
        case $791ce2ee9eb5657b$var$NodeType$1.Comment:
            node2 = document.createComment(rrNode.data);
            break;
        case $791ce2ee9eb5657b$var$NodeType$1.CDATA:
            node2 = document.createCDATASection(rrNode.data);
            break;
    }
    if (sn) domMirror.add(node2, {
        ...sn
    });
    try {
        $791ce2ee9eb5657b$var$createdNodeSet == null || $791ce2ee9eb5657b$var$createdNodeSet.add(node2);
    } catch (e2) {}
    return node2;
}
function $791ce2ee9eb5657b$var$sameNodeType(node1, node2) {
    if (node1.nodeType !== node2.nodeType) return false;
    return node1.nodeType !== node1.ELEMENT_NODE || node1.tagName.toUpperCase() === node2.tagName;
}
function $791ce2ee9eb5657b$var$nodeMatching(node1, node2, domMirror, rrdomMirror) {
    const node1Id = domMirror.getId(node1);
    const node2Id = rrdomMirror.getId(node2);
    if (node1Id === -1 || node1Id !== node2Id) return false;
    return $791ce2ee9eb5657b$var$sameNodeType(node1, node2);
}
class $791ce2ee9eb5657b$var$RRDocument extends $791ce2ee9eb5657b$var$BaseRRDocument {
    constructor(mirror2){
        super();
        $791ce2ee9eb5657b$var$__publicField2(this, "UNSERIALIZED_STARTING_ID", -2);
        $791ce2ee9eb5657b$var$__publicField2(this, "_unserializedId", this.UNSERIALIZED_STARTING_ID);
        $791ce2ee9eb5657b$var$__publicField2(this, "mirror", $791ce2ee9eb5657b$var$createMirror());
        $791ce2ee9eb5657b$var$__publicField2(this, "scrollData", null);
        if (mirror2) this.mirror = mirror2;
    }
    /**
   * Every time the id is used, it will minus 1 automatically to avoid collisions.
   */ get unserializedId() {
        return this._unserializedId--;
    }
    createDocument(_namespace, _qualifiedName, _doctype) {
        return new $791ce2ee9eb5657b$var$RRDocument();
    }
    createDocumentType(qualifiedName, publicId, systemId) {
        const documentTypeNode = new $791ce2ee9eb5657b$var$RRDocumentType(qualifiedName, publicId, systemId);
        documentTypeNode.ownerDocument = this;
        return documentTypeNode;
    }
    createElement(tagName) {
        const upperTagName = tagName.toUpperCase();
        let element;
        switch(upperTagName){
            case "AUDIO":
            case "VIDEO":
                element = new $791ce2ee9eb5657b$var$RRMediaElement(upperTagName);
                break;
            case "IFRAME":
                element = new $791ce2ee9eb5657b$var$RRIFrameElement(upperTagName, this.mirror);
                break;
            case "CANVAS":
                element = new $791ce2ee9eb5657b$var$RRCanvasElement(upperTagName);
                break;
            case "STYLE":
                element = new $791ce2ee9eb5657b$var$RRStyleElement(upperTagName);
                break;
            case "DIALOG":
                element = new $791ce2ee9eb5657b$var$RRDialogElement(upperTagName);
                break;
            default:
                element = new $791ce2ee9eb5657b$var$RRElement(upperTagName);
                break;
        }
        element.ownerDocument = this;
        return element;
    }
    createComment(data) {
        const commentNode = new $791ce2ee9eb5657b$var$RRComment(data);
        commentNode.ownerDocument = this;
        return commentNode;
    }
    createCDATASection(data) {
        const sectionNode = new $791ce2ee9eb5657b$var$RRCDATASection(data);
        sectionNode.ownerDocument = this;
        return sectionNode;
    }
    createTextNode(data) {
        const textNode = new $791ce2ee9eb5657b$var$RRText(data);
        textNode.ownerDocument = this;
        return textNode;
    }
    destroyTree() {
        this.firstChild = null;
        this.lastChild = null;
        this.mirror.reset();
    }
    open() {
        super.open();
        this._unserializedId = this.UNSERIALIZED_STARTING_ID;
    }
}
const $791ce2ee9eb5657b$var$RRDocumentType = $791ce2ee9eb5657b$var$BaseRRDocumentType;
class $791ce2ee9eb5657b$var$RRElement extends $791ce2ee9eb5657b$var$BaseRRElement {
    constructor(){
        super(...arguments);
        $791ce2ee9eb5657b$var$__publicField2(this, "inputData", null);
        $791ce2ee9eb5657b$var$__publicField2(this, "scrollData", null);
    }
}
class $791ce2ee9eb5657b$var$RRMediaElement extends $791ce2ee9eb5657b$var$BaseRRMediaElement {
}
class $791ce2ee9eb5657b$var$RRDialogElement extends $791ce2ee9eb5657b$var$BaseRRDialogElement {
}
class $791ce2ee9eb5657b$var$RRCanvasElement extends $791ce2ee9eb5657b$var$RRElement {
    constructor(){
        super(...arguments);
        $791ce2ee9eb5657b$var$__publicField2(this, "rr_dataURL", null);
        $791ce2ee9eb5657b$var$__publicField2(this, "canvasMutations", []);
    }
    /**
   * This is a dummy implementation to distinguish RRCanvasElement from real HTMLCanvasElement.
   */ getContext() {
        return null;
    }
}
class $791ce2ee9eb5657b$var$RRStyleElement extends $791ce2ee9eb5657b$var$RRElement {
    constructor(){
        super(...arguments);
        $791ce2ee9eb5657b$var$__publicField2(this, "rules", []);
    }
}
class $791ce2ee9eb5657b$var$RRIFrameElement extends $791ce2ee9eb5657b$var$RRElement {
    constructor(upperTagName, mirror2){
        super(upperTagName);
        $791ce2ee9eb5657b$var$__publicField2(this, "contentDocument", new $791ce2ee9eb5657b$var$RRDocument());
        this.contentDocument.mirror = mirror2;
    }
}
const $791ce2ee9eb5657b$var$RRText = $791ce2ee9eb5657b$var$BaseRRText;
const $791ce2ee9eb5657b$var$RRComment = $791ce2ee9eb5657b$var$BaseRRComment;
const $791ce2ee9eb5657b$var$RRCDATASection = $791ce2ee9eb5657b$var$BaseRRCDATASection;
function $791ce2ee9eb5657b$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "FORM";
    return element.tagName.toUpperCase();
}
function $791ce2ee9eb5657b$var$buildFromNode(node2, rrdom, domMirror, parentRRNode) {
    let rrNode;
    switch(node2.nodeType){
        case $791ce2ee9eb5657b$var$NodeType$2.DOCUMENT_NODE:
            if (parentRRNode && parentRRNode.nodeName === "IFRAME") rrNode = parentRRNode.contentDocument;
            else {
                rrNode = rrdom;
                rrNode.compatMode = node2.compatMode;
            }
            break;
        case $791ce2ee9eb5657b$var$NodeType$2.DOCUMENT_TYPE_NODE:
            {
                const documentType = node2;
                rrNode = rrdom.createDocumentType(documentType.name, documentType.publicId, documentType.systemId);
                break;
            }
        case $791ce2ee9eb5657b$var$NodeType$2.ELEMENT_NODE:
            {
                const elementNode = node2;
                const tagName = $791ce2ee9eb5657b$var$getValidTagName(elementNode);
                rrNode = rrdom.createElement(tagName);
                const rrElement = rrNode;
                for (const { name: name, value: value } of Array.from(elementNode.attributes))rrElement.attributes[name] = value;
                elementNode.scrollLeft && (rrElement.scrollLeft = elementNode.scrollLeft);
                elementNode.scrollTop && (rrElement.scrollTop = elementNode.scrollTop);
                break;
            }
        case $791ce2ee9eb5657b$var$NodeType$2.TEXT_NODE:
            rrNode = rrdom.createTextNode(node2.textContent || "");
            break;
        case $791ce2ee9eb5657b$var$NodeType$2.CDATA_SECTION_NODE:
            rrNode = rrdom.createCDATASection(node2.data);
            break;
        case $791ce2ee9eb5657b$var$NodeType$2.COMMENT_NODE:
            rrNode = rrdom.createComment(node2.textContent || "");
            break;
        case $791ce2ee9eb5657b$var$NodeType$2.DOCUMENT_FRAGMENT_NODE:
            rrNode = parentRRNode.attachShadow({
                mode: "open"
            });
            break;
        default:
            return null;
    }
    let sn = domMirror.getMeta(node2);
    if (rrdom instanceof $791ce2ee9eb5657b$var$RRDocument) {
        if (!sn) {
            sn = $791ce2ee9eb5657b$var$getDefaultSN(rrNode, rrdom.unserializedId);
            domMirror.add(node2, sn);
        }
        rrdom.mirror.add(rrNode, {
            ...sn
        });
    }
    return rrNode;
}
function $791ce2ee9eb5657b$var$buildFromDom(dom, domMirror = $791ce2ee9eb5657b$var$createMirror$1(), rrdom = new $791ce2ee9eb5657b$var$RRDocument()) {
    function walk2(node2, parentRRNode) {
        const rrNode = $791ce2ee9eb5657b$var$buildFromNode(node2, rrdom, domMirror, parentRRNode);
        if (rrNode === null) return;
        if (// if the parentRRNode isn't a RRIFrameElement
        (parentRRNode == null ? void 0 : parentRRNode.nodeName) !== "IFRAME" && // if node isn't a shadow root
        node2.nodeType !== $791ce2ee9eb5657b$var$NodeType$2.DOCUMENT_FRAGMENT_NODE) {
            parentRRNode == null || parentRRNode.appendChild(rrNode);
            rrNode.parentNode = parentRRNode;
            rrNode.parentElement = parentRRNode;
        }
        if (node2.nodeName === "IFRAME") {
            const iframeDoc = node2.contentDocument;
            iframeDoc && walk2(iframeDoc, rrNode);
        } else if (node2.nodeType === $791ce2ee9eb5657b$var$NodeType$2.DOCUMENT_NODE || node2.nodeType === $791ce2ee9eb5657b$var$NodeType$2.ELEMENT_NODE || node2.nodeType === $791ce2ee9eb5657b$var$NodeType$2.DOCUMENT_FRAGMENT_NODE) {
            if (node2.nodeType === $791ce2ee9eb5657b$var$NodeType$2.ELEMENT_NODE && node2.shadowRoot) walk2(node2.shadowRoot, rrNode);
            node2.childNodes.forEach((childNode)=>walk2(childNode, rrNode));
        }
    }
    walk2(dom, null);
    return rrdom;
}
function $791ce2ee9eb5657b$var$createMirror() {
    return new $791ce2ee9eb5657b$var$Mirror22();
}
class $791ce2ee9eb5657b$var$Mirror22 {
    constructor(){
        $791ce2ee9eb5657b$var$__publicField2(this, "idNodeMap", /* @__PURE__ */ new Map());
        $791ce2ee9eb5657b$var$__publicField2(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    getId(n2) {
        var _a2;
        if (!n2) return -1;
        const id = (_a2 = this.getMeta(n2)) == null ? void 0 : _a2.id;
        return id ?? -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n2) {
        const id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) n2.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node2) {
        return this.nodeMetaMap.has(node2);
    }
    add(n2, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    }
    replace(id, n2) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
}
function $791ce2ee9eb5657b$var$getDefaultSN(node2, id) {
    switch(node2.RRNodeType){
        case $791ce2ee9eb5657b$var$NodeType$1.Document:
            return {
                id: id,
                type: node2.RRNodeType,
                childNodes: []
            };
        case $791ce2ee9eb5657b$var$NodeType$1.DocumentType:
            {
                const doctype = node2;
                return {
                    id: id,
                    type: node2.RRNodeType,
                    name: doctype.name,
                    publicId: doctype.publicId,
                    systemId: doctype.systemId
                };
            }
        case $791ce2ee9eb5657b$var$NodeType$1.Element:
            return {
                id: id,
                type: node2.RRNodeType,
                tagName: node2.tagName.toLowerCase(),
                // In rrweb data, all tagNames are lowercase.
                attributes: {},
                childNodes: []
            };
        case $791ce2ee9eb5657b$var$NodeType$1.Text:
            return {
                id: id,
                type: node2.RRNodeType,
                textContent: node2.textContent || ""
            };
        case $791ce2ee9eb5657b$var$NodeType$1.Comment:
            return {
                id: id,
                type: node2.RRNodeType,
                textContent: node2.textContent || ""
            };
        case $791ce2ee9eb5657b$var$NodeType$1.CDATA:
            return {
                id: id,
                type: node2.RRNodeType,
                textContent: ""
            };
    }
}
const $791ce2ee9eb5657b$var$testableAccessors = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
const $791ce2ee9eb5657b$var$testableMethods = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
const $791ce2ee9eb5657b$var$untaintedBasePrototype = {};
const $791ce2ee9eb5657b$var$isAngularZonePresent = ()=>{
    return !!globalThis.Zone;
};
function $791ce2ee9eb5657b$var$getUntaintedPrototype(key) {
    if ($791ce2ee9eb5657b$var$untaintedBasePrototype[key]) return $791ce2ee9eb5657b$var$untaintedBasePrototype[key];
    const defaultObj = globalThis[key];
    const defaultPrototype = defaultObj.prototype;
    const accessorNames = key in $791ce2ee9eb5657b$var$testableAccessors ? $791ce2ee9eb5657b$var$testableAccessors[key] : void 0;
    const isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every((accessor)=>{
        var _a2, _b;
        return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    const methodNames = key in $791ce2ee9eb5657b$var$testableMethods ? $791ce2ee9eb5657b$var$testableMethods[key] : void 0;
    const isUntaintedMethods = Boolean(methodNames && methodNames.every(// @ts-expect-error 2345
    (method)=>{
        var _a2;
        return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods && !$791ce2ee9eb5657b$var$isAngularZonePresent()) {
        $791ce2ee9eb5657b$var$untaintedBasePrototype[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        const iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        const win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        const untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return $791ce2ee9eb5657b$var$untaintedBasePrototype[key] = untaintedObject;
    } catch  {
        return defaultPrototype;
    }
}
const $791ce2ee9eb5657b$var$untaintedAccessorCache = {};
function $791ce2ee9eb5657b$var$getUntaintedAccessor(key, instance, accessor) {
    var _a2;
    const cacheKey = `${key}.${String(accessor)}`;
    if ($791ce2ee9eb5657b$var$untaintedAccessorCache[cacheKey]) return $791ce2ee9eb5657b$var$untaintedAccessorCache[cacheKey].call(instance);
    const untaintedPrototype = $791ce2ee9eb5657b$var$getUntaintedPrototype(key);
    const untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
    if (!untaintedAccessor) return instance[accessor];
    $791ce2ee9eb5657b$var$untaintedAccessorCache[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
const $791ce2ee9eb5657b$var$untaintedMethodCache = {};
function $791ce2ee9eb5657b$var$getUntaintedMethod(key, instance, method) {
    const cacheKey = `${key}.${String(method)}`;
    if ($791ce2ee9eb5657b$var$untaintedMethodCache[cacheKey]) return $791ce2ee9eb5657b$var$untaintedMethodCache[cacheKey].bind(instance);
    const untaintedPrototype = $791ce2ee9eb5657b$var$getUntaintedPrototype(key);
    const untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    $791ce2ee9eb5657b$var$untaintedMethodCache[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function $791ce2ee9eb5657b$var$childNodes(n2) {
    return $791ce2ee9eb5657b$var$getUntaintedAccessor("Node", n2, "childNodes");
}
function $791ce2ee9eb5657b$var$parentNode(n2) {
    return $791ce2ee9eb5657b$var$getUntaintedAccessor("Node", n2, "parentNode");
}
function $791ce2ee9eb5657b$var$parentElement(n2) {
    return $791ce2ee9eb5657b$var$getUntaintedAccessor("Node", n2, "parentElement");
}
function $791ce2ee9eb5657b$var$textContent(n2) {
    return $791ce2ee9eb5657b$var$getUntaintedAccessor("Node", n2, "textContent");
}
function $791ce2ee9eb5657b$var$contains(n2, other) {
    return $791ce2ee9eb5657b$var$getUntaintedMethod("Node", n2, "contains")(other);
}
function $791ce2ee9eb5657b$var$getRootNode(n2) {
    return $791ce2ee9eb5657b$var$getUntaintedMethod("Node", n2, "getRootNode")();
}
function $791ce2ee9eb5657b$var$host(n2) {
    if (!n2 || !("host" in n2)) return null;
    return $791ce2ee9eb5657b$var$getUntaintedAccessor("ShadowRoot", n2, "host");
}
function $791ce2ee9eb5657b$var$styleSheets(n2) {
    return n2.styleSheets;
}
function $791ce2ee9eb5657b$var$shadowRoot(n2) {
    if (!n2 || !("shadowRoot" in n2)) return null;
    return $791ce2ee9eb5657b$var$getUntaintedAccessor("Element", n2, "shadowRoot");
}
function $791ce2ee9eb5657b$var$querySelector(n2, selectors) {
    return $791ce2ee9eb5657b$var$getUntaintedAccessor("Element", n2, "querySelector")(selectors);
}
function $791ce2ee9eb5657b$var$querySelectorAll(n2, selectors) {
    return $791ce2ee9eb5657b$var$getUntaintedAccessor("Element", n2, "querySelectorAll")(selectors);
}
function $791ce2ee9eb5657b$var$mutationObserverCtor() {
    return $791ce2ee9eb5657b$var$getUntaintedPrototype("MutationObserver").constructor;
}
const $791ce2ee9eb5657b$var$index = {
    childNodes: $791ce2ee9eb5657b$var$childNodes,
    parentNode: $791ce2ee9eb5657b$var$parentNode,
    parentElement: $791ce2ee9eb5657b$var$parentElement,
    textContent: $791ce2ee9eb5657b$var$textContent,
    contains: $791ce2ee9eb5657b$var$contains,
    getRootNode: $791ce2ee9eb5657b$var$getRootNode,
    host: $791ce2ee9eb5657b$var$host,
    styleSheets: $791ce2ee9eb5657b$var$styleSheets,
    shadowRoot: $791ce2ee9eb5657b$var$shadowRoot,
    querySelector: $791ce2ee9eb5657b$var$querySelector,
    querySelectorAll: $791ce2ee9eb5657b$var$querySelectorAll,
    mutationObserver: $791ce2ee9eb5657b$var$mutationObserverCtor
};
function $791ce2ee9eb5657b$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $791ce2ee9eb5657b$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $791ce2ee9eb5657b$export$205349702e9dbad8 = {
    map: {},
    getId () {
        console.error($791ce2ee9eb5657b$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($791ce2ee9eb5657b$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($791ce2ee9eb5657b$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($791ce2ee9eb5657b$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($791ce2ee9eb5657b$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $791ce2ee9eb5657b$export$205349702e9dbad8 = new Proxy($791ce2ee9eb5657b$export$205349702e9dbad8, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($791ce2ee9eb5657b$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $791ce2ee9eb5657b$var$throttle(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $791ce2ee9eb5657b$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$791ce2ee9eb5657b$var$hookSetter(target, key, original || {}, true);
}
function $791ce2ee9eb5657b$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch  {
        return ()=>{};
    }
}
let $791ce2ee9eb5657b$var$nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) $791ce2ee9eb5657b$var$nowTimestamp = ()=>/* @__PURE__ */ new Date().getTime();
function $791ce2ee9eb5657b$var$getWindowScroll(win) {
    var _a2, _b, _c, _d;
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc.documentElement.scrollLeft || (doc == null ? void 0 : doc.body) && ((_a2 = $791ce2ee9eb5657b$var$index.parentElement(doc.body)) == null ? void 0 : _a2.scrollLeft) || ((_b = doc == null ? void 0 : doc.body) == null ? void 0 : _b.scrollLeft) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : (doc == null ? void 0 : doc.documentElement.scrollTop) || (doc == null ? void 0 : doc.body) && ((_c = $791ce2ee9eb5657b$var$index.parentElement(doc.body)) == null ? void 0 : _c.scrollTop) || ((_d = doc == null ? void 0 : doc.body) == null ? void 0 : _d.scrollTop) || 0
    };
}
function $791ce2ee9eb5657b$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $791ce2ee9eb5657b$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $791ce2ee9eb5657b$var$closestElementOfNode(node2) {
    if (!node2) return null;
    const el = node2.nodeType === node2.ELEMENT_NODE ? node2 : $791ce2ee9eb5657b$var$index.parentElement(node2);
    return el;
}
function $791ce2ee9eb5657b$var$isBlocked(node2, blockClass, blockSelector, checkAncestors) {
    if (!node2) return false;
    const el = $791ce2ee9eb5657b$var$closestElementOfNode(node2);
    if (!el) return false;
    try {
        if (typeof blockClass === "string") {
            if (el.classList.contains(blockClass)) return true;
            if (checkAncestors && el.closest("." + blockClass) !== null) return true;
        } else {
            if ($791ce2ee9eb5657b$var$classMatchesRegex(el, blockClass, checkAncestors)) return true;
        }
    } catch (e2) {}
    if (blockSelector) {
        if (el.matches(blockSelector)) return true;
        if (checkAncestors && el.closest(blockSelector) !== null) return true;
    }
    return false;
}
function $791ce2ee9eb5657b$var$isSerialized(n2, mirror2) {
    return mirror2.getId(n2) !== -1;
}
function $791ce2ee9eb5657b$var$isIgnored(n2, mirror2, slimDOMOptions) {
    if (n2.tagName === "TITLE" && slimDOMOptions.headTitleMutations) return true;
    return mirror2.getId(n2) === $791ce2ee9eb5657b$var$IGNORED_NODE;
}
function $791ce2ee9eb5657b$var$isAncestorRemoved(target, mirror2) {
    if ($791ce2ee9eb5657b$var$isShadowRoot(target)) return false;
    const id = mirror2.getId(target);
    if (!mirror2.has(id)) return true;
    const parent = $791ce2ee9eb5657b$var$index.parentNode(target);
    if (parent && parent.nodeType === target.DOCUMENT_NODE) return false;
    if (!parent) return true;
    return $791ce2ee9eb5657b$var$isAncestorRemoved(parent, mirror2);
}
function $791ce2ee9eb5657b$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $791ce2ee9eb5657b$var$polyfill$1(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
}
function $791ce2ee9eb5657b$var$queueToResolveTrees(queue) {
    const queueNodeMap = {};
    const putIntoMap = (m, parent)=>{
        const nodeInTree = {
            value: m,
            parent: parent,
            children: []
        };
        queueNodeMap[m.node.id] = nodeInTree;
        return nodeInTree;
    };
    const queueNodeTrees = [];
    for (const mutation of queue){
        const { nextId: nextId, parentId: parentId } = mutation;
        if (nextId && nextId in queueNodeMap) {
            const nextInTree = queueNodeMap[nextId];
            if (nextInTree.parent) {
                const idx = nextInTree.parent.children.indexOf(nextInTree);
                nextInTree.parent.children.splice(idx, 0, putIntoMap(mutation, nextInTree.parent));
            } else {
                const idx = queueNodeTrees.indexOf(nextInTree);
                queueNodeTrees.splice(idx, 0, putIntoMap(mutation, null));
            }
            continue;
        }
        if (parentId in queueNodeMap) {
            const parentInTree = queueNodeMap[parentId];
            parentInTree.children.push(putIntoMap(mutation, parentInTree));
            continue;
        }
        queueNodeTrees.push(putIntoMap(mutation, null));
    }
    return queueNodeTrees;
}
function $791ce2ee9eb5657b$var$iterateResolveTree(tree, cb) {
    cb(tree.value);
    for(let i2 = tree.children.length - 1; i2 >= 0; i2--)$791ce2ee9eb5657b$var$iterateResolveTree(tree.children[i2], cb);
}
function $791ce2ee9eb5657b$var$isSerializedIframe(n2, mirror2) {
    return Boolean(n2.nodeName === "IFRAME" && mirror2.getMeta(n2));
}
function $791ce2ee9eb5657b$var$isSerializedStylesheet(n2, mirror2) {
    return Boolean(n2.nodeName === "LINK" && n2.nodeType === n2.ELEMENT_NODE && n2.getAttribute && n2.getAttribute("rel") === "stylesheet" && mirror2.getMeta(n2));
}
function $791ce2ee9eb5657b$var$getBaseDimension(node2, rootIframe) {
    var _a2, _b;
    const frameElement = (_b = (_a2 = node2.ownerDocument) == null ? void 0 : _a2.defaultView) == null ? void 0 : _b.frameElement;
    if (!frameElement || frameElement === rootIframe) return {
        x: 0,
        y: 0,
        relativeScale: 1,
        absoluteScale: 1
    };
    const frameDimension = frameElement.getBoundingClientRect();
    const frameBaseDimension = $791ce2ee9eb5657b$var$getBaseDimension(frameElement, rootIframe);
    const relativeScale = frameDimension.height / frameElement.clientHeight;
    return {
        x: frameDimension.x * frameBaseDimension.relativeScale + frameBaseDimension.x,
        y: frameDimension.y * frameBaseDimension.relativeScale + frameBaseDimension.y,
        relativeScale: relativeScale,
        absoluteScale: frameBaseDimension.absoluteScale * relativeScale
    };
}
function $791ce2ee9eb5657b$var$hasShadowRoot(n2) {
    if (!n2) return false;
    if (n2 instanceof $791ce2ee9eb5657b$var$BaseRRNode && "shadowRoot" in n2) return Boolean(n2.shadowRoot);
    return Boolean($791ce2ee9eb5657b$var$index.shadowRoot(n2));
}
function $791ce2ee9eb5657b$var$getNestedRule(rules2, position) {
    const rule2 = rules2[position[0]];
    if (position.length === 1) return rule2;
    else return $791ce2ee9eb5657b$var$getNestedRule(rule2.cssRules[position[1]].cssRules, position.slice(2));
}
function $791ce2ee9eb5657b$var$getPositionsAndIndex(nestedIndex) {
    const positions = [
        ...nestedIndex
    ];
    const index2 = positions.pop();
    return {
        positions: positions,
        index: index2
    };
}
function $791ce2ee9eb5657b$var$uniqueTextMutations(mutations) {
    const idSet = /* @__PURE__ */ new Set();
    const uniqueMutations = [];
    for(let i2 = mutations.length; i2--;){
        const mutation = mutations[i2];
        if (!idSet.has(mutation.id)) {
            uniqueMutations.push(mutation);
            idSet.add(mutation.id);
        }
    }
    return uniqueMutations;
}
class $791ce2ee9eb5657b$var$StyleSheetMirror {
    constructor(){
        $791ce2ee9eb5657b$var$__publicField(this, "id", 1);
        $791ce2ee9eb5657b$var$__publicField(this, "styleIDMap", /* @__PURE__ */ new WeakMap());
        $791ce2ee9eb5657b$var$__publicField(this, "idStyleMap", /* @__PURE__ */ new Map());
    }
    getId(stylesheet) {
        return this.styleIDMap.get(stylesheet) ?? -1;
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === void 0) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $791ce2ee9eb5657b$var$getShadowHost(n2) {
    var _a2;
    let shadowHost = null;
    if ("getRootNode" in n2 && ((_a2 = $791ce2ee9eb5657b$var$index.getRootNode(n2)) == null ? void 0 : _a2.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && $791ce2ee9eb5657b$var$index.host($791ce2ee9eb5657b$var$index.getRootNode(n2))) shadowHost = $791ce2ee9eb5657b$var$index.host($791ce2ee9eb5657b$var$index.getRootNode(n2));
    return shadowHost;
}
function $791ce2ee9eb5657b$var$getRootShadowHost(n2) {
    let rootShadowHost = n2;
    let shadowHost;
    while(shadowHost = $791ce2ee9eb5657b$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $791ce2ee9eb5657b$var$shadowHostInDom(n2) {
    const doc = n2.ownerDocument;
    if (!doc) return false;
    const shadowHost = $791ce2ee9eb5657b$var$getRootShadowHost(n2);
    return $791ce2ee9eb5657b$var$index.contains(doc, shadowHost);
}
function $791ce2ee9eb5657b$var$inDom(n2) {
    const doc = n2.ownerDocument;
    if (!doc) return false;
    return $791ce2ee9eb5657b$var$index.contains(doc, n2) || $791ce2ee9eb5657b$var$shadowHostInDom(n2);
}
const $791ce2ee9eb5657b$export$eab97d15b1788b8d = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    StyleSheetMirror: $791ce2ee9eb5657b$var$StyleSheetMirror,
    get _mirror () {
        return $791ce2ee9eb5657b$export$205349702e9dbad8;
    },
    closestElementOfNode: $791ce2ee9eb5657b$var$closestElementOfNode,
    getBaseDimension: $791ce2ee9eb5657b$var$getBaseDimension,
    getNestedRule: $791ce2ee9eb5657b$var$getNestedRule,
    getPositionsAndIndex: $791ce2ee9eb5657b$var$getPositionsAndIndex,
    getRootShadowHost: $791ce2ee9eb5657b$var$getRootShadowHost,
    getShadowHost: $791ce2ee9eb5657b$var$getShadowHost,
    getWindowHeight: $791ce2ee9eb5657b$var$getWindowHeight,
    getWindowScroll: $791ce2ee9eb5657b$var$getWindowScroll,
    getWindowWidth: $791ce2ee9eb5657b$var$getWindowWidth,
    hasShadowRoot: $791ce2ee9eb5657b$var$hasShadowRoot,
    hookSetter: $791ce2ee9eb5657b$var$hookSetter,
    inDom: $791ce2ee9eb5657b$var$inDom,
    isAncestorRemoved: $791ce2ee9eb5657b$var$isAncestorRemoved,
    isBlocked: $791ce2ee9eb5657b$var$isBlocked,
    isIgnored: $791ce2ee9eb5657b$var$isIgnored,
    isSerialized: $791ce2ee9eb5657b$var$isSerialized,
    isSerializedIframe: $791ce2ee9eb5657b$var$isSerializedIframe,
    isSerializedStylesheet: $791ce2ee9eb5657b$var$isSerializedStylesheet,
    iterateResolveTree: $791ce2ee9eb5657b$var$iterateResolveTree,
    legacy_isTouchEvent: $791ce2ee9eb5657b$var$legacy_isTouchEvent,
    get nowTimestamp () {
        return $791ce2ee9eb5657b$var$nowTimestamp;
    },
    on: $791ce2ee9eb5657b$var$on,
    patch: $791ce2ee9eb5657b$var$patch,
    polyfill: $791ce2ee9eb5657b$var$polyfill$1,
    queueToResolveTrees: $791ce2ee9eb5657b$var$queueToResolveTrees,
    shadowHostInDom: $791ce2ee9eb5657b$var$shadowHostInDom,
    throttle: $791ce2ee9eb5657b$var$throttle,
    uniqueTextMutations: $791ce2ee9eb5657b$var$uniqueTextMutations
}, Symbol.toStringTag, {
    value: "Module"
}));
var $791ce2ee9eb5657b$export$3d7865934588d77e = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($791ce2ee9eb5657b$export$3d7865934588d77e || {});
var $791ce2ee9eb5657b$export$24bb3ebc067ff5e1 = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($791ce2ee9eb5657b$export$24bb3ebc067ff5e1 || {});
var $791ce2ee9eb5657b$export$d87e674dba09af70 = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($791ce2ee9eb5657b$export$d87e674dba09af70 || {});
var $791ce2ee9eb5657b$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($791ce2ee9eb5657b$var$PointerTypes || {});
var $791ce2ee9eb5657b$var$CanvasContext = /* @__PURE__ */ ((CanvasContext2)=>{
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
})($791ce2ee9eb5657b$var$CanvasContext || {});
var $791ce2ee9eb5657b$var$MediaInteractions = /* @__PURE__ */ ((MediaInteractions2)=>{
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
})($791ce2ee9eb5657b$var$MediaInteractions || {});
var $791ce2ee9eb5657b$export$7b5ca317a0cad55c = /* @__PURE__ */ ((ReplayerEvents2)=>{
    ReplayerEvents2["Start"] = "start";
    ReplayerEvents2["Pause"] = "pause";
    ReplayerEvents2["Resume"] = "resume";
    ReplayerEvents2["Resize"] = "resize";
    ReplayerEvents2["Finish"] = "finish";
    ReplayerEvents2["FullsnapshotRebuilded"] = "fullsnapshot-rebuilded";
    ReplayerEvents2["LoadStylesheetStart"] = "load-stylesheet-start";
    ReplayerEvents2["LoadStylesheetEnd"] = "load-stylesheet-end";
    ReplayerEvents2["SkipStart"] = "skip-start";
    ReplayerEvents2["SkipEnd"] = "skip-end";
    ReplayerEvents2["MouseInteraction"] = "mouse-interaction";
    ReplayerEvents2["EventCast"] = "event-cast";
    ReplayerEvents2["CustomEvent"] = "custom-event";
    ReplayerEvents2["Flush"] = "flush";
    ReplayerEvents2["StateChange"] = "state-change";
    ReplayerEvents2["PlayBack"] = "play-back";
    ReplayerEvents2["Destroy"] = "destroy";
    return ReplayerEvents2;
})($791ce2ee9eb5657b$export$7b5ca317a0cad55c || {});
var $791ce2ee9eb5657b$var$NodeType = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($791ce2ee9eb5657b$var$NodeType || {});
function $791ce2ee9eb5657b$var$isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
class $791ce2ee9eb5657b$var$DoubleLinkedList {
    constructor(){
        $791ce2ee9eb5657b$var$__publicField(this, "length", 0);
        $791ce2ee9eb5657b$var$__publicField(this, "head", null);
        $791ce2ee9eb5657b$var$__publicField(this, "tail", null);
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index2 = 0; index2 < position; index2++)current = (current == null ? void 0 : current.next) || null;
        return current;
    }
    addNode(n2) {
        const node2 = {
            value: n2,
            previous: null,
            next: null
        };
        n2.__ln = node2;
        if (n2.previousSibling && $791ce2ee9eb5657b$var$isNodeInLinkedList(n2.previousSibling)) {
            const current = n2.previousSibling.__ln.next;
            node2.next = current;
            node2.previous = n2.previousSibling.__ln;
            n2.previousSibling.__ln.next = node2;
            if (current) current.previous = node2;
        } else if (n2.nextSibling && $791ce2ee9eb5657b$var$isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
            const current = n2.nextSibling.__ln.previous;
            node2.previous = current;
            node2.next = n2.nextSibling.__ln;
            n2.nextSibling.__ln.previous = node2;
            if (current) current.next = node2;
        } else {
            if (this.head) this.head.previous = node2;
            node2.next = this.head;
            this.head = node2;
        }
        if (node2.next === null) this.tail = node2;
        this.length++;
    }
    removeNode(n2) {
        const current = n2.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n2.__ln) delete n2.__ln;
        this.length--;
    }
}
const $791ce2ee9eb5657b$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $791ce2ee9eb5657b$var$MutationBuffer {
    constructor(){
        $791ce2ee9eb5657b$var$__publicField(this, "frozen", false);
        $791ce2ee9eb5657b$var$__publicField(this, "locked", false);
        $791ce2ee9eb5657b$var$__publicField(this, "texts", []);
        $791ce2ee9eb5657b$var$__publicField(this, "attributes", []);
        $791ce2ee9eb5657b$var$__publicField(this, "attributeMap", /* @__PURE__ */ new WeakMap());
        $791ce2ee9eb5657b$var$__publicField(this, "removes", []);
        $791ce2ee9eb5657b$var$__publicField(this, "mapRemoves", []);
        $791ce2ee9eb5657b$var$__publicField(this, "movedMap", {});
        /**
     * the browser MutationObserver emits multiple mutations after
     * a delay for performance reasons, making tracing added nodes hard
     * in our `processMutations` callback function.
     * For example, if we append an element el_1 into body, and then append
     * another element el_2 into el_1, these two mutations may be passed to the
     * callback function together when the two operations were done.
     * Generally we need to trace child nodes of newly added nodes, but in this
     * case if we count el_2 as el_1's child node in the first mutation record,
     * then we will count el_2 again in the second mutation record which was
     * duplicated.
     * To avoid of duplicate counting added nodes, we use a Set to store
     * added nodes and its child nodes during iterate mutation records. Then
     * collect added nodes from the Set which have no duplicate copy. But
     * this also causes newly added nodes will not be serialized with id ASAP,
     * which means all the id related calculation should be lazy too.
     */ $791ce2ee9eb5657b$var$__publicField(this, "addedSet", /* @__PURE__ */ new Set());
        $791ce2ee9eb5657b$var$__publicField(this, "movedSet", /* @__PURE__ */ new Set());
        $791ce2ee9eb5657b$var$__publicField(this, "droppedSet", /* @__PURE__ */ new Set());
        $791ce2ee9eb5657b$var$__publicField(this, "removesSubTreeCache", /* @__PURE__ */ new Set());
        $791ce2ee9eb5657b$var$__publicField(this, "mutationCb");
        $791ce2ee9eb5657b$var$__publicField(this, "blockClass");
        $791ce2ee9eb5657b$var$__publicField(this, "blockSelector");
        $791ce2ee9eb5657b$var$__publicField(this, "maskTextClass");
        $791ce2ee9eb5657b$var$__publicField(this, "maskTextSelector");
        $791ce2ee9eb5657b$var$__publicField(this, "inlineStylesheet");
        $791ce2ee9eb5657b$var$__publicField(this, "maskInputOptions");
        $791ce2ee9eb5657b$var$__publicField(this, "maskTextFn");
        $791ce2ee9eb5657b$var$__publicField(this, "maskInputFn");
        $791ce2ee9eb5657b$var$__publicField(this, "keepIframeSrcFn");
        $791ce2ee9eb5657b$var$__publicField(this, "recordCanvas");
        $791ce2ee9eb5657b$var$__publicField(this, "inlineImages");
        $791ce2ee9eb5657b$var$__publicField(this, "slimDOMOptions");
        $791ce2ee9eb5657b$var$__publicField(this, "dataURLOptions");
        $791ce2ee9eb5657b$var$__publicField(this, "doc");
        $791ce2ee9eb5657b$var$__publicField(this, "mirror");
        $791ce2ee9eb5657b$var$__publicField(this, "iframeManager");
        $791ce2ee9eb5657b$var$__publicField(this, "stylesheetManager");
        $791ce2ee9eb5657b$var$__publicField(this, "shadowDomManager");
        $791ce2ee9eb5657b$var$__publicField(this, "canvasManager");
        $791ce2ee9eb5657b$var$__publicField(this, "processedNodeManager");
        $791ce2ee9eb5657b$var$__publicField(this, "unattachedDoc");
        $791ce2ee9eb5657b$var$__publicField(this, "processMutations", (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        });
        $791ce2ee9eb5657b$var$__publicField(this, "emit", ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = /* @__PURE__ */ new Set();
            const addList = new $791ce2ee9eb5657b$var$DoubleLinkedList();
            const getNextId = (n2)=>{
                let ns = n2;
                let nextId = $791ce2ee9eb5657b$var$IGNORED_NODE;
                while(nextId === $791ce2ee9eb5657b$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n2)=>{
                const parent = $791ce2ee9eb5657b$var$index.parentNode(n2);
                if (!parent || !$791ce2ee9eb5657b$var$inDom(n2)) return;
                let cssCaptured = false;
                if (n2.nodeType === Node.TEXT_NODE) {
                    const parentTag = parent.tagName;
                    if (parentTag === "TEXTAREA") return;
                    else if (parentTag === "STYLE" && this.addedSet.has(parent)) cssCaptured = true;
                }
                const parentId = $791ce2ee9eb5657b$var$isShadowRoot(parent) ? this.mirror.getId($791ce2ee9eb5657b$var$getShadowHost(n2)) : this.mirror.getId(parent);
                const nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) return addList.addNode(n2);
                const sn = $791ce2ee9eb5657b$var$serializeNodeWithId(n2, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskTextClass: this.maskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($791ce2ee9eb5657b$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($791ce2ee9eb5657b$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($791ce2ee9eb5657b$var$hasShadowRoot(n2)) this.shadowDomManager.addShadowRoot($791ce2ee9eb5657b$var$index.shadowRoot(n2), this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    },
                    cssCaptured: cssCaptured
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n2 of this.movedSet){
                if ($791ce2ee9eb5657b$var$isParentRemoved(this.removesSubTreeCache, n2, this.mirror) && !this.movedSet.has($791ce2ee9eb5657b$var$index.parentNode(n2))) continue;
                pushAdd(n2);
            }
            for (const n2 of this.addedSet){
                if (!$791ce2ee9eb5657b$var$isAncestorInSet(this.droppedSet, n2) && !$791ce2ee9eb5657b$var$isParentRemoved(this.removesSubTreeCache, n2, this.mirror)) pushAdd(n2);
                else if ($791ce2ee9eb5657b$var$isAncestorInSet(this.movedSet, n2)) pushAdd(n2);
                else this.droppedSet.add(n2);
            }
            let candidate = null;
            while(addList.length){
                let node2 = null;
                if (candidate) {
                    const parentId = this.mirror.getId($791ce2ee9eb5657b$var$index.parentNode(candidate.value));
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node2 = candidate;
                }
                if (!node2) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId($791ce2ee9eb5657b$var$index.parentNode(_node.value));
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node2 = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                const parent = $791ce2ee9eb5657b$var$index.parentNode(unhandledNode);
                                if (parent && parent.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = $791ce2ee9eb5657b$var$index.host(parent);
                                    const parentId2 = this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node2 = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node2) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node2.previous;
                addList.removeNode(node2.value);
                pushAdd(node2.value);
            }
            const payload = {
                texts: this.texts.map((text)=>{
                    const n2 = text.node;
                    const parent = $791ce2ee9eb5657b$var$index.parentNode(n2);
                    if (parent && parent.tagName === "TEXTAREA") this.genTextAreaValueMutation(parent);
                    return {
                        id: this.mirror.getId(n2),
                        value: text.value
                    };
                }).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = /* @__PURE__ */ new WeakMap();
            this.removes = [];
            this.addedSet = /* @__PURE__ */ new Set();
            this.movedSet = /* @__PURE__ */ new Set();
            this.droppedSet = /* @__PURE__ */ new Set();
            this.removesSubTreeCache = /* @__PURE__ */ new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        });
        $791ce2ee9eb5657b$var$__publicField(this, "genTextAreaValueMutation", (textarea)=>{
            let item = this.attributeMap.get(textarea);
            if (!item) {
                item = {
                    node: textarea,
                    attributes: {},
                    styleDiff: {},
                    _unchangedStyles: {}
                };
                this.attributes.push(item);
                this.attributeMap.set(textarea, item);
            }
            const value = Array.from($791ce2ee9eb5657b$var$index.childNodes(textarea), (cn)=>$791ce2ee9eb5657b$var$index.textContent(cn) || "").join("");
            item.attributes.value = $791ce2ee9eb5657b$var$maskInputValue({
                element: textarea,
                maskInputOptions: this.maskInputOptions,
                tagName: textarea.tagName,
                type: $791ce2ee9eb5657b$var$getInputType(textarea),
                value: value,
                maskInputFn: this.maskInputFn
            });
        });
        $791ce2ee9eb5657b$var$__publicField(this, "processMutation", (m)=>{
            if ($791ce2ee9eb5657b$var$isIgnored(m.target, this.mirror, this.slimDOMOptions)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = $791ce2ee9eb5657b$var$index.textContent(m.target);
                        if (!$791ce2ee9eb5657b$var$isBlocked(m.target, this.blockClass, this.blockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $791ce2ee9eb5657b$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, true) && value ? this.maskTextFn ? this.maskTextFn(value, $791ce2ee9eb5657b$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $791ce2ee9eb5657b$var$getInputType(target);
                            value = $791ce2ee9eb5657b$var$maskInputValue({
                                element: target,
                                maskInputOptions: this.maskInputOptions,
                                tagName: target.tagName,
                                type: type,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($791ce2ee9eb5657b$var$isBlocked(m.target, this.blockClass, this.blockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$791ce2ee9eb5657b$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $791ce2ee9eb5657b$var$transformAttribute(this.doc, $791ce2ee9eb5657b$var$toLowerCase(target.tagName), $791ce2ee9eb5657b$var$toLowerCase(attributeName), value);
                            if (attributeName === "style") {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e2) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            } else if (attributeName === "open" && target.tagName === "DIALOG") {
                                if (target.matches("dialog:modal")) item.attributes["rr_open_mode"] = "modal";
                                else item.attributes["rr_open_mode"] = "non-modal";
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($791ce2ee9eb5657b$var$isBlocked(m.target, this.blockClass, this.blockSelector, true)) return;
                    if (m.target.tagName === "TEXTAREA") {
                        this.genTextAreaValueMutation(m.target);
                        return;
                    }
                    m.addedNodes.forEach((n2)=>this.genAdds(n2, m.target));
                    m.removedNodes.forEach((n2)=>{
                        const nodeId = this.mirror.getId(n2);
                        const parentId = $791ce2ee9eb5657b$var$isShadowRoot(m.target) ? this.mirror.getId($791ce2ee9eb5657b$var$index.host(m.target)) : this.mirror.getId(m.target);
                        if ($791ce2ee9eb5657b$var$isBlocked(m.target, this.blockClass, this.blockSelector, false) || $791ce2ee9eb5657b$var$isIgnored(n2, this.mirror, this.slimDOMOptions) || !$791ce2ee9eb5657b$var$isSerialized(n2, this.mirror)) return;
                        if (this.addedSet.has(n2)) {
                            $791ce2ee9eb5657b$var$deepDelete(this.addedSet, n2);
                            this.droppedSet.add(n2);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($791ce2ee9eb5657b$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n2) && this.movedMap[$791ce2ee9eb5657b$var$moveKey(nodeId, parentId)]) $791ce2ee9eb5657b$var$deepDelete(this.movedSet, n2);
                        else {
                            this.removes.push({
                                parentId: parentId,
                                id: nodeId,
                                isShadow: $791ce2ee9eb5657b$var$isShadowRoot(m.target) && $791ce2ee9eb5657b$var$isNativeShadowDom(m.target) ? true : void 0
                            });
                            $791ce2ee9eb5657b$var$processRemoves(n2, this.removesSubTreeCache);
                        }
                        this.mapRemoves.push(n2);
                    });
                    break;
            }
        });
        /**
     * Make sure you check if `n`'s parent is blocked before calling this function
     * */ $791ce2ee9eb5657b$var$__publicField(this, "genAdds", (n2, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n2, this)) return;
            if (this.addedSet.has(n2) || this.movedSet.has(n2)) return;
            if (this.mirror.hasNode(n2)) {
                if ($791ce2ee9eb5657b$var$isIgnored(n2, this.mirror, this.slimDOMOptions)) return;
                this.movedSet.add(n2);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$791ce2ee9eb5657b$var$moveKey(this.mirror.getId(n2), targetId)] = true;
            } else {
                this.addedSet.add(n2);
                this.droppedSet.delete(n2);
            }
            if (!$791ce2ee9eb5657b$var$isBlocked(n2, this.blockClass, this.blockSelector, false)) {
                $791ce2ee9eb5657b$var$index.childNodes(n2).forEach((childN)=>this.genAdds(childN));
                if ($791ce2ee9eb5657b$var$hasShadowRoot(n2)) $791ce2ee9eb5657b$var$index.childNodes($791ce2ee9eb5657b$var$index.shadowRoot(n2)).forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n2);
                });
            }
        });
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "maskTextClass",
            "maskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $791ce2ee9eb5657b$var$deepDelete(addsSet, n2) {
    addsSet.delete(n2);
    $791ce2ee9eb5657b$var$index.childNodes(n2).forEach((childN)=>$791ce2ee9eb5657b$var$deepDelete(addsSet, childN));
}
function $791ce2ee9eb5657b$var$processRemoves(n2, cache) {
    const queue = [
        n2
    ];
    while(queue.length){
        const next = queue.pop();
        if (cache.has(next)) continue;
        cache.add(next);
        $791ce2ee9eb5657b$var$index.childNodes(next).forEach((n22)=>queue.push(n22));
    }
    return;
}
function $791ce2ee9eb5657b$var$isParentRemoved(removes, n2, mirror2) {
    if (removes.size === 0) return false;
    return $791ce2ee9eb5657b$var$_isParentRemoved(removes, n2);
}
function $791ce2ee9eb5657b$var$_isParentRemoved(removes, n2, _mirror2) {
    const node2 = $791ce2ee9eb5657b$var$index.parentNode(n2);
    if (!node2) return false;
    return removes.has(node2);
}
function $791ce2ee9eb5657b$var$isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return $791ce2ee9eb5657b$var$_isAncestorInSet(set, n2);
}
function $791ce2ee9eb5657b$var$_isAncestorInSet(set, n2) {
    const parent = $791ce2ee9eb5657b$var$index.parentNode(n2);
    if (!parent) return false;
    if (set.has(parent)) return true;
    return $791ce2ee9eb5657b$var$_isAncestorInSet(set, parent);
}
let $791ce2ee9eb5657b$var$errorHandler;
function $791ce2ee9eb5657b$var$registerErrorHandler(handler) {
    $791ce2ee9eb5657b$var$errorHandler = handler;
}
function $791ce2ee9eb5657b$var$unregisterErrorHandler() {
    $791ce2ee9eb5657b$var$errorHandler = void 0;
}
const $791ce2ee9eb5657b$var$callbackWrapper = (cb)=>{
    if (!$791ce2ee9eb5657b$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($791ce2ee9eb5657b$var$errorHandler && $791ce2ee9eb5657b$var$errorHandler(error) === true) return;
            throw error;
        }
    };
    return rrwebWrapped;
};
function $791ce2ee9eb5657b$var$externalFunctionWrapper(func) {
    return (...args)=>{
        try {
            return func(...args);
        } catch (error) {
            try {
                error._external_ = true;
            } catch  {}
            throw error;
        }
    };
}
const $791ce2ee9eb5657b$var$mutationBuffers = [];
function $791ce2ee9eb5657b$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch  {}
    return event && event.target;
}
function $791ce2ee9eb5657b$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $791ce2ee9eb5657b$var$MutationBuffer();
    $791ce2ee9eb5657b$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    const observer = new ($791ce2ee9eb5657b$var$mutationObserverCtor())($791ce2ee9eb5657b$var$callbackWrapper(mutationBuffer.processMutations.bind(mutationBuffer)));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $791ce2ee9eb5657b$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror2 }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $791ce2ee9eb5657b$var$throttle($791ce2ee9eb5657b$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $791ce2ee9eb5657b$var$callbackWrapper($791ce2ee9eb5657b$var$throttle($791ce2ee9eb5657b$var$callbackWrapper((evt)=>{
        const target = $791ce2ee9eb5657b$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $791ce2ee9eb5657b$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $791ce2ee9eb5657b$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: $791ce2ee9eb5657b$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Drag : evt instanceof MouseEvent ? $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.MouseMove : $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $791ce2ee9eb5657b$var$on("mousemove", updatePosition, doc),
        $791ce2ee9eb5657b$var$on("touchmove", updatePosition, doc),
        $791ce2ee9eb5657b$var$on("drag", updatePosition, doc)
    ];
    return $791ce2ee9eb5657b$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $791ce2ee9eb5657b$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $791ce2ee9eb5657b$var$getEventTarget(event);
            if ($791ce2ee9eb5657b$var$isBlocked(target, blockClass, blockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $791ce2ee9eb5657b$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $791ce2ee9eb5657b$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $791ce2ee9eb5657b$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $791ce2ee9eb5657b$var$PointerTypes.Touch) {
                    if ($791ce2ee9eb5657b$export$d87e674dba09af70[eventKey] === $791ce2ee9eb5657b$export$d87e674dba09af70.MouseDown) thisEventKey = "TouchStart";
                    else if ($791ce2ee9eb5657b$export$d87e674dba09af70[eventKey] === $791ce2ee9eb5657b$export$d87e674dba09af70.MouseUp) thisEventKey = "TouchEnd";
                } else $791ce2ee9eb5657b$var$PointerTypes.Pen;
            } else if ($791ce2ee9eb5657b$var$legacy_isTouchEvent(event)) pointerType = $791ce2ee9eb5657b$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $791ce2ee9eb5657b$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $791ce2ee9eb5657b$var$PointerTypes.Mouse) pointerType = null;
            } else if ($791ce2ee9eb5657b$export$d87e674dba09af70[eventKey] === $791ce2ee9eb5657b$export$d87e674dba09af70.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e2 = $791ce2ee9eb5657b$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) return;
            const id = mirror2.getId(target);
            const { clientX: clientX, clientY: clientY } = e2;
            $791ce2ee9eb5657b$var$callbackWrapper(mouseInteractionCb)({
                type: $791ce2ee9eb5657b$export$d87e674dba09af70[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($791ce2ee9eb5657b$export$d87e674dba09af70).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $791ce2ee9eb5657b$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($791ce2ee9eb5657b$export$d87e674dba09af70[eventKey]){
            case $791ce2ee9eb5657b$export$d87e674dba09af70.MouseDown:
            case $791ce2ee9eb5657b$export$d87e674dba09af70.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $791ce2ee9eb5657b$export$d87e674dba09af70.TouchStart:
            case $791ce2ee9eb5657b$export$d87e674dba09af70.TouchEnd:
                return;
        }
        handlers.push($791ce2ee9eb5657b$var$on(eventName, handler, doc));
    });
    return $791ce2ee9eb5657b$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $791ce2ee9eb5657b$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, sampling: sampling }) {
    const updatePosition = $791ce2ee9eb5657b$var$callbackWrapper($791ce2ee9eb5657b$var$throttle($791ce2ee9eb5657b$var$callbackWrapper((evt)=>{
        const target = $791ce2ee9eb5657b$var$getEventTarget(evt);
        if (!target || $791ce2ee9eb5657b$var$isBlocked(target, blockClass, blockSelector, true)) return;
        const id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $791ce2ee9eb5657b$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $791ce2ee9eb5657b$var$on("scroll", updatePosition, doc);
}
function $791ce2ee9eb5657b$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $791ce2ee9eb5657b$var$callbackWrapper($791ce2ee9eb5657b$var$throttle($791ce2ee9eb5657b$var$callbackWrapper(()=>{
        const height = $791ce2ee9eb5657b$var$getWindowHeight();
        const width = $791ce2ee9eb5657b$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $791ce2ee9eb5657b$var$on("resize", updateDimension, win);
}
const $791ce2ee9eb5657b$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $791ce2ee9eb5657b$var$lastInputValueMap = /* @__PURE__ */ new WeakMap();
function $791ce2ee9eb5657b$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput }) {
    function eventHandler(event) {
        let target = $791ce2ee9eb5657b$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && target.tagName;
        if (target && tagName === "OPTION") target = $791ce2ee9eb5657b$var$index.parentElement(target);
        if (!target || !tagName || $791ce2ee9eb5657b$var$INPUT_TAGS.indexOf(tagName) < 0 || $791ce2ee9eb5657b$var$isBlocked(target, blockClass, blockSelector, true)) return;
        if (target.classList.contains(ignoreClass) || ignoreSelector && target.matches(ignoreSelector)) return;
        let text = target.value;
        let isChecked = false;
        const type = $791ce2ee9eb5657b$var$getInputType(target) || "";
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        else if (maskInputOptions[tagName.toLowerCase()] || maskInputOptions[type]) text = $791ce2ee9eb5657b$var$maskInputValue({
            element: target,
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text2 = el.value;
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text2,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text2,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v2) {
        const lastInputValue = $791ce2ee9eb5657b$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            $791ce2ee9eb5657b$var$lastInputValueMap.set(target, v2);
            const id = mirror2.getId(target);
            $791ce2ee9eb5657b$var$callbackWrapper(inputCb)({
                ...v2,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$791ce2ee9eb5657b$var$on(eventName, $791ce2ee9eb5657b$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$791ce2ee9eb5657b$var$hookSetter(p[0], p[1], {
            set () {
                $791ce2ee9eb5657b$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $791ce2ee9eb5657b$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $791ce2ee9eb5657b$var$getNestedCSSRulePositions(rule2) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($791ce2ee9eb5657b$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $791ce2ee9eb5657b$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $791ce2ee9eb5657b$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $791ce2ee9eb5657b$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules2 = Array.from(childRule.parentRule.cssRules);
            const index2 = rules2.indexOf(childRule);
            pos.unshift(index2);
        } else if (childRule.parentStyleSheet) {
            const rules2 = Array.from(childRule.parentStyleSheet.cssRules);
            const index2 = rules2.indexOf(childRule);
            pos.unshift(index2);
        }
        return pos;
    }
    return recurse(rule2, positions);
}
function $791ce2ee9eb5657b$var$getIdAndStyleId(sheet, mirror2, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $791ce2ee9eb5657b$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror2, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $791ce2ee9eb5657b$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule2, index2] = argumentsList;
            const { id: id, styleId: styleId } = $791ce2ee9eb5657b$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule2,
                        index: index2
                    }
                ]
            });
            return $791ce2ee9eb5657b$var$externalFunctionWrapper(()=>target.apply(thisArg, argumentsList))();
        })
    });
    win.CSSStyleSheet.prototype.addRule = function(selector, styleBlock, index2 = this.cssRules.length) {
        const rule2 = `${selector} { ${styleBlock} }`;
        return win.CSSStyleSheet.prototype.insertRule.apply(this, [
            rule2,
            index2
        ]);
    };
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $791ce2ee9eb5657b$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index2] = argumentsList;
            const { id: id, styleId: styleId } = $791ce2ee9eb5657b$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index2
                    }
                ]
            });
            return $791ce2ee9eb5657b$var$externalFunctionWrapper(()=>target.apply(thisArg, argumentsList))();
        })
    });
    win.CSSStyleSheet.prototype.removeRule = function(index2) {
        return win.CSSStyleSheet.prototype.deleteRule.apply(this, [
            index2
        ]);
    };
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $791ce2ee9eb5657b$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $791ce2ee9eb5657b$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $791ce2ee9eb5657b$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $791ce2ee9eb5657b$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($791ce2ee9eb5657b$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($791ce2ee9eb5657b$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($791ce2ee9eb5657b$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($791ce2ee9eb5657b$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $791ce2ee9eb5657b$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule2, index2] = argumentsList;
                const { id: id, styleId: styleId } = $791ce2ee9eb5657b$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule2,
                            index: [
                                ...$791ce2ee9eb5657b$var$getNestedCSSRulePositions(thisArg),
                                index2 || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $791ce2ee9eb5657b$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index2] = argumentsList;
                const { id: id, styleId: styleId } = $791ce2ee9eb5657b$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$791ce2ee9eb5657b$var$getNestedCSSRulePositions(thisArg),
                                index2
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $791ce2ee9eb5657b$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $791ce2ee9eb5657b$var$initAdoptedStyleSheetObserver({ mirror: mirror2, stylesheetManager: stylesheetManager }, host2) {
    var _a2, _b, _c;
    let hostId = null;
    if (host2.nodeName === "#document") hostId = mirror2.getId(host2);
    else hostId = mirror2.getId($791ce2ee9eb5657b$var$index.host(host2));
    const patchTarget = host2.nodeName === "#document" ? (_a2 = host2.defaultView) == null ? void 0 : _a2.Document : (_c = (_b = host2.ownerDocument) == null ? void 0 : _b.defaultView) == null ? void 0 : _c.ShadowRoot;
    const originalPropertyDescriptor = (patchTarget == null ? void 0 : patchTarget.prototype) ? Object.getOwnPropertyDescriptor(patchTarget == null ? void 0 : patchTarget.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host2, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            var _a3;
            return (_a3 = originalPropertyDescriptor.get) == null ? void 0 : _a3.call(this);
        },
        set (sheets) {
            var _a3;
            const result2 = (_a3 = originalPropertyDescriptor.set) == null ? void 0 : _a3.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e2) {}
            return result2;
        }
    });
    return $791ce2ee9eb5657b$var$callbackWrapper(()=>{
        Object.defineProperty(host2, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function $791ce2ee9eb5657b$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror2, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $791ce2ee9eb5657b$var$callbackWrapper((target, thisArg, argumentsList)=>{
            var _a2;
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $791ce2ee9eb5657b$var$getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $791ce2ee9eb5657b$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $791ce2ee9eb5657b$var$callbackWrapper((target, thisArg, argumentsList)=>{
            var _a2;
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $791ce2ee9eb5657b$var$getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $791ce2ee9eb5657b$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $791ce2ee9eb5657b$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $791ce2ee9eb5657b$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, mirror: mirror2, sampling: sampling, doc: doc }) {
    const handler = $791ce2ee9eb5657b$var$callbackWrapper((type)=>$791ce2ee9eb5657b$var$throttle($791ce2ee9eb5657b$var$callbackWrapper((event)=>{
            const target = $791ce2ee9eb5657b$var$getEventTarget(event);
            if (!target || $791ce2ee9eb5657b$var$isBlocked(target, blockClass, blockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate, loop: loop } = target;
            mediaInteractionCb({
                type: type,
                id: mirror2.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate,
                loop: loop
            });
        }), sampling.media || 500));
    const handlers = [
        $791ce2ee9eb5657b$var$on("play", handler($791ce2ee9eb5657b$var$MediaInteractions.Play), doc),
        $791ce2ee9eb5657b$var$on("pause", handler($791ce2ee9eb5657b$var$MediaInteractions.Pause), doc),
        $791ce2ee9eb5657b$var$on("seeked", handler($791ce2ee9eb5657b$var$MediaInteractions.Seeked), doc),
        $791ce2ee9eb5657b$var$on("volumechange", handler($791ce2ee9eb5657b$var$MediaInteractions.VolumeChange), doc),
        $791ce2ee9eb5657b$var$on("ratechange", handler($791ce2ee9eb5657b$var$MediaInteractions.RateChange), doc)
    ];
    return $791ce2ee9eb5657b$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $791ce2ee9eb5657b$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = /* @__PURE__ */ new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $791ce2ee9eb5657b$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout($791ce2ee9eb5657b$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $791ce2ee9eb5657b$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $791ce2ee9eb5657b$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $791ce2ee9eb5657b$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && (selection == null ? void 0 : selection.isCollapsed)) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i2 = 0; i2 < count; i2++){
            const range = selection.getRangeAt(i2);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $791ce2ee9eb5657b$var$isBlocked(startContainer, blockClass, blockSelector, true) || $791ce2ee9eb5657b$var$isBlocked(endContainer, blockClass, blockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset: startOffset,
                end: mirror2.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $791ce2ee9eb5657b$var$on("selectionchange", updateSelection);
}
function $791ce2ee9eb5657b$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $791ce2ee9eb5657b$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e2) {
                console.warn(`Custom element callback failed for ${name}`);
            }
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $791ce2ee9eb5657b$var$mergeHooks(o2, hooks) {
    const { mutationCb: mutationCb, mousemoveCb: mousemoveCb, mouseInteractionCb: mouseInteractionCb, scrollCb: scrollCb, viewportResizeCb: viewportResizeCb, inputCb: inputCb, mediaInteractionCb: mediaInteractionCb, styleSheetRuleCb: styleSheetRuleCb, styleDeclarationCb: styleDeclarationCb, canvasMutationCb: canvasMutationCb, fontCb: fontCb, selectionCb: selectionCb, customElementCb: customElementCb } = o2;
    o2.mutationCb = (...p)=>{
        if (hooks.mutation) hooks.mutation(...p);
        mutationCb(...p);
    };
    o2.mousemoveCb = (...p)=>{
        if (hooks.mousemove) hooks.mousemove(...p);
        mousemoveCb(...p);
    };
    o2.mouseInteractionCb = (...p)=>{
        if (hooks.mouseInteraction) hooks.mouseInteraction(...p);
        mouseInteractionCb(...p);
    };
    o2.scrollCb = (...p)=>{
        if (hooks.scroll) hooks.scroll(...p);
        scrollCb(...p);
    };
    o2.viewportResizeCb = (...p)=>{
        if (hooks.viewportResize) hooks.viewportResize(...p);
        viewportResizeCb(...p);
    };
    o2.inputCb = (...p)=>{
        if (hooks.input) hooks.input(...p);
        inputCb(...p);
    };
    o2.mediaInteractionCb = (...p)=>{
        if (hooks.mediaInteaction) hooks.mediaInteaction(...p);
        mediaInteractionCb(...p);
    };
    o2.styleSheetRuleCb = (...p)=>{
        if (hooks.styleSheetRule) hooks.styleSheetRule(...p);
        styleSheetRuleCb(...p);
    };
    o2.styleDeclarationCb = (...p)=>{
        if (hooks.styleDeclaration) hooks.styleDeclaration(...p);
        styleDeclarationCb(...p);
    };
    o2.canvasMutationCb = (...p)=>{
        if (hooks.canvasMutation) hooks.canvasMutation(...p);
        canvasMutationCb(...p);
    };
    o2.fontCb = (...p)=>{
        if (hooks.font) hooks.font(...p);
        fontCb(...p);
    };
    o2.selectionCb = (...p)=>{
        if (hooks.selection) hooks.selection(...p);
        selectionCb(...p);
    };
    o2.customElementCb = (...c2)=>{
        if (hooks.customElement) hooks.customElement(...c2);
        customElementCb(...c2);
    };
}
function $791ce2ee9eb5657b$var$initObservers(o2, hooks = {}) {
    const currentWindow = o2.doc.defaultView;
    if (!currentWindow) return ()=>{};
    $791ce2ee9eb5657b$var$mergeHooks(o2, hooks);
    let mutationObserver;
    if (o2.recordDOM) mutationObserver = $791ce2ee9eb5657b$var$initMutationObserver(o2, o2.doc);
    const mousemoveHandler = $791ce2ee9eb5657b$var$initMoveObserver(o2);
    const mouseInteractionHandler = $791ce2ee9eb5657b$var$initMouseInteractionObserver(o2);
    const scrollHandler = $791ce2ee9eb5657b$var$initScrollObserver(o2);
    const viewportResizeHandler = $791ce2ee9eb5657b$var$initViewportResizeObserver(o2, {
        win: currentWindow
    });
    const inputHandler = $791ce2ee9eb5657b$var$initInputObserver(o2);
    const mediaInteractionHandler = $791ce2ee9eb5657b$var$initMediaInteractionObserver(o2);
    let styleSheetObserver = ()=>{};
    let adoptedStyleSheetObserver = ()=>{};
    let styleDeclarationObserver = ()=>{};
    let fontObserver = ()=>{};
    if (o2.recordDOM) {
        styleSheetObserver = $791ce2ee9eb5657b$var$initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $791ce2ee9eb5657b$var$initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = $791ce2ee9eb5657b$var$initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) fontObserver = $791ce2ee9eb5657b$var$initFontObserver(o2);
    }
    const selectionObserver = $791ce2ee9eb5657b$var$initSelectionObserver(o2);
    const customElementObserver = $791ce2ee9eb5657b$var$initCustomElementObserver(o2);
    const pluginHandlers = [];
    for (const plugin3 of o2.plugins)pluginHandlers.push(plugin3.observer(plugin3.callback, currentWindow, plugin3.options));
    return $791ce2ee9eb5657b$var$callbackWrapper(()=>{
        $791ce2ee9eb5657b$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver == null || mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $791ce2ee9eb5657b$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $791ce2ee9eb5657b$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $791ce2ee9eb5657b$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        $791ce2ee9eb5657b$var$__publicField(this, "iframeIdToRemoteIdMap", /* @__PURE__ */ new WeakMap());
        $791ce2ee9eb5657b$var$__publicField(this, "iframeRemoteIdToIdMap", /* @__PURE__ */ new WeakMap());
        this.generateIdFn = generateIdFn;
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
            this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = /* @__PURE__ */ new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = /* @__PURE__ */ new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
class $791ce2ee9eb5657b$var$IframeManager {
    constructor(options){
        $791ce2ee9eb5657b$var$__publicField(this, "iframes", /* @__PURE__ */ new WeakMap());
        $791ce2ee9eb5657b$var$__publicField(this, "crossOriginIframeMap", /* @__PURE__ */ new WeakMap());
        $791ce2ee9eb5657b$var$__publicField(this, "crossOriginIframeMirror", new $791ce2ee9eb5657b$var$CrossOriginIframeMirror($791ce2ee9eb5657b$var$genId));
        $791ce2ee9eb5657b$var$__publicField(this, "crossOriginIframeStyleMirror");
        $791ce2ee9eb5657b$var$__publicField(this, "crossOriginIframeRootIdMap", /* @__PURE__ */ new WeakMap());
        $791ce2ee9eb5657b$var$__publicField(this, "mirror");
        $791ce2ee9eb5657b$var$__publicField(this, "mutationCb");
        $791ce2ee9eb5657b$var$__publicField(this, "wrappedEmit");
        $791ce2ee9eb5657b$var$__publicField(this, "loadListener");
        $791ce2ee9eb5657b$var$__publicField(this, "stylesheetManager");
        $791ce2ee9eb5657b$var$__publicField(this, "recordCrossOriginIframes");
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $791ce2ee9eb5657b$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        var _a2, _b;
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        if (this.recordCrossOriginIframes) (_a2 = iframeEl.contentWindow) == null || _a2.addEventListener("message", this.handleMessage.bind(this));
        (_b = this.loadListener) == null || _b.call(this, iframeEl);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
        crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e2) {
        var _a2;
        switch(e2.type){
            case $791ce2ee9eb5657b$export$3d7865934588d77e.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e2.data.node, iframeEl);
                    const rootId = e2.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e2.data.node, rootId);
                    return {
                        timestamp: e2.timestamp,
                        type: $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot,
                        data: {
                            source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e2.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $791ce2ee9eb5657b$export$3d7865934588d77e.Meta:
            case $791ce2ee9eb5657b$export$3d7865934588d77e.Load:
            case $791ce2ee9eb5657b$export$3d7865934588d77e.DomContentLoaded:
                return false;
            case $791ce2ee9eb5657b$export$3d7865934588d77e.Plugin:
                return e2;
            case $791ce2ee9eb5657b$export$3d7865934588d77e.Custom:
                this.replaceIds(e2.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e2;
            case $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot:
                switch(e2.data.source){
                    case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Mutation:
                        e2.data.adds.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n2.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n2.node, rootId);
                        });
                        e2.data.removes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e2.data.attributes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        e2.data.texts.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Drag:
                    case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.TouchMove:
                    case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.MouseMove:
                        e2.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.ViewportResize:
                        return false;
                    case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.MediaInteraction:
                    case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.MouseInteraction:
                    case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Scroll:
                    case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.CanvasMutation:
                    case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Input:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        return e2;
                    case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.StyleSheetRule:
                    case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.StyleDeclaration:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleId"
                        ]);
                        return e2;
                    case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Font:
                        return e2;
                    case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Selection:
                        e2.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e2;
                    case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.AdoptedStyleSheet:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleIds"
                        ]);
                        (_a2 = e2.data.styles) == null || _a2.forEach((style)=>{
                            this.replaceStyleIds(style, iframeEl, [
                                "styleId"
                            ]);
                        });
                        return e2;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node2, iframeEl) {
        this.replaceIds(node2, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node2) node2.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node2, rootId) {
        if (node2.type !== $791ce2ee9eb5657b$var$NodeType.Document && !node2.rootId) node2.rootId = rootId;
        if ("childNodes" in node2) node2.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $791ce2ee9eb5657b$var$ShadowDomManager {
    constructor(options){
        $791ce2ee9eb5657b$var$__publicField(this, "shadowDoms", /* @__PURE__ */ new WeakSet());
        $791ce2ee9eb5657b$var$__publicField(this, "mutationCb");
        $791ce2ee9eb5657b$var$__publicField(this, "scrollCb");
        $791ce2ee9eb5657b$var$__publicField(this, "bypassOptions");
        $791ce2ee9eb5657b$var$__publicField(this, "mirror");
        $791ce2ee9eb5657b$var$__publicField(this, "restoreHandlers", []);
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot2, doc) {
        if (!$791ce2ee9eb5657b$var$isNativeShadowDom(shadowRoot2)) return;
        if (this.shadowDoms.has(shadowRoot2)) return;
        this.shadowDoms.add(shadowRoot2);
        const observer = $791ce2ee9eb5657b$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot2);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($791ce2ee9eb5657b$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
            // scroll is not allowed to pass the boundary, so we need to listen the shadow document
            doc: shadowRoot2,
            mirror: this.mirror
        }));
        setTimeout(()=>{
            if (shadowRoot2.adoptedStyleSheets && shadowRoot2.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot2.adoptedStyleSheets, this.mirror.getId($791ce2ee9eb5657b$var$index.host(shadowRoot2)));
            this.restoreHandlers.push($791ce2ee9eb5657b$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot2));
        }, 0);
    }
    /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($791ce2ee9eb5657b$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const sRoot = original.call(this, option);
                const shadowRootEl = $791ce2ee9eb5657b$var$index.shadowRoot(this);
                if (shadowRootEl && $791ce2ee9eb5657b$var$inDom(this)) manager.addShadowRoot(shadowRootEl, doc);
                return sRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
    }
}
var $791ce2ee9eb5657b$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $791ce2ee9eb5657b$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $791ce2ee9eb5657b$var$i$1 = 0; $791ce2ee9eb5657b$var$i$1 < $791ce2ee9eb5657b$var$chars.length; $791ce2ee9eb5657b$var$i$1++)$791ce2ee9eb5657b$var$lookup[$791ce2ee9eb5657b$var$chars.charCodeAt($791ce2ee9eb5657b$var$i$1)] = $791ce2ee9eb5657b$var$i$1;
var $791ce2ee9eb5657b$var$encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i2, len = bytes.length, base64 = "";
    for(i2 = 0; i2 < len; i2 += 3){
        base64 += $791ce2ee9eb5657b$var$chars[bytes[i2] >> 2];
        base64 += $791ce2ee9eb5657b$var$chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
        base64 += $791ce2ee9eb5657b$var$chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
        base64 += $791ce2ee9eb5657b$var$chars[bytes[i2 + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
var $791ce2ee9eb5657b$var$decode = function(base64) {
    var bufferLength = base64.length * 0.75, len = base64.length, i2, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    var arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i2 = 0; i2 < len; i2 += 4){
        encoded1 = $791ce2ee9eb5657b$var$lookup[base64.charCodeAt(i2)];
        encoded2 = $791ce2ee9eb5657b$var$lookup[base64.charCodeAt(i2 + 1)];
        encoded3 = $791ce2ee9eb5657b$var$lookup[base64.charCodeAt(i2 + 2)];
        encoded4 = $791ce2ee9eb5657b$var$lookup[base64.charCodeAt(i2 + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};
const $791ce2ee9eb5657b$var$canvasVarMap = /* @__PURE__ */ new Map();
function $791ce2ee9eb5657b$var$variableListFor$1(ctx, ctor) {
    let contextMap = $791ce2ee9eb5657b$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = /* @__PURE__ */ new Map();
        $791ce2ee9eb5657b$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
const $791ce2ee9eb5657b$var$saveWebGLVar = (value, win, ctx)=>{
    if (!value || !($791ce2ee9eb5657b$var$isInstanceOfWebGLObject(value, win) || typeof value === "object")) return;
    const name = value.constructor.name;
    const list2 = $791ce2ee9eb5657b$var$variableListFor$1(ctx, name);
    let index2 = list2.indexOf(value);
    if (index2 === -1) {
        index2 = list2.length;
        list2.push(value);
    }
    return index2;
};
function $791ce2ee9eb5657b$var$serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map((arg)=>$791ce2ee9eb5657b$var$serializeArg(arg, win, ctx));
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (// SharedArrayBuffer disabled on most browsers due to spectre.
    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = $791ce2ee9eb5657b$var$encode(value);
        return {
            rr_type: name,
            base64: base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $791ce2ee9eb5657b$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src: src } = value;
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof HTMLCanvasElement) {
        const name = "HTMLImageElement";
        const src = value.toDataURL();
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $791ce2ee9eb5657b$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($791ce2ee9eb5657b$var$isInstanceOfWebGLObject(value, win) || typeof value === "object") {
        const name = value.constructor.name;
        const index2 = $791ce2ee9eb5657b$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index2
        };
    }
    return value;
}
const $791ce2ee9eb5657b$var$serializeArgs = (args, win, ctx)=>{
    return args.map((arg)=>$791ce2ee9eb5657b$var$serializeArg(arg, win, ctx));
};
const $791ce2ee9eb5657b$var$isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
        "WebGLVertexArrayObjectOES"
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === "function");
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function $791ce2ee9eb5657b$var$initCanvas2DMutationObserver(cb, win, blockClass, blockSelector) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D)try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") continue;
        const restoreHandler = $791ce2ee9eb5657b$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
            return function(...args) {
                if (!$791ce2ee9eb5657b$var$isBlocked(this.canvas, blockClass, blockSelector, true)) setTimeout(()=>{
                    const recordArgs = $791ce2ee9eb5657b$var$serializeArgs(args, win, this);
                    cb(this.canvas, {
                        type: $791ce2ee9eb5657b$var$CanvasContext["2D"],
                        property: prop,
                        args: recordArgs
                    });
                }, 0);
                return original.apply(this, args);
            };
        });
        handlers.push(restoreHandler);
    } catch  {
        const hookHandler = $791ce2ee9eb5657b$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
            set (v2) {
                cb(this.canvas, {
                    type: $791ce2ee9eb5657b$var$CanvasContext["2D"],
                    property: prop,
                    args: [
                        v2
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $791ce2ee9eb5657b$var$getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function $791ce2ee9eb5657b$var$initCanvasContextObserver(win, blockClass, blockSelector, setPreserveDrawingBufferToTrue) {
    const handlers = [];
    try {
        const restoreHandler = $791ce2ee9eb5657b$var$patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType, ...args) {
                if (!$791ce2ee9eb5657b$var$isBlocked(this, blockClass, blockSelector, true)) {
                    const ctxName = $791ce2ee9eb5657b$var$getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && typeof args[0] === "object") {
                            const contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch  {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $791ce2ee9eb5657b$var$patchGLPrototype(prototype, type, cb, blockClass, blockSelector, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props){
        if (//prop.startsWith('get') ||  // e.g. getProgramParameter, but too risky
        [
            "isContextLost",
            "canvas",
            "drawingBufferWidth",
            "drawingBufferHeight"
        ].includes(prop)) continue;
        try {
            if (typeof prototype[prop] !== "function") continue;
            const restoreHandler = $791ce2ee9eb5657b$var$patch(prototype, prop, function(original) {
                return function(...args) {
                    const result2 = original.apply(this, args);
                    $791ce2ee9eb5657b$var$saveWebGLVar(result2, win, this);
                    if ("tagName" in this.canvas && !$791ce2ee9eb5657b$var$isBlocked(this.canvas, blockClass, blockSelector, true)) {
                        const recordArgs = $791ce2ee9eb5657b$var$serializeArgs(args, win, this);
                        const mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result2;
                };
            });
            handlers.push(restoreHandler);
        } catch  {
            const hookHandler = $791ce2ee9eb5657b$var$hookSetter(prototype, prop, {
                set (v2) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v2
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    }
    return handlers;
}
function $791ce2ee9eb5657b$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector) {
    const handlers = [];
    handlers.push(...$791ce2ee9eb5657b$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $791ce2ee9eb5657b$var$CanvasContext.WebGL, cb, blockClass, blockSelector, win));
    if (typeof win.WebGL2RenderingContext !== "undefined") handlers.push(...$791ce2ee9eb5657b$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $791ce2ee9eb5657b$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, win));
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
const $791ce2ee9eb5657b$var$encodedJs = "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";
const $791ce2ee9eb5657b$var$decodeBase64 = (base64)=>Uint8Array.from(atob(base64), (c2)=>c2.charCodeAt(0));
const $791ce2ee9eb5657b$var$blob = typeof window !== "undefined" && window.Blob && new Blob([
    $791ce2ee9eb5657b$var$decodeBase64($791ce2ee9eb5657b$var$encodedJs)
], {
    type: "text/javascript;charset=utf-8"
});
function $791ce2ee9eb5657b$var$WorkerWrapper(options) {
    let objURL;
    try {
        objURL = $791ce2ee9eb5657b$var$blob && (window.URL || window.webkitURL).createObjectURL($791ce2ee9eb5657b$var$blob);
        if (!objURL) throw "";
        const worker = new Worker(objURL, {
            name: options == null ? void 0 : options.name
        });
        worker.addEventListener("error", ()=>{
            (window.URL || window.webkitURL).revokeObjectURL(objURL);
        });
        return worker;
    } catch (e2) {
        return new Worker("data:text/javascript;base64," + $791ce2ee9eb5657b$var$encodedJs, {
            name: options == null ? void 0 : options.name
        });
    } finally{
        objURL && (window.URL || window.webkitURL).revokeObjectURL(objURL);
    }
}
class $791ce2ee9eb5657b$var$CanvasManager {
    constructor(options){
        $791ce2ee9eb5657b$var$__publicField(this, "pendingCanvasMutations", /* @__PURE__ */ new Map());
        $791ce2ee9eb5657b$var$__publicField(this, "rafStamps", {
            latestId: 0,
            invokeId: null
        });
        $791ce2ee9eb5657b$var$__publicField(this, "mirror");
        $791ce2ee9eb5657b$var$__publicField(this, "mutationCb");
        $791ce2ee9eb5657b$var$__publicField(this, "resetObservers");
        $791ce2ee9eb5657b$var$__publicField(this, "frozen", false);
        $791ce2ee9eb5657b$var$__publicField(this, "locked", false);
        $791ce2ee9eb5657b$var$__publicField(this, "processMutation", (target, mutation)=>{
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        });
        const { sampling: sampling = "all", win: win, blockClass: blockClass, blockSelector: blockSelector, recordCanvas: recordCanvas, dataURLOptions: dataURLOptions } = options;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (recordCanvas && sampling === "all") this.initCanvasMutationObserver(win, blockClass, blockSelector);
        if (recordCanvas && typeof sampling === "number") this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, {
            dataURLOptions: dataURLOptions
        });
    }
    reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    initCanvasFPSObserver(fps, win, blockClass, blockSelector, options) {
        const canvasContextReset = $791ce2ee9eb5657b$var$initCanvasContextObserver(win, blockClass, blockSelector, true);
        const snapshotInProgressMap = /* @__PURE__ */ new Map();
        const worker = new $791ce2ee9eb5657b$var$WorkerWrapper();
        worker.onmessage = (e2)=>{
            const { id: id } = e2.data;
            snapshotInProgressMap.set(id, false);
            if (!("base64" in e2.data)) return;
            const { base64: base64, type: type, width: width, height: height } = e2.data;
            this.mutationCb({
                id: id,
                type: $791ce2ee9eb5657b$var$CanvasContext["2D"],
                commands: [
                    {
                        property: "clearRect",
                        // wipe canvas
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: "drawImage",
                        // draws (semi-transparent) image
                        args: [
                            {
                                rr_type: "ImageBitmap",
                                args: [
                                    {
                                        rr_type: "Blob",
                                        data: [
                                            {
                                                rr_type: "ArrayBuffer",
                                                base64: base64
                                            }
                                        ],
                                        type: type
                                    }
                                ]
                            },
                            0,
                            0
                        ]
                    }
                ]
            });
        };
        const timeBetweenSnapshots = 1e3 / fps;
        let lastSnapshotTime = 0;
        let rafId;
        const getCanvas = ()=>{
            const matchedCanvas = [];
            win.document.querySelectorAll("canvas").forEach((canvas)=>{
                if (!$791ce2ee9eb5657b$var$isBlocked(canvas, blockClass, blockSelector, true)) matchedCanvas.push(canvas);
            });
            return matchedCanvas;
        };
        const takeCanvasSnapshots = (timestamp)=>{
            if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                rafId = requestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            lastSnapshotTime = timestamp;
            getCanvas().forEach(async (canvas)=>{
                var _a2;
                const id = this.mirror.getId(canvas);
                if (snapshotInProgressMap.get(id)) return;
                if (canvas.width === 0 || canvas.height === 0) return;
                snapshotInProgressMap.set(id, true);
                if ([
                    "webgl",
                    "webgl2"
                ].includes(canvas.__context)) {
                    const context = canvas.getContext(canvas.__context);
                    if (((_a2 = context == null ? void 0 : context.getContextAttributes()) == null ? void 0 : _a2.preserveDrawingBuffer) === false) context.clear(context.COLOR_BUFFER_BIT);
                }
                const bitmap = await createImageBitmap(canvas);
                worker.postMessage({
                    id: id,
                    bitmap: bitmap,
                    width: canvas.width,
                    height: canvas.height,
                    dataURLOptions: options.dataURLOptions
                }, [
                    bitmap
                ]);
            });
            rafId = requestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = requestAnimationFrame(takeCanvasSnapshots);
        this.resetObservers = ()=>{
            canvasContextReset();
            cancelAnimationFrame(rafId);
        };
    }
    initCanvasMutationObserver(win, blockClass, blockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        const canvasContextReset = $791ce2ee9eb5657b$var$initCanvasContextObserver(win, blockClass, blockSelector, false);
        const canvas2DReset = $791ce2ee9eb5657b$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        const canvasWebGL1and2Reset = $791ce2ee9eb5657b$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        this.resetObservers = ()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    }
    startPendingCanvasMutationFlusher() {
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((_values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const { type: type2, ...rest } = value;
            return rest;
        });
        const { type: type } = valuesWithType[0];
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
}
class $791ce2ee9eb5657b$var$StylesheetManager {
    constructor(options){
        $791ce2ee9eb5657b$var$__publicField(this, "trackedLinkElements", /* @__PURE__ */ new WeakSet());
        $791ce2ee9eb5657b$var$__publicField(this, "mutationCb");
        $791ce2ee9eb5657b$var$__publicField(this, "adoptedStyleSheetCb");
        $791ce2ee9eb5657b$var$__publicField(this, "styleMirror", new $791ce2ee9eb5657b$var$StyleSheetMirror());
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r2, index2)=>({
                            rule: $791ce2ee9eb5657b$var$stringifyRule(r2, sheet.href),
                            index: index2
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
    }
    // TODO: take snapshot on stylesheet reload by applying event listener
    trackStylesheetInLinkElement(_linkEl) {}
}
class $791ce2ee9eb5657b$var$ProcessedNodeManager {
    constructor(){
        $791ce2ee9eb5657b$var$__publicField(this, "nodeMap", /* @__PURE__ */ new WeakMap());
        $791ce2ee9eb5657b$var$__publicField(this, "active", false);
    }
    inOtherBuffer(node2, thisBuffer) {
        const buffers = this.nodeMap.get(node2);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node2, buffer) {
        if (!this.active) {
            this.active = true;
            requestAnimationFrame(()=>{
                this.nodeMap = /* @__PURE__ */ new WeakMap();
                this.active = false;
            });
        }
        this.nodeMap.set(node2, (this.nodeMap.get(node2) || /* @__PURE__ */ new Set()).add(buffer));
    }
    destroy() {}
}
let $791ce2ee9eb5657b$var$wrappedEmit;
let $791ce2ee9eb5657b$var$takeFullSnapshot$1;
let $791ce2ee9eb5657b$var$canvasManager;
let $791ce2ee9eb5657b$var$recording = false;
try {
    if (Array.from([
        1
    ], (x2)=>x2 * 2)[0] !== 2) {
        const cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = (($791ce2ee9eb5657b$var$_a = cleanFrame.contentWindow) == null ? void 0 : $791ce2ee9eb5657b$var$_a.Array.from) || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
const $791ce2ee9eb5657b$var$mirror = $791ce2ee9eb5657b$var$createMirror$2();
function $791ce2ee9eb5657b$export$e5185e241753e543(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskTextClass: maskTextClass = "rr-mask", maskTextSelector: maskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskInputFn: maskInputFn, maskTextFn: maskTextFn, hooks: hooks, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordDOM: recordDOM = true, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = /* @__PURE__ */ new Set([]), errorHandler: errorHandler2 } = options;
    $791ce2ee9eb5657b$var$registerErrorHandler(errorHandler2);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e2) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return ()=>{};
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) sampling.mousemove = mousemoveWait;
    $791ce2ee9eb5657b$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {
        password: true
    };
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all",
        headTitleMutations: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $791ce2ee9eb5657b$var$polyfill$1();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e2)=>{
        for (const plugin3 of plugins || [])if (plugin3.eventProcessor) e2 = plugin3.eventProcessor(e2);
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) e2 = packFn(e2);
        return e2;
    };
    $791ce2ee9eb5657b$var$wrappedEmit = (r2, isCheckout)=>{
        var _a2;
        const e2 = r2;
        e2.timestamp = $791ce2ee9eb5657b$var$nowTimestamp();
        if (((_a2 = $791ce2ee9eb5657b$var$mutationBuffers[0]) == null ? void 0 : _a2.isFrozen()) && e2.type !== $791ce2ee9eb5657b$export$3d7865934588d77e.FullSnapshot && !(e2.type === $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot && e2.data.source === $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Mutation)) $791ce2ee9eb5657b$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) emit == null || emit(eventProcessor(e2), isCheckout);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === $791ce2ee9eb5657b$export$3d7865934588d77e.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot) {
            if (e2.data.source === $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Mutation && e2.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) $791ce2ee9eb5657b$var$takeFullSnapshot$1(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $791ce2ee9eb5657b$var$wrappedEmit({
            type: $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot,
            data: {
                source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$791ce2ee9eb5657b$var$wrappedEmit({
            type: $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot,
            data: {
                source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$791ce2ee9eb5657b$var$wrappedEmit({
            type: $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot,
            data: {
                source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a2)=>$791ce2ee9eb5657b$var$wrappedEmit({
            type: $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot,
            data: {
                source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.AdoptedStyleSheet,
                ...a2
            }
        });
    const stylesheetManager = new $791ce2ee9eb5657b$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = new $791ce2ee9eb5657b$var$IframeManager({
        mirror: $791ce2ee9eb5657b$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $791ce2ee9eb5657b$var$wrappedEmit
    });
    for (const plugin3 of plugins || [])if (plugin3.getMirror) plugin3.getMirror({
        nodeMirror: $791ce2ee9eb5657b$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $791ce2ee9eb5657b$var$ProcessedNodeManager();
    $791ce2ee9eb5657b$var$canvasManager = new $791ce2ee9eb5657b$var$CanvasManager({
        recordCanvas: recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass: blockClass,
        blockSelector: blockSelector,
        mirror: $791ce2ee9eb5657b$var$mirror,
        sampling: sampling.canvas,
        dataURLOptions: dataURLOptions
    });
    const shadowDomManager = new $791ce2ee9eb5657b$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: $791ce2ee9eb5657b$var$canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $791ce2ee9eb5657b$var$mirror
    });
    $791ce2ee9eb5657b$var$takeFullSnapshot$1 = (isCheckout = false)=>{
        if (!recordDOM) return;
        $791ce2ee9eb5657b$var$wrappedEmit({
            type: $791ce2ee9eb5657b$export$3d7865934588d77e.Meta,
            data: {
                href: window.location.href,
                width: $791ce2ee9eb5657b$var$getWindowWidth(),
                height: $791ce2ee9eb5657b$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $791ce2ee9eb5657b$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node2 = $791ce2ee9eb5657b$var$snapshot(document, {
            mirror: $791ce2ee9eb5657b$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n2)=>{
                if ($791ce2ee9eb5657b$var$isSerializedIframe(n2, $791ce2ee9eb5657b$var$mirror)) iframeManager.addIframe(n2);
                if ($791ce2ee9eb5657b$var$isSerializedStylesheet(n2, $791ce2ee9eb5657b$var$mirror)) stylesheetManager.trackLinkElement(n2);
                if ($791ce2ee9eb5657b$var$hasShadowRoot(n2)) shadowDomManager.addShadowRoot($791ce2ee9eb5657b$var$index.shadowRoot(n2), document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node2) return console.warn("Failed to snapshot the document");
        $791ce2ee9eb5657b$var$wrappedEmit({
            type: $791ce2ee9eb5657b$export$3d7865934588d77e.FullSnapshot,
            data: {
                node: node2,
                initialOffset: $791ce2ee9eb5657b$var$getWindowScroll(window)
            }
        }, isCheckout);
        $791ce2ee9eb5657b$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $791ce2ee9eb5657b$var$mirror.getId(document));
    };
    try {
        const handlers = [];
        const observe = (doc)=>{
            var _a2;
            return $791ce2ee9eb5657b$var$callbackWrapper($791ce2ee9eb5657b$var$initObservers)({
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$791ce2ee9eb5657b$var$wrappedEmit({
                        type: $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$791ce2ee9eb5657b$var$wrappedEmit({
                        type: $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot,
                        data: {
                            source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$791ce2ee9eb5657b$var$wrappedEmit({
                        type: $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot,
                        data: {
                            source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v2)=>$791ce2ee9eb5657b$var$wrappedEmit({
                        type: $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot,
                        data: {
                            source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Input,
                            ...v2
                        }
                    }),
                mediaInteractionCb: (p)=>$791ce2ee9eb5657b$var$wrappedEmit({
                        type: $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot,
                        data: {
                            source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r2)=>$791ce2ee9eb5657b$var$wrappedEmit({
                        type: $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot,
                        data: {
                            source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.StyleSheetRule,
                            ...r2
                        }
                    }),
                styleDeclarationCb: (r2)=>$791ce2ee9eb5657b$var$wrappedEmit({
                        type: $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot,
                        data: {
                            source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.StyleDeclaration,
                            ...r2
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$791ce2ee9eb5657b$var$wrappedEmit({
                        type: $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot,
                        data: {
                            source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $791ce2ee9eb5657b$var$wrappedEmit({
                        type: $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot,
                        data: {
                            source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c2)=>{
                    $791ce2ee9eb5657b$var$wrappedEmit({
                        type: $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot,
                        data: {
                            source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.CustomElement,
                            ...c2
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $791ce2ee9eb5657b$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: $791ce2ee9eb5657b$var$canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: ((_a2 = plugins == null ? void 0 : plugins.filter((p)=>p.observer)) == null ? void 0 : _a2.map((p)=>({
                        observer: p.observer,
                        options: p.options,
                        callback: (payload)=>$791ce2ee9eb5657b$var$wrappedEmit({
                                type: $791ce2ee9eb5657b$export$3d7865934588d77e.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            })
                    }))) || []
            }, hooks);
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            $791ce2ee9eb5657b$var$takeFullSnapshot$1();
            handlers.push(observe(document));
            $791ce2ee9eb5657b$var$recording = true;
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($791ce2ee9eb5657b$var$on("DOMContentLoaded", ()=>{
                $791ce2ee9eb5657b$var$wrappedEmit({
                    type: $791ce2ee9eb5657b$export$3d7865934588d77e.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($791ce2ee9eb5657b$var$on("load", ()=>{
                $791ce2ee9eb5657b$var$wrappedEmit({
                    type: $791ce2ee9eb5657b$export$3d7865934588d77e.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $791ce2ee9eb5657b$var$recording = false;
            $791ce2ee9eb5657b$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
$791ce2ee9eb5657b$export$e5185e241753e543.addCustomEvent = (tag, payload)=>{
    if (!$791ce2ee9eb5657b$var$recording) throw new Error("please add custom event after start recording");
    $791ce2ee9eb5657b$var$wrappedEmit({
        type: $791ce2ee9eb5657b$export$3d7865934588d77e.Custom,
        data: {
            tag: tag,
            payload: payload
        }
    });
};
$791ce2ee9eb5657b$export$e5185e241753e543.freezePage = ()=>{
    $791ce2ee9eb5657b$var$mutationBuffers.forEach((buf)=>buf.freeze());
};
$791ce2ee9eb5657b$export$e5185e241753e543.takeFullSnapshot = (isCheckout)=>{
    if (!$791ce2ee9eb5657b$var$recording) throw new Error("please take full snapshot after start recording");
    $791ce2ee9eb5657b$var$takeFullSnapshot$1(isCheckout);
};
$791ce2ee9eb5657b$export$e5185e241753e543.mirror = $791ce2ee9eb5657b$var$mirror;
function $791ce2ee9eb5657b$var$mitt$1(n2) {
    return {
        all: n2 = n2 || /* @__PURE__ */ new Map(),
        on: function(t2, e2) {
            var i2 = n2.get(t2);
            i2 ? i2.push(e2) : n2.set(t2, [
                e2
            ]);
        },
        off: function(t2, e2) {
            var i2 = n2.get(t2);
            i2 && (e2 ? i2.splice(i2.indexOf(e2) >>> 0, 1) : n2.set(t2, []));
        },
        emit: function(t2, e2) {
            var i2 = n2.get(t2);
            i2 && i2.slice().map(function(n3) {
                n3(e2);
            }), (i2 = n2.get("*")) && i2.slice().map(function(n3) {
                n3(t2, e2);
            });
        }
    };
}
const $791ce2ee9eb5657b$var$mittProxy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: $791ce2ee9eb5657b$var$mitt$1
}, Symbol.toStringTag, {
    value: "Module"
}));
function $791ce2ee9eb5657b$var$polyfill(w = window, d = document) {
    if ("scrollBehavior" in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) return;
    const Element2 = w.HTMLElement || w.Element;
    const SCROLL_TIME = 468;
    const original = {
        scroll: w.scroll || w.scrollTo,
        scrollBy: w.scrollBy,
        elementScroll: Element2.prototype.scroll || scrollElement,
        scrollIntoView: Element2.prototype.scrollIntoView
    };
    const now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
    function isMicrosoftBrowser(userAgent) {
        const userAgentPatterns = [
            "MSIE ",
            "Trident/",
            "Edge/"
        ];
        return new RegExp(userAgentPatterns.join("|")).test(userAgent);
    }
    const ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
    function scrollElement(x2, y) {
        this.scrollLeft = x2;
        this.scrollTop = y;
    }
    function ease(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    }
    function shouldBailOut(firstArg) {
        if (firstArg === null || typeof firstArg !== "object" || firstArg.behavior === void 0 || firstArg.behavior === "auto" || firstArg.behavior === "instant") return true;
        if (typeof firstArg === "object" && firstArg.behavior === "smooth") return false;
        throw new TypeError("behavior member of ScrollOptions " + firstArg.behavior + " is not a valid value for enumeration ScrollBehavior.");
    }
    function hasScrollableSpace(el, axis) {
        if (axis === "Y") return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
        if (axis === "X") return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
    }
    function canOverflow(el, axis) {
        const overflowValue = w.getComputedStyle(el, null)["overflow" + axis];
        return overflowValue === "auto" || overflowValue === "scroll";
    }
    function isScrollable(el) {
        const isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y");
        const isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");
        return isScrollableY || isScrollableX;
    }
    function findScrollableParent(el) {
        while(el !== d.body && isScrollable(el) === false)el = el.parentNode || el.host;
        return el;
    }
    function step(context) {
        const time = now();
        let value;
        let currentX;
        let currentY;
        let elapsed = (time - context.startTime) / SCROLL_TIME;
        elapsed = elapsed > 1 ? 1 : elapsed;
        value = ease(elapsed);
        currentX = context.startX + (context.x - context.startX) * value;
        currentY = context.startY + (context.y - context.startY) * value;
        context.method.call(context.scrollable, currentX, currentY);
        if (currentX !== context.x || currentY !== context.y) w.requestAnimationFrame(step.bind(w, context));
    }
    function smoothScroll(el, x2, y) {
        let scrollable;
        let startX;
        let startY;
        let method;
        const startTime = now();
        if (el === d.body) {
            scrollable = w;
            startX = w.scrollX || w.pageXOffset;
            startY = w.scrollY || w.pageYOffset;
            method = original.scroll;
        } else {
            scrollable = el;
            startX = el.scrollLeft;
            startY = el.scrollTop;
            method = scrollElement;
        }
        step({
            scrollable: scrollable,
            method: method,
            startTime: startTime,
            startX: startX,
            startY: startY,
            x: x2,
            y: y
        });
    }
    w.scroll = w.scrollTo = function() {
        if (arguments[0] === void 0) return;
        if (shouldBailOut(arguments[0]) === true) {
            original.scroll.call(w, arguments[0].left !== void 0 ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
            arguments[0].top !== void 0 ? arguments[0].top : arguments[1] !== void 0 ? arguments[1] : w.scrollY || w.pageYOffset);
            return;
        }
        smoothScroll.call(w, d.body, arguments[0].left !== void 0 ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== void 0 ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
    };
    w.scrollBy = function() {
        if (arguments[0] === void 0) return;
        if (shouldBailOut(arguments[0])) {
            original.scrollBy.call(w, arguments[0].left !== void 0 ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : 0, arguments[0].top !== void 0 ? arguments[0].top : arguments[1] !== void 0 ? arguments[1] : 0);
            return;
        }
        smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
    };
    Element2.prototype.scroll = Element2.prototype.scrollTo = function() {
        if (arguments[0] === void 0) return;
        if (shouldBailOut(arguments[0]) === true) {
            if (typeof arguments[0] === "number" && arguments[1] === void 0) throw new SyntaxError("Value could not be converted");
            original.elementScroll.call(this, // use left prop, first number argument or fallback to scrollLeft
            arguments[0].left !== void 0 ? ~~arguments[0].left : typeof arguments[0] !== "object" ? ~~arguments[0] : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
            arguments[0].top !== void 0 ? ~~arguments[0].top : arguments[1] !== void 0 ? ~~arguments[1] : this.scrollTop);
            return;
        }
        const left = arguments[0].left;
        const top = arguments[0].top;
        smoothScroll.call(this, this, typeof left === "undefined" ? this.scrollLeft : ~~left, typeof top === "undefined" ? this.scrollTop : ~~top);
    };
    Element2.prototype.scrollBy = function() {
        if (arguments[0] === void 0) return;
        if (shouldBailOut(arguments[0]) === true) {
            original.elementScroll.call(this, arguments[0].left !== void 0 ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== void 0 ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
            return;
        }
        this.scroll({
            left: ~~arguments[0].left + this.scrollLeft,
            top: ~~arguments[0].top + this.scrollTop,
            behavior: arguments[0].behavior
        });
    };
    Element2.prototype.scrollIntoView = function() {
        if (shouldBailOut(arguments[0]) === true) {
            original.scrollIntoView.call(this, arguments[0] === void 0 ? true : arguments[0]);
            return;
        }
        const scrollableParent = findScrollableParent(this);
        const parentRects = scrollableParent.getBoundingClientRect();
        const clientRects = this.getBoundingClientRect();
        if (scrollableParent !== d.body) {
            smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);
            if (w.getComputedStyle(scrollableParent).position !== "fixed") w.scrollBy({
                left: parentRects.left,
                top: parentRects.top,
                behavior: "smooth"
            });
        } else w.scrollBy({
            left: clientRects.left,
            top: clientRects.top,
            behavior: "smooth"
        });
    };
}
class $791ce2ee9eb5657b$var$Timer {
    constructor(actions = [], config){
        $791ce2ee9eb5657b$var$__publicField(this, "timeOffset", 0);
        $791ce2ee9eb5657b$var$__publicField(this, "speed");
        $791ce2ee9eb5657b$var$__publicField(this, "actions");
        $791ce2ee9eb5657b$var$__publicField(this, "raf", null);
        $791ce2ee9eb5657b$var$__publicField(this, "lastTimestamp");
        this.actions = actions;
        this.speed = config.speed;
    }
    /**
   * Add an action, possibly after the timer starts.
   */ addAction(action) {
        const rafWasActive = this.raf === true;
        if (!this.actions.length || this.actions[this.actions.length - 1].delay <= action.delay) this.actions.push(action);
        else {
            const index2 = this.findActionIndex(action);
            this.actions.splice(index2, 0, action);
        }
        if (rafWasActive) this.raf = requestAnimationFrame(this.rafCheck.bind(this));
    }
    start() {
        this.timeOffset = 0;
        this.lastTimestamp = performance.now();
        this.raf = requestAnimationFrame(this.rafCheck.bind(this));
    }
    rafCheck() {
        const time = performance.now();
        this.timeOffset += (time - this.lastTimestamp) * this.speed;
        this.lastTimestamp = time;
        while(this.actions.length){
            const action = this.actions[0];
            if (this.timeOffset >= action.delay) {
                this.actions.shift();
                action.doAction();
            } else break;
        }
        if (this.actions.length > 0) this.raf = requestAnimationFrame(this.rafCheck.bind(this));
        else this.raf = true;
    }
    clear() {
        if (this.raf) {
            if (this.raf !== true) cancelAnimationFrame(this.raf);
            this.raf = null;
        }
        this.actions.length = 0;
    }
    setSpeed(speed) {
        this.speed = speed;
    }
    isActive() {
        return this.raf !== null;
    }
    findActionIndex(action) {
        let start = 0;
        let end = this.actions.length - 1;
        while(start <= end){
            const mid = Math.floor((start + end) / 2);
            if (this.actions[mid].delay < action.delay) start = mid + 1;
            else if (this.actions[mid].delay > action.delay) end = mid - 1;
            else return mid + 1;
        }
        return start;
    }
}
function $791ce2ee9eb5657b$var$addDelay(event, baselineTime) {
    if (event.type === $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot && event.data.source === $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.MouseMove && event.data.positions && event.data.positions.length) {
        const firstOffset = event.data.positions[0].timeOffset;
        const firstTimestamp = event.timestamp + firstOffset;
        event.delay = firstTimestamp - baselineTime;
        return firstTimestamp - baselineTime;
    }
    event.delay = event.timestamp - baselineTime;
    return event.delay;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $791ce2ee9eb5657b$var$t(t2, n2) {
    var e2 = "function" == typeof Symbol && t2[Symbol.iterator];
    if (!e2) return t2;
    var r2, o2, i2 = e2.call(t2), a2 = [];
    try {
        for(; (void 0 === n2 || n2-- > 0) && !(r2 = i2.next()).done;)a2.push(r2.value);
    } catch (t3) {
        o2 = {
            error: t3
        };
    } finally{
        try {
            r2 && !r2.done && (e2 = i2.return) && e2.call(i2);
        } finally{
            if (o2) throw o2.error;
        }
    }
    return a2;
}
var $791ce2ee9eb5657b$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($791ce2ee9eb5657b$var$n || ($791ce2ee9eb5657b$var$n = {}));
var $791ce2ee9eb5657b$var$e = {
    type: "xstate.init"
};
function $791ce2ee9eb5657b$var$r(t2) {
    return void 0 === t2 ? [] : [].concat(t2);
}
function $791ce2ee9eb5657b$var$o(t2) {
    return {
        type: "xstate.assign",
        assignment: t2
    };
}
function $791ce2ee9eb5657b$var$i(t2, n2) {
    return "string" == typeof (t2 = "string" == typeof t2 && n2 && n2[t2] ? n2[t2] : t2) ? {
        type: t2
    } : "function" == typeof t2 ? {
        type: t2.name,
        exec: t2
    } : t2;
}
function $791ce2ee9eb5657b$var$a(t2) {
    return function(n2) {
        return t2 === n2;
    };
}
function $791ce2ee9eb5657b$var$u(t2) {
    return "string" == typeof t2 ? {
        type: t2
    } : t2;
}
function $791ce2ee9eb5657b$var$c(t2, n2) {
    return {
        value: t2,
        context: n2,
        actions: [],
        changed: false,
        matches: $791ce2ee9eb5657b$var$a(t2)
    };
}
function $791ce2ee9eb5657b$var$f(t2, n2, e2) {
    var r2 = n2, o2 = false;
    return [
        t2.filter(function(t3) {
            if ("xstate.assign" === t3.type) {
                o2 = true;
                var n3 = Object.assign({}, r2);
                return "function" == typeof t3.assignment ? n3 = t3.assignment(r2, e2) : Object.keys(t3.assignment).forEach(function(o3) {
                    n3[o3] = "function" == typeof t3.assignment[o3] ? t3.assignment[o3](r2, e2) : t3.assignment[o3];
                }), r2 = n3, false;
            }
            return true;
        }),
        r2,
        o2
    ];
}
function $791ce2ee9eb5657b$var$s(n2, o2) {
    void 0 === o2 && (o2 = {});
    var s2 = $791ce2ee9eb5657b$var$t($791ce2ee9eb5657b$var$f($791ce2ee9eb5657b$var$r(n2.states[n2.initial].entry).map(function(t2) {
        return $791ce2ee9eb5657b$var$i(t2, o2.actions);
    }), n2.context, $791ce2ee9eb5657b$var$e), 2), l2 = s2[0], v2 = s2[1], y = {
        config: n2,
        _options: o2,
        initialState: {
            value: n2.initial,
            actions: l2,
            context: v2,
            matches: $791ce2ee9eb5657b$var$a(n2.initial)
        },
        transition: function(e2, o3) {
            var s3, l3, v3 = "string" == typeof e2 ? {
                value: e2,
                context: n2.context
            } : e2, p = v3.value, g = v3.context, d = $791ce2ee9eb5657b$var$u(o3), x2 = n2.states[p];
            if (x2.on) {
                var m = $791ce2ee9eb5657b$var$r(x2.on[d.type]);
                try {
                    for(var h = function(t2) {
                        var n3 = "function" == typeof Symbol && Symbol.iterator, e3 = n3 && t2[n3], r2 = 0;
                        if (e3) return e3.call(t2);
                        if (t2 && "number" == typeof t2.length) return {
                            next: function() {
                                return t2 && r2 >= t2.length && (t2 = void 0), {
                                    value: t2 && t2[r2++],
                                    done: !t2
                                };
                            }
                        };
                        throw new TypeError(n3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
                    }(m), b = h.next(); !b.done; b = h.next()){
                        var S = b.value;
                        if (void 0 === S) return $791ce2ee9eb5657b$var$c(p, g);
                        var w = "string" == typeof S ? {
                            target: S
                        } : S, j = w.target, E = w.actions, R = void 0 === E ? [] : E, N = w.cond, O = void 0 === N ? function() {
                            return true;
                        } : N, _ = void 0 === j, k = null != j ? j : p, T = n2.states[k];
                        if (O(g, d)) {
                            var q = $791ce2ee9eb5657b$var$t($791ce2ee9eb5657b$var$f((_ ? $791ce2ee9eb5657b$var$r(R) : [].concat(x2.exit, R, T.entry).filter(function(t2) {
                                return t2;
                            })).map(function(t2) {
                                return $791ce2ee9eb5657b$var$i(t2, y._options.actions);
                            }), g, d), 3), z = q[0], A = q[1], B = q[2], C = null != j ? j : p;
                            return {
                                value: C,
                                context: A,
                                actions: z,
                                changed: j !== p || z.length > 0 || B,
                                matches: $791ce2ee9eb5657b$var$a(C)
                            };
                        }
                    }
                } catch (t2) {
                    s3 = {
                        error: t2
                    };
                } finally{
                    try {
                        b && !b.done && (l3 = h.return) && l3.call(h);
                    } finally{
                        if (s3) throw s3.error;
                    }
                }
            }
            return $791ce2ee9eb5657b$var$c(p, g);
        }
    };
    return y;
}
var $791ce2ee9eb5657b$var$l = function(t2, n2) {
    return t2.actions.forEach(function(e2) {
        var r2 = e2.exec;
        return r2 && r2(t2.context, n2);
    });
};
function $791ce2ee9eb5657b$var$v(t2) {
    var r2 = t2.initialState, o2 = $791ce2ee9eb5657b$var$n.NotStarted, i2 = /* @__PURE__ */ new Set(), c2 = {
        _machine: t2,
        send: function(e2) {
            o2 === $791ce2ee9eb5657b$var$n.Running && (r2 = t2.transition(r2, e2), $791ce2ee9eb5657b$var$l(r2, $791ce2ee9eb5657b$var$u(e2)), i2.forEach(function(t3) {
                return t3(r2);
            }));
        },
        subscribe: function(t3) {
            return i2.add(t3), t3(r2), {
                unsubscribe: function() {
                    return i2.delete(t3);
                }
            };
        },
        start: function(i3) {
            if (i3) {
                var u2 = "object" == typeof i3 ? i3 : {
                    context: t2.config.context,
                    value: i3
                };
                r2 = {
                    value: u2.value,
                    actions: [],
                    context: u2.context,
                    matches: $791ce2ee9eb5657b$var$a(u2.value)
                };
            }
            return o2 = $791ce2ee9eb5657b$var$n.Running, $791ce2ee9eb5657b$var$l(r2, $791ce2ee9eb5657b$var$e), c2;
        },
        stop: function() {
            return o2 = $791ce2ee9eb5657b$var$n.Stopped, i2.clear(), c2;
        },
        get state () {
            return r2;
        },
        get status () {
            return o2;
        }
    };
    return c2;
}
function $791ce2ee9eb5657b$var$discardPriorSnapshots(events, baselineTime) {
    for(let idx = events.length - 1; idx >= 0; idx--){
        const event = events[idx];
        if (event.type === $791ce2ee9eb5657b$export$3d7865934588d77e.Meta) {
            if (event.timestamp <= baselineTime) return events.slice(idx);
        }
    }
    return events;
}
function $791ce2ee9eb5657b$var$createPlayerService(context, { getCastFn: getCastFn, applyEventsSynchronously: applyEventsSynchronously, emitter: emitter }) {
    const playerMachine = $791ce2ee9eb5657b$var$s({
        id: "player",
        context: context,
        initial: "paused",
        states: {
            playing: {
                on: {
                    PAUSE: {
                        target: "paused",
                        actions: [
                            "pause"
                        ]
                    },
                    CAST_EVENT: {
                        target: "playing",
                        actions: "castEvent"
                    },
                    END: {
                        target: "paused",
                        actions: [
                            "resetLastPlayedEvent",
                            "pause"
                        ]
                    },
                    ADD_EVENT: {
                        target: "playing",
                        actions: [
                            "addEvent"
                        ]
                    }
                }
            },
            paused: {
                on: {
                    PLAY: {
                        target: "playing",
                        actions: [
                            "recordTimeOffset",
                            "play"
                        ]
                    },
                    CAST_EVENT: {
                        target: "paused",
                        actions: "castEvent"
                    },
                    TO_LIVE: {
                        target: "live",
                        actions: [
                            "startLive"
                        ]
                    },
                    ADD_EVENT: {
                        target: "paused",
                        actions: [
                            "addEvent"
                        ]
                    }
                }
            },
            live: {
                on: {
                    ADD_EVENT: {
                        target: "live",
                        actions: [
                            "addEvent"
                        ]
                    },
                    CAST_EVENT: {
                        target: "live",
                        actions: [
                            "castEvent"
                        ]
                    }
                }
            }
        }
    }, {
        actions: {
            castEvent: $791ce2ee9eb5657b$var$o({
                lastPlayedEvent: (ctx, event)=>{
                    if (event.type === "CAST_EVENT") return event.payload.event;
                    return ctx.lastPlayedEvent;
                }
            }),
            recordTimeOffset: $791ce2ee9eb5657b$var$o((ctx, event)=>{
                let timeOffset = ctx.timeOffset;
                if ("payload" in event && "timeOffset" in event.payload) timeOffset = event.payload.timeOffset;
                return {
                    ...ctx,
                    timeOffset: timeOffset,
                    baselineTime: ctx.events[0].timestamp + timeOffset
                };
            }),
            play (ctx) {
                var _a2;
                const { timer: timer, events: events, baselineTime: baselineTime, lastPlayedEvent: lastPlayedEvent } = ctx;
                timer.clear();
                for (const event of events)$791ce2ee9eb5657b$var$addDelay(event, baselineTime);
                const neededEvents = $791ce2ee9eb5657b$var$discardPriorSnapshots(events, baselineTime);
                let lastPlayedTimestamp = lastPlayedEvent == null ? void 0 : lastPlayedEvent.timestamp;
                if ((lastPlayedEvent == null ? void 0 : lastPlayedEvent.type) === $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot && lastPlayedEvent.data.source === $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.MouseMove) lastPlayedTimestamp = lastPlayedEvent.timestamp + ((_a2 = lastPlayedEvent.data.positions[0]) == null ? void 0 : _a2.timeOffset);
                if (baselineTime < (lastPlayedTimestamp || 0)) emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.PlayBack);
                const syncEvents = new Array();
                for (const event of neededEvents){
                    if (lastPlayedTimestamp && lastPlayedTimestamp < baselineTime && (event.timestamp <= lastPlayedTimestamp || event === lastPlayedEvent)) continue;
                    if (event.timestamp < baselineTime) syncEvents.push(event);
                    else {
                        const castFn = getCastFn(event, false);
                        timer.addAction({
                            doAction: ()=>{
                                castFn();
                            },
                            delay: event.delay
                        });
                    }
                }
                applyEventsSynchronously(syncEvents);
                emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Flush);
                timer.start();
            },
            pause (ctx) {
                ctx.timer.clear();
            },
            resetLastPlayedEvent: $791ce2ee9eb5657b$var$o((ctx)=>{
                return {
                    ...ctx,
                    lastPlayedEvent: null
                };
            }),
            startLive: $791ce2ee9eb5657b$var$o({
                baselineTime: (ctx, event)=>{
                    ctx.timer.start();
                    if (event.type === "TO_LIVE" && event.payload.baselineTime) return event.payload.baselineTime;
                    return Date.now();
                }
            }),
            addEvent: $791ce2ee9eb5657b$var$o((ctx, machineEvent)=>{
                const { baselineTime: baselineTime, timer: timer, events: events } = ctx;
                if (machineEvent.type === "ADD_EVENT") {
                    const { event: event } = machineEvent.payload;
                    $791ce2ee9eb5657b$var$addDelay(event, baselineTime);
                    let end = events.length - 1;
                    if (!events[end] || events[end].timestamp <= event.timestamp) events.push(event);
                    else {
                        let insertionIndex = -1;
                        let start = 0;
                        while(start <= end){
                            const mid = Math.floor((start + end) / 2);
                            if (events[mid].timestamp <= event.timestamp) start = mid + 1;
                            else end = mid - 1;
                        }
                        if (insertionIndex === -1) insertionIndex = start;
                        events.splice(insertionIndex, 0, event);
                    }
                    const isSync = event.timestamp < baselineTime;
                    const castFn = getCastFn(event, isSync);
                    if (isSync) castFn();
                    else if (timer.isActive()) timer.addAction({
                        doAction: ()=>{
                            castFn();
                        },
                        delay: event.delay
                    });
                }
                return {
                    ...ctx,
                    events: events
                };
            })
        }
    });
    return $791ce2ee9eb5657b$var$v(playerMachine);
}
function $791ce2ee9eb5657b$var$createSpeedService(context) {
    const speedMachine = $791ce2ee9eb5657b$var$s({
        id: "speed",
        context: context,
        initial: "normal",
        states: {
            normal: {
                on: {
                    FAST_FORWARD: {
                        target: "skipping",
                        actions: [
                            "recordSpeed",
                            "setSpeed"
                        ]
                    },
                    SET_SPEED: {
                        target: "normal",
                        actions: [
                            "setSpeed"
                        ]
                    }
                }
            },
            skipping: {
                on: {
                    BACK_TO_NORMAL: {
                        target: "normal",
                        actions: [
                            "restoreSpeed"
                        ]
                    },
                    SET_SPEED: {
                        target: "normal",
                        actions: [
                            "setSpeed"
                        ]
                    }
                }
            }
        }
    }, {
        actions: {
            setSpeed: (ctx, event)=>{
                if ("payload" in event) ctx.timer.setSpeed(event.payload.speed);
            },
            recordSpeed: $791ce2ee9eb5657b$var$o({
                normalSpeed: (ctx)=>ctx.timer.speed
            }),
            restoreSpeed: (ctx)=>{
                ctx.timer.setSpeed(ctx.normalSpeed);
            }
        }
    });
    return $791ce2ee9eb5657b$var$v(speedMachine);
}
const $791ce2ee9eb5657b$var$rules = (blockClass)=>[
        `.${blockClass} { background: currentColor }`,
        "noscript { display: none !important; }"
    ];
const $791ce2ee9eb5657b$var$webGLVarMap = /* @__PURE__ */ new Map();
function $791ce2ee9eb5657b$var$variableListFor(ctx, ctor) {
    let contextMap = $791ce2ee9eb5657b$var$webGLVarMap.get(ctx);
    if (!contextMap) {
        contextMap = /* @__PURE__ */ new Map();
        $791ce2ee9eb5657b$var$webGLVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
function $791ce2ee9eb5657b$var$deserializeArg(imageMap, ctx, preload) {
    return async (arg)=>{
        if (arg && typeof arg === "object" && "rr_type" in arg) {
            if (preload) preload.isUnchanged = false;
            if (arg.rr_type === "ImageBitmap" && "args" in arg) {
                const args = await $791ce2ee9eb5657b$var$deserializeArg(imageMap, ctx, preload)(arg.args);
                return await createImageBitmap.apply(null, args);
            } else if ("index" in arg) {
                if (preload || ctx === null) return arg;
                const { rr_type: name, index: index2 } = arg;
                return $791ce2ee9eb5657b$var$variableListFor(ctx, name)[index2];
            } else if ("args" in arg) {
                const { rr_type: name, args: args } = arg;
                const ctor = window[name];
                return new ctor(...await Promise.all(args.map($791ce2ee9eb5657b$var$deserializeArg(imageMap, ctx, preload))));
            } else if ("base64" in arg) return $791ce2ee9eb5657b$var$decode(arg.base64);
            else if ("src" in arg) {
                const image = imageMap.get(arg.src);
                if (image) return image;
                else {
                    const image2 = new Image();
                    image2.src = arg.src;
                    imageMap.set(arg.src, image2);
                    return image2;
                }
            } else if ("data" in arg && arg.rr_type === "Blob") {
                const blobContents = await Promise.all(arg.data.map($791ce2ee9eb5657b$var$deserializeArg(imageMap, ctx, preload)));
                const blob2 = new Blob(blobContents, {
                    type: arg.type
                });
                return blob2;
            }
        } else if (Array.isArray(arg)) {
            const result2 = await Promise.all(arg.map($791ce2ee9eb5657b$var$deserializeArg(imageMap, ctx, preload)));
            return result2;
        }
        return arg;
    };
}
function $791ce2ee9eb5657b$var$getContext(target, type) {
    try {
        if (type === $791ce2ee9eb5657b$var$CanvasContext.WebGL) return target.getContext("webgl") || target.getContext("experimental-webgl");
        return target.getContext("webgl2");
    } catch (e2) {
        return null;
    }
}
const $791ce2ee9eb5657b$var$WebGLVariableConstructorsNames = [
    "WebGLActiveInfo",
    "WebGLBuffer",
    "WebGLFramebuffer",
    "WebGLProgram",
    "WebGLRenderbuffer",
    "WebGLShader",
    "WebGLShaderPrecisionFormat",
    "WebGLTexture",
    "WebGLUniformLocation",
    "WebGLVertexArrayObject"
];
function $791ce2ee9eb5657b$var$saveToWebGLVarMap(ctx, result2) {
    if (!(result2 == null ? void 0 : result2.constructor)) return;
    const { name: name } = result2.constructor;
    if (!$791ce2ee9eb5657b$var$WebGLVariableConstructorsNames.includes(name)) return;
    const variables = $791ce2ee9eb5657b$var$variableListFor(ctx, name);
    if (!variables.includes(result2)) variables.push(result2);
}
async function $791ce2ee9eb5657b$var$webglMutation({ mutation: mutation, target: target, type: type, imageMap: imageMap, errorHandler: errorHandler2 }) {
    try {
        const ctx = $791ce2ee9eb5657b$var$getContext(target, type);
        if (!ctx) return;
        if (mutation.setter) {
            ctx[mutation.property] = mutation.args[0];
            return;
        }
        const original = ctx[mutation.property];
        const args = await Promise.all(mutation.args.map($791ce2ee9eb5657b$var$deserializeArg(imageMap, ctx)));
        const result2 = original.apply(ctx, args);
        $791ce2ee9eb5657b$var$saveToWebGLVarMap(ctx, result2);
        const debugMode = false;
        debugMode;
    } catch (error) {
        errorHandler2(mutation, error);
    }
}
async function $791ce2ee9eb5657b$var$canvasMutation$1({ event: event, mutations: mutations, target: target, imageMap: imageMap, errorHandler: errorHandler2 }) {
    const ctx = target.getContext("2d");
    if (!ctx) {
        errorHandler2(mutations[0], new Error("Canvas context is null"));
        return;
    }
    const mutationArgsPromises = mutations.map(async (mutation)=>{
        return Promise.all(mutation.args.map($791ce2ee9eb5657b$var$deserializeArg(imageMap, ctx)));
    });
    const args = await Promise.all(mutationArgsPromises);
    args.forEach((args2, index2)=>{
        const mutation = mutations[index2];
        try {
            if (mutation.setter) {
                ctx[mutation.property] = mutation.args[0];
                return;
            }
            const original = ctx[mutation.property];
            if (mutation.property === "drawImage" && typeof mutation.args[0] === "string") {
                imageMap.get(event);
                original.apply(ctx, mutation.args);
            } else original.apply(ctx, args2);
        } catch (error) {
            errorHandler2(mutation, error);
        }
        return;
    });
}
async function $791ce2ee9eb5657b$export$fa4d1d1fb6883ae({ event: event, mutation: mutation, target: target, imageMap: imageMap, canvasEventMap: canvasEventMap, errorHandler: errorHandler2 }) {
    try {
        const precomputedMutation = canvasEventMap.get(event) || mutation;
        const commands = "commands" in precomputedMutation ? precomputedMutation.commands : [
            precomputedMutation
        ];
        if ([
            $791ce2ee9eb5657b$var$CanvasContext.WebGL,
            $791ce2ee9eb5657b$var$CanvasContext.WebGL2
        ].includes(mutation.type)) {
            for(let i2 = 0; i2 < commands.length; i2++){
                const command = commands[i2];
                await $791ce2ee9eb5657b$var$webglMutation({
                    mutation: command,
                    type: mutation.type,
                    target: target,
                    imageMap: imageMap,
                    errorHandler: errorHandler2
                });
            }
            return;
        }
        await $791ce2ee9eb5657b$var$canvasMutation$1({
            event: event,
            mutations: commands,
            target: target,
            imageMap: imageMap,
            errorHandler: errorHandler2
        });
    } catch (error) {
        errorHandler2(mutation, error);
    }
}
class $791ce2ee9eb5657b$var$MediaManager {
    constructor(options){
        $791ce2ee9eb5657b$var$__publicField(this, "mediaMap", /* @__PURE__ */ new Map());
        $791ce2ee9eb5657b$var$__publicField(this, "warn");
        $791ce2ee9eb5657b$var$__publicField(this, "service");
        $791ce2ee9eb5657b$var$__publicField(this, "speedService");
        $791ce2ee9eb5657b$var$__publicField(this, "emitter");
        $791ce2ee9eb5657b$var$__publicField(this, "getCurrentTime");
        $791ce2ee9eb5657b$var$__publicField(this, "metadataCallbackMap", /* @__PURE__ */ new Map());
        this.warn = options.warn;
        this.service = options.service;
        this.speedService = options.speedService;
        this.emitter = options.emitter;
        this.getCurrentTime = options.getCurrentTime;
        this.emitter.on($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Start, this.start.bind(this));
        this.emitter.on($791ce2ee9eb5657b$export$7b5ca317a0cad55c.SkipStart, this.start.bind(this));
        this.emitter.on($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Pause, this.pause.bind(this));
        this.emitter.on($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Finish, this.pause.bind(this));
        this.speedService.subscribe(()=>{
            this.syncAllMediaElements();
        });
    }
    syncAllMediaElements(options = {
        pause: false
    }) {
        this.mediaMap.forEach((_mediaState, target)=>{
            this.syncTargetWithState(target);
            if (options.pause) target.pause();
        });
    }
    start() {
        this.syncAllMediaElements();
    }
    pause() {
        this.syncAllMediaElements({
            pause: true
        });
    }
    seekTo({ time: time, target: target, mediaState: mediaState }) {
        if (mediaState.isPlaying) {
            const differenceBetweenCurrentTimeAndMediaMutationTimestamp = time - mediaState.lastInteractionTimeOffset;
            const mediaPlaybackOffset = differenceBetweenCurrentTimeAndMediaMutationTimestamp / 1e3 * mediaState.playbackRate;
            const duration = "duration" in target && target.duration;
            if (Number.isNaN(duration)) {
                this.waitForMetadata(target);
                return;
            }
            let seekToTime = mediaState.currentTimeAtLastInteraction + mediaPlaybackOffset;
            if (target.loop && // RRMediaElement doesn't have a duration property
            duration !== false) seekToTime = seekToTime % duration;
            target.currentTime = seekToTime;
        } else {
            target.pause();
            target.currentTime = mediaState.currentTimeAtLastInteraction;
        }
    }
    waitForMetadata(target) {
        if (this.metadataCallbackMap.has(target)) return;
        if (!("addEventListener" in target)) return;
        const onLoadedMetadata = ()=>{
            this.metadataCallbackMap.delete(target);
            const mediaState = this.mediaMap.get(target);
            if (!mediaState) return;
            this.seekTo({
                time: this.getCurrentTime(),
                target: target,
                mediaState: mediaState
            });
        };
        this.metadataCallbackMap.set(target, onLoadedMetadata);
        target.addEventListener("loadedmetadata", onLoadedMetadata, {
            once: true
        });
    }
    getMediaStateFromMutation({ target: target, timeOffset: timeOffset, mutation: mutation }) {
        const lastState = this.mediaMap.get(target);
        const { type: type, playbackRate: playbackRate, currentTime: currentTime, muted: muted, volume: volume, loop: loop } = mutation;
        const isPlaying = type === $791ce2ee9eb5657b$var$MediaInteractions.Play || type !== $791ce2ee9eb5657b$var$MediaInteractions.Pause && ((lastState == null ? void 0 : lastState.isPlaying) || target.getAttribute("autoplay") !== null);
        const mediaState = {
            isPlaying: isPlaying,
            currentTimeAtLastInteraction: currentTime ?? (lastState == null ? void 0 : lastState.currentTimeAtLastInteraction) ?? 0,
            lastInteractionTimeOffset: timeOffset,
            playbackRate: playbackRate ?? (lastState == null ? void 0 : lastState.playbackRate) ?? 1,
            volume: volume ?? (lastState == null ? void 0 : lastState.volume) ?? 1,
            muted: muted ?? (lastState == null ? void 0 : lastState.muted) ?? target.getAttribute("muted") === null,
            loop: loop ?? (lastState == null ? void 0 : lastState.loop) ?? target.getAttribute("loop") === null
        };
        return mediaState;
    }
    syncTargetWithState(target) {
        const mediaState = this.mediaMap.get(target);
        if (!mediaState) return;
        const { muted: muted, loop: loop, volume: volume, isPlaying: isPlaying } = mediaState;
        const playerIsPaused = this.service.state.matches("paused");
        const playbackRate = mediaState.playbackRate * this.speedService.state.context.timer.speed;
        try {
            this.seekTo({
                time: this.getCurrentTime(),
                target: target,
                mediaState: mediaState
            });
            if (target.volume !== volume) target.volume = volume;
            target.muted = muted;
            target.loop = loop;
            if (target.playbackRate !== playbackRate) target.playbackRate = playbackRate;
            if (isPlaying && !playerIsPaused) target.play();
            else target.pause();
        } catch (error) {
            this.warn(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/restrict-template-expressions
            `Failed to replay media interactions: ${error.message || error}`);
        }
    }
    addMediaElements(node2, timeOffset, mirror2) {
        if (![
            "AUDIO",
            "VIDEO"
        ].includes(node2.nodeName)) return;
        const target = node2;
        const serializedNode = mirror2.getMeta(target);
        if (!serializedNode || !("attributes" in serializedNode)) return;
        const playerIsPaused = this.service.state.matches("paused");
        const mediaAttributes = serializedNode.attributes;
        let isPlaying = false;
        if (mediaAttributes.rr_mediaState) isPlaying = mediaAttributes.rr_mediaState === "played";
        else isPlaying = target.getAttribute("autoplay") !== null;
        if (isPlaying && playerIsPaused) target.pause();
        let playbackRate = 1;
        if (typeof mediaAttributes.rr_mediaPlaybackRate === "number") playbackRate = mediaAttributes.rr_mediaPlaybackRate;
        let muted = false;
        if (typeof mediaAttributes.rr_mediaMuted === "boolean") muted = mediaAttributes.rr_mediaMuted;
        else muted = target.getAttribute("muted") !== null;
        let loop = false;
        if (typeof mediaAttributes.rr_mediaLoop === "boolean") loop = mediaAttributes.rr_mediaLoop;
        else loop = target.getAttribute("loop") !== null;
        let volume = 1;
        if (typeof mediaAttributes.rr_mediaVolume === "number") volume = mediaAttributes.rr_mediaVolume;
        let currentTimeAtLastInteraction = 0;
        if (typeof mediaAttributes.rr_mediaCurrentTime === "number") currentTimeAtLastInteraction = mediaAttributes.rr_mediaCurrentTime;
        this.mediaMap.set(target, {
            isPlaying: isPlaying,
            currentTimeAtLastInteraction: currentTimeAtLastInteraction,
            lastInteractionTimeOffset: timeOffset,
            playbackRate: playbackRate,
            volume: volume,
            muted: muted,
            loop: loop
        });
        this.syncTargetWithState(target);
    }
    mediaMutation({ target: target, timeOffset: timeOffset, mutation: mutation }) {
        this.mediaMap.set(target, this.getMediaStateFromMutation({
            target: target,
            timeOffset: timeOffset,
            mutation: mutation
        }));
        this.syncTargetWithState(target);
    }
    isSupportedMediaElement(node2) {
        return [
            "AUDIO",
            "VIDEO"
        ].includes(node2.nodeName);
    }
    reset() {
        this.mediaMap.clear();
    }
}
function $791ce2ee9eb5657b$var$applyDialogToTopLevel(node2, attributeMutation) {
    if (node2.nodeName !== "DIALOG" || node2 instanceof $791ce2ee9eb5657b$var$BaseRRNode) return;
    const dialog = node2;
    const oldIsOpen = dialog.open;
    const oldIsModalState = oldIsOpen && dialog.matches("dialog:modal");
    const rrOpenMode = dialog.getAttribute("rr_open_mode");
    const newIsOpen = typeof (attributeMutation == null ? void 0 : attributeMutation.attributes.open) === "string" || typeof dialog.getAttribute("open") === "string";
    const newIsModalState = rrOpenMode === "modal";
    const newIsNonModalState = rrOpenMode === "non-modal";
    const modalStateChanged = oldIsModalState && newIsNonModalState || !oldIsModalState && newIsModalState;
    if (oldIsOpen && !modalStateChanged) return;
    if (!dialog.isConnected) {
        console.warn("dialog is not attached to the dom", dialog);
        return;
    }
    if (oldIsOpen) dialog.close();
    if (!newIsOpen) return;
    if (newIsModalState) dialog.showModal();
    else dialog.show();
}
function $791ce2ee9eb5657b$var$removeDialogFromTopLevel(node2, attributeMutation) {
    if (node2.nodeName !== "DIALOG" || node2 instanceof $791ce2ee9eb5657b$var$BaseRRNode) return;
    const dialog = node2;
    if (!dialog.isConnected) {
        console.warn("dialog is not attached to the dom", dialog);
        return;
    }
    if (attributeMutation.attributes.open === null) {
        dialog.removeAttribute("open");
        dialog.removeAttribute("rr_open_mode");
    }
}
const $791ce2ee9eb5657b$var$mitt = $791ce2ee9eb5657b$var$mitt$1 || $791ce2ee9eb5657b$var$mittProxy;
const $791ce2ee9eb5657b$var$REPLAY_CONSOLE_PREFIX = "[replayer]";
const $791ce2ee9eb5657b$var$defaultMouseTailConfig = {
    duration: 500,
    lineCap: "round",
    lineWidth: 3,
    strokeStyle: "red"
};
function $791ce2ee9eb5657b$var$indicatesTouchDevice(e2) {
    return e2.type == $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot && (e2.data.source == $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.TouchMove || e2.data.source == $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.MouseInteraction && e2.data.type == $791ce2ee9eb5657b$export$d87e674dba09af70.TouchStart);
}
class $791ce2ee9eb5657b$export$7cf0e3aed6c403c6 {
    constructor(events, config){
        $791ce2ee9eb5657b$var$__publicField(this, "wrapper");
        $791ce2ee9eb5657b$var$__publicField(this, "iframe");
        $791ce2ee9eb5657b$var$__publicField(this, "service");
        $791ce2ee9eb5657b$var$__publicField(this, "speedService");
        $791ce2ee9eb5657b$var$__publicField(this, "config");
        // In the fast-forward process, if the virtual-dom optimization is used, this flag value is true.
        $791ce2ee9eb5657b$var$__publicField(this, "usingVirtualDom", false);
        $791ce2ee9eb5657b$var$__publicField(this, "virtualDom", new $791ce2ee9eb5657b$var$RRDocument());
        $791ce2ee9eb5657b$var$__publicField(this, "mouse");
        $791ce2ee9eb5657b$var$__publicField(this, "mouseTail", null);
        $791ce2ee9eb5657b$var$__publicField(this, "tailPositions", []);
        $791ce2ee9eb5657b$var$__publicField(this, "emitter", $791ce2ee9eb5657b$var$mitt());
        $791ce2ee9eb5657b$var$__publicField(this, "nextUserInteractionEvent");
        $791ce2ee9eb5657b$var$__publicField(this, "legacy_missingNodeRetryMap", {});
        // The replayer uses the cache to speed up replay and scrubbing.
        $791ce2ee9eb5657b$var$__publicField(this, "cache", $791ce2ee9eb5657b$var$createCache());
        $791ce2ee9eb5657b$var$__publicField(this, "imageMap", /* @__PURE__ */ new Map());
        $791ce2ee9eb5657b$var$__publicField(this, "canvasEventMap", /* @__PURE__ */ new Map());
        $791ce2ee9eb5657b$var$__publicField(this, "mirror", $791ce2ee9eb5657b$var$createMirror$2());
        // Used to track StyleSheetObjects adopted on multiple document hosts.
        $791ce2ee9eb5657b$var$__publicField(this, "styleMirror", new $791ce2ee9eb5657b$var$StyleSheetMirror());
        // Used to track video & audio elements, and keep them in sync with general playback.
        $791ce2ee9eb5657b$var$__publicField(this, "mediaManager");
        $791ce2ee9eb5657b$var$__publicField(this, "firstFullSnapshot", null);
        $791ce2ee9eb5657b$var$__publicField(this, "newDocumentQueue", []);
        $791ce2ee9eb5657b$var$__publicField(this, "mousePos", null);
        $791ce2ee9eb5657b$var$__publicField(this, "touchActive", null);
        $791ce2ee9eb5657b$var$__publicField(this, "lastMouseDownEvent", null);
        // Keep the rootNode of the last hovered element. So  when hovering a new element, we can remove the last hovered element's :hover style.
        $791ce2ee9eb5657b$var$__publicField(this, "lastHoveredRootNode");
        // In the fast-forward mode, only the last selection data needs to be applied.
        $791ce2ee9eb5657b$var$__publicField(this, "lastSelectionData", null);
        // In the fast-forward mode using VirtualDom optimization, all stylesheetRule, and styleDeclaration events on constructed StyleSheets will be delayed to get applied until the flush stage.
        $791ce2ee9eb5657b$var$__publicField(this, "constructedStyleMutations", []);
        // Similar to the reason for constructedStyleMutations.
        $791ce2ee9eb5657b$var$__publicField(this, "adoptedStyleSheets", []);
        $791ce2ee9eb5657b$var$__publicField(this, "handleResize", (dimension)=>{
            this.iframe.style.display = "inherit";
            for (const el of [
                this.mouseTail,
                this.iframe
            ]){
                if (!el) continue;
                el.setAttribute("width", String(dimension.width));
                el.setAttribute("height", String(dimension.height));
            }
        });
        $791ce2ee9eb5657b$var$__publicField(this, "applyEventsSynchronously", (events)=>{
            for (const event of events){
                switch(event.type){
                    case $791ce2ee9eb5657b$export$3d7865934588d77e.DomContentLoaded:
                    case $791ce2ee9eb5657b$export$3d7865934588d77e.Load:
                    case $791ce2ee9eb5657b$export$3d7865934588d77e.Custom:
                        continue;
                    case $791ce2ee9eb5657b$export$3d7865934588d77e.FullSnapshot:
                    case $791ce2ee9eb5657b$export$3d7865934588d77e.Meta:
                    case $791ce2ee9eb5657b$export$3d7865934588d77e.Plugin:
                    case $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot:
                        break;
                }
                const castFn = this.getCastFn(event, true);
                castFn();
            }
        });
        $791ce2ee9eb5657b$var$__publicField(this, "getCastFn", (event, isSync = false)=>{
            let castFn;
            switch(event.type){
                case $791ce2ee9eb5657b$export$3d7865934588d77e.DomContentLoaded:
                case $791ce2ee9eb5657b$export$3d7865934588d77e.Load:
                    break;
                case $791ce2ee9eb5657b$export$3d7865934588d77e.Custom:
                    castFn = ()=>{
                        this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.CustomEvent, event);
                    };
                    break;
                case $791ce2ee9eb5657b$export$3d7865934588d77e.Meta:
                    castFn = ()=>this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Resize, {
                            width: event.data.width,
                            height: event.data.height
                        });
                    break;
                case $791ce2ee9eb5657b$export$3d7865934588d77e.FullSnapshot:
                    castFn = ()=>{
                        var _a2;
                        if (this.firstFullSnapshot) {
                            if (this.firstFullSnapshot === event) {
                                this.firstFullSnapshot = true;
                                return;
                            }
                        } else this.firstFullSnapshot = true;
                        this.mediaManager.reset();
                        this.styleMirror.reset();
                        this.rebuildFullSnapshot(event, isSync);
                        (_a2 = this.iframe.contentWindow) == null || _a2.scrollTo(event.data.initialOffset);
                    };
                    break;
                case $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot:
                    castFn = ()=>{
                        this.applyIncremental(event, isSync);
                        if (isSync) return;
                        if (this.config.skipInactive && !this.nextUserInteractionEvent) {
                            for (const _event of this.service.state.context.events){
                                if (_event.timestamp <= event.timestamp) continue;
                                if (this.isUserInteraction(_event)) {
                                    if (// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    _event.delay - event.delay > this.config.inactivePeriodThreshold * this.speedService.state.context.timer.speed) this.nextUserInteractionEvent = _event;
                                    break;
                                }
                            }
                            if (this.nextUserInteractionEvent) {
                                const skipTime = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                this.nextUserInteractionEvent.delay - event.delay;
                                this.play(this.getCurrentTime() + skipTime);
                                this.nextUserInteractionEvent = null;
                            }
                        }
                    };
                    break;
            }
            const wrappedCastFn = ()=>{
                if (castFn) castFn();
                for (const plugin3 of this.config.plugins || [])if (plugin3.handler) plugin3.handler(event, isSync, {
                    replayer: this
                });
                this.service.send({
                    type: "CAST_EVENT",
                    payload: {
                        event: event
                    }
                });
                const last_index = this.service.state.context.events.length - 1;
                if (!this.config.liveMode && event === this.service.state.context.events[last_index]) {
                    const finish = ()=>{
                        if (last_index < this.service.state.context.events.length - 1) return;
                        this.backToNormal();
                        this.service.send("END");
                        this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Finish);
                    };
                    let finish_buffer = 50;
                    if (event.type === $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot && event.data.source === $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.MouseMove && event.data.positions.length) finish_buffer += Math.max(0, -event.data.positions[0].timeOffset);
                    setTimeout(finish, finish_buffer);
                }
                this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.EventCast, event);
            };
            return wrappedCastFn;
        });
        if (!(config == null ? void 0 : config.liveMode) && events.length < 2) throw new Error("Replayer need at least 2 events.");
        const defaultConfig = {
            speed: 1,
            maxSpeed: 360,
            root: document.body,
            loadTimeout: 0,
            skipInactive: false,
            inactivePeriodThreshold: 10000,
            showWarning: true,
            showDebug: false,
            blockClass: "rr-block",
            liveMode: false,
            insertStyleRules: [],
            triggerFocus: true,
            UNSAFE_replayCanvas: false,
            pauseAnimation: true,
            mouseTail: $791ce2ee9eb5657b$var$defaultMouseTailConfig,
            useVirtualDom: true,
            // Virtual-dom optimization is enabled by default.
            logger: console
        };
        this.config = Object.assign({}, defaultConfig, config);
        this.handleResize = this.handleResize.bind(this);
        this.getCastFn = this.getCastFn.bind(this);
        this.applyEventsSynchronously = this.applyEventsSynchronously.bind(this);
        this.emitter.on($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Resize, this.handleResize);
        this.setupDom();
        for (const plugin3 of this.config.plugins || [])if (plugin3.getMirror) plugin3.getMirror({
            nodeMirror: this.mirror
        });
        this.emitter.on($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Flush, ()=>{
            if (this.usingVirtualDom) {
                const replayerHandler = {
                    mirror: this.mirror,
                    applyCanvas: (canvasEvent, canvasMutationData, target)=>{
                        $791ce2ee9eb5657b$export$fa4d1d1fb6883ae({
                            event: canvasEvent,
                            mutation: canvasMutationData,
                            target: target,
                            imageMap: this.imageMap,
                            canvasEventMap: this.canvasEventMap,
                            errorHandler: this.warnCanvasMutationFailed.bind(this)
                        });
                    },
                    applyInput: this.applyInput.bind(this),
                    applyScroll: this.applyScroll.bind(this),
                    applyStyleSheetMutation: (data, styleSheet)=>{
                        if (data.source === $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.StyleSheetRule) this.applyStyleSheetRule(data, styleSheet);
                        else if (data.source === $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.StyleDeclaration) this.applyStyleDeclaration(data, styleSheet);
                    },
                    afterAppend: (node2, id)=>{
                        for (const plugin3 of this.config.plugins || [])if (plugin3.onBuild) plugin3.onBuild(node2, {
                            id: id,
                            replayer: this
                        });
                    }
                };
                if (this.iframe.contentDocument) try {
                    $791ce2ee9eb5657b$var$diff(this.iframe.contentDocument, this.virtualDom, replayerHandler, this.virtualDom.mirror);
                } catch (e2) {
                    console.warn(e2);
                }
                this.virtualDom.destroyTree();
                this.usingVirtualDom = false;
                if (Object.keys(this.legacy_missingNodeRetryMap).length) {
                    for(const key in this.legacy_missingNodeRetryMap)try {
                        const value = this.legacy_missingNodeRetryMap[key];
                        const realNode = $791ce2ee9eb5657b$var$createOrGetNode(value.node, this.mirror, this.virtualDom.mirror);
                        $791ce2ee9eb5657b$var$diff(realNode, value.node, replayerHandler, this.virtualDom.mirror);
                        value.node = realNode;
                    } catch (error) {
                        this.warn(error);
                    }
                }
                this.constructedStyleMutations.forEach((data)=>{
                    this.applyStyleSheetMutation(data);
                });
                this.constructedStyleMutations = [];
                this.adoptedStyleSheets.forEach((data)=>{
                    this.applyAdoptedStyleSheet(data);
                });
                this.adoptedStyleSheets = [];
            }
            if (this.mousePos) {
                this.moveAndHover(this.mousePos.x, this.mousePos.y, this.mousePos.id, true, this.mousePos.debugData);
                this.mousePos = null;
            }
            if (this.touchActive === true) this.mouse.classList.add("touch-active");
            else if (this.touchActive === false) this.mouse.classList.remove("touch-active");
            this.touchActive = null;
            if (this.lastMouseDownEvent) {
                const [target, event] = this.lastMouseDownEvent;
                target.dispatchEvent(event);
            }
            this.lastMouseDownEvent = null;
            if (this.lastSelectionData) {
                this.applySelection(this.lastSelectionData);
                this.lastSelectionData = null;
            }
        });
        this.emitter.on($791ce2ee9eb5657b$export$7b5ca317a0cad55c.PlayBack, ()=>{
            this.firstFullSnapshot = null;
            this.mirror.reset();
            this.styleMirror.reset();
            this.mediaManager.reset();
        });
        const timer = new $791ce2ee9eb5657b$var$Timer([], {
            speed: this.config.speed
        });
        this.service = $791ce2ee9eb5657b$var$createPlayerService({
            events: events.map((e2)=>{
                if (config && config.unpackFn) return config.unpackFn(e2);
                return e2;
            }).sort((a1, a2)=>a1.timestamp - a2.timestamp),
            timer: timer,
            timeOffset: 0,
            baselineTime: 0,
            lastPlayedEvent: null
        }, {
            getCastFn: this.getCastFn,
            applyEventsSynchronously: this.applyEventsSynchronously,
            emitter: this.emitter
        });
        this.service.start();
        this.service.subscribe((state)=>{
            this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.StateChange, {
                player: state
            });
        });
        this.speedService = $791ce2ee9eb5657b$var$createSpeedService({
            normalSpeed: -1,
            timer: timer
        });
        this.speedService.start();
        this.speedService.subscribe((state)=>{
            this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.StateChange, {
                speed: state
            });
        });
        this.mediaManager = new $791ce2ee9eb5657b$var$MediaManager({
            warn: this.warn.bind(this),
            service: this.service,
            speedService: this.speedService,
            emitter: this.emitter,
            getCurrentTime: this.getCurrentTime.bind(this)
        });
        const firstMeta = this.service.state.context.events.find((e2)=>e2.type === $791ce2ee9eb5657b$export$3d7865934588d77e.Meta);
        const firstFullsnapshot = this.service.state.context.events.find((e2)=>e2.type === $791ce2ee9eb5657b$export$3d7865934588d77e.FullSnapshot);
        if (firstMeta) {
            const { width: width, height: height } = firstMeta.data;
            setTimeout(()=>{
                this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Resize, {
                    width: width,
                    height: height
                });
            }, 0);
        }
        if (firstFullsnapshot) setTimeout(()=>{
            var _a2;
            if (this.firstFullSnapshot) return;
            this.firstFullSnapshot = firstFullsnapshot;
            this.rebuildFullSnapshot(firstFullsnapshot);
            (_a2 = this.iframe.contentWindow) == null || _a2.scrollTo(firstFullsnapshot.data.initialOffset);
        }, 1);
        if (this.service.state.context.events.find($791ce2ee9eb5657b$var$indicatesTouchDevice)) this.mouse.classList.add("touch-device");
    }
    get timer() {
        return this.service.state.context.timer;
    }
    on(event, handler) {
        this.emitter.on(event, handler);
        return this;
    }
    off(event, handler) {
        this.emitter.off(event, handler);
        return this;
    }
    setConfig(config) {
        Object.keys(config).forEach((key)=>{
            config[key];
            this.config[key] = config[key];
        });
        if (!this.config.skipInactive) this.backToNormal();
        if (typeof config.speed !== "undefined") this.speedService.send({
            type: "SET_SPEED",
            payload: {
                speed: config.speed
            }
        });
        if (typeof config.mouseTail !== "undefined") {
            if (config.mouseTail === false) {
                if (this.mouseTail) this.mouseTail.style.display = "none";
            } else {
                if (!this.mouseTail) {
                    this.mouseTail = document.createElement("canvas");
                    this.mouseTail.width = Number.parseFloat(this.iframe.width);
                    this.mouseTail.height = Number.parseFloat(this.iframe.height);
                    this.mouseTail.classList.add("replayer-mouse-tail");
                    this.wrapper.insertBefore(this.mouseTail, this.iframe);
                }
                this.mouseTail.style.display = "inherit";
            }
        }
    }
    getMetaData() {
        const firstEvent = this.service.state.context.events[0];
        const lastEvent = this.service.state.context.events[this.service.state.context.events.length - 1];
        return {
            startTime: firstEvent.timestamp,
            endTime: lastEvent.timestamp,
            totalTime: lastEvent.timestamp - firstEvent.timestamp
        };
    }
    /**
   * Get the actual time offset the player is at now compared to the first event.
   */ getCurrentTime() {
        return this.timer.timeOffset + this.getTimeOffset();
    }
    /**
   * Get the time offset the player is at now compared to the first event, but without regard for the timer.
   */ getTimeOffset() {
        const { baselineTime: baselineTime, events: events } = this.service.state.context;
        return baselineTime - events[0].timestamp;
    }
    getMirror() {
        return this.mirror;
    }
    /**
   * This API was designed to be used as play at any time offset.
   * Since we minimized the data collected from recorder, we do not
   * have the ability of undo an event.
   * So the implementation of play at any time offset will always iterate
   * all of the events, cast event before the offset synchronously
   * and cast event after the offset asynchronously with timer.
   * @param timeOffset - number
   */ play(timeOffset = 0) {
        var _a2, _b;
        if (this.service.state.matches("paused")) this.service.send({
            type: "PLAY",
            payload: {
                timeOffset: timeOffset
            }
        });
        else {
            this.service.send({
                type: "PAUSE"
            });
            this.service.send({
                type: "PLAY",
                payload: {
                    timeOffset: timeOffset
                }
            });
        }
        (_b = (_a2 = this.iframe.contentDocument) == null ? void 0 : _a2.getElementsByTagName("html")[0]) == null || _b.classList.remove("rrweb-paused");
        this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Start);
    }
    pause(timeOffset) {
        var _a2, _b;
        if (timeOffset === void 0 && this.service.state.matches("playing")) this.service.send({
            type: "PAUSE"
        });
        if (typeof timeOffset === "number") {
            this.play(timeOffset);
            this.service.send({
                type: "PAUSE"
            });
        }
        (_b = (_a2 = this.iframe.contentDocument) == null ? void 0 : _a2.getElementsByTagName("html")[0]) == null || _b.classList.add("rrweb-paused");
        this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Pause);
    }
    resume(timeOffset = 0) {
        this.warn(`The 'resume' was deprecated in 1.0. Please use 'play' method which has the same interface.`);
        this.play(timeOffset);
        this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Resume);
    }
    /**
   * Totally destroy this replayer and please be careful that this operation is irreversible.
   * Memory occupation can be released by removing all references to this replayer.
   */ destroy() {
        this.pause();
        this.mirror.reset();
        this.styleMirror.reset();
        this.mediaManager.reset();
        this.config.root.removeChild(this.wrapper);
        this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Destroy);
    }
    startLive(baselineTime) {
        this.service.send({
            type: "TO_LIVE",
            payload: {
                baselineTime: baselineTime
            }
        });
    }
    addEvent(rawEvent) {
        const event = this.config.unpackFn ? this.config.unpackFn(rawEvent) : rawEvent;
        if ($791ce2ee9eb5657b$var$indicatesTouchDevice(event)) this.mouse.classList.add("touch-device");
        Promise.resolve().then(()=>this.service.send({
                type: "ADD_EVENT",
                payload: {
                    event: event
                }
            }));
    }
    enableInteract() {
        this.iframe.setAttribute("scrolling", "auto");
        this.iframe.style.pointerEvents = "auto";
    }
    disableInteract() {
        this.iframe.setAttribute("scrolling", "no");
        this.iframe.style.pointerEvents = "none";
    }
    /**
   * Empties the replayer's cache and reclaims memory.
   * The replayer will use this cache to speed up the playback.
   */ resetCache() {
        this.cache = $791ce2ee9eb5657b$var$createCache();
    }
    setupDom() {
        this.wrapper = document.createElement("div");
        this.wrapper.classList.add("replayer-wrapper");
        this.config.root.appendChild(this.wrapper);
        this.mouse = document.createElement("div");
        this.mouse.classList.add("replayer-mouse");
        this.wrapper.appendChild(this.mouse);
        if (this.config.mouseTail !== false) {
            this.mouseTail = document.createElement("canvas");
            this.mouseTail.classList.add("replayer-mouse-tail");
            this.mouseTail.style.display = "inherit";
            this.wrapper.appendChild(this.mouseTail);
        }
        this.iframe = document.createElement("iframe");
        const attributes = [
            "allow-same-origin"
        ];
        if (this.config.UNSAFE_replayCanvas) attributes.push("allow-scripts");
        this.iframe.style.display = "none";
        this.iframe.setAttribute("sandbox", attributes.join(" "));
        this.disableInteract();
        this.wrapper.appendChild(this.iframe);
        if (this.iframe.contentWindow && this.iframe.contentDocument) {
            $791ce2ee9eb5657b$var$polyfill(this.iframe.contentWindow, this.iframe.contentDocument);
            $791ce2ee9eb5657b$var$polyfill$1(this.iframe.contentWindow);
        }
    }
    rebuildFullSnapshot(event, isSync = false) {
        if (!this.iframe.contentDocument) return this.warn("Looks like your replayer has been destroyed.");
        if (Object.keys(this.legacy_missingNodeRetryMap).length) this.warn("Found unresolved missing node map", this.legacy_missingNodeRetryMap);
        this.legacy_missingNodeRetryMap = {};
        const collectedIframes = [];
        const collectedDialogs = /* @__PURE__ */ new Set();
        const afterAppend = (builtNode, id)=>{
            if (builtNode.nodeName === "DIALOG") collectedDialogs.add(builtNode);
            this.collectIframeAndAttachDocument(collectedIframes, builtNode);
            if (this.mediaManager.isSupportedMediaElement(builtNode)) {
                const { events: events } = this.service.state.context;
                this.mediaManager.addMediaElements(builtNode, event.timestamp - events[0].timestamp, this.mirror);
            }
            for (const plugin3 of this.config.plugins || [])if (plugin3.onBuild) plugin3.onBuild(builtNode, {
                id: id,
                replayer: this
            });
        };
        if (this.usingVirtualDom) {
            this.virtualDom.destroyTree();
            this.usingVirtualDom = false;
        }
        this.mirror.reset();
        $791ce2ee9eb5657b$var$rebuild(event.data.node, {
            doc: this.iframe.contentDocument,
            afterAppend: afterAppend,
            cache: this.cache,
            mirror: this.mirror
        });
        afterAppend(this.iframe.contentDocument, event.data.node.id);
        for (const { mutationInQueue: mutationInQueue, builtNode: builtNode } of collectedIframes){
            this.attachDocumentToIframe(mutationInQueue, builtNode);
            this.newDocumentQueue = this.newDocumentQueue.filter((m)=>m !== mutationInQueue);
        }
        const { documentElement: documentElement, head: head } = this.iframe.contentDocument;
        this.insertStyleRules(documentElement, head);
        collectedDialogs.forEach((d)=>$791ce2ee9eb5657b$var$applyDialogToTopLevel(d));
        if (!this.service.state.matches("playing")) this.iframe.contentDocument.getElementsByTagName("html")[0].classList.add("rrweb-paused");
        this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.FullsnapshotRebuilded, event);
        if (!isSync) this.waitForStylesheetLoad();
        if (this.config.UNSAFE_replayCanvas) this.preloadAllImages();
    }
    insertStyleRules(documentElement, head) {
        var _a2;
        const injectStylesRules = $791ce2ee9eb5657b$var$rules(this.config.blockClass).concat(this.config.insertStyleRules);
        if (this.config.pauseAnimation) injectStylesRules.push("html.rrweb-paused *, html.rrweb-paused *:before, html.rrweb-paused *:after { animation-play-state: paused !important; }");
        if (!injectStylesRules.length) return;
        if (this.usingVirtualDom) {
            const styleEl = this.virtualDom.createElement("style");
            this.virtualDom.mirror.add(styleEl, $791ce2ee9eb5657b$var$getDefaultSN(styleEl, this.virtualDom.unserializedId));
            documentElement.insertBefore(styleEl, head);
            styleEl.rules.push({
                source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.StyleSheetRule,
                adds: injectStylesRules.map((cssText, index2)=>({
                        rule: cssText,
                        index: index2
                    }))
            });
        } else {
            const styleEl = document.createElement("style");
            documentElement.insertBefore(styleEl, head);
            for(let idx = 0; idx < injectStylesRules.length; idx++)(_a2 = styleEl.sheet) == null || _a2.insertRule(injectStylesRules[idx], idx);
        }
    }
    attachDocumentToIframe(mutation, iframeEl) {
        const mirror2 = this.usingVirtualDom ? this.virtualDom.mirror : this.mirror;
        const collectedIframes = [];
        const collectedDialogs = /* @__PURE__ */ new Set();
        const afterAppend = (builtNode, id)=>{
            if (builtNode.nodeName === "DIALOG") collectedDialogs.add(builtNode);
            this.collectIframeAndAttachDocument(collectedIframes, builtNode);
            const sn = mirror2.getMeta(builtNode);
            if ((sn == null ? void 0 : sn.type) === $791ce2ee9eb5657b$var$NodeType.Element && (sn == null ? void 0 : sn.tagName.toUpperCase()) === "HTML") {
                const { documentElement: documentElement, head: head } = iframeEl.contentDocument;
                this.insertStyleRules(documentElement, head);
            }
            if (this.usingVirtualDom) return;
            for (const plugin3 of this.config.plugins || [])if (plugin3.onBuild) plugin3.onBuild(builtNode, {
                id: id,
                replayer: this
            });
        };
        $791ce2ee9eb5657b$var$buildNodeWithSN(mutation.node, {
            doc: iframeEl.contentDocument,
            mirror: mirror2,
            hackCss: true,
            skipChild: false,
            afterAppend: afterAppend,
            cache: this.cache
        });
        afterAppend(iframeEl.contentDocument, mutation.node.id);
        for (const { mutationInQueue: mutationInQueue, builtNode: builtNode } of collectedIframes){
            this.attachDocumentToIframe(mutationInQueue, builtNode);
            this.newDocumentQueue = this.newDocumentQueue.filter((m)=>m !== mutationInQueue);
        }
        collectedDialogs.forEach((d)=>$791ce2ee9eb5657b$var$applyDialogToTopLevel(d));
    }
    collectIframeAndAttachDocument(collected, builtNode) {
        if ($791ce2ee9eb5657b$var$isSerializedIframe(builtNode, this.mirror)) {
            const mutationInQueue = this.newDocumentQueue.find((m)=>m.parentId === this.mirror.getId(builtNode));
            if (mutationInQueue) collected.push({
                mutationInQueue: mutationInQueue,
                builtNode: builtNode
            });
        }
    }
    /**
   * pause when loading style sheet, resume when loaded all timeout exceed
   */ waitForStylesheetLoad() {
        var _a2;
        const head = (_a2 = this.iframe.contentDocument) == null ? void 0 : _a2.head;
        if (head) {
            const unloadSheets = /* @__PURE__ */ new Set();
            let timer;
            let beforeLoadState = this.service.state;
            const stateHandler = ()=>{
                beforeLoadState = this.service.state;
            };
            this.emitter.on($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Start, stateHandler);
            this.emitter.on($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Pause, stateHandler);
            const unsubscribe = ()=>{
                this.emitter.off($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Start, stateHandler);
                this.emitter.off($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Pause, stateHandler);
            };
            head.querySelectorAll('link[rel="stylesheet"]').forEach((css)=>{
                if (!css.sheet) {
                    unloadSheets.add(css);
                    css.addEventListener("load", ()=>{
                        unloadSheets.delete(css);
                        if (unloadSheets.size === 0 && timer !== -1) {
                            if (beforeLoadState.matches("playing")) this.play(this.getCurrentTime());
                            this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.LoadStylesheetEnd);
                            if (timer) clearTimeout(timer);
                            unsubscribe();
                        }
                    });
                }
            });
            if (unloadSheets.size > 0) {
                this.service.send({
                    type: "PAUSE"
                });
                this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.LoadStylesheetStart);
                timer = setTimeout(()=>{
                    if (beforeLoadState.matches("playing")) this.play(this.getCurrentTime());
                    timer = -1;
                    unsubscribe();
                }, this.config.loadTimeout);
            }
        }
    }
    /**
   * pause when there are some canvas drawImage args need to be loaded
   */ async preloadAllImages() {
        const promises = [];
        for (const event of this.service.state.context.events)if (event.type === $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot && event.data.source === $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.CanvasMutation) {
            promises.push(this.deserializeAndPreloadCanvasEvents(event.data, event));
            const commands = "commands" in event.data ? event.data.commands : [
                event.data
            ];
            commands.forEach((c2)=>{
                this.preloadImages(c2, event);
            });
        }
        return Promise.all(promises);
    }
    preloadImages(data, event) {
        if (data.property === "drawImage" && typeof data.args[0] === "string" && !this.imageMap.has(event)) {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const imgd = ctx == null ? void 0 : ctx.createImageData(canvas.width, canvas.height);
            ctx == null || ctx.putImageData(imgd, 0, 0);
        }
    }
    async deserializeAndPreloadCanvasEvents(data, event) {
        if (!this.canvasEventMap.has(event)) {
            const status = {
                isUnchanged: true
            };
            if ("commands" in data) {
                const commands = await Promise.all(data.commands.map(async (c2)=>{
                    const args = await Promise.all(c2.args.map($791ce2ee9eb5657b$var$deserializeArg(this.imageMap, null, status)));
                    return {
                        ...c2,
                        args: args
                    };
                }));
                if (status.isUnchanged === false) this.canvasEventMap.set(event, {
                    ...data,
                    commands: commands
                });
            } else {
                const args = await Promise.all(data.args.map($791ce2ee9eb5657b$var$deserializeArg(this.imageMap, null, status)));
                if (status.isUnchanged === false) this.canvasEventMap.set(event, {
                    ...data,
                    args: args
                });
            }
        }
    }
    applyIncremental(e2, isSync) {
        var _a2, _b, _c;
        const { data: d } = e2;
        switch(d.source){
            case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Mutation:
                try {
                    this.applyMutation(d, isSync);
                } catch (error) {
                    this.warn(`Exception in mutation ${error.message || error}`, d);
                }
                break;
            case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Drag:
            case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.TouchMove:
            case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.MouseMove:
                if (isSync) {
                    const lastPosition = d.positions[d.positions.length - 1];
                    this.mousePos = {
                        x: lastPosition.x,
                        y: lastPosition.y,
                        id: lastPosition.id,
                        debugData: d
                    };
                } else {
                    d.positions.forEach((p)=>{
                        const action = {
                            doAction: ()=>{
                                this.moveAndHover(p.x, p.y, p.id, isSync, d);
                            },
                            delay: p.timeOffset + e2.timestamp - this.service.state.context.baselineTime
                        };
                        this.timer.addAction(action);
                    });
                    this.timer.addAction({
                        doAction () {},
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        delay: e2.delay - ((_a2 = d.positions[0]) == null ? void 0 : _a2.timeOffset)
                    });
                }
                break;
            case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.MouseInteraction:
                {
                    if (d.id === -1) break;
                    const event = new Event($791ce2ee9eb5657b$var$toLowerCase($791ce2ee9eb5657b$export$d87e674dba09af70[d.type]));
                    const target = this.mirror.getNode(d.id);
                    if (!target) return this.debugNodeNotFound(d, d.id);
                    this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.MouseInteraction, {
                        type: d.type,
                        target: target
                    });
                    const { triggerFocus: triggerFocus } = this.config;
                    switch(d.type){
                        case $791ce2ee9eb5657b$export$d87e674dba09af70.Blur:
                            if ("blur" in target) target.blur();
                            break;
                        case $791ce2ee9eb5657b$export$d87e674dba09af70.Focus:
                            if (triggerFocus && target.focus) target.focus({
                                preventScroll: true
                            });
                            break;
                        case $791ce2ee9eb5657b$export$d87e674dba09af70.Click:
                        case $791ce2ee9eb5657b$export$d87e674dba09af70.TouchStart:
                        case $791ce2ee9eb5657b$export$d87e674dba09af70.TouchEnd:
                        case $791ce2ee9eb5657b$export$d87e674dba09af70.MouseDown:
                        case $791ce2ee9eb5657b$export$d87e674dba09af70.MouseUp:
                            if (isSync) {
                                if (d.type === $791ce2ee9eb5657b$export$d87e674dba09af70.TouchStart) this.touchActive = true;
                                else if (d.type === $791ce2ee9eb5657b$export$d87e674dba09af70.TouchEnd) this.touchActive = false;
                                if (d.type === $791ce2ee9eb5657b$export$d87e674dba09af70.MouseDown) this.lastMouseDownEvent = [
                                    target,
                                    event
                                ];
                                else if (d.type === $791ce2ee9eb5657b$export$d87e674dba09af70.MouseUp) this.lastMouseDownEvent = null;
                                this.mousePos = {
                                    x: d.x || 0,
                                    y: d.y || 0,
                                    id: d.id,
                                    debugData: d
                                };
                            } else {
                                if (d.type === $791ce2ee9eb5657b$export$d87e674dba09af70.TouchStart) this.tailPositions.length = 0;
                                this.moveAndHover(d.x || 0, d.y || 0, d.id, isSync, d);
                                if (d.type === $791ce2ee9eb5657b$export$d87e674dba09af70.Click) {
                                    this.mouse.classList.remove("active");
                                    this.mouse.offsetWidth;
                                    this.mouse.classList.add("active");
                                } else if (d.type === $791ce2ee9eb5657b$export$d87e674dba09af70.TouchStart) {
                                    this.mouse.offsetWidth;
                                    this.mouse.classList.add("touch-active");
                                } else if (d.type === $791ce2ee9eb5657b$export$d87e674dba09af70.TouchEnd) this.mouse.classList.remove("touch-active");
                                else target.dispatchEvent(event);
                            }
                            break;
                        case $791ce2ee9eb5657b$export$d87e674dba09af70.TouchCancel:
                            if (isSync) this.touchActive = false;
                            else this.mouse.classList.remove("touch-active");
                            break;
                        default:
                            target.dispatchEvent(event);
                    }
                    break;
                }
            case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Scroll:
                if (d.id === -1) break;
                if (this.usingVirtualDom) {
                    const target = this.virtualDom.mirror.getNode(d.id);
                    if (!target) return this.debugNodeNotFound(d, d.id);
                    target.scrollData = d;
                    break;
                }
                this.applyScroll(d, isSync);
                break;
            case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.ViewportResize:
                this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.Resize, {
                    width: d.width,
                    height: d.height
                });
                break;
            case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Input:
                if (d.id === -1) break;
                if (this.usingVirtualDom) {
                    const target = this.virtualDom.mirror.getNode(d.id);
                    if (!target) return this.debugNodeNotFound(d, d.id);
                    target.inputData = d;
                    break;
                }
                this.applyInput(d);
                break;
            case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.MediaInteraction:
                {
                    const target = this.usingVirtualDom ? this.virtualDom.mirror.getNode(d.id) : this.mirror.getNode(d.id);
                    if (!target) return this.debugNodeNotFound(d, d.id);
                    const mediaEl = target;
                    const { events: events } = this.service.state.context;
                    this.mediaManager.mediaMutation({
                        target: mediaEl,
                        timeOffset: e2.timestamp - events[0].timestamp,
                        mutation: d
                    });
                    break;
                }
            case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.StyleSheetRule:
            case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.StyleDeclaration:
                if (this.usingVirtualDom) {
                    if (d.styleId) this.constructedStyleMutations.push(d);
                    else if (d.id) (_b = this.virtualDom.mirror.getNode(d.id)) == null || _b.rules.push(d);
                } else this.applyStyleSheetMutation(d);
                break;
            case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.CanvasMutation:
                if (!this.config.UNSAFE_replayCanvas) return;
                if (this.usingVirtualDom) {
                    const target = this.virtualDom.mirror.getNode(d.id);
                    if (!target) return this.debugNodeNotFound(d, d.id);
                    target.canvasMutations.push({
                        event: e2,
                        mutation: d
                    });
                } else {
                    const target = this.mirror.getNode(d.id);
                    if (!target) return this.debugNodeNotFound(d, d.id);
                    $791ce2ee9eb5657b$export$fa4d1d1fb6883ae({
                        event: e2,
                        mutation: d,
                        target: target,
                        imageMap: this.imageMap,
                        canvasEventMap: this.canvasEventMap,
                        errorHandler: this.warnCanvasMutationFailed.bind(this)
                    });
                }
                break;
            case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Font:
                try {
                    const fontFace = new FontFace(d.family, d.buffer ? new Uint8Array(JSON.parse(d.fontSource)) : d.fontSource, d.descriptors);
                    (_c = this.iframe.contentDocument) == null || _c.fonts.add(fontFace);
                } catch (error) {
                    this.warn(error);
                }
                break;
            case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Selection:
                if (isSync) {
                    this.lastSelectionData = d;
                    break;
                }
                this.applySelection(d);
                break;
            case $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.AdoptedStyleSheet:
                if (this.usingVirtualDom) this.adoptedStyleSheets.push(d);
                else this.applyAdoptedStyleSheet(d);
                break;
        }
    }
    /**
   * Apply the mutation to the virtual dom or the real dom.
   * @param d - The mutation data.
   * @param isSync - Whether the mutation should be applied synchronously (while fast-forwarding).
   */ applyMutation(d, isSync) {
        if (this.config.useVirtualDom && !this.usingVirtualDom && isSync) {
            this.usingVirtualDom = true;
            $791ce2ee9eb5657b$var$buildFromDom(this.iframe.contentDocument, this.mirror, this.virtualDom);
            if (Object.keys(this.legacy_missingNodeRetryMap).length) {
                for(const key in this.legacy_missingNodeRetryMap)try {
                    const value = this.legacy_missingNodeRetryMap[key];
                    const virtualNode = $791ce2ee9eb5657b$var$buildFromNode(value.node, this.virtualDom, this.mirror);
                    if (virtualNode) value.node = virtualNode;
                } catch (error) {
                    this.warn(error);
                }
            }
        }
        const mirror2 = this.usingVirtualDom ? this.virtualDom.mirror : this.mirror;
        d.removes = d.removes.filter((mutation)=>{
            if (!mirror2.getNode(mutation.id)) {
                this.warnNodeNotFound(d, mutation.id);
                return false;
            }
            return true;
        });
        d.removes.forEach((mutation)=>{
            var _a2;
            const target = mirror2.getNode(mutation.id);
            if (!target) return;
            let parent = mirror2.getNode(mutation.parentId);
            if (!parent) return this.warnNodeNotFound(d, mutation.parentId);
            if (mutation.isShadow && $791ce2ee9eb5657b$var$hasShadowRoot(parent)) parent = parent.shadowRoot;
            mirror2.removeNodeFromMap(target);
            if (parent) try {
                parent.removeChild(target);
                if (this.usingVirtualDom && target.nodeName === "#text" && parent.nodeName === "STYLE" && ((_a2 = parent.rules) == null ? void 0 : _a2.length) > 0) parent.rules = [];
            } catch (error) {
                if (error instanceof DOMException) this.warn("parent could not remove child in mutation", parent, target, d);
                else throw error;
            }
        });
        const legacy_missingNodeMap = {
            ...this.legacy_missingNodeRetryMap
        };
        const queue = [];
        const nextNotInDOM = (mutation)=>{
            let next = null;
            if (mutation.nextId) next = mirror2.getNode(mutation.nextId);
            if (mutation.nextId !== null && mutation.nextId !== void 0 && mutation.nextId !== -1 && !next) return true;
            return false;
        };
        const appendNode = (mutation)=>{
            var _a2, _b;
            if (!this.iframe.contentDocument) return this.warn("Looks like your replayer has been destroyed.");
            let parent = mirror2.getNode(mutation.parentId);
            if (!parent) {
                if (mutation.node.type === $791ce2ee9eb5657b$var$NodeType.Document) return this.newDocumentQueue.push(mutation);
                return queue.push(mutation);
            }
            if (mutation.node.isShadow) {
                if (!$791ce2ee9eb5657b$var$hasShadowRoot(parent)) {
                    parent.attachShadow({
                        mode: "open"
                    });
                    parent = parent.shadowRoot;
                } else parent = parent.shadowRoot;
            }
            let previous = null;
            let next = null;
            if (mutation.previousId) previous = mirror2.getNode(mutation.previousId);
            if (mutation.nextId) next = mirror2.getNode(mutation.nextId);
            if (nextNotInDOM(mutation)) return queue.push(mutation);
            if (mutation.node.rootId && !mirror2.getNode(mutation.node.rootId)) return;
            const targetDoc = mutation.node.rootId ? mirror2.getNode(mutation.node.rootId) : this.usingVirtualDom ? this.virtualDom : this.iframe.contentDocument;
            if ($791ce2ee9eb5657b$var$isSerializedIframe(parent, mirror2)) {
                this.attachDocumentToIframe(mutation, parent);
                return;
            }
            const afterAppend = (node2, id)=>{
                if (this.usingVirtualDom) return;
                $791ce2ee9eb5657b$var$applyDialogToTopLevel(node2);
                for (const plugin3 of this.config.plugins || [])if (plugin3.onBuild) plugin3.onBuild(node2, {
                    id: id,
                    replayer: this
                });
            };
            const target = $791ce2ee9eb5657b$var$buildNodeWithSN(mutation.node, {
                doc: targetDoc,
                // can be Document or RRDocument
                mirror: mirror2,
                // can be this.mirror or virtualDom.mirror
                skipChild: true,
                hackCss: true,
                cache: this.cache,
                afterAppend: /**
         * caveat: `afterAppend` only gets called on child nodes of target
         * we have to call it again below when this target was added to the DOM
         */ afterAppend
            });
            if (mutation.previousId === -1 || mutation.nextId === -1) {
                legacy_missingNodeMap[mutation.node.id] = {
                    node: target,
                    mutation: mutation
                };
                return;
            }
            const parentSn = mirror2.getMeta(parent);
            if (parentSn && parentSn.type === $791ce2ee9eb5657b$var$NodeType.Element && mutation.node.type === $791ce2ee9eb5657b$var$NodeType.Text) {
                const prospectiveSiblings = Array.isArray(parent.childNodes) ? parent.childNodes : Array.from(parent.childNodes);
                if (parentSn.tagName === "textarea") {
                    for (const c2 of prospectiveSiblings)if (c2.nodeType === parent.TEXT_NODE) parent.removeChild(c2);
                } else if (parentSn.tagName === "style" && prospectiveSiblings.length === 1) {
                    for (const cssText of prospectiveSiblings)if (cssText.nodeType === parent.TEXT_NODE && !mirror2.hasNode(cssText)) {
                        target.textContent = cssText.textContent;
                        parent.removeChild(cssText);
                    }
                }
            } else if ((parentSn == null ? void 0 : parentSn.type) === $791ce2ee9eb5657b$var$NodeType.Document) {
                const parentDoc = parent;
                if (mutation.node.type === $791ce2ee9eb5657b$var$NodeType.DocumentType && ((_a2 = parentDoc.childNodes[0]) == null ? void 0 : _a2.nodeType) === Node.DOCUMENT_TYPE_NODE) parentDoc.removeChild(parentDoc.childNodes[0]);
                if (target.nodeName === "HTML" && parentDoc.documentElement) parentDoc.removeChild(parentDoc.documentElement);
            }
            if (previous && previous.nextSibling && previous.nextSibling.parentNode) parent.insertBefore(target, previous.nextSibling);
            else if (next && next.parentNode) parent.contains(next) ? parent.insertBefore(target, next) : parent.insertBefore(target, null);
            else parent.appendChild(target);
            afterAppend(target, mutation.node.id);
            if (this.usingVirtualDom && target.nodeName === "#text" && parent.nodeName === "STYLE" && ((_b = parent.rules) == null ? void 0 : _b.length) > 0) parent.rules = [];
            if ($791ce2ee9eb5657b$var$isSerializedIframe(target, this.mirror)) {
                const targetId = this.mirror.getId(target);
                const mutationInQueue = this.newDocumentQueue.find((m)=>m.parentId === targetId);
                if (mutationInQueue) {
                    this.attachDocumentToIframe(mutationInQueue, target);
                    this.newDocumentQueue = this.newDocumentQueue.filter((m)=>m !== mutationInQueue);
                }
            }
            if (mutation.previousId || mutation.nextId) this.legacy_resolveMissingNode(legacy_missingNodeMap, parent, target, mutation);
        };
        d.adds.forEach((mutation)=>{
            appendNode(mutation);
        });
        const startTime = Date.now();
        while(queue.length){
            const resolveTrees = $791ce2ee9eb5657b$var$queueToResolveTrees(queue);
            queue.length = 0;
            if (Date.now() - startTime > 500) {
                this.warn("Timeout in the loop, please check the resolve tree data:", resolveTrees);
                break;
            }
            for (const tree of resolveTrees){
                const parent = mirror2.getNode(tree.value.parentId);
                if (!parent) this.debug("Drop resolve tree since there is no parent for the root node.", tree);
                else $791ce2ee9eb5657b$var$iterateResolveTree(tree, (mutation)=>{
                    appendNode(mutation);
                });
            }
        }
        if (Object.keys(legacy_missingNodeMap).length) Object.assign(this.legacy_missingNodeRetryMap, legacy_missingNodeMap);
        $791ce2ee9eb5657b$var$uniqueTextMutations(d.texts).forEach((mutation)=>{
            var _a2;
            const target = mirror2.getNode(mutation.id);
            if (!target) {
                if (d.removes.find((r2)=>r2.id === mutation.id)) return;
                return this.warnNodeNotFound(d, mutation.id);
            }
            const parentEl = target.parentElement;
            if (mutation.value && parentEl && parentEl.tagName === "STYLE") target.textContent = $791ce2ee9eb5657b$var$adaptCssForReplay(mutation.value, this.cache);
            else target.textContent = mutation.value;
            if (this.usingVirtualDom) {
                const parent = target.parentNode;
                if (((_a2 = parent == null ? void 0 : parent.rules) == null ? void 0 : _a2.length) > 0) parent.rules = [];
            }
        });
        d.attributes.forEach((mutation)=>{
            var _a2;
            const target = mirror2.getNode(mutation.id);
            if (!target) {
                if (d.removes.find((r2)=>r2.id === mutation.id)) return;
                return this.warnNodeNotFound(d, mutation.id);
            }
            for(const attributeName in mutation.attributes)if (typeof attributeName === "string") {
                const value = mutation.attributes[attributeName];
                if (value === null) {
                    target.removeAttribute(attributeName);
                    if (attributeName === "open") $791ce2ee9eb5657b$var$removeDialogFromTopLevel(target, mutation);
                } else if (typeof value === "string") try {
                    if (attributeName === "_cssText" && (target.nodeName === "LINK" || target.nodeName === "STYLE")) try {
                        const newSn = mirror2.getMeta(target);
                        Object.assign(newSn.attributes, mutation.attributes);
                        const newNode = $791ce2ee9eb5657b$var$buildNodeWithSN(newSn, {
                            doc: target.ownerDocument,
                            // can be Document or RRDocument
                            mirror: mirror2,
                            skipChild: true,
                            hackCss: true,
                            cache: this.cache
                        });
                        const siblingNode = target.nextSibling;
                        const parentNode2 = target.parentNode;
                        if (newNode && parentNode2) {
                            parentNode2.removeChild(target);
                            parentNode2.insertBefore(newNode, siblingNode);
                            mirror2.replace(mutation.id, newNode);
                            break;
                        }
                    } catch (e2) {}
                    if (attributeName === "value" && target.nodeName === "TEXTAREA") {
                        const textarea = target;
                        textarea.childNodes.forEach((c2)=>textarea.removeChild(c2));
                        const tn = (_a2 = target.ownerDocument) == null ? void 0 : _a2.createTextNode(value);
                        if (tn) textarea.appendChild(tn);
                    } else target.setAttribute(attributeName, value);
                    if (attributeName === "rr_open_mode" && target.nodeName === "DIALOG") $791ce2ee9eb5657b$var$applyDialogToTopLevel(target, mutation);
                } catch (error) {
                    this.warn("An error occurred may due to the checkout feature.", error);
                }
                else if (attributeName === "style") {
                    const styleValues = value;
                    const targetEl = target;
                    for(const s2 in styleValues){
                        if (styleValues[s2] === false) targetEl.style.removeProperty(s2);
                        else if (styleValues[s2] instanceof Array) {
                            const svp = styleValues[s2];
                            targetEl.style.setProperty(s2, svp[0], svp[1]);
                        } else {
                            const svs = styleValues[s2];
                            targetEl.style.setProperty(s2, svs);
                        }
                    }
                }
            }
        });
    }
    /**
   * Apply the scroll data on real elements.
   * If the replayer is in sync mode, smooth scroll behavior should be disabled.
   * @param d - the scroll data
   * @param isSync - whether the replayer is in sync mode(fast-forward)
   */ applyScroll(d, isSync) {
        var _a2, _b;
        const target = this.mirror.getNode(d.id);
        if (!target) return this.debugNodeNotFound(d, d.id);
        const sn = this.mirror.getMeta(target);
        if (target === this.iframe.contentDocument) (_a2 = this.iframe.contentWindow) == null || _a2.scrollTo({
            top: d.y,
            left: d.x,
            behavior: isSync ? "auto" : "smooth"
        });
        else if ((sn == null ? void 0 : sn.type) === $791ce2ee9eb5657b$var$NodeType.Document) (_b = target.defaultView) == null || _b.scrollTo({
            top: d.y,
            left: d.x,
            behavior: isSync ? "auto" : "smooth"
        });
        else try {
            target.scrollTo({
                top: d.y,
                left: d.x,
                behavior: isSync ? "auto" : "smooth"
            });
        } catch (error) {}
    }
    applyInput(d) {
        const target = this.mirror.getNode(d.id);
        if (!target) return this.debugNodeNotFound(d, d.id);
        try {
            target.checked = d.isChecked;
            target.value = d.text;
        } catch (error) {}
    }
    applySelection(d) {
        try {
            const selectionSet = /* @__PURE__ */ new Set();
            const ranges = d.ranges.map(({ start: start, startOffset: startOffset, end: end, endOffset: endOffset })=>{
                const startContainer = this.mirror.getNode(start);
                const endContainer = this.mirror.getNode(end);
                if (!startContainer || !endContainer) return;
                const result2 = new Range();
                result2.setStart(startContainer, startOffset);
                result2.setEnd(endContainer, endOffset);
                const doc = startContainer.ownerDocument;
                const selection = doc == null ? void 0 : doc.getSelection();
                selection && selectionSet.add(selection);
                return {
                    range: result2,
                    selection: selection
                };
            });
            selectionSet.forEach((s2)=>s2.removeAllRanges());
            ranges.forEach((r2)=>{
                var _a2;
                return r2 && ((_a2 = r2.selection) == null ? void 0 : _a2.addRange(r2.range));
            });
        } catch (error) {}
    }
    applyStyleSheetMutation(data) {
        var _a2;
        let styleSheet = null;
        if (data.styleId) styleSheet = this.styleMirror.getStyle(data.styleId);
        else if (data.id) styleSheet = ((_a2 = this.mirror.getNode(data.id)) == null ? void 0 : _a2.sheet) || null;
        if (!styleSheet) return;
        if (data.source === $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.StyleSheetRule) this.applyStyleSheetRule(data, styleSheet);
        else if (data.source === $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.StyleDeclaration) this.applyStyleDeclaration(data, styleSheet);
    }
    applyStyleSheetRule(data, styleSheet) {
        var _a2, _b, _c, _d;
        (_a2 = data.adds) == null || _a2.forEach(({ rule: rule2, index: nestedIndex })=>{
            try {
                if (Array.isArray(nestedIndex)) {
                    const { positions: positions, index: index2 } = $791ce2ee9eb5657b$var$getPositionsAndIndex(nestedIndex);
                    const nestedRule = $791ce2ee9eb5657b$var$getNestedRule(styleSheet.cssRules, positions);
                    nestedRule.insertRule(rule2, index2);
                } else {
                    const index2 = nestedIndex === void 0 ? void 0 : Math.min(nestedIndex, styleSheet.cssRules.length);
                    styleSheet == null || styleSheet.insertRule(rule2, index2);
                }
            } catch (e2) {}
        });
        (_b = data.removes) == null || _b.forEach(({ index: nestedIndex })=>{
            try {
                if (Array.isArray(nestedIndex)) {
                    const { positions: positions, index: index2 } = $791ce2ee9eb5657b$var$getPositionsAndIndex(nestedIndex);
                    const nestedRule = $791ce2ee9eb5657b$var$getNestedRule(styleSheet.cssRules, positions);
                    nestedRule.deleteRule(index2 || 0);
                } else styleSheet == null || styleSheet.deleteRule(nestedIndex);
            } catch (e2) {}
        });
        if (data.replace) try {
            (_c = styleSheet.replace) == null || _c.call(styleSheet, data.replace);
        } catch (e2) {}
        if (data.replaceSync) try {
            (_d = styleSheet.replaceSync) == null || _d.call(styleSheet, data.replaceSync);
        } catch (e2) {}
    }
    applyStyleDeclaration(data, styleSheet) {
        if (data.set) {
            const rule2 = $791ce2ee9eb5657b$var$getNestedRule(styleSheet.rules, data.index);
            rule2.style.setProperty(data.set.property, data.set.value, data.set.priority);
        }
        if (data.remove) {
            const rule2 = $791ce2ee9eb5657b$var$getNestedRule(styleSheet.rules, data.index);
            rule2.style.removeProperty(data.remove.property);
        }
    }
    applyAdoptedStyleSheet(data) {
        var _a2;
        const targetHost = this.mirror.getNode(data.id);
        if (!targetHost) return;
        (_a2 = data.styles) == null || _a2.forEach((style)=>{
            var _a3;
            let newStyleSheet = null;
            let hostWindow = null;
            if ($791ce2ee9eb5657b$var$hasShadowRoot(targetHost)) hostWindow = ((_a3 = targetHost.ownerDocument) == null ? void 0 : _a3.defaultView) || null;
            else if (targetHost.nodeName === "#document") hostWindow = targetHost.defaultView;
            if (!hostWindow) return;
            try {
                newStyleSheet = new hostWindow.CSSStyleSheet();
                this.styleMirror.add(newStyleSheet, style.styleId);
                this.applyStyleSheetRule({
                    source: $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.StyleSheetRule,
                    adds: style.rules
                }, newStyleSheet);
            } catch (e2) {}
        });
        const MAX_RETRY_TIME = 10;
        let count = 0;
        const adoptStyleSheets = (targetHost2, styleIds)=>{
            const stylesToAdopt = styleIds.map((styleId)=>this.styleMirror.getStyle(styleId)).filter((style)=>style !== null);
            if ($791ce2ee9eb5657b$var$hasShadowRoot(targetHost2)) targetHost2.shadowRoot.adoptedStyleSheets = stylesToAdopt;
            else if (targetHost2.nodeName === "#document") targetHost2.adoptedStyleSheets = stylesToAdopt;
            if (stylesToAdopt.length !== styleIds.length && count < MAX_RETRY_TIME) {
                setTimeout(()=>adoptStyleSheets(targetHost2, styleIds), 0 + 100 * count);
                count++;
            }
        };
        adoptStyleSheets(targetHost, data.styleIds);
    }
    legacy_resolveMissingNode(map, parent, target, targetMutation) {
        const { previousId: previousId, nextId: nextId } = targetMutation;
        const previousInMap = previousId && map[previousId];
        const nextInMap = nextId && map[nextId];
        if (previousInMap) {
            const { node: node2, mutation: mutation } = previousInMap;
            parent.insertBefore(node2, target);
            delete map[mutation.node.id];
            delete this.legacy_missingNodeRetryMap[mutation.node.id];
            if (mutation.previousId || mutation.nextId) this.legacy_resolveMissingNode(map, parent, node2, mutation);
        }
        if (nextInMap) {
            const { node: node2, mutation: mutation } = nextInMap;
            parent.insertBefore(node2, target.nextSibling);
            delete map[mutation.node.id];
            delete this.legacy_missingNodeRetryMap[mutation.node.id];
            if (mutation.previousId || mutation.nextId) this.legacy_resolveMissingNode(map, parent, node2, mutation);
        }
    }
    moveAndHover(x2, y, id, isSync, debugData) {
        const target = this.mirror.getNode(id);
        if (!target) return this.debugNodeNotFound(debugData, id);
        const base = $791ce2ee9eb5657b$var$getBaseDimension(target, this.iframe);
        const _x = x2 * base.absoluteScale + base.x;
        const _y = y * base.absoluteScale + base.y;
        this.mouse.style.left = `${_x}px`;
        this.mouse.style.top = `${_y}px`;
        if (!isSync) this.drawMouseTail({
            x: _x,
            y: _y
        });
        this.hoverElements(target);
    }
    drawMouseTail(position) {
        if (!this.mouseTail) return;
        const { lineCap: lineCap, lineWidth: lineWidth, strokeStyle: strokeStyle, duration: duration } = this.config.mouseTail === true ? $791ce2ee9eb5657b$var$defaultMouseTailConfig : Object.assign({}, $791ce2ee9eb5657b$var$defaultMouseTailConfig, this.config.mouseTail);
        const draw = ()=>{
            if (!this.mouseTail) return;
            const ctx = this.mouseTail.getContext("2d");
            if (!ctx || !this.tailPositions.length) return;
            ctx.clearRect(0, 0, this.mouseTail.width, this.mouseTail.height);
            ctx.beginPath();
            ctx.lineWidth = lineWidth;
            ctx.lineCap = lineCap;
            ctx.strokeStyle = strokeStyle;
            ctx.moveTo(this.tailPositions[0].x, this.tailPositions[0].y);
            this.tailPositions.forEach((p)=>ctx.lineTo(p.x, p.y));
            ctx.stroke();
        };
        this.tailPositions.push(position);
        draw();
        setTimeout(()=>{
            this.tailPositions = this.tailPositions.filter((p)=>p !== position);
            draw();
        }, duration / this.speedService.state.context.timer.speed);
    }
    hoverElements(el) {
        var _a2;
        (_a2 = this.lastHoveredRootNode || this.iframe.contentDocument) == null || _a2.querySelectorAll(".\\:hover").forEach((hoveredEl)=>{
            hoveredEl.classList.remove(":hover");
        });
        this.lastHoveredRootNode = el.getRootNode();
        let currentEl = el;
        while(currentEl){
            if (currentEl.classList) currentEl.classList.add(":hover");
            currentEl = currentEl.parentElement;
        }
    }
    isUserInteraction(event) {
        if (event.type !== $791ce2ee9eb5657b$export$3d7865934588d77e.IncrementalSnapshot) return false;
        return event.data.source > $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Mutation && event.data.source <= $791ce2ee9eb5657b$export$24bb3ebc067ff5e1.Input;
    }
    backToNormal() {
        this.nextUserInteractionEvent = null;
        if (this.speedService.state.matches("normal")) return;
        this.speedService.send({
            type: "BACK_TO_NORMAL"
        });
        this.emitter.emit($791ce2ee9eb5657b$export$7b5ca317a0cad55c.SkipEnd, {
            speed: this.speedService.state.context.normalSpeed
        });
    }
    warnNodeNotFound(d, id) {
        this.warn(`Node with id '${id}' not found. `, d);
    }
    warnCanvasMutationFailed(d, error) {
        this.warn(`Has error on canvas update`, error, "canvas mutation:", d);
    }
    debugNodeNotFound(d, id) {
        this.debug(`Node with id '${id}' not found. `, d);
    }
    warn(...args) {
        if (!this.config.showWarning) return;
        this.config.logger.warn($791ce2ee9eb5657b$var$REPLAY_CONSOLE_PREFIX, ...args);
    }
    debug(...args) {
        if (!this.config.showDebug) return;
        this.config.logger.log($791ce2ee9eb5657b$var$REPLAY_CONSOLE_PREFIX, ...args);
    }
}
const { addCustomEvent: $791ce2ee9eb5657b$export$b815c10346cf8fa7 } = $791ce2ee9eb5657b$export$e5185e241753e543;
const { freezePage: $791ce2ee9eb5657b$export$a0cad6c9f92aaafa } = $791ce2ee9eb5657b$export$e5185e241753e543;
const { takeFullSnapshot: $791ce2ee9eb5657b$export$c3be3e220a841d68 } = $791ce2ee9eb5657b$export$e5185e241753e543;

});

parcelRegister("eZeQJ", function(module, exports) {

$parcel$export(module.exports, "createSessionReplayJoinedConfigGenerator", () => $ae924802a37aa8d6$export$2661437740ffd25e);

var $3VFsf = parcelRequire("3VFsf");

var $1cksA = parcelRequire("1cksA");

var $6Wtbz = parcelRequire("6Wtbz");

var $lu7yz = parcelRequire("lu7yz");
var $ae924802a37aa8d6$export$1259d32da3a75f6c = function(privacyConfig, loggerProvider) {
    // This allows us to not search the DOM.
    var fragment = document.createDocumentFragment();
    var dropInvalidSelectors = function(selectors) {
        if (selectors === void 0) selectors = [];
        if (typeof selectors === 'string') selectors = [
            selectors
        ];
        selectors = selectors.filter(function(selector) {
            try {
                fragment.querySelector(selector);
            } catch (_a) {
                loggerProvider.warn("[session-replay-browser] omitting selector \"".concat(selector, "\" because it is invalid"));
                return false;
            }
            return true;
        });
        if (selectors.length === 0) return undefined;
        return selectors;
    };
    privacyConfig.blockSelector = dropInvalidSelectors(privacyConfig.blockSelector);
    privacyConfig.maskSelector = dropInvalidSelectors(privacyConfig.maskSelector);
    privacyConfig.unmaskSelector = dropInvalidSelectors(privacyConfig.unmaskSelector);
    return privacyConfig;
};
var $ae924802a37aa8d6$export$910f854ed53f727f = /** @class */ function() {
    function SessionReplayJoinedConfigGenerator(remoteConfigFetch, localConfig) {
        this.localConfig = localConfig;
        this.remoteConfigFetch = remoteConfigFetch;
    }
    SessionReplayJoinedConfigGenerator.prototype.generateJoinedConfig = function(sessionId) {
        var _a, _b, _c;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var config, remoteConfig, samplingConfig_1, privacyConfig, _d, _e, err_1, knownError, samplingConfig, remotePrivacyConfig, localPrivacyConfig, joinedPrivacyConfig, privacyConfigSelectorMap, selectorMap, _f, _g, _h, selector, selectorType;
            var e_1, _j;
            return (0, $3VFsf.__generator)(this, function(_k) {
                switch(_k.label){
                    case 0:
                        config = (0, $3VFsf.__assign)({}, this.localConfig);
                        // Special case here as optOut is implemented via getter/setter
                        config.optOut = this.localConfig.optOut;
                        // We always want captureEnabled to be true, unless there's an override
                        // in the remote config.
                        config.captureEnabled = true;
                        _k.label = 1;
                    case 1:
                        _k.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.remoteConfigFetch.getRemoteConfig('sessionReplay', 'sr_sampling_config', sessionId)
                        ];
                    case 2:
                        samplingConfig_1 = _k.sent();
                        return [
                            4 /*yield*/ ,
                            this.remoteConfigFetch.getRemoteConfig('sessionReplay', 'sr_privacy_config', sessionId)
                        ];
                    case 3:
                        privacyConfig = _k.sent();
                        // This is intentionally forced to only be set through the remote config.
                        _d = config;
                        return [
                            4 /*yield*/ ,
                            this.remoteConfigFetch.getRemoteConfig('sessionReplay', 'sr_interaction_config', sessionId)
                        ];
                    case 4:
                        // This is intentionally forced to only be set through the remote config.
                        _d.interactionConfig = _k.sent();
                        // This is intentionally forced to only be set through the remote config.
                        _e = config;
                        return [
                            4 /*yield*/ ,
                            this.remoteConfigFetch.getRemoteConfig('sessionReplay', 'sr_logging_config', sessionId)
                        ];
                    case 5:
                        // This is intentionally forced to only be set through the remote config.
                        _e.loggingConfig = _k.sent();
                        if (samplingConfig_1 || privacyConfig) {
                            remoteConfig = {};
                            if (samplingConfig_1) remoteConfig.sr_sampling_config = samplingConfig_1;
                            if (privacyConfig) remoteConfig.sr_privacy_config = privacyConfig;
                        }
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        err_1 = _k.sent();
                        knownError = err_1;
                        this.localConfig.loggerProvider.warn(knownError.message);
                        config.captureEnabled = false;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        if (!remoteConfig) return [
                            2 /*return*/ ,
                            config
                        ];
                        samplingConfig = remoteConfig.sr_sampling_config, remotePrivacyConfig = remoteConfig.sr_privacy_config;
                        if (samplingConfig && Object.keys(samplingConfig).length > 0) {
                            if (Object.prototype.hasOwnProperty.call(samplingConfig, 'capture_enabled')) config.captureEnabled = samplingConfig.capture_enabled;
                            else config.captureEnabled = false;
                            if (Object.prototype.hasOwnProperty.call(samplingConfig, 'sample_rate')) config.sampleRate = samplingConfig.sample_rate;
                        } else {
                            // If config API response was valid (ie 200), but no config returned, assume that
                            // customer has not yet set up config, and use sample rate from SDK options,
                            // allowing for immediate replay capture
                            config.captureEnabled = true;
                            this.localConfig.loggerProvider.debug('Remote config successfully fetched, but no values set for project, Session Replay capture enabled.');
                        }
                        // Remote config join acts somewhat like a left join between the remote and the local
                        // config. That is, remote config has precedence over local values as with sampling.
                        // However, non conflicting values will be added to the lists.
                        // Here's an example to illustrate:
                        //
                        // Remote config:   {'.selector1': 'MASK',   '.selector2': 'UNMASK'}
                        // Local config:    {'.selector1': 'UNMASK',                         '.selector3': 'MASK'}
                        //
                        // Resolved config: {'.selector1': 'MASK',   '.selector2': 'UNMASK', '.selector3': 'MASK'}
                        // config.privacyConfig = {
                        //   ...(config.privacyConfig ?? {}),
                        //   ...remotePrivacyConfig,
                        // };
                        if (remotePrivacyConfig) {
                            localPrivacyConfig = (_a = config.privacyConfig) !== null && _a !== void 0 ? _a : {};
                            joinedPrivacyConfig = {
                                defaultMaskLevel: (_c = (_b = remotePrivacyConfig.defaultMaskLevel) !== null && _b !== void 0 ? _b : localPrivacyConfig.defaultMaskLevel) !== null && _c !== void 0 ? _c : 'medium',
                                blockSelector: [],
                                maskSelector: [],
                                unmaskSelector: []
                            };
                            privacyConfigSelectorMap = function(privacyConfig) {
                                var e_2, _a, e_3, _b, e_4, _c;
                                var _d, _e, _f;
                                var selectorMap = {};
                                if (typeof privacyConfig.blockSelector === 'string') privacyConfig.blockSelector = [
                                    privacyConfig.blockSelector
                                ];
                                try {
                                    for(var _g = (0, $3VFsf.__values)((_d = privacyConfig.blockSelector) !== null && _d !== void 0 ? _d : []), _h = _g.next(); !_h.done; _h = _g.next()){
                                        var selector = _h.value;
                                        selectorMap[selector] = 'block';
                                    }
                                } catch (e_2_1) {
                                    e_2 = {
                                        error: e_2_1
                                    };
                                } finally{
                                    try {
                                        if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
                                    } finally{
                                        if (e_2) throw e_2.error;
                                    }
                                }
                                try {
                                    for(var _j = (0, $3VFsf.__values)((_e = privacyConfig.maskSelector) !== null && _e !== void 0 ? _e : []), _k = _j.next(); !_k.done; _k = _j.next()){
                                        var selector = _k.value;
                                        selectorMap[selector] = 'mask';
                                    }
                                } catch (e_3_1) {
                                    e_3 = {
                                        error: e_3_1
                                    };
                                } finally{
                                    try {
                                        if (_k && !_k.done && (_b = _j.return)) _b.call(_j);
                                    } finally{
                                        if (e_3) throw e_3.error;
                                    }
                                }
                                try {
                                    for(var _l = (0, $3VFsf.__values)((_f = privacyConfig.unmaskSelector) !== null && _f !== void 0 ? _f : []), _m = _l.next(); !_m.done; _m = _l.next()){
                                        var selector = _m.value;
                                        selectorMap[selector] = 'unmask';
                                    }
                                } catch (e_4_1) {
                                    e_4 = {
                                        error: e_4_1
                                    };
                                } finally{
                                    try {
                                        if (_m && !_m.done && (_c = _l.return)) _c.call(_l);
                                    } finally{
                                        if (e_4) throw e_4.error;
                                    }
                                }
                                return selectorMap;
                            };
                            selectorMap = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, privacyConfigSelectorMap(localPrivacyConfig)), privacyConfigSelectorMap(remotePrivacyConfig));
                            try {
                                for(_f = (0, $3VFsf.__values)(Object.entries(selectorMap)), _g = _f.next(); !_g.done; _g = _f.next()){
                                    _h = (0, $3VFsf.__read)(_g.value, 2), selector = _h[0], selectorType = _h[1];
                                    if (selectorType === 'mask') joinedPrivacyConfig.maskSelector.push(selector);
                                    else if (selectorType === 'block') joinedPrivacyConfig.blockSelector.push(selector);
                                    else if (selectorType === 'unmask') joinedPrivacyConfig.unmaskSelector.push(selector);
                                }
                            } catch (e_1_1) {
                                e_1 = {
                                    error: e_1_1
                                };
                            } finally{
                                try {
                                    if (_g && !_g.done && (_j = _f.return)) _j.call(_f);
                                } finally{
                                    if (e_1) throw e_1.error;
                                }
                            }
                            config.privacyConfig = $ae924802a37aa8d6$export$1259d32da3a75f6c(joinedPrivacyConfig, this.localConfig.loggerProvider);
                        }
                        this.localConfig.loggerProvider.debug(JSON.stringify({
                            name: 'session replay joined config',
                            config: (0, $6Wtbz.getDebugConfig)(config)
                        }, null, 2));
                        return [
                            2 /*return*/ ,
                            config
                        ];
                }
            });
        });
    };
    return SessionReplayJoinedConfigGenerator;
}();
var $ae924802a37aa8d6$export$2661437740ffd25e = function(apiKey, options) {
    return (0, $3VFsf.__awaiter)(void 0, void 0, void 0, function() {
        var localConfig, remoteConfigFetch;
        return (0, $3VFsf.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    localConfig = new (0, $lu7yz.SessionReplayLocalConfig)(apiKey, options);
                    return [
                        4 /*yield*/ ,
                        (0, $1cksA.createRemoteConfigFetch)({
                            localConfig: localConfig,
                            configKeys: [
                                'sessionReplay'
                            ]
                        })
                    ];
                case 1:
                    remoteConfigFetch = _a.sent();
                    return [
                        2 /*return*/ ,
                        new $ae924802a37aa8d6$export$910f854ed53f727f(remoteConfigFetch, localConfig)
                    ];
            }
        });
    });
};

});
parcelRegister("1cksA", function(module, exports) {

$parcel$export(module.exports, "createRemoteConfigFetch", () => $0df6c863a80fc042$export$7a3c00b7d3a9d561);

var $6qxbD = parcelRequire("6qxbD");
var $0df6c863a80fc042$export$7a3c00b7d3a9d561 = $6qxbD.createRemoteConfigFetch;

});
parcelRegister("6qxbD", function(module, exports) {

$parcel$export(module.exports, "createRemoteConfigFetch", () => $4adee9fd40d8a2d0$export$7a3c00b7d3a9d561);

var $3VFsf = parcelRequire("3VFsf");

var $jGwM5 = parcelRequire("jGwM5");

var $bLS3S = parcelRequire("bLS3S");
var $4TbHg = parcelRequire("4TbHg");
var $4adee9fd40d8a2d0$var$UNEXPECTED_NETWORK_ERROR_MESSAGE = 'Network error occurred, remote config fetch failed';
var $4adee9fd40d8a2d0$var$SUCCESS_REMOTE_CONFIG = 'Remote config successfully fetched';
var $4adee9fd40d8a2d0$var$MAX_RETRIES_EXCEEDED_MESSAGE = 'Remote config fetch rejected due to exceeded retry count';
var $4adee9fd40d8a2d0$var$TIMEOUT_MESSAGE = 'Remote config fetch rejected due to timeout after 5 seconds';
var $4adee9fd40d8a2d0$var$UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
var $4adee9fd40d8a2d0$export$f176a68f93d1169b = 'https://sr-client-cfg.amplitude.com/config';
var $4adee9fd40d8a2d0$export$557cb299ba3f9edf = 'https://sr-client-cfg.stag2.amplitude.com/config';
var $4adee9fd40d8a2d0$export$4e157f75ce52a111 = 'https://sr-client-cfg.eu.amplitude.com/config';
var $4adee9fd40d8a2d0$export$91805d21bf5f9610 = /** @class */ function() {
    function RemoteConfigFetch(_a) {
        var localConfig = _a.localConfig, configKeys = _a.configKeys;
        var _this = this;
        this.retryTimeout = 1000;
        this.attempts = 0;
        this.sessionTargetingMatch = false;
        this.metrics = {};
        this.getRemoteConfig = function(configNamespace, key, sessionId) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var fetchStartTime, configAPIResponse, remoteConfig;
                return (0, $3VFsf.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            fetchStartTime = Date.now();
                            return [
                                4 /*yield*/ ,
                                this.fetchWithTimeout(sessionId)
                            ];
                        case 1:
                            configAPIResponse = _a.sent();
                            if (configAPIResponse) {
                                remoteConfig = configAPIResponse.configs && configAPIResponse.configs[configNamespace];
                                if (remoteConfig) {
                                    this.metrics.fetchTimeAPISuccess = Date.now() - fetchStartTime;
                                    return [
                                        2 /*return*/ ,
                                        remoteConfig[key]
                                    ];
                                }
                            }
                            this.metrics.fetchTimeAPIFail = Date.now() - fetchStartTime;
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                    }
                });
            });
        };
        this.fetchWithTimeout = function(sessionId) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var controller, timeoutId, remoteConfig;
                return (0, $3VFsf.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            controller = new AbortController();
                            timeoutId = setTimeout(function() {
                                return controller.abort();
                            }, 5000);
                            return [
                                4 /*yield*/ ,
                                this.fetchRemoteConfig(controller.signal, sessionId)
                            ];
                        case 1:
                            remoteConfig = _a.sent();
                            clearTimeout(timeoutId);
                            return [
                                2 /*return*/ ,
                                remoteConfig
                            ];
                    }
                });
            });
        };
        this.fetchRemoteConfig = function(signal, sessionId) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var urlParams, _a, _b, configKey, options, serverUrl, res, parsedStatus, e_1, knownError;
                var e_2, _c;
                var _d;
                return (0, $3VFsf.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            if (sessionId === this.lastFetchedSessionId && this.attempts >= this.localConfig.flushMaxRetries) return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: $4adee9fd40d8a2d0$var$MAX_RETRIES_EXCEEDED_MESSAGE
                                })
                            ];
                            else if (signal.aborted) return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: $4adee9fd40d8a2d0$var$TIMEOUT_MESSAGE
                                })
                            ];
                            else if (sessionId !== this.lastFetchedSessionId) {
                                this.lastFetchedSessionId = sessionId;
                                this.attempts = 0;
                            }
                            _e.label = 1;
                        case 1:
                            _e.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            urlParams = new URLSearchParams({
                                api_key: this.localConfig.apiKey
                            });
                            try {
                                for(_a = (0, $3VFsf.__values)(this.configKeys), _b = _a.next(); !_b.done; _b = _a.next()){
                                    configKey = _b.value;
                                    urlParams.append('config_keys', configKey);
                                }
                            } catch (e_2_1) {
                                e_2 = {
                                    error: e_2_1
                                };
                            } finally{
                                try {
                                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                                } finally{
                                    if (e_2) throw e_2.error;
                                }
                            }
                            if (sessionId) urlParams.set('session_id', String(sessionId));
                            options = {
                                headers: {
                                    Accept: '*/*'
                                },
                                method: 'GET'
                            };
                            serverUrl = "".concat(this.getServerUrl(), "?").concat(urlParams.toString());
                            this.attempts += 1;
                            return [
                                4 /*yield*/ ,
                                fetch(serverUrl, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
                                    signal: signal
                                }))
                            ];
                        case 2:
                            res = _e.sent();
                            if (res === null) return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: $4adee9fd40d8a2d0$var$UNEXPECTED_ERROR_MESSAGE
                                })
                            ];
                            parsedStatus = new (0, $jGwM5.BaseTransport)().buildStatus(res.status);
                            switch(parsedStatus){
                                case (0, $4TbHg.Status).Success:
                                    this.attempts = 0;
                                    return [
                                        2 /*return*/ ,
                                        this.parseAndStoreConfig(res)
                                    ];
                                case (0, $4TbHg.Status).Failed:
                                    return [
                                        2 /*return*/ ,
                                        this.retryFetch(signal, sessionId)
                                    ];
                                default:
                                    return [
                                        2 /*return*/ ,
                                        this.completeRequest({
                                            err: $4adee9fd40d8a2d0$var$UNEXPECTED_NETWORK_ERROR_MESSAGE
                                        })
                                    ];
                            }
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            e_1 = _e.sent();
                            knownError = e_1;
                            if (signal.aborted) return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: $4adee9fd40d8a2d0$var$TIMEOUT_MESSAGE
                                })
                            ];
                            return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: (_d = knownError.message) !== null && _d !== void 0 ? _d : $4adee9fd40d8a2d0$var$UNEXPECTED_ERROR_MESSAGE
                                })
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.retryFetch = function(signal, sessionId) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, $3VFsf.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve) {
                                    return setTimeout(resolve, _this.attempts * _this.retryTimeout);
                                })
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ ,
                                this.fetchRemoteConfig(signal, sessionId)
                            ];
                    }
                });
            });
        };
        this.parseAndStoreConfig = function(res) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var remoteConfig;
                return (0, $3VFsf.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                res.json()
                            ];
                        case 1:
                            remoteConfig = _a.sent();
                            this.completeRequest({
                                success: $4adee9fd40d8a2d0$var$SUCCESS_REMOTE_CONFIG
                            });
                            return [
                                2 /*return*/ ,
                                remoteConfig
                            ];
                    }
                });
            });
        };
        this.localConfig = localConfig;
        this.configKeys = configKeys;
    }
    RemoteConfigFetch.prototype.getServerUrl = function() {
        if (this.localConfig.configServerUrl) return this.localConfig.configServerUrl;
        if (this.localConfig.serverZone === (0, $bLS3S.ServerZone).STAGING) return $4adee9fd40d8a2d0$export$557cb299ba3f9edf;
        if (this.localConfig.serverZone === (0, $bLS3S.ServerZone).EU) return $4adee9fd40d8a2d0$export$4e157f75ce52a111;
        return $4adee9fd40d8a2d0$export$f176a68f93d1169b;
    };
    RemoteConfigFetch.prototype.completeRequest = function(_a) {
        var err = _a.err, success = _a.success;
        if (err) throw new Error(err);
        else if (success) this.localConfig.loggerProvider.log(success);
    };
    return RemoteConfigFetch;
}();
var $4adee9fd40d8a2d0$export$7a3c00b7d3a9d561 = function(_a) {
    var localConfig = _a.localConfig, configKeys = _a.configKeys;
    return (0, $3VFsf.__awaiter)(void 0, void 0, void 0, function() {
        return (0, $3VFsf.__generator)(this, function(_b) {
            return [
                2 /*return*/ ,
                new $4adee9fd40d8a2d0$export$91805d21bf5f9610({
                    localConfig: localConfig,
                    configKeys: configKeys
                })
            ];
        });
    });
};

});
parcelRegister("jGwM5", function(module, exports) {

$parcel$export(module.exports, "BaseTransport", () => $e54b5cefdf454844$export$74b99d619e90f481);
/* eslint-disable @typescript-eslint/no-unsafe-argument */ /* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-unsafe-call */ 
var $4TbHg = parcelRequire("4TbHg");
var $e54b5cefdf454844$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport() {}
    BaseTransport.prototype.send = function(_serverUrl, _payload) {
        return Promise.resolve(null);
    };
    BaseTransport.prototype.buildResponse = function(responseJSON) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        if (typeof responseJSON !== 'object') return null;
        var statusCode = responseJSON.code || 0;
        var status = this.buildStatus(statusCode);
        switch(status){
            case (0, $4TbHg.Status).Success:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        eventsIngested: (_a = responseJSON.events_ingested) !== null && _a !== void 0 ? _a : 0,
                        payloadSizeBytes: (_b = responseJSON.payload_size_bytes) !== null && _b !== void 0 ? _b : 0,
                        serverUploadTime: (_c = responseJSON.server_upload_time) !== null && _c !== void 0 ? _c : 0
                    }
                };
            case (0, $4TbHg.Status).Invalid:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_d = responseJSON.error) !== null && _d !== void 0 ? _d : '',
                        missingField: (_e = responseJSON.missing_field) !== null && _e !== void 0 ? _e : '',
                        eventsWithInvalidFields: (_f = responseJSON.events_with_invalid_fields) !== null && _f !== void 0 ? _f : {},
                        eventsWithMissingFields: (_g = responseJSON.events_with_missing_fields) !== null && _g !== void 0 ? _g : {},
                        eventsWithInvalidIdLengths: (_h = responseJSON.events_with_invalid_id_lengths) !== null && _h !== void 0 ? _h : {},
                        epsThreshold: (_j = responseJSON.eps_threshold) !== null && _j !== void 0 ? _j : 0,
                        exceededDailyQuotaDevices: (_k = responseJSON.exceeded_daily_quota_devices) !== null && _k !== void 0 ? _k : {},
                        silencedDevices: (_l = responseJSON.silenced_devices) !== null && _l !== void 0 ? _l : [],
                        silencedEvents: (_m = responseJSON.silenced_events) !== null && _m !== void 0 ? _m : [],
                        throttledDevices: (_o = responseJSON.throttled_devices) !== null && _o !== void 0 ? _o : {},
                        throttledEvents: (_p = responseJSON.throttled_events) !== null && _p !== void 0 ? _p : []
                    }
                };
            case (0, $4TbHg.Status).PayloadTooLarge:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_q = responseJSON.error) !== null && _q !== void 0 ? _q : ''
                    }
                };
            case (0, $4TbHg.Status).RateLimit:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_r = responseJSON.error) !== null && _r !== void 0 ? _r : '',
                        epsThreshold: (_s = responseJSON.eps_threshold) !== null && _s !== void 0 ? _s : 0,
                        throttledDevices: (_t = responseJSON.throttled_devices) !== null && _t !== void 0 ? _t : {},
                        throttledUsers: (_u = responseJSON.throttled_users) !== null && _u !== void 0 ? _u : {},
                        exceededDailyQuotaDevices: (_v = responseJSON.exceeded_daily_quota_devices) !== null && _v !== void 0 ? _v : {},
                        exceededDailyQuotaUsers: (_w = responseJSON.exceeded_daily_quota_users) !== null && _w !== void 0 ? _w : {},
                        throttledEvents: (_x = responseJSON.throttled_events) !== null && _x !== void 0 ? _x : []
                    }
                };
            case (0, $4TbHg.Status).Timeout:
            default:
                return {
                    status: status,
                    statusCode: statusCode
                };
        }
    };
    BaseTransport.prototype.buildStatus = function(code) {
        if (code >= 200 && code < 300) return (0, $4TbHg.Status).Success;
        if (code === 429) return (0, $4TbHg.Status).RateLimit;
        if (code === 413) return (0, $4TbHg.Status).PayloadTooLarge;
        if (code === 408) return (0, $4TbHg.Status).Timeout;
        if (code >= 400 && code < 500) return (0, $4TbHg.Status).Invalid;
        if (code >= 500) return (0, $4TbHg.Status).Failed;
        return (0, $4TbHg.Status).Unknown;
    };
    return BaseTransport;
}();

});
parcelRegister("4TbHg", function(module, exports) {

$parcel$export(module.exports, "Status", () => $38f55f384e8db0bb$export$96e9906d6d93a972);
/** The status of an event. */ var $38f55f384e8db0bb$export$96e9906d6d93a972;
(function(Status) {
    /** The status could not be determined. */ Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */ Status["Skipped"] = "skipped";
    /** The event was sent successfully. */ Status["Success"] = "success";
    /** A user or device in the payload is currently rate limited and should try again later. */ Status["RateLimit"] = "rate_limit";
    /** The sent payload was too large to be processed. */ Status["PayloadTooLarge"] = "payload_too_large";
    /** The event could not be processed. */ Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */ Status["Failed"] = "failed";
    /** a server or client side error occuring when a request takes too long and is cancelled */ Status["Timeout"] = "Timeout";
    /** NodeJS runtime environment error.. E.g. disconnected from network */ Status["SystemError"] = "SystemError";
})($38f55f384e8db0bb$export$96e9906d6d93a972 || ($38f55f384e8db0bb$export$96e9906d6d93a972 = {}));

});


parcelRegister("bLS3S", function(module, exports) {

$parcel$export(module.exports, "ServerZone", () => $891e04fdffa44f02$export$df0bb87b763999e2);
var $891e04fdffa44f02$export$df0bb87b763999e2;
(function(ServerZone) {
    ServerZone["US"] = "US";
    ServerZone["EU"] = "EU";
    ServerZone["STAGING"] = "STAGING";
})($891e04fdffa44f02$export$df0bb87b763999e2 || ($891e04fdffa44f02$export$df0bb87b763999e2 = {}));

});



parcelRegister("6Wtbz", function(module, exports) {

$parcel$export(module.exports, "maskFn", () => $50decc8340f74203$export$b50891354f8a5b50);
$parcel$export(module.exports, "generateHashCode", () => $50decc8340f74203$export$df97552b118e0edd);
$parcel$export(module.exports, "isSessionInSample", () => $50decc8340f74203$export$8724442f57e3b0e0);
$parcel$export(module.exports, "getCurrentUrl", () => $50decc8340f74203$export$dc90482e4ef07afd);
$parcel$export(module.exports, "generateSessionReplayId", () => $50decc8340f74203$export$957113276b7f5030);
$parcel$export(module.exports, "getServerUrl", () => $50decc8340f74203$export$3c14a5a58c5a65d4);
$parcel$export(module.exports, "getStorageSize", () => $50decc8340f74203$export$e5743f664113a9a2);
$parcel$export(module.exports, "getDebugConfig", () => $50decc8340f74203$export$9934ee945f5a74);

var $3VFsf = parcelRequire("3VFsf");

var $gOnHi = parcelRequire("gOnHi");
var $FRUho = parcelRequire("FRUho");

var $5m43j = parcelRequire("5m43j");

var $hT1mD = parcelRequire("hT1mD");

var $gPQg5 = parcelRequire("gPQg5");
/**
 * Light: Subset of inputs
 * Medium: All inputs
 * Conservative: All inputs and all texts
 */ var $50decc8340f74203$var$isMaskedForLevel = function(elementType, level, element) {
    switch(level){
        case 'light':
            if (elementType !== 'input') return true;
            var inputType = element ? (0, $5m43j.getInputType)(element) : '';
            /* istanbul ignore if */ // TODO(lew): For some reason it's impossible to test this.
            if (!inputType) return false;
            if ([
                'password',
                'hidden',
                'email',
                'tel'
            ].includes(inputType)) return true;
            if (element.autocomplete.startsWith('cc-')) return true;
            return false;
        case 'medium':
        case 'conservative':
            return true;
        default:
            return $50decc8340f74203$var$isMaskedForLevel(elementType, (0, $hT1mD.DEFAULT_MASK_LEVEL), element);
    }
};
/**
 * Checks if the given element set to be masked by rrweb
 *
 * Priority is:
 *  1. [In code] Element/class based masking/unmasking <> [Config based] Selector based masking/unmasking
 *  2. Use app defaults
 */ var $50decc8340f74203$var$isMasked = function(elementType, config, element) {
    var _a, _b, _c;
    if (config === void 0) config = {
        defaultMaskLevel: (0, $hT1mD.DEFAULT_MASK_LEVEL)
    };
    if (element) {
        // Element or parent is explicitly instrumented in code to mask
        if (element.closest('.' + (0, $gPQg5.MASK_TEXT_CLASS))) return true;
        // Config has override for mask
        var shouldMask = ((_a = config.maskSelector) !== null && _a !== void 0 ? _a : []).some(function(selector) {
            return element.closest(selector);
        });
        if (shouldMask) return true;
        // Code or config has override to unmask
        if (element.closest('.' + (0, $gPQg5.UNMASK_TEXT_CLASS))) return false;
        // Here we are probably sent an element, but we want to match if they have a
        // parent with an unmask selector.
        var shouldUnmask = ((_b = config.unmaskSelector) !== null && _b !== void 0 ? _b : []).some(function(selector) {
            return element.closest(selector);
        });
        if (shouldUnmask) return false;
    }
    return $50decc8340f74203$var$isMaskedForLevel(elementType, (_c = config.defaultMaskLevel) !== null && _c !== void 0 ? _c : (0, $hT1mD.DEFAULT_MASK_LEVEL), element);
};
var $50decc8340f74203$export$b50891354f8a5b50 = function(elementType, config) {
    return function(text, element) {
        return $50decc8340f74203$var$isMasked(elementType, config, element) ? text.replace(/[^\s]/g, '*') : text;
    };
};
var $50decc8340f74203$export$df97552b118e0edd = function(str) {
    var hash = 0;
    if (str.length === 0) return hash;
    for(var i = 0; i < str.length; i++){
        var chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return hash;
};
var $50decc8340f74203$export$8724442f57e3b0e0 = function(sessionId, sampleRate) {
    var hashNumber = $50decc8340f74203$export$df97552b118e0edd(sessionId.toString());
    var absHash = Math.abs(hashNumber);
    var absHashMultiply = absHash * 31;
    var mod = absHashMultiply % 1000000;
    return mod / 1000000 < sampleRate;
};
var $50decc8340f74203$export$dc90482e4ef07afd = function() {
    var globalScope = (0, $gOnHi.getGlobalScope)();
    return (globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) ? globalScope.location.href : '';
};
var $50decc8340f74203$export$957113276b7f5030 = function(sessionId, deviceId) {
    return "".concat(deviceId, "/").concat(sessionId);
};
var $50decc8340f74203$export$3c14a5a58c5a65d4 = function(serverZone, trackServerUrl) {
    if (trackServerUrl) return trackServerUrl;
    if (serverZone === (0, $FRUho.ServerZone).STAGING) return 0, $gPQg5.SESSION_REPLAY_STAGING_URL;
    if (serverZone === (0, $FRUho.ServerZone).EU) return 0, $gPQg5.SESSION_REPLAY_EU_URL;
    return 0, $gPQg5.SESSION_REPLAY_SERVER_URL;
};
var $50decc8340f74203$export$e5743f664113a9a2 = function() {
    return (0, $3VFsf.__awaiter)(void 0, void 0, void 0, function() {
        var globalScope, _a, usage, quota, usageDetails, totalStorageSize, percentOfQuota, e_1;
        return (0, $3VFsf.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    globalScope = (0, $gOnHi.getGlobalScope)();
                    if (!globalScope) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        globalScope.navigator.storage.estimate()
                    ];
                case 1:
                    _a = _b.sent(), usage = _a.usage, quota = _a.quota, usageDetails = _a.usageDetails;
                    totalStorageSize = usage ? Math.round(usage / (0, $gPQg5.KB_SIZE)) : 0;
                    percentOfQuota = usage && quota ? Math.round((usage / quota + Number.EPSILON) * 1000) / 1000 : 0;
                    return [
                        2 /*return*/ ,
                        {
                            totalStorageSize: totalStorageSize,
                            percentOfQuota: percentOfQuota,
                            usageDetails: JSON.stringify(usageDetails)
                        }
                    ];
                case 2:
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    e_1 = _b.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        {
                            totalStorageSize: 0,
                            percentOfQuota: 0,
                            usageDetails: ''
                        }
                    ];
            }
        });
    });
};
var $50decc8340f74203$export$9934ee945f5a74 = function(config) {
    var debugConfig = (0, $3VFsf.__assign)({}, config);
    var apiKey = debugConfig.apiKey;
    debugConfig.apiKey = "****".concat(apiKey.substring(apiKey.length - 4));
    return debugConfig;
};

});
parcelRegister("5m43j", function(module, exports) {

$parcel$export(module.exports, "getInputType", () => $3e622689738ca3a1$export$f531fc545c6b4728);

var $5k7LC = parcelRequire("5k7LC");
var $3e622689738ca3a1$require$Buffer = $5k7LC.Buffer;
var $3e622689738ca3a1$var$__defProp = Object.defineProperty;
var $3e622689738ca3a1$var$__defNormalProp = (obj, key, value)=>key in obj ? $3e622689738ca3a1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3e622689738ca3a1$var$__publicField = (obj, key, value)=>$3e622689738ca3a1$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $3e622689738ca3a1$var$NodeType = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($3e622689738ca3a1$var$NodeType || {});
const $3e622689738ca3a1$var$testableAccessors = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
const $3e622689738ca3a1$var$testableMethods = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
const $3e622689738ca3a1$var$untaintedBasePrototype = {};
const $3e622689738ca3a1$var$isAngularZonePresent = ()=>{
    return !!globalThis.Zone;
};
function $3e622689738ca3a1$var$getUntaintedPrototype(key) {
    if ($3e622689738ca3a1$var$untaintedBasePrototype[key]) return $3e622689738ca3a1$var$untaintedBasePrototype[key];
    const defaultObj = globalThis[key];
    const defaultPrototype = defaultObj.prototype;
    const accessorNames = key in $3e622689738ca3a1$var$testableAccessors ? $3e622689738ca3a1$var$testableAccessors[key] : void 0;
    const isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every((accessor)=>{
        var _a, _b;
        return Boolean((_b = (_a = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    const methodNames = key in $3e622689738ca3a1$var$testableMethods ? $3e622689738ca3a1$var$testableMethods[key] : void 0;
    const isUntaintedMethods = Boolean(methodNames && methodNames.every(// @ts-expect-error 2345
    (method)=>{
        var _a;
        return typeof defaultPrototype[method] === "function" && ((_a = defaultPrototype[method]) == null ? void 0 : _a.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods && !$3e622689738ca3a1$var$isAngularZonePresent()) {
        $3e622689738ca3a1$var$untaintedBasePrototype[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        const iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        const win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        const untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return $3e622689738ca3a1$var$untaintedBasePrototype[key] = untaintedObject;
    } catch  {
        return defaultPrototype;
    }
}
const $3e622689738ca3a1$var$untaintedAccessorCache = {};
function $3e622689738ca3a1$var$getUntaintedAccessor(key, instance, accessor) {
    var _a;
    const cacheKey = `${key}.${String(accessor)}`;
    if ($3e622689738ca3a1$var$untaintedAccessorCache[cacheKey]) return $3e622689738ca3a1$var$untaintedAccessorCache[cacheKey].call(instance);
    const untaintedPrototype = $3e622689738ca3a1$var$getUntaintedPrototype(key);
    const untaintedAccessor = (_a = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a.get;
    if (!untaintedAccessor) return instance[accessor];
    $3e622689738ca3a1$var$untaintedAccessorCache[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
const $3e622689738ca3a1$var$untaintedMethodCache = {};
function $3e622689738ca3a1$var$getUntaintedMethod(key, instance, method) {
    const cacheKey = `${key}.${String(method)}`;
    if ($3e622689738ca3a1$var$untaintedMethodCache[cacheKey]) return $3e622689738ca3a1$var$untaintedMethodCache[cacheKey].bind(instance);
    const untaintedPrototype = $3e622689738ca3a1$var$getUntaintedPrototype(key);
    const untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    $3e622689738ca3a1$var$untaintedMethodCache[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function $3e622689738ca3a1$var$childNodes(n) {
    return $3e622689738ca3a1$var$getUntaintedAccessor("Node", n, "childNodes");
}
function $3e622689738ca3a1$var$parentNode(n) {
    return $3e622689738ca3a1$var$getUntaintedAccessor("Node", n, "parentNode");
}
function $3e622689738ca3a1$var$parentElement(n) {
    return $3e622689738ca3a1$var$getUntaintedAccessor("Node", n, "parentElement");
}
function $3e622689738ca3a1$var$textContent(n) {
    return $3e622689738ca3a1$var$getUntaintedAccessor("Node", n, "textContent");
}
function $3e622689738ca3a1$var$contains(n, other) {
    return $3e622689738ca3a1$var$getUntaintedMethod("Node", n, "contains")(other);
}
function $3e622689738ca3a1$var$getRootNode(n) {
    return $3e622689738ca3a1$var$getUntaintedMethod("Node", n, "getRootNode")();
}
function $3e622689738ca3a1$var$host(n) {
    if (!n || !("host" in n)) return null;
    return $3e622689738ca3a1$var$getUntaintedAccessor("ShadowRoot", n, "host");
}
function $3e622689738ca3a1$var$styleSheets(n) {
    return n.styleSheets;
}
function $3e622689738ca3a1$var$shadowRoot(n) {
    if (!n || !("shadowRoot" in n)) return null;
    return $3e622689738ca3a1$var$getUntaintedAccessor("Element", n, "shadowRoot");
}
function $3e622689738ca3a1$var$querySelector(n, selectors) {
    return $3e622689738ca3a1$var$getUntaintedAccessor("Element", n, "querySelector")(selectors);
}
function $3e622689738ca3a1$var$querySelectorAll(n, selectors) {
    return $3e622689738ca3a1$var$getUntaintedAccessor("Element", n, "querySelectorAll")(selectors);
}
function $3e622689738ca3a1$var$mutationObserverCtor() {
    return $3e622689738ca3a1$var$getUntaintedPrototype("MutationObserver").constructor;
}
const $3e622689738ca3a1$var$index = {
    childNodes: $3e622689738ca3a1$var$childNodes,
    parentNode: $3e622689738ca3a1$var$parentNode,
    parentElement: $3e622689738ca3a1$var$parentElement,
    textContent: $3e622689738ca3a1$var$textContent,
    contains: $3e622689738ca3a1$var$contains,
    getRootNode: $3e622689738ca3a1$var$getRootNode,
    host: $3e622689738ca3a1$var$host,
    styleSheets: $3e622689738ca3a1$var$styleSheets,
    shadowRoot: $3e622689738ca3a1$var$shadowRoot,
    querySelector: $3e622689738ca3a1$var$querySelector,
    querySelectorAll: $3e622689738ca3a1$var$querySelectorAll,
    mutationObserver: $3e622689738ca3a1$var$mutationObserverCtor
};
function $3e622689738ca3a1$export$45a5e7f76e0caa8d(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $3e622689738ca3a1$export$af51f0f06c0f328a(n) {
    const hostEl = // anchor and textarea elements also have a `host` property
    // but only shadow roots have a `mode` property
    n && "host" in n && "mode" in n && $3e622689738ca3a1$var$index.host(n) || null;
    return Boolean(hostEl && "shadowRoot" in hostEl && $3e622689738ca3a1$var$index.shadowRoot(hostEl) === n);
}
function $3e622689738ca3a1$export$eca2d267b6af372(shadowRoot2) {
    return Object.prototype.toString.call(shadowRoot2) === "[object ShadowRoot]";
}
function $3e622689738ca3a1$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $3e622689738ca3a1$export$9a5ffc80deb8e73e(rule2) {
    const { cssText: cssText } = rule2;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule2.href)})`
    ];
    if (rule2.layerName === "") statement.push(`layer`);
    else if (rule2.layerName) statement.push(`layer(${rule2.layerName})`);
    if (rule2.supportsText) statement.push(`supports(${rule2.supportsText})`);
    if (rule2.media.length) statement.push(rule2.media.mediaText);
    return statement.join(" ") + ";";
}
function $3e622689738ca3a1$export$89f06f685a7616be(s) {
    try {
        const rules = s.rules || s.cssRules;
        if (!rules) return null;
        let sheetHref = s.href;
        if (!sheetHref && s.ownerNode && s.ownerNode.ownerDocument) sheetHref = s.ownerNode.ownerDocument.location.href;
        const stringifiedRules = Array.from(rules, (rule2)=>$3e622689738ca3a1$export$307cae8ba68e4150(rule2, sheetHref)).join("");
        return $3e622689738ca3a1$var$fixBrowserCompatibilityIssuesInCSS(stringifiedRules);
    } catch (error) {
        return null;
    }
}
function $3e622689738ca3a1$export$307cae8ba68e4150(rule2, sheetHref) {
    if ($3e622689738ca3a1$export$e85711815614a10e(rule2)) {
        let importStringified;
        try {
            importStringified = // we can access the imported stylesheet rules directly
            $3e622689738ca3a1$export$89f06f685a7616be(rule2.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
            $3e622689738ca3a1$export$9a5ffc80deb8e73e(rule2);
        } catch (error) {
            importStringified = rule2.cssText;
        }
        if (rule2.styleSheet.href) return $3e622689738ca3a1$export$fbb998be3a1599cb(importStringified, rule2.styleSheet.href);
        return importStringified;
    } else {
        let ruleStringified = rule2.cssText;
        if ($3e622689738ca3a1$export$420f30688de25102(rule2) && rule2.selectorText.includes(":")) ruleStringified = $3e622689738ca3a1$export$726136590fca50b3(ruleStringified);
        if (sheetHref) return $3e622689738ca3a1$export$fbb998be3a1599cb(ruleStringified, sheetHref);
        return ruleStringified;
    }
}
function $3e622689738ca3a1$export$726136590fca50b3(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $3e622689738ca3a1$export$e85711815614a10e(rule2) {
    return "styleSheet" in rule2;
}
function $3e622689738ca3a1$export$420f30688de25102(rule2) {
    return "selectorText" in rule2;
}
class $3e622689738ca3a1$export$a80993881abc373d {
    constructor(){
        $3e622689738ca3a1$var$__publicField(this, "idNodeMap", /* @__PURE__ */ new Map());
        $3e622689738ca3a1$var$__publicField(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    getId(n) {
        var _a;
        if (!n) return -1;
        const id = (_a = this.getMeta(n)) == null ? void 0 : _a.id;
        return id ?? -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node2) {
        return this.nodeMetaMap.has(node2);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
}
function $3e622689738ca3a1$export$b307838285d1a62e() {
    return new $3e622689738ca3a1$export$a80993881abc373d();
}
function $3e622689738ca3a1$export$b547f2d5941e071e({ element: element, maskInputOptions: maskInputOptions, tagName: tagName, type: type, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    const actualType = type && $3e622689738ca3a1$export$84b9399c77df0edf(type);
    if (maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType]) {
        if (maskInputFn) text = maskInputFn(text, element);
        else text = "*".repeat(text.length);
    }
    return text;
}
function $3e622689738ca3a1$export$84b9399c77df0edf(str) {
    return str.toLowerCase();
}
const $3e622689738ca3a1$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $3e622689738ca3a1$export$4604fdf2f9aabdf2(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x2 = 0; x2 < canvas.width; x2 += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $3e622689738ca3a1$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$3e622689738ca3a1$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        originalGetImageData.call(ctx, x2, y, Math.min(chunkSize, canvas.width - x2), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $3e622689738ca3a1$export$ab8d9629a25fa8ef(a, b) {
    if (!a || !b || a.type !== b.type) return false;
    if (a.type === $3e622689738ca3a1$var$NodeType.Document) return a.compatMode === b.compatMode;
    else if (a.type === $3e622689738ca3a1$var$NodeType.DocumentType) return a.name === b.name && a.publicId === b.publicId && a.systemId === b.systemId;
    else if (a.type === $3e622689738ca3a1$var$NodeType.Comment || a.type === $3e622689738ca3a1$var$NodeType.Text || a.type === $3e622689738ca3a1$var$NodeType.CDATA) return a.textContent === b.textContent;
    else if (a.type === $3e622689738ca3a1$var$NodeType.Element) return a.tagName === b.tagName && JSON.stringify(a.attributes) === JSON.stringify(b.attributes) && a.isSVG === b.isSVG && a.needBlock === b.needBlock;
    return false;
}
function $3e622689738ca3a1$export$f531fc545c6b4728(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    $3e622689738ca3a1$export$84b9399c77df0edf(type) : null;
}
function $3e622689738ca3a1$export$a470f4968c939b6a(path, baseURL) {
    let url;
    try {
        url = new URL(path, baseURL ?? window.location.href);
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    return (match == null ? void 0 : match[1]) ?? null;
}
function $3e622689738ca3a1$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
const $3e622689738ca3a1$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $3e622689738ca3a1$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $3e622689738ca3a1$var$URL_WWW_MATCH = /^www\..*/i;
const $3e622689738ca3a1$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $3e622689738ca3a1$export$fbb998be3a1599cb(cssText, href) {
    return (cssText || "").replace($3e622689738ca3a1$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($3e622689738ca3a1$var$URL_PROTOCOL_MATCH.test(filePath) || $3e622689738ca3a1$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($3e622689738ca3a1$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$3e622689738ca3a1$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
function $3e622689738ca3a1$export$59bcf587ce0cafce(cssText, _testNoPxNorm = false) {
    if (_testNoPxNorm) return cssText.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "");
    else return cssText.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "").replace(/0px/g, "0");
}
function $3e622689738ca3a1$export$5fb76088097cbb4b(cssText, style, _testNoPxNorm = false) {
    const childNodes2 = Array.from(style.childNodes);
    const splits = [];
    let iterCount = 0;
    if (childNodes2.length > 1 && cssText && typeof cssText === "string") {
        let cssTextNorm = $3e622689738ca3a1$export$59bcf587ce0cafce(cssText, _testNoPxNorm);
        const normFactor = cssTextNorm.length / cssText.length;
        for(let i = 1; i < childNodes2.length; i++)if (childNodes2[i].textContent && typeof childNodes2[i].textContent === "string") {
            const textContentNorm = $3e622689738ca3a1$export$59bcf587ce0cafce(childNodes2[i].textContent, _testNoPxNorm);
            const jLimit = 100;
            let j = 3;
            for(; j < textContentNorm.length; j++){
                if (// keep consuming css identifiers (to get a decent chunk more quickly)
                textContentNorm[j].match(/[a-zA-Z0-9]/) || // substring needs to be unique to this section
                textContentNorm.indexOf(textContentNorm.substring(0, j), 1) !== -1) continue;
                break;
            }
            for(; j < textContentNorm.length; j++){
                let startSubstring = textContentNorm.substring(0, j);
                let cssNormSplits = cssTextNorm.split(startSubstring);
                let splitNorm = -1;
                if (cssNormSplits.length === 2) splitNorm = cssNormSplits[0].length;
                else if (cssNormSplits.length > 2 && cssNormSplits[0] === "" && childNodes2[i - 1].textContent !== "") splitNorm = cssTextNorm.indexOf(startSubstring, 1);
                else if (cssNormSplits.length === 1) {
                    startSubstring = startSubstring.substring(0, startSubstring.length - 1);
                    cssNormSplits = cssTextNorm.split(startSubstring);
                    if (cssNormSplits.length <= 1) {
                        splits.push(cssText);
                        return splits;
                    }
                    j = jLimit + 1;
                } else if (j === textContentNorm.length - 1) splitNorm = cssTextNorm.indexOf(startSubstring);
                if (cssNormSplits.length >= 2 && j > jLimit) {
                    const prevTextContent = childNodes2[i - 1].textContent;
                    if (prevTextContent && typeof prevTextContent === "string") {
                        const prevMinLength = $3e622689738ca3a1$export$59bcf587ce0cafce(prevTextContent).length;
                        splitNorm = cssTextNorm.indexOf(startSubstring, prevMinLength);
                    }
                    if (splitNorm === -1) splitNorm = cssNormSplits[0].length;
                }
                if (splitNorm !== -1) {
                    let k = Math.floor(splitNorm / normFactor);
                    for(; k > 0 && k < cssText.length;){
                        iterCount += 1;
                        if (iterCount > 50 * childNodes2.length) {
                            splits.push(cssText);
                            return splits;
                        }
                        const normPart = $3e622689738ca3a1$export$59bcf587ce0cafce(cssText.substring(0, k), _testNoPxNorm);
                        if (normPart.length === splitNorm) {
                            splits.push(cssText.substring(0, k));
                            cssText = cssText.substring(k);
                            cssTextNorm = cssTextNorm.substring(splitNorm);
                            break;
                        } else if (normPart.length < splitNorm) k += Math.max(1, Math.floor((splitNorm - normPart.length) / normFactor));
                        else k -= Math.max(1, Math.floor((normPart.length - splitNorm) * normFactor));
                    }
                    break;
                }
            }
        }
    }
    splits.push(cssText);
    return splits;
}
function $3e622689738ca3a1$export$d1ba9be3a87961fc(cssText, style) {
    return $3e622689738ca3a1$export$5fb76088097cbb4b(cssText, style).join("/* rr_split */");
}
let $3e622689738ca3a1$var$_id = 1;
const $3e622689738ca3a1$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $3e622689738ca3a1$export$e4e7f8ddf3795ddb = -2;
function $3e622689738ca3a1$export$87d45d9755ebb726() {
    return $3e622689738ca3a1$var$_id++;
}
function $3e622689738ca3a1$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $3e622689738ca3a1$export$84b9399c77df0edf(element.tagName);
    if ($3e622689738ca3a1$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
let $3e622689738ca3a1$var$canvasService;
let $3e622689738ca3a1$var$canvasCtx;
const $3e622689738ca3a1$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $3e622689738ca3a1$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $3e622689738ca3a1$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($3e622689738ca3a1$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($3e622689738ca3a1$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $3e622689738ca3a1$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $3e622689738ca3a1$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
const $3e622689738ca3a1$var$cachedDocument = /* @__PURE__ */ new WeakMap();
function $3e622689738ca3a1$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $3e622689738ca3a1$var$getHref(doc, attributeValue);
}
function $3e622689738ca3a1$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $3e622689738ca3a1$var$getHref(doc, customHref) {
    let a = $3e622689738ca3a1$var$cachedDocument.get(doc);
    if (!a) {
        a = doc.createElement("a");
        $3e622689738ca3a1$var$cachedDocument.set(doc, a);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a.setAttribute("href", customHref);
    return a.href;
}
function $3e622689738ca3a1$export$cb0776038f0c16b2(doc, tagName, name, value) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $3e622689738ca3a1$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $3e622689738ca3a1$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $3e622689738ca3a1$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $3e622689738ca3a1$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $3e622689738ca3a1$export$fbb998be3a1599cb(value, $3e622689738ca3a1$var$getHref(doc));
    else if (tagName === "object" && name === "data") return $3e622689738ca3a1$var$absoluteToDoc(doc, value);
    return value;
}
function $3e622689738ca3a1$export$72d101e93c081651(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $3e622689738ca3a1$var$_isBlockedElement(element, blockClass, blockSelector) {
    try {
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $3e622689738ca3a1$export$37a2ff4715fee513(node2, regex, checkAncestors) {
    if (!node2) return false;
    if (node2.nodeType !== node2.ELEMENT_NODE) {
        if (!checkAncestors) return false;
        return $3e622689738ca3a1$export$37a2ff4715fee513($3e622689738ca3a1$var$index.parentNode(node2), regex, checkAncestors);
    }
    for(let eIndex = node2.classList.length; eIndex--;){
        const className = node2.classList[eIndex];
        if (regex.test(className)) return true;
    }
    if (!checkAncestors) return false;
    return $3e622689738ca3a1$export$37a2ff4715fee513($3e622689738ca3a1$var$index.parentNode(node2), regex, checkAncestors);
}
function $3e622689738ca3a1$export$80849672af49d9a0(node2, maskTextClass, maskTextSelector, checkAncestors) {
    let el;
    if ($3e622689738ca3a1$export$45a5e7f76e0caa8d(node2)) {
        el = node2;
        if (!$3e622689738ca3a1$var$index.childNodes(el).length) return false;
    } else if ($3e622689738ca3a1$var$index.parentElement(node2) === null) return false;
    else el = $3e622689738ca3a1$var$index.parentElement(node2);
    try {
        if (typeof maskTextClass === "string") {
            if (checkAncestors) {
                if (el.closest(`.${maskTextClass}`)) return true;
            } else {
                if (el.classList.contains(maskTextClass)) return true;
            }
        } else {
            if ($3e622689738ca3a1$export$37a2ff4715fee513(el, maskTextClass, checkAncestors)) return true;
        }
        if (maskTextSelector) {
            if (checkAncestors) {
                if (el.closest(maskTextSelector)) return true;
            } else {
                if (el.matches(maskTextSelector)) return true;
            }
        }
    } catch (e) {}
    return false;
}
function $3e622689738ca3a1$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $3e622689738ca3a1$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $3e622689738ca3a1$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, needsMask: needsMask, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, cssCaptured: cssCaptured = false } = options;
    const rootId = $3e622689738ca3a1$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $3e622689738ca3a1$var$NodeType.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $3e622689738ca3a1$var$NodeType.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $3e622689738ca3a1$var$NodeType.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $3e622689738ca3a1$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId
            });
        case n.TEXT_NODE:
            return $3e622689738ca3a1$var$serializeTextNode(n, {
                doc: doc,
                needsMask: needsMask,
                maskTextFn: maskTextFn,
                rootId: rootId,
                cssCaptured: cssCaptured
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $3e622689738ca3a1$var$NodeType.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $3e622689738ca3a1$var$NodeType.Comment,
                textContent: $3e622689738ca3a1$var$index.textContent(n) || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $3e622689738ca3a1$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return void 0;
    const docId = mirror.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function $3e622689738ca3a1$var$serializeTextNode(n, options) {
    const { needsMask: needsMask, maskTextFn: maskTextFn, rootId: rootId, cssCaptured: cssCaptured } = options;
    const parent = $3e622689738ca3a1$var$index.parentNode(n);
    const parentTagName = parent && parent.tagName;
    let textContent2 = "";
    const isStyle = parentTagName === "STYLE" ? true : void 0;
    const isScript = parentTagName === "SCRIPT" ? true : void 0;
    if (isScript) textContent2 = "SCRIPT_PLACEHOLDER";
    else if (!cssCaptured) {
        textContent2 = $3e622689738ca3a1$var$index.textContent(n);
        if (isStyle && textContent2) textContent2 = $3e622689738ca3a1$export$fbb998be3a1599cb(textContent2, $3e622689738ca3a1$var$getHref(options.doc));
    }
    if (!isStyle && !isScript && textContent2 && needsMask) textContent2 = maskTextFn ? maskTextFn(textContent2, $3e622689738ca3a1$var$index.parentElement(n)) : textContent2.replace(/[\S]/g, "*");
    return {
        type: $3e622689738ca3a1$var$NodeType.Text,
        textContent: textContent2 || "",
        rootId: rootId
    };
}
function $3e622689738ca3a1$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId } = options;
    const needBlock = $3e622689738ca3a1$var$_isBlockedElement(n, blockClass, blockSelector);
    const tagName = $3e622689738ca3a1$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (!$3e622689738ca3a1$export$72d101e93c081651(tagName, attr.name, attr.value)) attributes[attr.name] = $3e622689738ca3a1$export$cb0776038f0c16b2(doc, tagName, $3e622689738ca3a1$export$84b9399c77df0edf(attr.name), attr.value);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $3e622689738ca3a1$export$89f06f685a7616be(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = cssText;
        }
    }
    if (tagName === "style" && n.sheet) {
        let cssText = $3e622689738ca3a1$export$89f06f685a7616be(n.sheet);
        if (cssText) {
            if (n.childNodes.length > 1) cssText = $3e622689738ca3a1$export$d1ba9be3a87961fc(cssText, n);
            attributes._cssText = cssText;
        }
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select") {
        const value = n.value;
        const checked = n.checked;
        if (attributes.type !== "radio" && attributes.type !== "checkbox" && attributes.type !== "submit" && attributes.type !== "button" && value) attributes.value = $3e622689738ca3a1$export$b547f2d5941e071e({
            element: n,
            type: $3e622689738ca3a1$export$f531fc545c6b4728(n),
            tagName: tagName,
            value: value,
            maskInputOptions: maskInputOptions,
            maskInputFn: maskInputFn
        });
        else if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "dialog" && n.open) attributes.rr_open_mode = n.matches("dialog:modal") ? "modal" : "non-modal";
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$3e622689738ca3a1$export$4604fdf2f9aabdf2(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$3e622689738ca3a1$var$canvasService) {
            $3e622689738ca3a1$var$canvasService = doc.createElement("canvas");
            $3e622689738ca3a1$var$canvasCtx = $3e622689738ca3a1$var$canvasService.getContext("2d");
        }
        const image = n;
        const imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        const priorCrossOrigin = image.crossOrigin;
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $3e622689738ca3a1$var$canvasService.width = image.naturalWidth;
                $3e622689738ca3a1$var$canvasService.height = image.naturalHeight;
                $3e622689738ca3a1$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $3e622689738ca3a1$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn(`Cannot inline img src=${imageSrc}! Error: ${err}`);
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        const mediaAttributes = attributes;
        mediaAttributes.rr_mediaState = n.paused ? "paused" : "played";
        mediaAttributes.rr_mediaCurrentTime = n.currentTime;
        mediaAttributes.rr_mediaPlaybackRate = n.playbackRate;
        mediaAttributes.rr_mediaMuted = n.muted;
        mediaAttributes.rr_mediaLoop = n.loop;
        mediaAttributes.rr_mediaVolume = n.volume;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $3e622689738ca3a1$var$NodeType.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $3e622689738ca3a1$var$isSVGElement(n) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $3e622689738ca3a1$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $3e622689738ca3a1$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $3e622689738ca3a1$var$NodeType.Comment) return true;
    else if (sn.type === $3e622689738ca3a1$var$NodeType.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $3e622689738ca3a1$export$a470f4968c939b6a(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($3e622689738ca3a1$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "application-name" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.rel) === "icon" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($3e622689738ca3a1$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "robots" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "googlebot" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "author" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "generator" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "framework" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "publisher" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "progid" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "verification" || $3e622689738ca3a1$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $3e622689738ca3a1$export$27792c824d895cd4(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, maskTextClass: maskTextClass, maskTextSelector: maskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5e3, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5e3, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false, cssCaptured: cssCaptured = false } = options;
    let { needsMask: needsMask } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    if (!needsMask) {
        const checkAncestors = needsMask === void 0;
        needsMask = $3e622689738ca3a1$export$80849672af49d9a0(n, maskTextClass, maskTextSelector, checkAncestors);
    }
    const _serializedNode = $3e622689738ca3a1$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        needsMask: needsMask,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement,
        cssCaptured: cssCaptured
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($3e622689738ca3a1$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $3e622689738ca3a1$var$NodeType.Text && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $3e622689738ca3a1$export$e4e7f8ddf3795ddb;
    else id = $3e622689738ca3a1$export$87d45d9755ebb726();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $3e622689738ca3a1$export$e4e7f8ddf3795ddb) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $3e622689738ca3a1$var$NodeType.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRootEl = $3e622689738ca3a1$var$index.shadowRoot(n);
        if (shadowRootEl && $3e622689738ca3a1$export$eca2d267b6af372(shadowRootEl)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $3e622689738ca3a1$var$NodeType.Document || serializedNode.type === $3e622689738ca3a1$var$NodeType.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $3e622689738ca3a1$var$NodeType.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            needsMask: needsMask,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn,
            cssCaptured: false
        };
        if (serializedNode.type === $3e622689738ca3a1$var$NodeType.Element && serializedNode.tagName === "textarea" && serializedNode.attributes.value !== void 0) ;
        else {
            if (serializedNode.type === $3e622689738ca3a1$var$NodeType.Element && serializedNode.attributes._cssText !== void 0 && typeof serializedNode.attributes._cssText === "string") bypassOptions.cssCaptured = true;
            for (const childN of Array.from($3e622689738ca3a1$var$index.childNodes(n))){
                const serializedChildNode = $3e622689738ca3a1$export$27792c824d895cd4(childN, bypassOptions);
                if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
            }
        }
        let shadowRootEl = null;
        if ($3e622689738ca3a1$export$45a5e7f76e0caa8d(n) && (shadowRootEl = $3e622689738ca3a1$var$index.shadowRoot(n))) for (const childN of Array.from($3e622689738ca3a1$var$index.childNodes(shadowRootEl))){
            const serializedChildNode = $3e622689738ca3a1$export$27792c824d895cd4(childN, bypassOptions);
            if (serializedChildNode) {
                $3e622689738ca3a1$export$eca2d267b6af372(shadowRootEl) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    const parent = $3e622689738ca3a1$var$index.parentNode(n);
    if (parent && $3e622689738ca3a1$export$af51f0f06c0f328a(parent) && $3e622689738ca3a1$export$eca2d267b6af372(parent)) serializedNode.isShadow = true;
    if (serializedNode.type === $3e622689738ca3a1$var$NodeType.Element && serializedNode.tagName === "iframe") $3e622689738ca3a1$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $3e622689738ca3a1$export$27792c824d895cd4(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $3e622689738ca3a1$var$NodeType.Element && serializedNode.tagName === "link" && typeof serializedNode.attributes.rel === "string" && (serializedNode.attributes.rel === "stylesheet" || serializedNode.attributes.rel === "preload" && typeof serializedNode.attributes.href === "string" && $3e622689738ca3a1$export$a470f4968c939b6a(serializedNode.attributes.href) === "css")) $3e622689738ca3a1$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $3e622689738ca3a1$export$27792c824d895cd4(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $3e622689738ca3a1$export$b8801ea43165ed7d(n, options) {
    const { mirror: mirror = new $3e622689738ca3a1$export$a80993881abc373d(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, maskTextClass: maskTextClass = "rr-mask", maskTextSelector: maskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : maskAllInputs === false ? {
        password: true
    } : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? // if true: set of sensible options that should not throw away any information
    {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $3e622689738ca3a1$export$27792c824d895cd4(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $3e622689738ca3a1$export$848abaf7b0ecb1f8(node2, onVisit) {
    function walk(current) {
        onVisit(current);
        if (current.type === $3e622689738ca3a1$var$NodeType.Document || current.type === $3e622689738ca3a1$var$NodeType.Element) current.childNodes.forEach(walk);
    }
    walk(node2);
}
function $3e622689738ca3a1$export$4553ffcef31d4d68() {
    $3e622689738ca3a1$var$_id = 1;
}
const $3e622689738ca3a1$var$MEDIA_SELECTOR = /(max|min)-device-(width|height)/;
const $3e622689738ca3a1$var$MEDIA_SELECTOR_GLOBAL = new RegExp($3e622689738ca3a1$var$MEDIA_SELECTOR.source, "g");
const $3e622689738ca3a1$var$mediaSelectorPlugin = {
    postcssPlugin: "postcss-custom-selectors",
    prepare () {
        return {
            postcssPlugin: "postcss-custom-selectors",
            AtRule: function(atrule) {
                if (atrule.params.match($3e622689738ca3a1$var$MEDIA_SELECTOR_GLOBAL)) atrule.params = atrule.params.replace($3e622689738ca3a1$var$MEDIA_SELECTOR_GLOBAL, "$1-$2");
            }
        };
    }
};
const $3e622689738ca3a1$var$pseudoClassPlugin = {
    postcssPlugin: "postcss-hover-classes",
    prepare: function() {
        const fixed = [];
        return {
            Rule: function(rule2) {
                if (fixed.indexOf(rule2) !== -1) return;
                fixed.push(rule2);
                rule2.selectors.forEach(function(selector) {
                    if (selector.includes(":hover")) rule2.selector += ",\n" + selector.replace(/:hover/g, ".\\:hover");
                });
            }
        };
    }
};
function $3e622689738ca3a1$var$getDefaultExportFromCjs(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function $3e622689738ca3a1$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var f = n.default;
    if (typeof f == "function") {
        var a = function a2() {
            if (this instanceof a2) return Reflect.construct(f, arguments, this.constructor);
            return f.apply(this, arguments);
        };
        a.prototype = f.prototype;
    } else a = {};
    Object.defineProperty(a, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
var $3e622689738ca3a1$var$picocolors_browser = {
    exports: {}
};
var $3e622689738ca3a1$var$x = String;
var $3e622689738ca3a1$var$create = function() {
    return {
        isColorSupported: false,
        reset: $3e622689738ca3a1$var$x,
        bold: $3e622689738ca3a1$var$x,
        dim: $3e622689738ca3a1$var$x,
        italic: $3e622689738ca3a1$var$x,
        underline: $3e622689738ca3a1$var$x,
        inverse: $3e622689738ca3a1$var$x,
        hidden: $3e622689738ca3a1$var$x,
        strikethrough: $3e622689738ca3a1$var$x,
        black: $3e622689738ca3a1$var$x,
        red: $3e622689738ca3a1$var$x,
        green: $3e622689738ca3a1$var$x,
        yellow: $3e622689738ca3a1$var$x,
        blue: $3e622689738ca3a1$var$x,
        magenta: $3e622689738ca3a1$var$x,
        cyan: $3e622689738ca3a1$var$x,
        white: $3e622689738ca3a1$var$x,
        gray: $3e622689738ca3a1$var$x,
        bgBlack: $3e622689738ca3a1$var$x,
        bgRed: $3e622689738ca3a1$var$x,
        bgGreen: $3e622689738ca3a1$var$x,
        bgYellow: $3e622689738ca3a1$var$x,
        bgBlue: $3e622689738ca3a1$var$x,
        bgMagenta: $3e622689738ca3a1$var$x,
        bgCyan: $3e622689738ca3a1$var$x,
        bgWhite: $3e622689738ca3a1$var$x
    };
};
$3e622689738ca3a1$var$picocolors_browser.exports = $3e622689738ca3a1$var$create();
$3e622689738ca3a1$var$picocolors_browser.exports.createColors = $3e622689738ca3a1$var$create;
var $3e622689738ca3a1$var$picocolors_browserExports = $3e622689738ca3a1$var$picocolors_browser.exports;
const $3e622689738ca3a1$var$__viteBrowserExternal = {};
const $3e622689738ca3a1$var$__viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: $3e622689738ca3a1$var$__viteBrowserExternal
}, Symbol.toStringTag, {
    value: "Module"
}));
const $3e622689738ca3a1$var$require$$2 = /* @__PURE__ */ $3e622689738ca3a1$var$getAugmentedNamespace($3e622689738ca3a1$var$__viteBrowserExternal$1);
let $3e622689738ca3a1$var$pico = $3e622689738ca3a1$var$picocolors_browserExports;
let $3e622689738ca3a1$var$terminalHighlight$1 = $3e622689738ca3a1$var$require$$2;
let $3e622689738ca3a1$var$CssSyntaxError$3 = class CssSyntaxError extends Error {
    constructor(message, line, column, source, file, plugin2){
        super(message);
        this.name = "CssSyntaxError";
        this.reason = message;
        if (file) this.file = file;
        if (source) this.source = source;
        if (plugin2) this.plugin = plugin2;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                this.line = line;
                this.column = column;
            } else {
                this.line = line.line;
                this.column = line.column;
                this.endLine = column.line;
                this.endColumn = column.column;
            }
        }
        this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(this, CssSyntaxError);
    }
    setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    }
    showSourceCode(color) {
        if (!this.source) return "";
        let css = this.source;
        if (color == null) color = $3e622689738ca3a1$var$pico.isColorSupported;
        if ($3e622689738ca3a1$var$terminalHighlight$1) {
            if (color) css = $3e622689738ca3a1$var$terminalHighlight$1(css);
        }
        let lines = css.split(/\r?\n/);
        let start = Math.max(this.line - 3, 0);
        let end = Math.min(this.line + 2, lines.length);
        let maxWidth = String(end).length;
        let mark, aside;
        if (color) {
            let { bold: bold, gray: gray, red: red } = $3e622689738ca3a1$var$pico.createColors(true);
            mark = (text)=>bold(red(text));
            aside = (text)=>gray(text);
        } else mark = aside = (str)=>str;
        return lines.slice(start, end).map((line, index2)=>{
            let number = start + 1 + index2;
            let gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === this.line) {
                let spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    }
    toString() {
        let code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    }
};
var $3e622689738ca3a1$var$cssSyntaxError = $3e622689738ca3a1$var$CssSyntaxError$3;
$3e622689738ca3a1$var$CssSyntaxError$3.default = $3e622689738ca3a1$var$CssSyntaxError$3;
var $3e622689738ca3a1$var$symbols = {};
$3e622689738ca3a1$var$symbols.isClean = Symbol("isClean");
$3e622689738ca3a1$var$symbols.my = Symbol("my");
const $3e622689738ca3a1$var$DEFAULT_RAW = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $3e622689738ca3a1$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
let $3e622689738ca3a1$var$Stringifier$2 = class Stringifier {
    constructor(builder){
        this.builder = builder;
    }
    atrule(node2, semicolon) {
        let name = "@" + node2.name;
        let params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") name += node2.raws.afterName;
        else if (params) name += " ";
        if (node2.nodes) this.block(node2, name + params);
        else {
            let end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    }
    beforeAfter(node2, detect) {
        let value;
        if (node2.type === "decl") value = this.raw(node2, null, "beforeDecl");
        else if (node2.type === "comment") value = this.raw(node2, null, "beforeComment");
        else if (detect === "before") value = this.raw(node2, null, "beforeRule");
        else value = this.raw(node2, null, "beforeClose");
        let buf = node2.parent;
        let depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            let indent = this.raw(node2, null, "indent");
            if (indent.length) for(let step = 0; step < depth; step++)value += indent;
        }
        return value;
    }
    block(node2, start) {
        let between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        let after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else after = this.raw(node2, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    }
    body(node2) {
        let last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        let semicolon = this.raw(node2, "semicolon");
        for(let i = 0; i < node2.nodes.length; i++){
            let child = node2.nodes[i];
            let before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i || semicolon);
        }
    }
    comment(node2) {
        let left = this.raw(node2, "left", "commentLeft");
        let right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    }
    decl(node2, semicolon) {
        let between = this.raw(node2, "between", "colon");
        let string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) string += node2.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node2);
    }
    document(node2) {
        this.body(node2);
    }
    raw(node2, own, detect) {
        let value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        let parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) return "";
            if (parent && parent.type === "document") return "";
        }
        if (!parent) return $3e622689738ca3a1$var$DEFAULT_RAW[detect];
        let root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") return root2.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node2, detect);
        else {
            let method = "raw" + $3e622689738ca3a1$var$capitalize(detect);
            if (this[method]) value = this[method](root2, node2);
            else root2.walk((i)=>{
                value = i.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $3e622689738ca3a1$var$DEFAULT_RAW[detect];
        root2.rawCache[detect] = value;
        return value;
    }
    rawBeforeClose(root2) {
        let value;
        root2.walk((i)=>{
            if (i.nodes && i.nodes.length > 0) {
                if (typeof i.raws.after !== "undefined") {
                    value = i.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeComment(root2, node2) {
        let value;
        root2.walkComments((i)=>{
            if (typeof i.raws.before !== "undefined") {
                value = i.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeDecl(root2, node2) {
        let value;
        root2.walkDecls((i)=>{
            if (typeof i.raws.before !== "undefined") {
                value = i.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeOpen(root2) {
        let value;
        root2.walk((i)=>{
            if (i.type !== "decl") {
                value = i.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawBeforeRule(root2) {
        let value;
        root2.walk((i)=>{
            if (i.nodes && (i.parent !== root2 || root2.first !== i)) {
                if (typeof i.raws.before !== "undefined") {
                    value = i.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawColon(root2) {
        let value;
        root2.walkDecls((i)=>{
            if (typeof i.raws.between !== "undefined") {
                value = i.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    }
    rawEmptyBody(root2) {
        let value;
        root2.walk((i)=>{
            if (i.nodes && i.nodes.length === 0) {
                value = i.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        let value;
        root2.walk((i)=>{
            let p = i.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i.raws.before !== "undefined") {
                    let parts = i.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    }
    rawSemicolon(root2) {
        let value;
        root2.walk((i)=>{
            if (i.nodes && i.nodes.length && i.last.type === "decl") {
                value = i.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawValue(node2, prop) {
        let value = node2[prop];
        let raw = node2.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    }
    root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    }
    rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) this.builder(node2.raws.ownSemicolon, node2, "end");
    }
    stringify(node2, semicolon) {
        if (!this[node2.type]) throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        this[node2.type](node2, semicolon);
    }
};
var $3e622689738ca3a1$var$stringifier = $3e622689738ca3a1$var$Stringifier$2;
$3e622689738ca3a1$var$Stringifier$2.default = $3e622689738ca3a1$var$Stringifier$2;
let $3e622689738ca3a1$var$Stringifier$1 = $3e622689738ca3a1$var$stringifier;
function $3e622689738ca3a1$var$stringify$4(node2, builder) {
    let str = new $3e622689738ca3a1$var$Stringifier$1(builder);
    str.stringify(node2);
}
var $3e622689738ca3a1$var$stringify_1 = $3e622689738ca3a1$var$stringify$4;
$3e622689738ca3a1$var$stringify$4.default = $3e622689738ca3a1$var$stringify$4;
let { isClean: $3e622689738ca3a1$var$isClean$2, my: $3e622689738ca3a1$var$my$2 } = $3e622689738ca3a1$var$symbols;
let $3e622689738ca3a1$var$CssSyntaxError$2 = $3e622689738ca3a1$var$cssSyntaxError;
let $3e622689738ca3a1$var$Stringifier2 = $3e622689738ca3a1$var$stringifier;
let $3e622689738ca3a1$var$stringify$3 = $3e622689738ca3a1$var$stringify_1;
function $3e622689738ca3a1$var$cloneNode(obj, parent) {
    let cloned = new obj.constructor();
    for(let i in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        if (i === "proxyCache") continue;
        let value = obj[i];
        let type = typeof value;
        if (i === "parent" && type === "object") {
            if (parent) cloned[i] = parent;
        } else if (i === "source") cloned[i] = value;
        else if (Array.isArray(value)) cloned[i] = value.map((j)=>$3e622689738ca3a1$var$cloneNode(j, cloned));
        else {
            if (type === "object" && value !== null) value = $3e622689738ca3a1$var$cloneNode(value);
            cloned[i] = value;
        }
    }
    return cloned;
}
let $3e622689738ca3a1$var$Node$4 = class Node {
    constructor(defaults = {}){
        this.raws = {};
        this[$3e622689738ca3a1$var$isClean$2] = false;
        this[$3e622689738ca3a1$var$my$2] = true;
        for(let name in defaults)if (name === "nodes") {
            this.nodes = [];
            for (let node2 of defaults[name])if (typeof node2.clone === "function") this.append(node2.clone());
            else this.append(node2);
        } else this[name] = defaults[name];
    }
    addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            let s = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, `$&${s.input.from}:${s.start.line}:${s.start.column}$&`);
        }
        return error;
    }
    after(add) {
        this.parent.insertAfter(this, add);
        return this;
    }
    assign(overrides = {}) {
        for(let name in overrides)this[name] = overrides[name];
        return this;
    }
    before(add) {
        this.parent.insertBefore(this, add);
        return this;
    }
    cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    }
    clone(overrides = {}) {
        let cloned = $3e622689738ca3a1$var$cloneNode(this);
        for(let name in overrides)cloned[name] = overrides[name];
        return cloned;
    }
    cloneAfter(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    }
    cloneBefore(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    }
    error(message, opts = {}) {
        if (this.source) {
            let { end: end, start: start } = this.rangeBy(opts);
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $3e622689738ca3a1$var$CssSyntaxError$2(message);
    }
    getProxyProcessor() {
        return {
            get (node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (prop === "root") return ()=>node2.root().toProxy();
                else return node2[prop];
            },
            set (node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node2.markDirty();
                return true;
            }
        };
    }
    markDirty() {
        if (this[$3e622689738ca3a1$var$isClean$2]) {
            this[$3e622689738ca3a1$var$isClean$2] = false;
            let next = this;
            while(next = next.parent)next[$3e622689738ca3a1$var$isClean$2] = false;
        }
    }
    next() {
        if (!this.parent) return void 0;
        let index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    }
    positionBy(opts, stringRepresentation) {
        let pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            let index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    }
    positionInside(index2, stringRepresentation) {
        let string = stringRepresentation || this.toString();
        let column = this.source.start.column;
        let line = this.source.start.line;
        for(let i = 0; i < index2; i++)if (string[i] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    }
    prev() {
        if (!this.parent) return void 0;
        let index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    }
    rangeBy(opts) {
        let start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        let end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            let stringRepresentation = this.toString();
            let index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (typeof opts.endIndex === "number") end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    }
    raw(prop, defaultType) {
        let str = new $3e622689738ca3a1$var$Stringifier2();
        return str.raw(this, prop, defaultType);
    }
    remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = void 0;
        return this;
    }
    replaceWith(...nodes) {
        if (this.parent) {
            let bookmark = this;
            let foundSelf = false;
            for (let node2 of nodes){
                if (node2 === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else this.parent.insertBefore(bookmark, node2);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    }
    root() {
        let result2 = this;
        while(result2.parent && result2.parent.type !== "document")result2 = result2.parent;
        return result2;
    }
    toJSON(_, inputs) {
        let fixed = {};
        let emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        let inputsNextIndex = 0;
        for(let name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            let value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map((i)=>{
                if (typeof i === "object" && i.toJSON) return i.toJSON(null, inputs);
                else return i;
            });
            else if (typeof value === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                let inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [
            ...inputs.keys()
        ].map((input2)=>input2.toJSON());
        return fixed;
    }
    toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    }
    toString(stringifier2 = $3e622689738ca3a1$var$stringify$3) {
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        let result2 = "";
        stringifier2(this, (i)=>{
            result2 += i;
        });
        return result2;
    }
    warn(result2, text, opts) {
        let data = {
            node: this
        };
        for(let i in opts)data[i] = opts[i];
        return result2.warn(text, data);
    }
    get proxyOf() {
        return this;
    }
};
var $3e622689738ca3a1$var$node = $3e622689738ca3a1$var$Node$4;
$3e622689738ca3a1$var$Node$4.default = $3e622689738ca3a1$var$Node$4;
let $3e622689738ca3a1$var$Node$3 = $3e622689738ca3a1$var$node;
let $3e622689738ca3a1$var$Declaration$4 = class Declaration extends $3e622689738ca3a1$var$Node$3 {
    constructor(defaults){
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = {
            ...defaults,
            value: String(defaults.value)
        };
        super(defaults);
        this.type = "decl";
    }
    get variable() {
        return this.prop.startsWith("--") || this.prop[0] === "$";
    }
};
var $3e622689738ca3a1$var$declaration = $3e622689738ca3a1$var$Declaration$4;
$3e622689738ca3a1$var$Declaration$4.default = $3e622689738ca3a1$var$Declaration$4;
let $3e622689738ca3a1$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $3e622689738ca3a1$var$customAlphabet = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $3e622689738ca3a1$var$nanoid$1 = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $3e622689738ca3a1$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
var $3e622689738ca3a1$var$nonSecure = {
    nanoid: $3e622689738ca3a1$var$nanoid$1,
    customAlphabet: $3e622689738ca3a1$var$customAlphabet
};
let { SourceMapConsumer: $3e622689738ca3a1$var$SourceMapConsumer$2, SourceMapGenerator: $3e622689738ca3a1$var$SourceMapGenerator$2 } = $3e622689738ca3a1$var$require$$2;
let { existsSync: $3e622689738ca3a1$var$existsSync, readFileSync: $3e622689738ca3a1$var$readFileSync } = $3e622689738ca3a1$var$require$$2;
let { dirname: $3e622689738ca3a1$var$dirname$1, join: $3e622689738ca3a1$var$join } = $3e622689738ca3a1$var$require$$2;
function $3e622689738ca3a1$var$fromBase64(str) {
    if ($3e622689738ca3a1$require$Buffer) return $3e622689738ca3a1$require$Buffer.from(str, "base64").toString();
    else return window.atob(str);
}
let $3e622689738ca3a1$var$PreviousMap$2 = class PreviousMap {
    constructor(css, opts){
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        let prev = opts.map ? opts.map.prev : void 0;
        let text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $3e622689738ca3a1$var$dirname$1(this.mapFile);
        if (text) this.text = text;
    }
    consumer() {
        if (!this.consumerCache) this.consumerCache = new $3e622689738ca3a1$var$SourceMapConsumer$2(this.text);
        return this.consumerCache;
    }
    decodeInline(text) {
        let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        let baseUri = /^data:application\/json;base64,/;
        let charsetUri = /^data:application\/json;charset=utf-?8,/;
        let uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $3e622689738ca3a1$var$fromBase64(text.substr(RegExp.lastMatch.length));
        let encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    }
    getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(map) {
        if (typeof map !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    }
    loadAnnotation(css) {
        let comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        let start = css.lastIndexOf(comments.pop());
        let end = css.indexOf("*/", start);
        if (start > -1 && end > -1) this.annotation = this.getAnnotationURL(css.substring(start, end));
    }
    loadFile(path) {
        this.root = $3e622689738ca3a1$var$dirname$1(path);
        if ($3e622689738ca3a1$var$existsSync(path)) {
            this.mapFile = path;
            return $3e622689738ca3a1$var$readFileSync(path, "utf-8").toString().trim();
        }
    }
    loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                let prevPath = prev(file);
                if (prevPath) {
                    let map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if (prev instanceof $3e622689738ca3a1$var$SourceMapConsumer$2) return $3e622689738ca3a1$var$SourceMapGenerator$2.fromSourceMap(prev).toString();
            else if (prev instanceof $3e622689738ca3a1$var$SourceMapGenerator$2) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            let map = this.annotation;
            if (file) map = $3e622689738ca3a1$var$join($3e622689738ca3a1$var$dirname$1(file), map);
            return this.loadFile(map);
        }
    }
    startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    }
    withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
};
var $3e622689738ca3a1$var$previousMap = $3e622689738ca3a1$var$PreviousMap$2;
$3e622689738ca3a1$var$PreviousMap$2.default = $3e622689738ca3a1$var$PreviousMap$2;
let { SourceMapConsumer: $3e622689738ca3a1$var$SourceMapConsumer$1, SourceMapGenerator: $3e622689738ca3a1$var$SourceMapGenerator$1 } = $3e622689738ca3a1$var$require$$2;
let { fileURLToPath: $3e622689738ca3a1$var$fileURLToPath, pathToFileURL: $3e622689738ca3a1$var$pathToFileURL$1 } = $3e622689738ca3a1$var$require$$2;
let { isAbsolute: $3e622689738ca3a1$var$isAbsolute, resolve: $3e622689738ca3a1$var$resolve$1 } = $3e622689738ca3a1$var$require$$2;
let { nanoid: $3e622689738ca3a1$var$nanoid } = $3e622689738ca3a1$var$nonSecure;
let $3e622689738ca3a1$var$terminalHighlight = $3e622689738ca3a1$var$require$$2;
let $3e622689738ca3a1$var$CssSyntaxError$1 = $3e622689738ca3a1$var$cssSyntaxError;
let $3e622689738ca3a1$var$PreviousMap$1 = $3e622689738ca3a1$var$previousMap;
let $3e622689738ca3a1$var$fromOffsetCache = Symbol("fromOffsetCache");
let $3e622689738ca3a1$var$sourceMapAvailable$1 = Boolean($3e622689738ca3a1$var$SourceMapConsumer$1 && $3e622689738ca3a1$var$SourceMapGenerator$1);
let $3e622689738ca3a1$var$pathAvailable$1 = Boolean($3e622689738ca3a1$var$resolve$1 && $3e622689738ca3a1$var$isAbsolute);
let $3e622689738ca3a1$var$Input$4 = class Input {
    constructor(css, opts = {}){
        if (css === null || typeof css === "undefined" || typeof css === "object" && !css.toString) throw new Error(`PostCSS received ${css} instead of CSS string`);
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$3e622689738ca3a1$var$pathAvailable$1 || /^\w+:\/\//.test(opts.from) || $3e622689738ca3a1$var$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $3e622689738ca3a1$var$resolve$1(opts.from);
        }
        if ($3e622689738ca3a1$var$pathAvailable$1 && $3e622689738ca3a1$var$sourceMapAvailable$1) {
            let map = new $3e622689738ca3a1$var$PreviousMap$1(this.css, opts);
            if (map.text) {
                this.map = map;
                let file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $3e622689738ca3a1$var$nanoid(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    error(message, line, column, opts = {}) {
        let result2, endLine, endColumn;
        if (line && typeof line === "object") {
            let start = line;
            let end = column;
            if (typeof start.offset === "number") {
                let pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                let pos = this.fromOffset(end.offset);
                endLine = pos.line;
                endColumn = pos.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            let pos = this.fromOffset(line);
            line = pos.line;
            column = pos.col;
        }
        let origin = this.origin(line, column, endLine, endColumn);
        if (origin) result2 = new $3e622689738ca3a1$var$CssSyntaxError$1(message, origin.endLine === void 0 ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === void 0 ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result2 = new $3e622689738ca3a1$var$CssSyntaxError$1(message, endLine === void 0 ? line : {
            column: column,
            line: line
        }, endLine === void 0 ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result2.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($3e622689738ca3a1$var$pathToFileURL$1) result2.input.url = $3e622689738ca3a1$var$pathToFileURL$1(this.file).toString();
            result2.input.file = this.file;
        }
        return result2;
    }
    fromOffset(offset) {
        let lastLine, lineToIndex;
        if (!this[$3e622689738ca3a1$var$fromOffsetCache]) {
            let lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            let prevIndex = 0;
            for(let i = 0, l = lines.length; i < l; i++){
                lineToIndex[i] = prevIndex;
                prevIndex += lines[i].length + 1;
            }
            this[$3e622689738ca3a1$var$fromOffsetCache] = lineToIndex;
        } else lineToIndex = this[$3e622689738ca3a1$var$fromOffsetCache];
        lastLine = lineToIndex[lineToIndex.length - 1];
        let min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            let max = lineToIndex.length - 2;
            let mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    }
    mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $3e622689738ca3a1$var$resolve$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    }
    origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        let consumer = this.map.consumer();
        let from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        let to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        let fromUrl;
        if ($3e622689738ca3a1$var$isAbsolute(from.source)) fromUrl = $3e622689738ca3a1$var$pathToFileURL$1(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $3e622689738ca3a1$var$pathToFileURL$1(this.map.mapFile));
        let result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($3e622689738ca3a1$var$fileURLToPath) result2.file = $3e622689738ca3a1$var$fileURLToPath(fromUrl);
            else throw new Error(`file: protocol is not available in this PostCSS build`);
        }
        let source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    }
    toJSON() {
        let json = {};
        for (let name of [
            "hasBOM",
            "css",
            "file",
            "id"
        ])if (this[name] != null) json[name] = this[name];
        if (this.map) {
            json.map = {
                ...this.map
            };
            if (json.map.consumerCache) json.map.consumerCache = void 0;
        }
        return json;
    }
    get from() {
        return this.file || this.id;
    }
};
var $3e622689738ca3a1$var$input = $3e622689738ca3a1$var$Input$4;
$3e622689738ca3a1$var$Input$4.default = $3e622689738ca3a1$var$Input$4;
if ($3e622689738ca3a1$var$terminalHighlight && $3e622689738ca3a1$var$terminalHighlight.registerInput) $3e622689738ca3a1$var$terminalHighlight.registerInput($3e622689738ca3a1$var$Input$4);
let { SourceMapConsumer: $3e622689738ca3a1$var$SourceMapConsumer, SourceMapGenerator: $3e622689738ca3a1$var$SourceMapGenerator } = $3e622689738ca3a1$var$require$$2;
let { dirname: $3e622689738ca3a1$var$dirname, relative: $3e622689738ca3a1$var$relative, resolve: $3e622689738ca3a1$var$resolve, sep: $3e622689738ca3a1$var$sep } = $3e622689738ca3a1$var$require$$2;
let { pathToFileURL: $3e622689738ca3a1$var$pathToFileURL } = $3e622689738ca3a1$var$require$$2;
let $3e622689738ca3a1$var$Input$3 = $3e622689738ca3a1$var$input;
let $3e622689738ca3a1$var$sourceMapAvailable = Boolean($3e622689738ca3a1$var$SourceMapConsumer && $3e622689738ca3a1$var$SourceMapGenerator);
let $3e622689738ca3a1$var$pathAvailable = Boolean($3e622689738ca3a1$var$dirname && $3e622689738ca3a1$var$resolve && $3e622689738ca3a1$var$relative && $3e622689738ca3a1$var$sep);
let $3e622689738ca3a1$var$MapGenerator$2 = class MapGenerator {
    constructor(stringify2, root2, opts, cssString){
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
        let content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        let eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    }
    applyPrevMaps() {
        for (let prev of this.previous()){
            let from = this.toUrl(this.path(prev.file));
            let root2 = prev.root || $3e622689738ca3a1$var$dirname(prev.file);
            let map;
            if (this.mapOpts.sourcesContent === false) {
                map = new $3e622689738ca3a1$var$SourceMapConsumer(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    }
    clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            let node2;
            for(let i = this.root.nodes.length - 1; i >= 0; i--){
                node2 = this.root.nodes[i];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i);
            }
        } else if (this.css) this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
    }
    generate() {
        this.clearAnnotation();
        if ($3e622689738ca3a1$var$pathAvailable && $3e622689738ca3a1$var$sourceMapAvailable && this.isMap()) return this.generateMap();
        else {
            let result2 = "";
            this.stringify(this.root, (i)=>{
                result2 += i;
            });
            return [
                result2
            ];
        }
    }
    generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            let prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $3e622689738ca3a1$var$SourceMapGenerator.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $3e622689738ca3a1$var$SourceMapGenerator({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    }
    generateString() {
        this.css = "";
        this.map = new $3e622689738ca3a1$var$SourceMapGenerator({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        let line = 1;
        let column = 1;
        let noSource = "<no source>";
        let mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        let lines, last;
        this.stringify(this.root, (str, node2, type)=>{
            this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node2 && type !== "start") {
                let p = node2.parent || {
                    raws: {}
                };
                let childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        this.map.addMapping(mapping);
                    }
                }
            }
        });
    }
    isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some((i)=>i.annotation);
        return true;
    }
    isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        let annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some((i)=>i.inline);
        return true;
    }
    isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    }
    isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some((i)=>i.withContent());
        return true;
    }
    outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    }
    path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        let cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        let from = this.opts.to ? $3e622689738ca3a1$var$dirname(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $3e622689738ca3a1$var$dirname($3e622689738ca3a1$var$resolve(from, this.mapOpts.annotation));
        let path = $3e622689738ca3a1$var$relative(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    }
    previous() {
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk((node2)=>{
                if (node2.source && node2.source.input.map) {
                    let map = node2.source.input.map;
                    if (!this.previousMaps.includes(map)) this.previousMaps.push(map);
                }
            });
            else {
                let input2 = new $3e622689738ca3a1$var$Input$3(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    }
    setSourcesContent() {
        let already = {};
        if (this.root) this.root.walk((node2)=>{
            if (node2.source) {
                let from = node2.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
                    this.map.setSourceContent(fromUrl, node2.source.input.css);
                }
            }
        });
        else if (this.css) {
            let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    }
    sourcePath(node2) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node2.source.input.from);
        else return this.toUrl(this.path(node2.source.input.from));
    }
    toBase64(str) {
        if ($3e622689738ca3a1$require$Buffer) return $3e622689738ca3a1$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    }
    toFileUrl(path) {
        let cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($3e622689738ca3a1$var$pathToFileURL) {
            let fileURL = $3e622689738ca3a1$var$pathToFileURL(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error("`map.absolute` option is not available in this PostCSS build");
    }
    toUrl(path) {
        let cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($3e622689738ca3a1$var$sep === "\\") path = path.replace(/\\/g, "/");
        let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    }
};
var $3e622689738ca3a1$var$mapGenerator = $3e622689738ca3a1$var$MapGenerator$2;
let $3e622689738ca3a1$var$Node$2 = $3e622689738ca3a1$var$node;
let $3e622689738ca3a1$var$Comment$4 = class Comment extends $3e622689738ca3a1$var$Node$2 {
    constructor(defaults){
        super(defaults);
        this.type = "comment";
    }
};
var $3e622689738ca3a1$var$comment = $3e622689738ca3a1$var$Comment$4;
$3e622689738ca3a1$var$Comment$4.default = $3e622689738ca3a1$var$Comment$4;
let { isClean: $3e622689738ca3a1$var$isClean$1, my: $3e622689738ca3a1$var$my$1 } = $3e622689738ca3a1$var$symbols;
let $3e622689738ca3a1$var$Declaration$3 = $3e622689738ca3a1$var$declaration;
let $3e622689738ca3a1$var$Comment$3 = $3e622689738ca3a1$var$comment;
let $3e622689738ca3a1$var$Node$1 = $3e622689738ca3a1$var$node;
let $3e622689738ca3a1$var$parse$4, $3e622689738ca3a1$var$Rule$4, $3e622689738ca3a1$var$AtRule$4, $3e622689738ca3a1$var$Root$6;
function $3e622689738ca3a1$var$cleanSource(nodes) {
    return nodes.map((i)=>{
        if (i.nodes) i.nodes = $3e622689738ca3a1$var$cleanSource(i.nodes);
        delete i.source;
        return i;
    });
}
function $3e622689738ca3a1$var$markDirtyUp(node2) {
    node2[$3e622689738ca3a1$var$isClean$1] = false;
    if (node2.proxyOf.nodes) for (let i of node2.proxyOf.nodes)$3e622689738ca3a1$var$markDirtyUp(i);
}
let $3e622689738ca3a1$var$Container$7 = class Container extends $3e622689738ca3a1$var$Node$1 {
    append(...children) {
        for (let child of children){
            let nodes = this.normalize(child, this.last);
            for (let node2 of nodes)this.proxyOf.nodes.push(node2);
        }
        this.markDirty();
        return this;
    }
    cleanRaws(keepBetween) {
        super.cleanRaws(keepBetween);
        if (this.nodes) for (let node2 of this.nodes)node2.cleanRaws(keepBetween);
    }
    each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        let iterator = this.getIterator();
        let index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    }
    every(condition) {
        return this.nodes.every(condition);
    }
    getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        let iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    }
    getProxyProcessor() {
        return {
            get (node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (!node2[prop]) return node2[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return (...args)=>{
                    return node2[prop](...args.map((i)=>{
                        if (typeof i === "function") return (child, index2)=>i(child.toProxy(), index2);
                        else return i;
                    }));
                };
                else if (prop === "every" || prop === "some") return (cb)=>{
                    return node2[prop]((child, ...other)=>cb(child.toProxy(), ...other));
                };
                else if (prop === "root") return ()=>node2.root().toProxy();
                else if (prop === "nodes") return node2.nodes.map((i)=>i.toProxy());
                else if (prop === "first" || prop === "last") return node2[prop].toProxy();
                else return node2[prop];
            },
            set (node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node2.markDirty();
                return true;
            }
        };
    }
    index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    }
    insertAfter(exist, add) {
        let existIndex = this.index(exist);
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for (let node2 of nodes)this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    }
    insertBefore(exist, add) {
        let existIndex = this.index(exist);
        let type = existIndex === 0 ? "prepend" : false;
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for (let node2 of nodes)this.proxyOf.nodes.splice(existIndex, 0, node2);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    }
    normalize(nodes, sample) {
        if (typeof nodes === "string") nodes = $3e622689738ca3a1$var$cleanSource($3e622689738ca3a1$var$parse$4(nodes).nodes);
        else if (typeof nodes === "undefined") nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, "ignore");
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, "ignore");
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $3e622689738ca3a1$var$Declaration$3(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $3e622689738ca3a1$var$Rule$4(nodes)
        ];
        else if (nodes.name) nodes = [
            new $3e622689738ca3a1$var$AtRule$4(nodes)
        ];
        else if (nodes.text) nodes = [
            new $3e622689738ca3a1$var$Comment$3(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        let processed = nodes.map((i)=>{
            if (!i[$3e622689738ca3a1$var$my$1]) Container.rebuild(i);
            i = i.proxyOf;
            if (i.parent) i.parent.removeChild(i);
            if (i[$3e622689738ca3a1$var$isClean$1]) $3e622689738ca3a1$var$markDirtyUp(i);
            if (typeof i.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i.parent = this.proxyOf;
            return i;
        });
        return processed;
    }
    prepend(...children) {
        children = children.reverse();
        for (let child of children){
            let nodes = this.normalize(child, this.first, "prepend").reverse();
            for (let node2 of nodes)this.proxyOf.nodes.unshift(node2);
            for(let id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    }
    push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    }
    removeAll() {
        for (let node2 of this.proxyOf.nodes)node2.parent = void 0;
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    }
    removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        let index2;
        for(let id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) this.indexes[id] = index2 - 1;
        }
        this.markDirty();
        return this;
    }
    replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls((decl)=>{
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    }
    some(condition) {
        return this.nodes.some(condition);
    }
    walk(callback) {
        return this.each((child, i)=>{
            let result2;
            try {
                result2 = callback(child, i);
            } catch (e) {
                throw child.addToError(e);
            }
            if (result2 !== false && child.walk) result2 = child.walk(callback);
            return result2;
        });
    }
    walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk((child, i)=>{
                if (child.type === "atrule") return callback(child, i);
            });
        }
        if (name instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === "atrule" && child.name === name) return callback(child, i);
        });
    }
    walkComments(callback) {
        return this.walk((child, i)=>{
            if (child.type === "comment") return callback(child, i);
        });
    }
    walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk((child, i)=>{
                if (child.type === "decl") return callback(child, i);
            });
        }
        if (prop instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === "decl" && child.prop === prop) return callback(child, i);
        });
    }
    walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk((child, i)=>{
                if (child.type === "rule") return callback(child, i);
            });
        }
        if (selector instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === "rule" && child.selector === selector) return callback(child, i);
        });
    }
    get first() {
        if (!this.proxyOf.nodes) return void 0;
        return this.proxyOf.nodes[0];
    }
    get last() {
        if (!this.proxyOf.nodes) return void 0;
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
};
$3e622689738ca3a1$var$Container$7.registerParse = (dependant)=>{
    $3e622689738ca3a1$var$parse$4 = dependant;
};
$3e622689738ca3a1$var$Container$7.registerRule = (dependant)=>{
    $3e622689738ca3a1$var$Rule$4 = dependant;
};
$3e622689738ca3a1$var$Container$7.registerAtRule = (dependant)=>{
    $3e622689738ca3a1$var$AtRule$4 = dependant;
};
$3e622689738ca3a1$var$Container$7.registerRoot = (dependant)=>{
    $3e622689738ca3a1$var$Root$6 = dependant;
};
var $3e622689738ca3a1$var$container = $3e622689738ca3a1$var$Container$7;
$3e622689738ca3a1$var$Container$7.default = $3e622689738ca3a1$var$Container$7;
$3e622689738ca3a1$var$Container$7.rebuild = (node2)=>{
    if (node2.type === "atrule") Object.setPrototypeOf(node2, $3e622689738ca3a1$var$AtRule$4.prototype);
    else if (node2.type === "rule") Object.setPrototypeOf(node2, $3e622689738ca3a1$var$Rule$4.prototype);
    else if (node2.type === "decl") Object.setPrototypeOf(node2, $3e622689738ca3a1$var$Declaration$3.prototype);
    else if (node2.type === "comment") Object.setPrototypeOf(node2, $3e622689738ca3a1$var$Comment$3.prototype);
    else if (node2.type === "root") Object.setPrototypeOf(node2, $3e622689738ca3a1$var$Root$6.prototype);
    node2[$3e622689738ca3a1$var$my$1] = true;
    if (node2.nodes) node2.nodes.forEach((child)=>{
        $3e622689738ca3a1$var$Container$7.rebuild(child);
    });
};
let $3e622689738ca3a1$var$Container$6 = $3e622689738ca3a1$var$container;
let $3e622689738ca3a1$var$LazyResult$4, $3e622689738ca3a1$var$Processor$3;
let $3e622689738ca3a1$var$Document$3 = class Document extends $3e622689738ca3a1$var$Container$6 {
    constructor(defaults){
        super({
            type: "document",
            ...defaults
        });
        if (!this.nodes) this.nodes = [];
    }
    toResult(opts = {}) {
        let lazy = new $3e622689738ca3a1$var$LazyResult$4(new $3e622689738ca3a1$var$Processor$3(), this, opts);
        return lazy.stringify();
    }
};
$3e622689738ca3a1$var$Document$3.registerLazyResult = (dependant)=>{
    $3e622689738ca3a1$var$LazyResult$4 = dependant;
};
$3e622689738ca3a1$var$Document$3.registerProcessor = (dependant)=>{
    $3e622689738ca3a1$var$Processor$3 = dependant;
};
var $3e622689738ca3a1$var$document$1 = $3e622689738ca3a1$var$Document$3;
$3e622689738ca3a1$var$Document$3.default = $3e622689738ca3a1$var$Document$3;
let $3e622689738ca3a1$var$printed = {};
var $3e622689738ca3a1$var$warnOnce$2 = function warnOnce(message) {
    if ($3e622689738ca3a1$var$printed[message]) return;
    $3e622689738ca3a1$var$printed[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};
let $3e622689738ca3a1$var$Warning$2 = class Warning {
    constructor(text, opts = {}){
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            let range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(let opt in opts)this[opt] = opts[opt];
    }
    toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    }
};
var $3e622689738ca3a1$var$warning = $3e622689738ca3a1$var$Warning$2;
$3e622689738ca3a1$var$Warning$2.default = $3e622689738ca3a1$var$Warning$2;
let $3e622689738ca3a1$var$Warning$1 = $3e622689738ca3a1$var$warning;
let $3e622689738ca3a1$var$Result$3 = class Result {
    constructor(processor2, root2, opts){
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
    toString() {
        return this.css;
    }
    warn(text, opts = {}) {
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        let warning2 = new $3e622689738ca3a1$var$Warning$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    }
    warnings() {
        return this.messages.filter((i)=>i.type === "warning");
    }
    get content() {
        return this.css;
    }
};
var $3e622689738ca3a1$var$result = $3e622689738ca3a1$var$Result$3;
$3e622689738ca3a1$var$Result$3.default = $3e622689738ca3a1$var$Result$3;
const $3e622689738ca3a1$var$SINGLE_QUOTE = "'".charCodeAt(0);
const $3e622689738ca3a1$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
const $3e622689738ca3a1$var$BACKSLASH = "\\".charCodeAt(0);
const $3e622689738ca3a1$var$SLASH = "/".charCodeAt(0);
const $3e622689738ca3a1$var$NEWLINE = "\n".charCodeAt(0);
const $3e622689738ca3a1$var$SPACE = " ".charCodeAt(0);
const $3e622689738ca3a1$var$FEED = "\f".charCodeAt(0);
const $3e622689738ca3a1$var$TAB = "	".charCodeAt(0);
const $3e622689738ca3a1$var$CR = "\r".charCodeAt(0);
const $3e622689738ca3a1$var$OPEN_SQUARE = "[".charCodeAt(0);
const $3e622689738ca3a1$var$CLOSE_SQUARE = "]".charCodeAt(0);
const $3e622689738ca3a1$var$OPEN_PARENTHESES = "(".charCodeAt(0);
const $3e622689738ca3a1$var$CLOSE_PARENTHESES = ")".charCodeAt(0);
const $3e622689738ca3a1$var$OPEN_CURLY = "{".charCodeAt(0);
const $3e622689738ca3a1$var$CLOSE_CURLY = "}".charCodeAt(0);
const $3e622689738ca3a1$var$SEMICOLON = ";".charCodeAt(0);
const $3e622689738ca3a1$var$ASTERISK = "*".charCodeAt(0);
const $3e622689738ca3a1$var$COLON = ":".charCodeAt(0);
const $3e622689738ca3a1$var$AT = "@".charCodeAt(0);
const $3e622689738ca3a1$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const $3e622689738ca3a1$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const $3e622689738ca3a1$var$RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
const $3e622689738ca3a1$var$RE_HEX_ESCAPE = /[\da-f]/i;
var $3e622689738ca3a1$var$tokenize = function tokenizer(input2, options = {}) {
    let css = input2.css.valueOf();
    let ignore = options.ignoreErrors;
    let code, next, quote, content, escape;
    let escaped, escapePos, prev, n, currentToken;
    let length = css.length;
    let pos = 0;
    let buffer = [];
    let returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $3e622689738ca3a1$var$NEWLINE:
            case $3e622689738ca3a1$var$SPACE:
            case $3e622689738ca3a1$var$TAB:
            case $3e622689738ca3a1$var$CR:
            case $3e622689738ca3a1$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $3e622689738ca3a1$var$SPACE || code === $3e622689738ca3a1$var$NEWLINE || code === $3e622689738ca3a1$var$TAB || code === $3e622689738ca3a1$var$CR || code === $3e622689738ca3a1$var$FEED);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $3e622689738ca3a1$var$OPEN_SQUARE:
            case $3e622689738ca3a1$var$CLOSE_SQUARE:
            case $3e622689738ca3a1$var$OPEN_CURLY:
            case $3e622689738ca3a1$var$CLOSE_CURLY:
            case $3e622689738ca3a1$var$COLON:
            case $3e622689738ca3a1$var$SEMICOLON:
            case $3e622689738ca3a1$var$CLOSE_PARENTHESES:
                {
                    let controlChar = String.fromCharCode(code);
                    currentToken = [
                        controlChar,
                        controlChar,
                        pos
                    ];
                    break;
                }
            case $3e622689738ca3a1$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : "";
                n = css.charCodeAt(pos + 1);
                if (prev === "url" && n !== $3e622689738ca3a1$var$SINGLE_QUOTE && n !== $3e622689738ca3a1$var$DOUBLE_QUOTE && n !== $3e622689738ca3a1$var$SPACE && n !== $3e622689738ca3a1$var$NEWLINE && n !== $3e622689738ca3a1$var$TAB && n !== $3e622689738ca3a1$var$FEED && n !== $3e622689738ca3a1$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $3e622689738ca3a1$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $3e622689738ca3a1$var$RE_BAD_BRACKET.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $3e622689738ca3a1$var$SINGLE_QUOTE:
            case $3e622689738ca3a1$var$DOUBLE_QUOTE:
                quote = code === $3e622689738ca3a1$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $3e622689738ca3a1$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $3e622689738ca3a1$var$AT:
                $3e622689738ca3a1$var$RE_AT_END.lastIndex = pos + 1;
                $3e622689738ca3a1$var$RE_AT_END.test(css);
                if ($3e622689738ca3a1$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $3e622689738ca3a1$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $3e622689738ca3a1$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $3e622689738ca3a1$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $3e622689738ca3a1$var$SLASH && code !== $3e622689738ca3a1$var$SPACE && code !== $3e622689738ca3a1$var$NEWLINE && code !== $3e622689738ca3a1$var$TAB && code !== $3e622689738ca3a1$var$CR && code !== $3e622689738ca3a1$var$FEED) {
                    next += 1;
                    if ($3e622689738ca3a1$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($3e622689738ca3a1$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $3e622689738ca3a1$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $3e622689738ca3a1$var$SLASH && css.charCodeAt(pos + 1) === $3e622689738ca3a1$var$ASTERISK) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $3e622689738ca3a1$var$RE_WORD_END.lastIndex = pos + 1;
                    $3e622689738ca3a1$var$RE_WORD_END.test(css);
                    if ($3e622689738ca3a1$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $3e622689738ca3a1$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};
let $3e622689738ca3a1$var$Container$5 = $3e622689738ca3a1$var$container;
let $3e622689738ca3a1$var$AtRule$3 = class AtRule extends $3e622689738ca3a1$var$Container$5 {
    constructor(defaults){
        super(defaults);
        this.type = "atrule";
    }
    append(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.append(...children);
    }
    prepend(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.prepend(...children);
    }
};
var $3e622689738ca3a1$var$atRule = $3e622689738ca3a1$var$AtRule$3;
$3e622689738ca3a1$var$AtRule$3.default = $3e622689738ca3a1$var$AtRule$3;
$3e622689738ca3a1$var$Container$5.registerAtRule($3e622689738ca3a1$var$AtRule$3);
let $3e622689738ca3a1$var$Container$4 = $3e622689738ca3a1$var$container;
let $3e622689738ca3a1$var$LazyResult$3, $3e622689738ca3a1$var$Processor$2;
let $3e622689738ca3a1$var$Root$5 = class Root extends $3e622689738ca3a1$var$Container$4 {
    constructor(defaults){
        super(defaults);
        this.type = "root";
        if (!this.nodes) this.nodes = [];
    }
    normalize(child, sample, type) {
        let nodes = super.normalize(child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for (let node2 of nodes)node2.raws.before = sample.raws.before;
        }
        return nodes;
    }
    removeChild(child, ignore) {
        let index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index2].raws.before;
        return super.removeChild(child);
    }
    toResult(opts = {}) {
        let lazy = new $3e622689738ca3a1$var$LazyResult$3(new $3e622689738ca3a1$var$Processor$2(), this, opts);
        return lazy.stringify();
    }
};
$3e622689738ca3a1$var$Root$5.registerLazyResult = (dependant)=>{
    $3e622689738ca3a1$var$LazyResult$3 = dependant;
};
$3e622689738ca3a1$var$Root$5.registerProcessor = (dependant)=>{
    $3e622689738ca3a1$var$Processor$2 = dependant;
};
var $3e622689738ca3a1$var$root = $3e622689738ca3a1$var$Root$5;
$3e622689738ca3a1$var$Root$5.default = $3e622689738ca3a1$var$Root$5;
$3e622689738ca3a1$var$Container$4.registerRoot($3e622689738ca3a1$var$Root$5);
let $3e622689738ca3a1$var$list$2 = {
    comma (string) {
        return $3e622689738ca3a1$var$list$2.split(string, [
            ","
        ], true);
    },
    space (string) {
        let spaces = [
            " ",
            "\n",
            "	"
        ];
        return $3e622689738ca3a1$var$list$2.split(string, spaces);
    },
    split (string, separators, last) {
        let array = [];
        let current = "";
        let split = false;
        let func = 0;
        let inQuote = false;
        let prevQuote = "";
        let escape = false;
        for (let letter of string){
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var $3e622689738ca3a1$var$list_1 = $3e622689738ca3a1$var$list$2;
$3e622689738ca3a1$var$list$2.default = $3e622689738ca3a1$var$list$2;
let $3e622689738ca3a1$var$Container$3 = $3e622689738ca3a1$var$container;
let $3e622689738ca3a1$var$list$1 = $3e622689738ca3a1$var$list_1;
let $3e622689738ca3a1$var$Rule$3 = class Rule extends $3e622689738ca3a1$var$Container$3 {
    constructor(defaults){
        super(defaults);
        this.type = "rule";
        if (!this.nodes) this.nodes = [];
    }
    get selectors() {
        return $3e622689738ca3a1$var$list$1.comma(this.selector);
    }
    set selectors(values) {
        let match = this.selector ? this.selector.match(/,\s*/) : null;
        let sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
        this.selector = values.join(sep2);
    }
};
var $3e622689738ca3a1$var$rule = $3e622689738ca3a1$var$Rule$3;
$3e622689738ca3a1$var$Rule$3.default = $3e622689738ca3a1$var$Rule$3;
$3e622689738ca3a1$var$Container$3.registerRule($3e622689738ca3a1$var$Rule$3);
let $3e622689738ca3a1$var$Declaration$2 = $3e622689738ca3a1$var$declaration;
let $3e622689738ca3a1$var$tokenizer2 = $3e622689738ca3a1$var$tokenize;
let $3e622689738ca3a1$var$Comment$2 = $3e622689738ca3a1$var$comment;
let $3e622689738ca3a1$var$AtRule$2 = $3e622689738ca3a1$var$atRule;
let $3e622689738ca3a1$var$Root$4 = $3e622689738ca3a1$var$root;
let $3e622689738ca3a1$var$Rule$2 = $3e622689738ca3a1$var$rule;
const $3e622689738ca3a1$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $3e622689738ca3a1$var$findLastWithPosition(tokens) {
    for(let i = tokens.length - 1; i >= 0; i--){
        let token = tokens[i];
        let pos = token[3] || token[2];
        if (pos) return pos;
    }
}
let $3e622689738ca3a1$var$Parser$1 = class Parser {
    constructor(input2){
        this.input = input2;
        this.root = new $3e622689738ca3a1$var$Root$4();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    atrule(token) {
        let node2 = new $3e622689738ca3a1$var$AtRule$2();
        node2.name = token[1].slice(1);
        if (node2.name === "") this.unnamedAtrule(node2, token);
        this.init(node2, token[2]);
        let type;
        let prev;
        let shift;
        let last = false;
        let open = false;
        let params = [];
        let brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    }
    checkMissedSemicolon(tokens) {
        let colon = this.colon(tokens);
        if (colon === false) return;
        let founded = 0;
        let token;
        for(let j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    }
    colon(tokens) {
        let brackets = 0;
        let token, type, prev;
        for (let [i, element] of tokens.entries()){
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i;
            }
            prev = token;
        }
        return false;
    }
    comment(token) {
        let node2 = new $3e622689738ca3a1$var$Comment$2();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        let text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    }
    createTokenizer() {
        this.tokenizer = $3e622689738ca3a1$var$tokenizer2(this.input);
    }
    decl(tokens, customProperty) {
        let node2 = new $3e622689738ca3a1$var$Declaration$2();
        this.init(node2, tokens[0][2]);
        let last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || $3e622689738ca3a1$var$findLastWithPosition(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            let type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        let token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        let firstSpaces = [];
        let next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(let i = tokens.length - 1; i >= 0; i--){
            token = tokens[i];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                let string = this.stringFrom(tokens, i);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                let cache = tokens.slice(0);
                let str = "";
                for(let j = i; j > 0; j--){
                    let type = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        let hasWord = tokens.some((i)=>i[0] !== "space" && i[0] !== "comment");
        if (hasWord) {
            node2.raws.between += firstSpaces.map((i)=>i[1]).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    }
    doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    emptyRule(token) {
        let node2 = new $3e622689738ca3a1$var$Rule$2();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    }
    end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    }
    endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            let prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    }
    // Helpers
    getPosition(offset) {
        let pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    }
    init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    }
    other(start) {
        let end = false;
        let type = null;
        let colon = false;
        let bracket = null;
        let brackets = [];
        let customProperty = start[1].startsWith("--");
        let tokens = [];
        let token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    }
    parse() {
        let token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    }
    precheckMissedSemicolon() {}
    raw(node2, prop, tokens, customProperty) {
        let token, type;
        let length = tokens.length;
        let value = "";
        let clean = true;
        let next, prev;
        for(let i = 0; i < length; i += 1){
            token = tokens[i];
            type = token[0];
            if (type === "space" && i === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i - 1] ? tokens[i - 1][0] : "empty";
                next = tokens[i + 1] ? tokens[i + 1][0] : "empty";
                if (!$3e622689738ca3a1$var$SAFE_COMMENT_NEIGHBOR[prev] && !$3e622689738ca3a1$var$SAFE_COMMENT_NEIGHBOR[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            let raw = tokens.reduce((all, i)=>all + i[1], "");
            node2.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node2[prop] = value;
    }
    rule(tokens) {
        tokens.pop();
        let node2 = new $3e622689738ca3a1$var$Rule$2();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    }
    spacesAndCommentsFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    // Errors
    spacesAndCommentsFromStart(tokens) {
        let next;
        let spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    }
    spacesFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    stringFrom(tokens, from) {
        let result2 = "";
        for(let i = from; i < tokens.length; i++)result2 += tokens[i][1];
        tokens.splice(from, tokens.length - from);
        return result2;
    }
    unclosedBlock() {
        let pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    }
    unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    }
    unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    }
    unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    }
    unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
};
var $3e622689738ca3a1$var$parser = $3e622689738ca3a1$var$Parser$1;
let $3e622689738ca3a1$var$Container$2 = $3e622689738ca3a1$var$container;
let $3e622689738ca3a1$var$Parser2 = $3e622689738ca3a1$var$parser;
let $3e622689738ca3a1$var$Input$2 = $3e622689738ca3a1$var$input;
function $3e622689738ca3a1$var$parse$3(css, opts) {
    let input2 = new $3e622689738ca3a1$var$Input$2(css, opts);
    let parser2 = new $3e622689738ca3a1$var$Parser2(input2);
    try {
        parser2.parse();
    } catch (e) {
        throw e;
    }
    return parser2.root;
}
var $3e622689738ca3a1$var$parse_1 = $3e622689738ca3a1$var$parse$3;
$3e622689738ca3a1$var$parse$3.default = $3e622689738ca3a1$var$parse$3;
$3e622689738ca3a1$var$Container$2.registerParse($3e622689738ca3a1$var$parse$3);
let { isClean: $3e622689738ca3a1$var$isClean, my: $3e622689738ca3a1$var$my } = $3e622689738ca3a1$var$symbols;
let $3e622689738ca3a1$var$MapGenerator$1 = $3e622689738ca3a1$var$mapGenerator;
let $3e622689738ca3a1$var$stringify$2 = $3e622689738ca3a1$var$stringify_1;
let $3e622689738ca3a1$var$Container$1 = $3e622689738ca3a1$var$container;
let $3e622689738ca3a1$var$Document$2 = $3e622689738ca3a1$var$document$1;
let $3e622689738ca3a1$var$warnOnce$1 = $3e622689738ca3a1$var$warnOnce$2;
let $3e622689738ca3a1$var$Result$2 = $3e622689738ca3a1$var$result;
let $3e622689738ca3a1$var$parse$2 = $3e622689738ca3a1$var$parse_1;
let $3e622689738ca3a1$var$Root$3 = $3e622689738ca3a1$var$root;
const $3e622689738ca3a1$var$TYPE_TO_CLASS_NAME = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
const $3e622689738ca3a1$var$PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
const $3e622689738ca3a1$var$NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
const $3e622689738ca3a1$var$CHILDREN = 0;
function $3e622689738ca3a1$var$isPromise(obj) {
    return typeof obj === "object" && typeof obj.then === "function";
}
function $3e622689738ca3a1$var$getEvents(node2) {
    let key = false;
    let type = $3e622689738ca3a1$var$TYPE_TO_CLASS_NAME[node2.type];
    if (node2.type === "decl") key = node2.prop.toLowerCase();
    else if (node2.type === "atrule") key = node2.name.toLowerCase();
    if (key && node2.append) return [
        type,
        type + "-" + key,
        $3e622689738ca3a1$var$CHILDREN,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node2.append) return [
        type,
        $3e622689738ca3a1$var$CHILDREN,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $3e622689738ca3a1$var$toStack(node2) {
    let events;
    if (node2.type === "document") events = [
        "Document",
        $3e622689738ca3a1$var$CHILDREN,
        "DocumentExit"
    ];
    else if (node2.type === "root") events = [
        "Root",
        $3e622689738ca3a1$var$CHILDREN,
        "RootExit"
    ];
    else events = $3e622689738ca3a1$var$getEvents(node2);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function $3e622689738ca3a1$var$cleanMarks(node2) {
    node2[$3e622689738ca3a1$var$isClean] = false;
    if (node2.nodes) node2.nodes.forEach((i)=>$3e622689738ca3a1$var$cleanMarks(i));
    return node2;
}
let $3e622689738ca3a1$var$postcss$2 = {};
let $3e622689738ca3a1$var$LazyResult$2 = class LazyResult {
    constructor(processor2, css, opts){
        this.stringified = false;
        this.processed = false;
        let root2;
        if (typeof css === "object" && css !== null && (css.type === "root" || css.type === "document")) root2 = $3e622689738ca3a1$var$cleanMarks(css);
        else if (css instanceof LazyResult || css instanceof $3e622689738ca3a1$var$Result$2) {
            root2 = $3e622689738ca3a1$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            let parser2 = $3e622689738ca3a1$var$parse$2;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[$3e622689738ca3a1$var$my]) $3e622689738ca3a1$var$Container$1.rebuild(root2);
        }
        this.result = new $3e622689738ca3a1$var$Result$2(processor2, root2, opts);
        this.helpers = {
            ...$3e622689738ca3a1$var$postcss$2,
            postcss: $3e622689738ca3a1$var$postcss$2,
            result: this.result
        };
        this.plugins = this.processor.plugins.map((plugin2)=>{
            if (typeof plugin2 === "object" && plugin2.prepare) return {
                ...plugin2,
                ...plugin2.prepare(this.result)
            };
            else return plugin2;
        });
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(error, node2) {
        let plugin2 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin2.postcssPlugin;
                error.setMessage();
            } else plugin2.postcssVersion;
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    }
    prepareVisitors() {
        this.listeners = {};
        let add = (plugin2, type, cb)=>{
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push([
                plugin2,
                cb
            ]);
        };
        for (let plugin2 of this.plugins){
            if (typeof plugin2 === "object") for(let event in plugin2){
                if (!$3e622689738ca3a1$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error(`Unknown event ${event} in ${plugin2.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`);
                if (!$3e622689738ca3a1$var$NOT_VISITORS[event]) {
                    if (typeof plugin2[event] === "object") {
                        for(let filter in plugin2[event])if (filter === "*") add(plugin2, event, plugin2[event][filter]);
                        else add(plugin2, event + "-" + filter.toLowerCase(), plugin2[event][filter]);
                    } else if (typeof plugin2[event] === "function") add(plugin2, event, plugin2[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
        this.plugin = 0;
        for(let i = 0; i < this.plugins.length; i++){
            let plugin2 = this.plugins[i];
            let promise = this.runOnRoot(plugin2);
            if ($3e622689738ca3a1$var$isPromise(promise)) try {
                await promise;
            } catch (error) {
                throw this.handleError(error);
            }
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root2 = this.result.root;
            while(!root2[$3e622689738ca3a1$var$isClean]){
                root2[$3e622689738ca3a1$var$isClean] = true;
                let stack = [
                    $3e622689738ca3a1$var$toStack(root2)
                ];
                while(stack.length > 0){
                    let promise = this.visitTick(stack);
                    if ($3e622689738ca3a1$var$isPromise(promise)) try {
                        await promise;
                    } catch (e) {
                        let node2 = stack[stack.length - 1].node;
                        throw this.handleError(e, node2);
                    }
                }
            }
            if (this.listeners.OnceExit) for (let [plugin2, visitor] of this.listeners.OnceExit){
                this.result.lastPlugin = plugin2;
                try {
                    if (root2.type === "document") {
                        let roots = root2.nodes.map((subRoot)=>visitor(subRoot, this.helpers));
                        await Promise.all(roots);
                    } else await visitor(root2, this.helpers);
                } catch (e) {
                    throw this.handleError(e);
                }
            }
        }
        this.processed = true;
        return this.stringify();
    }
    runOnRoot(plugin2) {
        this.result.lastPlugin = plugin2;
        try {
            if (typeof plugin2 === "object" && plugin2.Once) {
                if (this.result.root.type === "document") {
                    let roots = this.result.root.nodes.map((root2)=>plugin2.Once(root2, this.helpers));
                    if ($3e622689738ca3a1$var$isPromise(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin2.Once(this.result.root, this.helpers);
            } else if (typeof plugin2 === "function") return plugin2(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    }
    stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        let opts = this.result.opts;
        let str = $3e622689738ca3a1$var$stringify$2;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        let map = new $3e622689738ca3a1$var$MapGenerator$1(str, this.result.root, this.result.opts);
        let data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    }
    sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for (let plugin2 of this.plugins){
            let promise = this.runOnRoot(plugin2);
            if ($3e622689738ca3a1$var$isPromise(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root2 = this.result.root;
            while(!root2[$3e622689738ca3a1$var$isClean]){
                root2[$3e622689738ca3a1$var$isClean] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") for (let subRoot of root2.nodes)this.visitSync(this.listeners.OnceExit, subRoot);
                else this.visitSync(this.listeners.OnceExit, root2);
            }
        }
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this.css;
    }
    visitSync(visitors, node2) {
        for (let [plugin2, visitor] of visitors){
            this.result.lastPlugin = plugin2;
            let promise;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e) {
                throw this.handleError(e, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) return true;
            if ($3e622689738ca3a1$var$isPromise(promise)) throw this.getAsyncError();
        }
    }
    visitTick(stack) {
        let visit2 = stack[stack.length - 1];
        let { node: node2, visitors: visitors } = visit2;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            let [plugin2, visitor] = visitors[visit2.visitorIndex];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin2;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e) {
                throw this.handleError(e, node2);
            }
        }
        if (visit2.iterator !== 0) {
            let iterator = visit2.iterator;
            let child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[$3e622689738ca3a1$var$isClean]) {
                    child[$3e622689738ca3a1$var$isClean] = true;
                    stack.push($3e622689738ca3a1$var$toStack(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        let events = visit2.events;
        while(visit2.eventIndex < events.length){
            let event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === $3e622689738ca3a1$var$CHILDREN) {
                if (node2.nodes && node2.nodes.length) {
                    node2[$3e622689738ca3a1$var$isClean] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    }
    walkSync(node2) {
        node2[$3e622689738ca3a1$var$isClean] = true;
        let events = $3e622689738ca3a1$var$getEvents(node2);
        for (let event of events){
            if (event === $3e622689738ca3a1$var$CHILDREN) {
                if (node2.nodes) node2.each((child)=>{
                    if (!child[$3e622689738ca3a1$var$isClean]) this.walkSync(child);
                });
            } else {
                let visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    }
    warnings() {
        return this.sync().warnings();
    }
    get content() {
        return this.stringify().content;
    }
    get css() {
        return this.stringify().css;
    }
    get map() {
        return this.stringify().map;
    }
    get messages() {
        return this.sync().messages;
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        return this.sync().root;
    }
    get [Symbol.toStringTag]() {
        return "LazyResult";
    }
};
$3e622689738ca3a1$var$LazyResult$2.registerPostcss = (dependant)=>{
    $3e622689738ca3a1$var$postcss$2 = dependant;
};
var $3e622689738ca3a1$var$lazyResult = $3e622689738ca3a1$var$LazyResult$2;
$3e622689738ca3a1$var$LazyResult$2.default = $3e622689738ca3a1$var$LazyResult$2;
$3e622689738ca3a1$var$Root$3.registerLazyResult($3e622689738ca3a1$var$LazyResult$2);
$3e622689738ca3a1$var$Document$2.registerLazyResult($3e622689738ca3a1$var$LazyResult$2);
let $3e622689738ca3a1$var$MapGenerator2 = $3e622689738ca3a1$var$mapGenerator;
let $3e622689738ca3a1$var$stringify$1 = $3e622689738ca3a1$var$stringify_1;
let $3e622689738ca3a1$var$warnOnce2 = $3e622689738ca3a1$var$warnOnce$2;
let $3e622689738ca3a1$var$parse$1 = $3e622689738ca3a1$var$parse_1;
const $3e622689738ca3a1$var$Result$1 = $3e622689738ca3a1$var$result;
let $3e622689738ca3a1$var$NoWorkResult$1 = class NoWorkResult {
    constructor(processor2, css, opts){
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        let root2;
        let str = $3e622689738ca3a1$var$stringify$1;
        this.result = new $3e622689738ca3a1$var$Result$1(this._processor, root2, this._opts);
        this.result.css = css;
        let self = this;
        Object.defineProperty(this.result, "root", {
            get () {
                return self.root;
            }
        });
        let map = new $3e622689738ca3a1$var$MapGenerator2(str, root2, this._opts, css);
        if (map.isMap()) {
            let [generatedCSS, generatedMap] = map.generate();
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    sync() {
        if (this.error) throw this.error;
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this._css;
    }
    warnings() {
        return [];
    }
    get content() {
        return this.result.css;
    }
    get css() {
        return this.result.css;
    }
    get map() {
        return this.result.map;
    }
    get messages() {
        return [];
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        if (this._root) return this._root;
        let root2;
        let parser2 = $3e622689738ca3a1$var$parse$1;
        try {
            root2 = parser2(this._css, this._opts);
        } catch (error) {
            this.error = error;
        }
        if (this.error) throw this.error;
        else {
            this._root = root2;
            return root2;
        }
    }
    get [Symbol.toStringTag]() {
        return "NoWorkResult";
    }
};
var $3e622689738ca3a1$var$noWorkResult = $3e622689738ca3a1$var$NoWorkResult$1;
$3e622689738ca3a1$var$NoWorkResult$1.default = $3e622689738ca3a1$var$NoWorkResult$1;
let $3e622689738ca3a1$var$NoWorkResult2 = $3e622689738ca3a1$var$noWorkResult;
let $3e622689738ca3a1$var$LazyResult$1 = $3e622689738ca3a1$var$lazyResult;
let $3e622689738ca3a1$var$Document$1 = $3e622689738ca3a1$var$document$1;
let $3e622689738ca3a1$var$Root$2 = $3e622689738ca3a1$var$root;
let $3e622689738ca3a1$var$Processor$1 = class Processor {
    constructor(plugins = []){
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
    normalize(plugins) {
        let normalized = [];
        for (let i of plugins){
            if (i.postcss === true) i = i();
            else if (i.postcss) i = i.postcss;
            if (typeof i === "object" && Array.isArray(i.plugins)) normalized = normalized.concat(i.plugins);
            else if (typeof i === "object" && i.postcssPlugin) normalized.push(i);
            else if (typeof i === "function") normalized.push(i);
            else if (typeof i === "object" && (i.parse || i.stringify)) ;
            else throw new Error(i + " is not a PostCSS plugin");
        }
        return normalized;
    }
    process(css, opts = {}) {
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $3e622689738ca3a1$var$NoWorkResult2(this, css, opts);
        else return new $3e622689738ca3a1$var$LazyResult$1(this, css, opts);
    }
    use(plugin2) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin2
        ]));
        return this;
    }
};
var $3e622689738ca3a1$var$processor = $3e622689738ca3a1$var$Processor$1;
$3e622689738ca3a1$var$Processor$1.default = $3e622689738ca3a1$var$Processor$1;
$3e622689738ca3a1$var$Root$2.registerProcessor($3e622689738ca3a1$var$Processor$1);
$3e622689738ca3a1$var$Document$1.registerProcessor($3e622689738ca3a1$var$Processor$1);
let $3e622689738ca3a1$var$Declaration$1 = $3e622689738ca3a1$var$declaration;
let $3e622689738ca3a1$var$PreviousMap2 = $3e622689738ca3a1$var$previousMap;
let $3e622689738ca3a1$var$Comment$1 = $3e622689738ca3a1$var$comment;
let $3e622689738ca3a1$var$AtRule$1 = $3e622689738ca3a1$var$atRule;
let $3e622689738ca3a1$var$Input$1 = $3e622689738ca3a1$var$input;
let $3e622689738ca3a1$var$Root$1 = $3e622689738ca3a1$var$root;
let $3e622689738ca3a1$var$Rule$1 = $3e622689738ca3a1$var$rule;
function $3e622689738ca3a1$var$fromJSON$1(json, inputs) {
    if (Array.isArray(json)) return json.map((n)=>$3e622689738ca3a1$var$fromJSON$1(n));
    let { inputs: ownInputs, ...defaults } = json;
    if (ownInputs) {
        inputs = [];
        for (let input2 of ownInputs){
            let inputHydrated = {
                ...input2,
                __proto__: $3e622689738ca3a1$var$Input$1.prototype
            };
            if (inputHydrated.map) inputHydrated.map = {
                ...inputHydrated.map,
                __proto__: $3e622689738ca3a1$var$PreviousMap2.prototype
            };
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map((n)=>$3e622689738ca3a1$var$fromJSON$1(n, inputs));
    if (defaults.source) {
        let { inputId: inputId, ...source } = defaults.source;
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $3e622689738ca3a1$var$Root$1(defaults);
    else if (defaults.type === "decl") return new $3e622689738ca3a1$var$Declaration$1(defaults);
    else if (defaults.type === "rule") return new $3e622689738ca3a1$var$Rule$1(defaults);
    else if (defaults.type === "comment") return new $3e622689738ca3a1$var$Comment$1(defaults);
    else if (defaults.type === "atrule") return new $3e622689738ca3a1$var$AtRule$1(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
var $3e622689738ca3a1$var$fromJSON_1 = $3e622689738ca3a1$var$fromJSON$1;
$3e622689738ca3a1$var$fromJSON$1.default = $3e622689738ca3a1$var$fromJSON$1;
let $3e622689738ca3a1$var$CssSyntaxError2 = $3e622689738ca3a1$var$cssSyntaxError;
let $3e622689738ca3a1$var$Declaration2 = $3e622689738ca3a1$var$declaration;
let $3e622689738ca3a1$var$LazyResult2 = $3e622689738ca3a1$var$lazyResult;
let $3e622689738ca3a1$var$Container2 = $3e622689738ca3a1$var$container;
let $3e622689738ca3a1$var$Processor2 = $3e622689738ca3a1$var$processor;
let $3e622689738ca3a1$var$stringify = $3e622689738ca3a1$var$stringify_1;
let $3e622689738ca3a1$var$fromJSON = $3e622689738ca3a1$var$fromJSON_1;
let $3e622689738ca3a1$var$Document2 = $3e622689738ca3a1$var$document$1;
let $3e622689738ca3a1$var$Warning2 = $3e622689738ca3a1$var$warning;
let $3e622689738ca3a1$var$Comment2 = $3e622689738ca3a1$var$comment;
let $3e622689738ca3a1$var$AtRule2 = $3e622689738ca3a1$var$atRule;
let $3e622689738ca3a1$var$Result2 = $3e622689738ca3a1$var$result;
let $3e622689738ca3a1$var$Input2 = $3e622689738ca3a1$var$input;
let $3e622689738ca3a1$var$parse = $3e622689738ca3a1$var$parse_1;
let $3e622689738ca3a1$var$list = $3e622689738ca3a1$var$list_1;
let $3e622689738ca3a1$var$Rule2 = $3e622689738ca3a1$var$rule;
let $3e622689738ca3a1$var$Root2 = $3e622689738ca3a1$var$root;
let $3e622689738ca3a1$var$Node2 = $3e622689738ca3a1$var$node;
function $3e622689738ca3a1$var$postcss(...plugins) {
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $3e622689738ca3a1$var$Processor2(plugins);
}
$3e622689738ca3a1$var$postcss.plugin = function plugin(name, initializer) {
    let warningPrinted = false;
    function creator(...args) {
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        let transformer = initializer(...args);
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $3e622689738ca3a1$var$Processor2().version;
        return transformer;
    }
    let cache;
    Object.defineProperty(creator, "postcss", {
        get () {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $3e622689738ca3a1$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$3e622689738ca3a1$var$postcss.stringify = $3e622689738ca3a1$var$stringify;
$3e622689738ca3a1$var$postcss.parse = $3e622689738ca3a1$var$parse;
$3e622689738ca3a1$var$postcss.fromJSON = $3e622689738ca3a1$var$fromJSON;
$3e622689738ca3a1$var$postcss.list = $3e622689738ca3a1$var$list;
$3e622689738ca3a1$var$postcss.comment = (defaults)=>new $3e622689738ca3a1$var$Comment2(defaults);
$3e622689738ca3a1$var$postcss.atRule = (defaults)=>new $3e622689738ca3a1$var$AtRule2(defaults);
$3e622689738ca3a1$var$postcss.decl = (defaults)=>new $3e622689738ca3a1$var$Declaration2(defaults);
$3e622689738ca3a1$var$postcss.rule = (defaults)=>new $3e622689738ca3a1$var$Rule2(defaults);
$3e622689738ca3a1$var$postcss.root = (defaults)=>new $3e622689738ca3a1$var$Root2(defaults);
$3e622689738ca3a1$var$postcss.document = (defaults)=>new $3e622689738ca3a1$var$Document2(defaults);
$3e622689738ca3a1$var$postcss.CssSyntaxError = $3e622689738ca3a1$var$CssSyntaxError2;
$3e622689738ca3a1$var$postcss.Declaration = $3e622689738ca3a1$var$Declaration2;
$3e622689738ca3a1$var$postcss.Container = $3e622689738ca3a1$var$Container2;
$3e622689738ca3a1$var$postcss.Processor = $3e622689738ca3a1$var$Processor2;
$3e622689738ca3a1$var$postcss.Document = $3e622689738ca3a1$var$Document2;
$3e622689738ca3a1$var$postcss.Comment = $3e622689738ca3a1$var$Comment2;
$3e622689738ca3a1$var$postcss.Warning = $3e622689738ca3a1$var$Warning2;
$3e622689738ca3a1$var$postcss.AtRule = $3e622689738ca3a1$var$AtRule2;
$3e622689738ca3a1$var$postcss.Result = $3e622689738ca3a1$var$Result2;
$3e622689738ca3a1$var$postcss.Input = $3e622689738ca3a1$var$Input2;
$3e622689738ca3a1$var$postcss.Rule = $3e622689738ca3a1$var$Rule2;
$3e622689738ca3a1$var$postcss.Root = $3e622689738ca3a1$var$Root2;
$3e622689738ca3a1$var$postcss.Node = $3e622689738ca3a1$var$Node2;
$3e622689738ca3a1$var$LazyResult2.registerPostcss($3e622689738ca3a1$var$postcss);
var $3e622689738ca3a1$var$postcss_1 = $3e622689738ca3a1$var$postcss;
$3e622689738ca3a1$var$postcss.default = $3e622689738ca3a1$var$postcss;
const $3e622689738ca3a1$var$postcss$1 = /* @__PURE__ */ $3e622689738ca3a1$var$getDefaultExportFromCjs($3e622689738ca3a1$var$postcss_1);
$3e622689738ca3a1$var$postcss$1.stringify;
$3e622689738ca3a1$var$postcss$1.fromJSON;
$3e622689738ca3a1$var$postcss$1.plugin;
$3e622689738ca3a1$var$postcss$1.parse;
$3e622689738ca3a1$var$postcss$1.list;
$3e622689738ca3a1$var$postcss$1.document;
$3e622689738ca3a1$var$postcss$1.comment;
$3e622689738ca3a1$var$postcss$1.atRule;
$3e622689738ca3a1$var$postcss$1.rule;
$3e622689738ca3a1$var$postcss$1.decl;
$3e622689738ca3a1$var$postcss$1.root;
$3e622689738ca3a1$var$postcss$1.CssSyntaxError;
$3e622689738ca3a1$var$postcss$1.Declaration;
$3e622689738ca3a1$var$postcss$1.Container;
$3e622689738ca3a1$var$postcss$1.Processor;
$3e622689738ca3a1$var$postcss$1.Document;
$3e622689738ca3a1$var$postcss$1.Comment;
$3e622689738ca3a1$var$postcss$1.Warning;
$3e622689738ca3a1$var$postcss$1.AtRule;
$3e622689738ca3a1$var$postcss$1.Result;
$3e622689738ca3a1$var$postcss$1.Input;
$3e622689738ca3a1$var$postcss$1.Rule;
$3e622689738ca3a1$var$postcss$1.Root;
$3e622689738ca3a1$var$postcss$1.Node;
const $3e622689738ca3a1$var$tagMap = {
    script: "noscript",
    // camel case svg element tag names
    altglyph: "altGlyph",
    altglyphdef: "altGlyphDef",
    altglyphitem: "altGlyphItem",
    animatecolor: "animateColor",
    animatemotion: "animateMotion",
    animatetransform: "animateTransform",
    clippath: "clipPath",
    feblend: "feBlend",
    fecolormatrix: "feColorMatrix",
    fecomponenttransfer: "feComponentTransfer",
    fecomposite: "feComposite",
    feconvolvematrix: "feConvolveMatrix",
    fediffuselighting: "feDiffuseLighting",
    fedisplacementmap: "feDisplacementMap",
    fedistantlight: "feDistantLight",
    fedropshadow: "feDropShadow",
    feflood: "feFlood",
    fefunca: "feFuncA",
    fefuncb: "feFuncB",
    fefuncg: "feFuncG",
    fefuncr: "feFuncR",
    fegaussianblur: "feGaussianBlur",
    feimage: "feImage",
    femerge: "feMerge",
    femergenode: "feMergeNode",
    femorphology: "feMorphology",
    feoffset: "feOffset",
    fepointlight: "fePointLight",
    fespecularlighting: "feSpecularLighting",
    fespotlight: "feSpotLight",
    fetile: "feTile",
    feturbulence: "feTurbulence",
    foreignobject: "foreignObject",
    glyphref: "glyphRef",
    lineargradient: "linearGradient",
    radialgradient: "radialGradient"
};
function $3e622689738ca3a1$var$getTagName(n) {
    let tagName = $3e622689738ca3a1$var$tagMap[n.tagName] ? $3e622689738ca3a1$var$tagMap[n.tagName] : n.tagName;
    if (tagName === "link" && n.attributes._cssText) tagName = "style";
    return tagName;
}
function $3e622689738ca3a1$export$9c4151baa0370798(cssText, cache) {
    const cachedStyle = cache == null ? void 0 : cache.stylesWithHoverClass.get(cssText);
    if (cachedStyle) return cachedStyle;
    let result2 = cssText;
    try {
        const ast = $3e622689738ca3a1$var$postcss$1([
            $3e622689738ca3a1$var$mediaSelectorPlugin,
            $3e622689738ca3a1$var$pseudoClassPlugin
        ]).process(cssText);
        result2 = ast.css;
    } catch (error) {
        console.warn("Failed to adapt css for replay", error);
    }
    cache == null || cache.stylesWithHoverClass.set(cssText, result2);
    return result2;
}
function $3e622689738ca3a1$export$cf6fa0bbcc94b912() {
    const stylesWithHoverClass = /* @__PURE__ */ new Map();
    return {
        stylesWithHoverClass: stylesWithHoverClass
    };
}
function $3e622689738ca3a1$var$applyCssSplits(n, cssText, hackCss, cache) {
    const childTextNodes = [];
    for (const scn of n.childNodes)if (scn.type === $3e622689738ca3a1$var$NodeType.Text) childTextNodes.push(scn);
    const cssTextSplits = cssText.split("/* rr_split */");
    while(cssTextSplits.length > 1 && cssTextSplits.length > childTextNodes.length)cssTextSplits.splice(-2, 2, cssTextSplits.slice(-2).join(""));
    for(let i = 0; i < childTextNodes.length; i++){
        const childTextNode = childTextNodes[i];
        const cssTextSection = cssTextSplits[i];
        if (childTextNode && cssTextSection) childTextNode.textContent = hackCss ? $3e622689738ca3a1$export$9c4151baa0370798(cssTextSection, cache) : cssTextSection;
    }
}
function $3e622689738ca3a1$var$buildStyleNode(n, styleEl, cssText, options) {
    const { doc: doc, hackCss: hackCss, cache: cache } = options;
    if (n.childNodes.length) $3e622689738ca3a1$var$applyCssSplits(n, cssText, hackCss, cache);
    else {
        if (hackCss) cssText = $3e622689738ca3a1$export$9c4151baa0370798(cssText, cache);
        styleEl.appendChild(doc.createTextNode(cssText));
    }
}
function $3e622689738ca3a1$var$buildNode(n, options) {
    var _a;
    const { doc: doc, hackCss: hackCss, cache: cache } = options;
    switch(n.type){
        case $3e622689738ca3a1$var$NodeType.Document:
            return doc.implementation.createDocument(null, "", null);
        case $3e622689738ca3a1$var$NodeType.DocumentType:
            return doc.implementation.createDocumentType(n.name || "html", n.publicId, n.systemId);
        case $3e622689738ca3a1$var$NodeType.Element:
            {
                const tagName = $3e622689738ca3a1$var$getTagName(n);
                let node2;
                if (n.isSVG) node2 = doc.createElementNS("http://www.w3.org/2000/svg", tagName);
                else {
                    if (// If the tag name is a custom element name
                    n.isCustom && // If the browser supports custom elements
                    ((_a = doc.defaultView) == null ? void 0 : _a.customElements) && // If the custom element hasn't been defined yet
                    !doc.defaultView.customElements.get(n.tagName)) doc.defaultView.customElements.define(n.tagName, class extends doc.defaultView.HTMLElement {
                    });
                    node2 = doc.createElement(tagName);
                }
                const specialAttributes = {};
                for(const name in n.attributes){
                    if (!Object.prototype.hasOwnProperty.call(n.attributes, name)) continue;
                    let value = n.attributes[name];
                    if (tagName === "option" && name === "selected" && value === false) continue;
                    if (value === null) continue;
                    if (value === true) value = "";
                    if (name.startsWith("rr_")) {
                        specialAttributes[name] = value;
                        continue;
                    }
                    if (typeof value !== "string") ;
                    else if (tagName === "style" && name === "_cssText") {
                        $3e622689738ca3a1$var$buildStyleNode(n, node2, value, options);
                        continue;
                    } else if (tagName === "textarea" && name === "value") {
                        node2.appendChild(doc.createTextNode(value));
                        n.childNodes = [];
                        continue;
                    }
                    try {
                        if (n.isSVG && name === "xlink:href") node2.setAttributeNS("http://www.w3.org/1999/xlink", name, value.toString());
                        else if (name === "onload" || name === "onclick" || name.substring(0, 7) === "onmouse") node2.setAttribute("_" + name, value.toString());
                        else if (tagName === "meta" && n.attributes["http-equiv"] === "Content-Security-Policy" && name === "content") {
                            node2.setAttribute("csp-content", value.toString());
                            continue;
                        } else if (tagName === "link" && (n.attributes.rel === "preload" || n.attributes.rel === "modulepreload") && n.attributes.as === "script") ;
                        else if (tagName === "link" && n.attributes.rel === "prefetch" && typeof n.attributes.href === "string" && n.attributes.href.endsWith(".js")) ;
                        else if (tagName === "img" && n.attributes.srcset && n.attributes.rr_dataURL) node2.setAttribute("rrweb-original-srcset", n.attributes.srcset);
                        else node2.setAttribute(name, value.toString());
                    } catch (error) {}
                }
                for(const name in specialAttributes){
                    const value = specialAttributes[name];
                    if (tagName === "canvas" && name === "rr_dataURL") {
                        const image = doc.createElement("img");
                        image.onload = ()=>{
                            const ctx = node2.getContext("2d");
                            if (ctx) ctx.drawImage(image, 0, 0, image.width, image.height);
                        };
                        image.src = value.toString();
                        if (node2.RRNodeType) node2.rr_dataURL = value.toString();
                    } else if (tagName === "img" && name === "rr_dataURL") {
                        const image = node2;
                        if (!image.currentSrc.startsWith("data:")) {
                            image.setAttribute("rrweb-original-src", n.attributes.src);
                            image.src = value.toString();
                        }
                    }
                    if (name === "rr_width") node2.style.setProperty("width", value.toString());
                    else if (name === "rr_height") node2.style.setProperty("height", value.toString());
                    else if (name === "rr_mediaCurrentTime" && typeof value === "number") node2.currentTime = value;
                    else if (name === "rr_mediaState") switch(value){
                        case "played":
                            node2.play().catch((e)=>console.warn("media playback error", e));
                            break;
                        case "paused":
                            node2.pause();
                            break;
                    }
                    else if (name === "rr_mediaPlaybackRate" && typeof value === "number") node2.playbackRate = value;
                    else if (name === "rr_mediaMuted" && typeof value === "boolean") node2.muted = value;
                    else if (name === "rr_mediaLoop" && typeof value === "boolean") node2.loop = value;
                    else if (name === "rr_mediaVolume" && typeof value === "number") node2.volume = value;
                    else if (name === "rr_open_mode") node2.setAttribute("rr_open_mode", value);
                }
                if (n.isShadowHost) {
                    if (!node2.shadowRoot) node2.attachShadow({
                        mode: "open"
                    });
                    else while(node2.shadowRoot.firstChild)node2.shadowRoot.removeChild(node2.shadowRoot.firstChild);
                }
                return node2;
            }
        case $3e622689738ca3a1$var$NodeType.Text:
            if (n.isStyle && hackCss) return doc.createTextNode($3e622689738ca3a1$export$9c4151baa0370798(n.textContent, cache));
            return doc.createTextNode(n.textContent);
        case $3e622689738ca3a1$var$NodeType.CDATA:
            return doc.createCDATASection(n.textContent);
        case $3e622689738ca3a1$var$NodeType.Comment:
            return doc.createComment(n.textContent);
        default:
            return null;
    }
}
function $3e622689738ca3a1$export$24ec8ca0cae8790(n, options) {
    const { doc: doc, mirror: mirror, skipChild: skipChild = false, hackCss: hackCss = true, afterAppend: afterAppend, cache: cache } = options;
    if (mirror.has(n.id)) {
        const nodeInMirror = mirror.getNode(n.id);
        const meta = mirror.getMeta(nodeInMirror);
        if ($3e622689738ca3a1$export$ab8d9629a25fa8ef(meta, n)) return mirror.getNode(n.id);
    }
    let node2 = $3e622689738ca3a1$var$buildNode(n, {
        doc: doc,
        hackCss: hackCss,
        cache: cache
    });
    if (!node2) return null;
    if (n.rootId && mirror.getNode(n.rootId) !== doc) mirror.replace(n.rootId, doc);
    if (n.type === $3e622689738ca3a1$var$NodeType.Document) {
        doc.close();
        doc.open();
        if (n.compatMode === "BackCompat" && n.childNodes && n.childNodes[0].type !== $3e622689738ca3a1$var$NodeType.DocumentType) {
            if (n.childNodes[0].type === $3e622689738ca3a1$var$NodeType.Element && "xmlns" in n.childNodes[0].attributes && n.childNodes[0].attributes.xmlns === "http://www.w3.org/1999/xhtml") doc.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "">');
            else doc.write('<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "">');
        }
        node2 = doc;
    }
    mirror.add(node2, n);
    if ((n.type === $3e622689738ca3a1$var$NodeType.Document || n.type === $3e622689738ca3a1$var$NodeType.Element) && !skipChild) for (const childN of n.childNodes){
        const childNode = $3e622689738ca3a1$export$24ec8ca0cae8790(childN, {
            doc: doc,
            mirror: mirror,
            skipChild: false,
            hackCss: hackCss,
            afterAppend: afterAppend,
            cache: cache
        });
        if (!childNode) {
            console.warn("Failed to rebuild", childN);
            continue;
        }
        if (childN.isShadow && $3e622689738ca3a1$export$45a5e7f76e0caa8d(node2) && node2.shadowRoot) node2.shadowRoot.appendChild(childNode);
        else if (n.type === $3e622689738ca3a1$var$NodeType.Document && childN.type == $3e622689738ca3a1$var$NodeType.Element) {
            const htmlElement = childNode;
            let body = null;
            htmlElement.childNodes.forEach((child)=>{
                if (child.nodeName === "BODY") body = child;
            });
            if (body) {
                htmlElement.removeChild(body);
                node2.appendChild(childNode);
                htmlElement.appendChild(body);
            } else node2.appendChild(childNode);
        } else node2.appendChild(childNode);
        if (afterAppend) afterAppend(childNode, childN.id);
    }
    return node2;
}
function $3e622689738ca3a1$var$visit(mirror, onVisit) {
    function walk(node2) {
        onVisit(node2);
    }
    for (const id of mirror.getIds())if (mirror.has(id)) walk(mirror.getNode(id));
}
function $3e622689738ca3a1$var$handleScroll(node2, mirror) {
    const n = mirror.getMeta(node2);
    if ((n == null ? void 0 : n.type) !== $3e622689738ca3a1$var$NodeType.Element) return;
    const el = node2;
    for(const name in n.attributes){
        if (!(Object.prototype.hasOwnProperty.call(n.attributes, name) && name.startsWith("rr_"))) continue;
        const value = n.attributes[name];
        if (name === "rr_scrollLeft") el.scrollLeft = value;
        if (name === "rr_scrollTop") el.scrollTop = value;
    }
}
function $3e622689738ca3a1$export$e95decb5aab14503(n, options) {
    const { doc: doc, onVisit: onVisit, hackCss: hackCss = true, afterAppend: afterAppend, cache: cache, mirror: mirror = new $3e622689738ca3a1$export$a80993881abc373d() } = options;
    const node2 = $3e622689738ca3a1$export$24ec8ca0cae8790(n, {
        doc: doc,
        mirror: mirror,
        skipChild: false,
        hackCss: hackCss,
        afterAppend: afterAppend,
        cache: cache
    });
    $3e622689738ca3a1$var$visit(mirror, (visitedNode)=>{
        if (onVisit) onVisit(visitedNode);
        $3e622689738ca3a1$var$handleScroll(visitedNode, mirror);
    });
    return node2;
}

});

parcelRegister("hT1mD", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MASK_LEVEL", () => $d058a19dfdea0d65$export$fd9fda72fba2fd59);
var $d058a19dfdea0d65$export$fd9fda72fba2fd59 = 'medium';

});



parcelRegister("8ceUs", function(module, exports) {

$parcel$export(module.exports, "createEventsManager", () => $5f7b0270c3fcbbb0$export$e50880e61cbada11);

var $3VFsf = parcelRequire("3VFsf");

var $6Wtbz = parcelRequire("6Wtbz");

var $btsg0 = parcelRequire("btsg0");

var $9Ka73 = parcelRequire("9Ka73");

var $gxFrz = parcelRequire("gxFrz");
var $5f7b0270c3fcbbb0$export$e50880e61cbada11 = function(_a) {
    var config = _a.config, sessionId = _a.sessionId, minInterval = _a.minInterval, maxInterval = _a.maxInterval, type = _a.type, payloadBatcher = _a.payloadBatcher, storeType = _a.storeType;
    return (0, $3VFsf.__awaiter)(void 0, void 0, void 0, function() {
        function flush(useRetry) {
            if (useRetry === void 0) useRetry = false;
            return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
                return (0, $3VFsf.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        trackDestination.flush(useRetry)
                    ];
                });
            });
        }
        var trackDestination, getMemoryStore, getIdbStoreOrFallback, store, _b, sendEventsList, sendCurrentSequenceEvents, sendStoredEvents, addEvent;
        return (0, $3VFsf.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    trackDestination = new (0, $btsg0.SessionReplayTrackDestination)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, config), {
                        loggerProvider: config.loggerProvider,
                        payloadBatcher: payloadBatcher
                    }));
                    getMemoryStore = function() {
                        return new (0, $gxFrz.InMemoryEventsStore)({
                            loggerProvider: config.loggerProvider,
                            maxInterval: maxInterval,
                            minInterval: minInterval
                        });
                    };
                    getIdbStoreOrFallback = function() {
                        return (0, $3VFsf.__awaiter)(void 0, void 0, void 0, function() {
                            var store;
                            return (0, $3VFsf.__generator)(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            (0, $9Ka73.SessionReplayEventsIDBStore).new(type, {
                                                loggerProvider: config.loggerProvider,
                                                minInterval: minInterval,
                                                maxInterval: maxInterval,
                                                apiKey: config.apiKey
                                            }, sessionId)
                                        ];
                                    case 1:
                                        store = _a.sent();
                                        config.loggerProvider.log('Failed to initialize idb store, falling back to memory store.');
                                        return [
                                            2 /*return*/ ,
                                            store !== null && store !== void 0 ? store : getMemoryStore()
                                        ];
                                }
                            });
                        });
                    };
                    if (!(storeType === 'idb')) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        getIdbStoreOrFallback()
                    ];
                case 1:
                    _b = _c.sent();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    _b = getMemoryStore();
                    _c.label = 3;
                case 3:
                    store = _b;
                    sendEventsList = function(_a) {
                        var events = _a.events, sessionId = _a.sessionId, deviceId = _a.deviceId, sequenceId = _a.sequenceId;
                        if (config.debugMode) (0, $6Wtbz.getStorageSize)().then(function(_a) {
                            var totalStorageSize = _a.totalStorageSize, percentOfQuota = _a.percentOfQuota, usageDetails = _a.usageDetails;
                            config.loggerProvider.debug("Total storage size: ".concat(totalStorageSize, " KB, percentage of quota: ").concat(percentOfQuota, "%, usage details: ").concat(usageDetails));
                        }).catch(function() {
                        // swallow error
                        });
                        trackDestination.sendEventsList({
                            events: events,
                            sessionId: sessionId,
                            flushMaxRetries: config.flushMaxRetries,
                            apiKey: config.apiKey,
                            deviceId: deviceId,
                            sampleRate: config.sampleRate,
                            serverZone: config.serverZone,
                            version: config.version,
                            type: type,
                            onComplete: function() {
                                return (0, $3VFsf.__awaiter)(void 0, void 0, void 0, function() {
                                    return (0, $3VFsf.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    store.cleanUpSessionEventsStore(sessionId, sequenceId)
                                                ];
                                            case 1:
                                                _a.sent();
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }
                        });
                    };
                    sendCurrentSequenceEvents = function(_a) {
                        var sessionId = _a.sessionId, deviceId = _a.deviceId;
                        store.storeCurrentSequence(sessionId).then(function(currentSequence) {
                            if (currentSequence) sendEventsList({
                                sequenceId: currentSequence.sequenceId,
                                events: currentSequence.events,
                                sessionId: currentSequence.sessionId,
                                deviceId: deviceId
                            });
                        }).catch(function(e) {
                            config.loggerProvider.warn('Failed to get current sequence of session replay events for session:', e);
                        });
                    };
                    sendStoredEvents = function(_a) {
                        var deviceId = _a.deviceId;
                        return (0, $3VFsf.__awaiter)(void 0, void 0, void 0, function() {
                            var sequencesToSend;
                            return (0, $3VFsf.__generator)(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            store.getSequencesToSend()
                                        ];
                                    case 1:
                                        sequencesToSend = _b.sent();
                                        sequencesToSend && sequencesToSend.forEach(function(sequence) {
                                            sendEventsList({
                                                sequenceId: sequence.sequenceId,
                                                events: sequence.events,
                                                sessionId: sequence.sessionId,
                                                deviceId: deviceId
                                            });
                                        });
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    addEvent = function(_a) {
                        var event = _a.event, sessionId = _a.sessionId, deviceId = _a.deviceId;
                        store.addEventToCurrentSequence(sessionId, event.data).then(function(sequenceToSend) {
                            return sequenceToSend && sendEventsList({
                                sequenceId: sequenceToSend.sequenceId,
                                events: sequenceToSend.events,
                                sessionId: sequenceToSend.sessionId,
                                deviceId: deviceId
                            });
                        }).catch(function(e) {
                            config.loggerProvider.warn('Failed to add event to session replay capture:', e);
                        });
                    };
                    return [
                        2 /*return*/ ,
                        {
                            sendCurrentSequenceEvents: sendCurrentSequenceEvents,
                            addEvent: addEvent,
                            sendStoredEvents: sendStoredEvents,
                            flush: flush
                        }
                    ];
            }
        });
    });
};

});
parcelRegister("btsg0", function(module, exports) {

$parcel$export(module.exports, "SessionReplayTrackDestination", () => $85a8526da5833b7a$export$c02b7e33b753e1b6);

var $3VFsf = parcelRequire("3VFsf");

var $aOGzY = parcelRequire("aOGzY");
var $fsuka = parcelRequire("fsuka");

var $6Wtbz = parcelRequire("6Wtbz");

var $cf3Bu = parcelRequire("cf3Bu");

var $knBOj = parcelRequire("knBOj");

var $gPQg5 = parcelRequire("gPQg5");
var $85a8526da5833b7a$export$c02b7e33b753e1b6 = /** @class */ function() {
    function SessionReplayTrackDestination(_a) {
        var trackServerUrl = _a.trackServerUrl, loggerProvider = _a.loggerProvider, payloadBatcher = _a.payloadBatcher;
        this.storageKey = '';
        this.retryTimeout = 1000;
        this.scheduled = null;
        this.queue = [];
        this.loggerProvider = loggerProvider;
        this.payloadBatcher = payloadBatcher ? payloadBatcher : function(payload) {
            return payload;
        };
        this.trackServerUrl = trackServerUrl;
    }
    SessionReplayTrackDestination.prototype.sendEventsList = function(destinationData) {
        this.addToQueue((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, destinationData), {
            attempts: 0,
            timeout: 0
        }));
    };
    SessionReplayTrackDestination.prototype.addToQueue = function() {
        var _this = this;
        var list = [];
        for(var _i = 0; _i < arguments.length; _i++)list[_i] = arguments[_i];
        var tryable = list.filter(function(context) {
            if (context.attempts < (context.flushMaxRetries || 0)) {
                context.attempts += 1;
                return true;
            }
            _this.completeRequest({
                context: context,
                err: (0, $cf3Bu.MAX_RETRIES_EXCEEDED_MESSAGE)
            });
            return false;
        });
        tryable.forEach(function(context) {
            _this.queue = _this.queue.concat(context);
            if (context.timeout === 0) {
                _this.schedule(0);
                return;
            }
            setTimeout(function() {
                context.timeout = 0;
                _this.schedule(0);
            }, context.timeout);
        });
    };
    SessionReplayTrackDestination.prototype.schedule = function(timeout) {
        var _this = this;
        if (this.scheduled) return;
        this.scheduled = setTimeout(function() {
            _this.flush(true).then(function() {
                if (_this.queue.length > 0) _this.schedule(timeout);
            });
        }, timeout);
    };
    SessionReplayTrackDestination.prototype.flush = function(useRetry) {
        if (useRetry === void 0) useRetry = false;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var list, later;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        list = [];
                        later = [];
                        this.queue.forEach(function(context) {
                            return context.timeout === 0 ? list.push(context) : later.push(context);
                        });
                        this.queue = later;
                        if (this.scheduled) {
                            clearTimeout(this.scheduled);
                            this.scheduled = null;
                        }
                        return [
                            4 /*yield*/ ,
                            Promise.all(list.map(function(context) {
                                return _this.send(context, useRetry);
                            }))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionReplayTrackDestination.prototype.send = function(context, useRetry) {
        var _a, _b;
        if (useRetry === void 0) useRetry = true;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var apiKey, deviceId, url, version, sampleRate, urlParams, sessionReplayLibrary, payload, options, serverUrl, res, responseBody, e_1;
            return (0, $3VFsf.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        apiKey = context.apiKey;
                        if (!apiKey) return [
                            2 /*return*/ ,
                            this.completeRequest({
                                context: context,
                                err: (0, $cf3Bu.MISSING_API_KEY_MESSAGE)
                            })
                        ];
                        deviceId = context.deviceId;
                        if (!deviceId) return [
                            2 /*return*/ ,
                            this.completeRequest({
                                context: context,
                                err: (0, $cf3Bu.MISSING_DEVICE_ID_MESSAGE)
                            })
                        ];
                        url = (0, $6Wtbz.getCurrentUrl)();
                        version = (0, $knBOj.VERSION);
                        sampleRate = context.sampleRate;
                        urlParams = new URLSearchParams({
                            device_id: deviceId,
                            session_id: "".concat(context.sessionId),
                            type: "".concat(context.type)
                        });
                        sessionReplayLibrary = "".concat(((_a = context.version) === null || _a === void 0 ? void 0 : _a.type) || 'standalone', "/").concat(((_b = context.version) === null || _b === void 0 ? void 0 : _b.version) || version);
                        payload = this.payloadBatcher({
                            version: 1,
                            events: context.events
                        });
                        if (payload.events.length === 0) {
                            this.completeRequest({
                                context: context
                            });
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        options = {
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: '*/*',
                                Authorization: "Bearer ".concat(apiKey),
                                'X-Client-Version': version,
                                'X-Client-Library': sessionReplayLibrary,
                                'X-Client-Url': url.substring(0, (0, $gPQg5.MAX_URL_LENGTH)),
                                'X-Client-Sample-Rate': "".concat(sampleRate)
                            },
                            body: JSON.stringify(payload),
                            method: 'POST'
                        };
                        serverUrl = "".concat((0, $6Wtbz.getServerUrl)(context.serverZone, this.trackServerUrl), "?").concat(urlParams.toString());
                        return [
                            4 /*yield*/ ,
                            fetch(serverUrl, options)
                        ];
                    case 2:
                        res = _c.sent();
                        if (res === null) {
                            this.completeRequest({
                                context: context,
                                err: (0, $cf3Bu.UNEXPECTED_ERROR_MESSAGE)
                            });
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (!useRetry) {
                            responseBody = '';
                            try {
                                responseBody = JSON.stringify(res.body, null, 2);
                            } catch (_d) {
                            // to avoid crash, but don't care about the error, add comment to avoid empty block lint error
                            }
                            this.completeRequest({
                                context: context,
                                success: "".concat(res.status, ": ").concat(responseBody)
                            });
                        } else this.handleReponse(res.status, context);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _c.sent();
                        this.completeRequest({
                            context: context,
                            err: e_1
                        });
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionReplayTrackDestination.prototype.handleReponse = function(status, context) {
        var parsedStatus = new (0, $aOGzY.BaseTransport)().buildStatus(status);
        switch(parsedStatus){
            case (0, $fsuka.Status).Success:
                this.handleSuccessResponse(context);
                break;
            case (0, $fsuka.Status).Failed:
                this.handleOtherResponse(context);
                break;
            default:
                this.completeRequest({
                    context: context,
                    err: (0, $cf3Bu.UNEXPECTED_NETWORK_ERROR_MESSAGE)
                });
        }
    };
    SessionReplayTrackDestination.prototype.handleSuccessResponse = function(context) {
        var sizeOfEventsList = Math.round(new Blob(context.events).size / (0, $gPQg5.KB_SIZE));
        this.completeRequest({
            context: context,
            success: "Session replay event batch tracked successfully for session id ".concat(context.sessionId, ", size of events: ").concat(sizeOfEventsList, " KB")
        });
    };
    SessionReplayTrackDestination.prototype.handleOtherResponse = function(context) {
        this.addToQueue((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
            timeout: context.attempts * this.retryTimeout
        }));
    };
    SessionReplayTrackDestination.prototype.completeRequest = function(_a) {
        var context = _a.context, err = _a.err, success = _a.success;
        context.onComplete();
        if (err) this.loggerProvider.warn(err);
        else if (success) this.loggerProvider.log(success);
    };
    return SessionReplayTrackDestination;
}();

});
parcelRegister("cf3Bu", function(module, exports) {

$parcel$export(module.exports, "UNEXPECTED_ERROR_MESSAGE", () => $8e99ae588e99ac61$export$77be9b23e6f97080);
$parcel$export(module.exports, "UNEXPECTED_NETWORK_ERROR_MESSAGE", () => $8e99ae588e99ac61$export$85dfb1b70c6950c8);
$parcel$export(module.exports, "MAX_RETRIES_EXCEEDED_MESSAGE", () => $8e99ae588e99ac61$export$db21e8e2aba60c7d);
$parcel$export(module.exports, "STORAGE_FAILURE", () => $8e99ae588e99ac61$export$c9ef45adc7aea7ba);
$parcel$export(module.exports, "MISSING_DEVICE_ID_MESSAGE", () => $8e99ae588e99ac61$export$7f1bc1279abcc1f1);
$parcel$export(module.exports, "MISSING_API_KEY_MESSAGE", () => $8e99ae588e99ac61$export$9229755af3d7ecf1);
var $8e99ae588e99ac61$export$77be9b23e6f97080 = 'Unexpected error occurred';
var $8e99ae588e99ac61$export$85dfb1b70c6950c8 = 'Network error occurred, event batch rejected';
var $8e99ae588e99ac61$export$db21e8e2aba60c7d = 'Session replay event batch rejected due to exceeded retry count';
var $8e99ae588e99ac61$export$c9ef45adc7aea7ba = 'Failed to store session replay events in IndexedDB';
var $8e99ae588e99ac61$export$7f1bc1279abcc1f1 = 'Session replay event batch not sent due to missing device ID';
var $8e99ae588e99ac61$export$9229755af3d7ecf1 = 'Session replay event batch not sent due to missing api key';

});

parcelRegister("knBOj", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $ed6349061de8a7d2$export$a4ad2735b021c132);
// Autogenerated by `yarn version-file`. DO NOT EDIT
var $ed6349061de8a7d2$export$a4ad2735b021c132 = '1.22.5';

});


parcelRegister("9Ka73", function(module, exports) {

$parcel$export(module.exports, "SessionReplayEventsIDBStore", () => $71804121416ec2f6$export$a694e687d3b08e06);

var $3VFsf = parcelRequire("3VFsf");

var $gOnHi = parcelRequire("gOnHi");
var $hAghI = parcelRequire("hAghI");

var $8Rw0V = parcelRequire("8Rw0V");

var $cf3Bu = parcelRequire("cf3Bu");

var $53V2s = parcelRequire("53V2s");

var $9elZm = parcelRequire("9elZm");
var $71804121416ec2f6$export$861544f340d49a94 = 'sessionCurrentSequence';
var $71804121416ec2f6$export$d89e245593d1690c = 'sequencesToSend';
var $71804121416ec2f6$export$61c84e7d233f97db = 'remoteConfig';
var $71804121416ec2f6$export$52f7e44fb9d5bd20 = function() {
    var globalScope = (0, $gOnHi.getGlobalScope)();
    return new Promise(function(resolve, reject) {
        if (!globalScope) return reject(new Error('Global scope not found'));
        if (!globalScope.indexedDB) return reject(new Error('Session Replay: cannot find indexedDB'));
        try {
            var request_1 = globalScope.indexedDB.open('keyval-store');
            request_1.onupgradeneeded = function() {
                if (request_1.result.version === 1) {
                    request_1.result.close();
                    request_1.transaction && request_1.transaction.abort();
                    globalScope.indexedDB.deleteDatabase('keyval-store');
                    resolve();
                }
            };
            request_1.onsuccess = function() {
                resolve(request_1.result);
            };
        } catch (e) {
            reject(e);
        }
    });
};
var $71804121416ec2f6$var$batchPromiseAll = function(promiseBatch) {
    return (0, $3VFsf.__awaiter)(void 0, void 0, void 0, function() {
        var chunkSize, batch;
        return (0, $3VFsf.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(promiseBatch.length > 0)) return [
                        3 /*break*/ ,
                        2
                    ];
                    chunkSize = 10;
                    batch = promiseBatch.splice(0, chunkSize);
                    return [
                        4 /*yield*/ ,
                        Promise.all(batch)
                    ];
                case 1:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        0
                    ];
                case 2:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $71804121416ec2f6$export$42488f0b93e35169 = function(db) {
    var sequencesStore;
    var currentSequenceStore;
    if (!db.objectStoreNames.contains($71804121416ec2f6$export$861544f340d49a94)) currentSequenceStore = db.createObjectStore($71804121416ec2f6$export$861544f340d49a94, {
        keyPath: 'sessionId'
    });
    if (!db.objectStoreNames.contains($71804121416ec2f6$export$d89e245593d1690c)) {
        sequencesStore = db.createObjectStore($71804121416ec2f6$export$d89e245593d1690c, {
            keyPath: 'sequenceId',
            autoIncrement: true
        });
        sequencesStore.createIndex('sessionId', 'sessionId');
    }
    return {
        sequencesStore: sequencesStore,
        currentSequenceStore: currentSequenceStore
    };
};
var $71804121416ec2f6$export$f51a9068ac82ea43 = function(dbName) {
    return (0, $3VFsf.__awaiter)(void 0, void 0, void 0, function() {
        return (0, $3VFsf.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, $8Rw0V.openDB)(dbName, 1, {
                            upgrade: $71804121416ec2f6$export$42488f0b93e35169
                        })
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
};
var $71804121416ec2f6$export$a694e687d3b08e06 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(SessionReplayEventsIDBStore, _super);
    function SessionReplayEventsIDBStore(args) {
        var _this = _super.call(this, args) || this;
        _this.getSequencesToSend = function() {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var sequences, cursor, _a, sessionId, events, e_1;
                return (0, $3VFsf.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _b.trys.push([
                                0,
                                5,
                                ,
                                6
                            ]);
                            sequences = [];
                            return [
                                4 /*yield*/ ,
                                this.db.transaction('sequencesToSend').store.openCursor()
                            ];
                        case 1:
                            cursor = _b.sent();
                            _b.label = 2;
                        case 2:
                            if (!cursor) return [
                                3 /*break*/ ,
                                4
                            ];
                            _a = cursor.value, sessionId = _a.sessionId, events = _a.events;
                            sequences.push({
                                events: events,
                                sequenceId: cursor.key,
                                sessionId: sessionId
                            });
                            return [
                                4 /*yield*/ ,
                                cursor.continue()
                            ];
                        case 3:
                            cursor = _b.sent();
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 4:
                            return [
                                2 /*return*/ ,
                                sequences
                            ];
                        case 5:
                            e_1 = _b.sent();
                            this.loggerProvider.warn("".concat((0, $cf3Bu.STORAGE_FAILURE), ": ").concat(e_1));
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 6:
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                    }
                });
            });
        };
        _this.storeCurrentSequence = function(sessionId) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var currentSequenceData, sequenceId, e_2;
                return (0, $3VFsf.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.db.get($71804121416ec2f6$export$861544f340d49a94, sessionId)
                            ];
                        case 1:
                            currentSequenceData = _a.sent();
                            if (!currentSequenceData) return [
                                2 /*return*/ ,
                                undefined
                            ];
                            return [
                                4 /*yield*/ ,
                                this.db.put($71804121416ec2f6$export$d89e245593d1690c, {
                                    sessionId: sessionId,
                                    events: currentSequenceData.events
                                })
                            ];
                        case 2:
                            sequenceId = _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.db.put($71804121416ec2f6$export$861544f340d49a94, {
                                    sessionId: sessionId,
                                    events: []
                                })
                            ];
                        case 3:
                            _a.sent();
                            return [
                                2 /*return*/ ,
                                (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentSequenceData), {
                                    sessionId: sessionId,
                                    sequenceId: sequenceId
                                })
                            ];
                        case 4:
                            e_2 = _a.sent();
                            this.loggerProvider.warn("".concat((0, $cf3Bu.STORAGE_FAILURE), ": ").concat(e_2));
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                    }
                });
            });
        };
        _this.addEventToCurrentSequence = function(sessionId, event) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var tx, sequenceEvents, eventsToSend, updatedEvents, sequenceId, e_3;
                return (0, $3VFsf.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                10,
                                ,
                                11
                            ]);
                            tx = this.db.transaction($71804121416ec2f6$export$861544f340d49a94, 'readwrite');
                            return [
                                4 /*yield*/ ,
                                tx.store.get(sessionId)
                            ];
                        case 1:
                            sequenceEvents = _a.sent();
                            if (!!sequenceEvents) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                tx.store.put({
                                    sessionId: sessionId,
                                    events: [
                                        event
                                    ]
                                })
                            ];
                        case 2:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 3:
                            eventsToSend = void 0;
                            if (!this.shouldSplitEventsList(sequenceEvents.events, event)) return [
                                3 /*break*/ ,
                                5
                            ];
                            eventsToSend = sequenceEvents.events;
                            // set store to empty array
                            return [
                                4 /*yield*/ ,
                                tx.store.put({
                                    sessionId: sessionId,
                                    events: [
                                        event
                                    ]
                                })
                            ];
                        case 4:
                            // set store to empty array
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 5:
                            updatedEvents = sequenceEvents.events.concat(event);
                            return [
                                4 /*yield*/ ,
                                tx.store.put({
                                    sessionId: sessionId,
                                    events: updatedEvents
                                })
                            ];
                        case 6:
                            _a.sent();
                            _a.label = 7;
                        case 7:
                            return [
                                4 /*yield*/ ,
                                tx.done
                            ];
                        case 8:
                            _a.sent();
                            if (!eventsToSend) return [
                                2 /*return*/ ,
                                undefined
                            ];
                            return [
                                4 /*yield*/ ,
                                this.storeSendingEvents(sessionId, eventsToSend)
                            ];
                        case 9:
                            sequenceId = _a.sent();
                            if (!sequenceId) return [
                                2 /*return*/ ,
                                undefined
                            ];
                            return [
                                2 /*return*/ ,
                                {
                                    events: eventsToSend,
                                    sessionId: sessionId,
                                    sequenceId: sequenceId
                                }
                            ];
                        case 10:
                            e_3 = _a.sent();
                            this.loggerProvider.warn("".concat((0, $cf3Bu.STORAGE_FAILURE), ": ").concat(e_3));
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 11:
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                    }
                });
            });
        };
        _this.storeSendingEvents = function(sessionId, events) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var sequenceId, e_4;
                return (0, $3VFsf.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.db.put($71804121416ec2f6$export$d89e245593d1690c, {
                                    sessionId: sessionId,
                                    events: events
                                })
                            ];
                        case 1:
                            sequenceId = _a.sent();
                            return [
                                2 /*return*/ ,
                                sequenceId
                            ];
                        case 2:
                            e_4 = _a.sent();
                            this.loggerProvider.warn("".concat((0, $cf3Bu.STORAGE_FAILURE), ": ").concat(e_4));
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                    }
                });
            });
        };
        _this.cleanUpSessionEventsStore = function(_sessionId, sequenceId) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var e_5;
                return (0, $3VFsf.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!sequenceId) return [
                                2 /*return*/ 
                            ];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.db.delete($71804121416ec2f6$export$d89e245593d1690c, sequenceId)
                            ];
                        case 2:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            e_5 = _a.sent();
                            this.loggerProvider.warn("".concat((0, $cf3Bu.STORAGE_FAILURE), ": ").concat(e_5));
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        _this.transitionFromKeyValStore = function(sessionId) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var keyValDb, transitionCurrentSessionSequences_1, storageKey, getAllRequest_1, transitionPromise, globalScope, e_6, e_7;
                var _this = this;
                return (0, $3VFsf.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                6,
                                ,
                                7
                            ]);
                            return [
                                4 /*yield*/ ,
                                $71804121416ec2f6$export$52f7e44fb9d5bd20()
                            ];
                        case 1:
                            keyValDb = _a.sent();
                            if (!keyValDb) return [
                                2 /*return*/ 
                            ];
                            transitionCurrentSessionSequences_1 = function(numericSessionId, sessionStore) {
                                return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                                    var currentSessionSequences, promisesToBatch;
                                    var _this = this;
                                    return (0, $3VFsf.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                currentSessionSequences = sessionStore.sessionSequences;
                                                promisesToBatch = [];
                                                Object.keys(currentSessionSequences).forEach(function(sequenceId) {
                                                    var numericSequenceId = parseInt(sequenceId, 10);
                                                    var sequence = currentSessionSequences[numericSequenceId];
                                                    if (numericSequenceId === sessionStore.currentSequenceId) {
                                                        var eventAddPromises = sequence.events.map(function(event) {
                                                            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                                                                return (0, $3VFsf.__generator)(this, function(_a) {
                                                                    return [
                                                                        2 /*return*/ ,
                                                                        this.addEventToCurrentSequence(numericSessionId, event)
                                                                    ];
                                                                });
                                                            });
                                                        });
                                                        promisesToBatch.concat(eventAddPromises);
                                                    } else if (sequence.status !== (0, $9elZm.RecordingStatus).SENT) promisesToBatch.push(_this.storeSendingEvents(numericSessionId, sequence.events));
                                                });
                                                return [
                                                    4 /*yield*/ ,
                                                    $71804121416ec2f6$var$batchPromiseAll(promisesToBatch)
                                                ];
                                            case 1:
                                                _a.sent();
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            };
                            storageKey = "".concat((0, $hAghI.STORAGE_PREFIX), "_").concat(this.apiKey.substring(0, 10));
                            _a.label = 2;
                        case 2:
                            _a.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            getAllRequest_1 = keyValDb.transaction('keyval').objectStore('keyval').getAll(storageKey);
                            transitionPromise = new Promise(function(resolve) {
                                getAllRequest_1.onsuccess = function(e) {
                                    return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                                        var storedReplaySessionContextList, storedReplaySessionContexts, promisesToBatch_1;
                                        var _this = this;
                                        return (0, $3VFsf.__generator)(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    storedReplaySessionContextList = e && e.target.result;
                                                    storedReplaySessionContexts = storedReplaySessionContextList && storedReplaySessionContextList[0];
                                                    if (!storedReplaySessionContexts) return [
                                                        3 /*break*/ ,
                                                        2
                                                    ];
                                                    promisesToBatch_1 = [];
                                                    Object.keys(storedReplaySessionContexts).forEach(function(storedSessionId) {
                                                        var numericSessionId = parseInt(storedSessionId, 10);
                                                        var oldSessionStore = storedReplaySessionContexts[numericSessionId];
                                                        if (sessionId === numericSessionId) promisesToBatch_1.push(transitionCurrentSessionSequences_1(numericSessionId, oldSessionStore));
                                                        else {
                                                            var oldSessionSequences_1 = oldSessionStore.sessionSequences;
                                                            Object.keys(oldSessionSequences_1).forEach(function(sequenceId) {
                                                                var numericSequenceId = parseInt(sequenceId, 10);
                                                                if (oldSessionSequences_1[numericSequenceId].status !== (0, $9elZm.RecordingStatus).SENT) promisesToBatch_1.push(_this.storeSendingEvents(numericSessionId, oldSessionSequences_1[numericSequenceId].events));
                                                            });
                                                        }
                                                    });
                                                    return [
                                                        4 /*yield*/ ,
                                                        $71804121416ec2f6$var$batchPromiseAll(promisesToBatch_1)
                                                    ];
                                                case 1:
                                                    _a.sent();
                                                    _a.label = 2;
                                                case 2:
                                                    resolve();
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                };
                            });
                            return [
                                4 /*yield*/ ,
                                transitionPromise
                            ];
                        case 3:
                            _a.sent();
                            globalScope = (0, $gOnHi.getGlobalScope)();
                            if (globalScope) globalScope.indexedDB.deleteDatabase('keyval-store');
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            e_6 = _a.sent();
                            this.loggerProvider.warn("Failed to transition session replay events from keyval to new store: ".concat(e_6));
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 6:
                            e_7 = _a.sent();
                            this.loggerProvider.warn("Failed to access keyval store: ".concat(e_7, ". For more information, visit: https://www.docs.developers.amplitude.com/session-replay/sdks/standalone/#indexeddb-best-practices"));
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 7:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        _this.apiKey = args.apiKey;
        _this.db = args.db;
        return _this;
    }
    SessionReplayEventsIDBStore.new = function(type, args, sessionId) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var dbSuffix, dbName, db, eventsIDBStore, e_8;
            return (0, $3VFsf.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        dbSuffix = type === 'replay' ? '' : "_".concat(type);
                        dbName = "".concat(args.apiKey.substring(0, 10), "_amp_session_replay_events").concat(dbSuffix);
                        return [
                            4 /*yield*/ ,
                            $71804121416ec2f6$export$f51a9068ac82ea43(dbName)
                        ];
                    case 1:
                        db = _a.sent();
                        eventsIDBStore = new SessionReplayEventsIDBStore((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, args), {
                            db: db
                        }));
                        return [
                            4 /*yield*/ ,
                            eventsIDBStore.transitionFromKeyValStore(sessionId)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            eventsIDBStore
                        ];
                    case 3:
                        e_8 = _a.sent();
                        args.loggerProvider.warn("".concat((0, $cf3Bu.STORAGE_FAILURE), ": ").concat(e_8));
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionReplayEventsIDBStore.prototype.getCurrentSequenceEvents = function(sessionId) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var events, allEvents, _a, _b, events, e_9_1;
            var e_9, _c;
            return (0, $3VFsf.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!sessionId) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.db.get('sessionCurrentSequence', sessionId)
                        ];
                    case 1:
                        events = _d.sent();
                        if (!events) return [
                            2 /*return*/ ,
                            undefined
                        ];
                        return [
                            2 /*return*/ ,
                            [
                                events
                            ]
                        ];
                    case 2:
                        allEvents = [];
                        _d.label = 3;
                    case 3:
                        _d.trys.push([
                            3,
                            8,
                            9,
                            10
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.db.getAll('sessionCurrentSequence')
                        ];
                    case 4:
                        _a = (0, $3VFsf.__values).apply(void 0, [
                            _d.sent()
                        ]), _b = _a.next();
                        _d.label = 5;
                    case 5:
                        if (!!_b.done) return [
                            3 /*break*/ ,
                            7
                        ];
                        events = _b.value;
                        allEvents.push(events);
                        _d.label = 6;
                    case 6:
                        _b = _a.next();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        e_9_1 = _d.sent();
                        e_9 = {
                            error: e_9_1
                        };
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        } finally{
                            if (e_9) throw e_9.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        return [
                            2 /*return*/ ,
                            allEvents
                        ];
                }
            });
        });
    };
    return SessionReplayEventsIDBStore;
}((0, $53V2s.BaseEventsStore));

});
parcelRegister("8Rw0V", function(module, exports) {

$parcel$export(module.exports, "openDB", () => $673c1b416bac7a54$export$ca0ed41b1a2af7e);
const $673c1b416bac7a54$var$instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $673c1b416bac7a54$var$idbProxyableTypes;
let $673c1b416bac7a54$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $673c1b416bac7a54$var$getIdbProxyableTypes() {
    return $673c1b416bac7a54$var$idbProxyableTypes || ($673c1b416bac7a54$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $673c1b416bac7a54$var$getCursorAdvanceMethods() {
    return $673c1b416bac7a54$var$cursorAdvanceMethods || ($673c1b416bac7a54$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $673c1b416bac7a54$var$transactionDoneMap = new WeakMap();
const $673c1b416bac7a54$var$transformCache = new WeakMap();
const $673c1b416bac7a54$var$reverseTransformCache = new WeakMap();
function $673c1b416bac7a54$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($673c1b416bac7a54$export$4997ffc0176396a6(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $673c1b416bac7a54$var$reverseTransformCache.set(promise, request);
    return promise;
}
function $673c1b416bac7a54$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($673c1b416bac7a54$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $673c1b416bac7a54$var$transactionDoneMap.set(tx, done);
}
let $673c1b416bac7a54$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $673c1b416bac7a54$var$transactionDoneMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $673c1b416bac7a54$export$4997ffc0176396a6(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $673c1b416bac7a54$var$replaceTraps(callback) {
    $673c1b416bac7a54$var$idbProxyTraps = callback($673c1b416bac7a54$var$idbProxyTraps);
}
function $673c1b416bac7a54$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($673c1b416bac7a54$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($673c1b416bac7a54$export$debb760848ca95a(this), args);
        return $673c1b416bac7a54$export$4997ffc0176396a6(this.request);
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $673c1b416bac7a54$export$4997ffc0176396a6(func.apply($673c1b416bac7a54$export$debb760848ca95a(this), args));
    };
}
function $673c1b416bac7a54$var$transformCachableValue(value) {
    if (typeof value === 'function') return $673c1b416bac7a54$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $673c1b416bac7a54$var$cacheDonePromiseForTransaction(value);
    if ($673c1b416bac7a54$var$instanceOfAny(value, $673c1b416bac7a54$var$getIdbProxyableTypes())) return new Proxy(value, $673c1b416bac7a54$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $673c1b416bac7a54$export$4997ffc0176396a6(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $673c1b416bac7a54$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($673c1b416bac7a54$var$transformCache.has(value)) return $673c1b416bac7a54$var$transformCache.get(value);
    const newValue = $673c1b416bac7a54$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $673c1b416bac7a54$var$transformCache.set(value, newValue);
        $673c1b416bac7a54$var$reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const $673c1b416bac7a54$export$debb760848ca95a = (value)=>$673c1b416bac7a54$var$reverseTransformCache.get(value);
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $673c1b416bac7a54$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = $673c1b416bac7a54$export$4997ffc0176396a6(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade($673c1b416bac7a54$export$4997ffc0176396a6(request.result), event.oldVersion, event.newVersion, $673c1b416bac7a54$export$4997ffc0176396a6(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $673c1b416bac7a54$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return $673c1b416bac7a54$export$4997ffc0176396a6(request).then(()=>undefined);
}
const $673c1b416bac7a54$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $673c1b416bac7a54$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $673c1b416bac7a54$var$cachedMethods = new Map();
function $673c1b416bac7a54$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($673c1b416bac7a54$var$cachedMethods.get(prop)) return $673c1b416bac7a54$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $673c1b416bac7a54$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $673c1b416bac7a54$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $673c1b416bac7a54$var$cachedMethods.set(prop, method);
    return method;
}
$673c1b416bac7a54$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$673c1b416bac7a54$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$673c1b416bac7a54$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));
const $673c1b416bac7a54$var$advanceMethodProps = [
    'continue',
    'continuePrimaryKey',
    'advance'
];
const $673c1b416bac7a54$var$methodMap = {};
const $673c1b416bac7a54$var$advanceResults = new WeakMap();
const $673c1b416bac7a54$var$ittrProxiedCursorToOriginalProxy = new WeakMap();
const $673c1b416bac7a54$var$cursorIteratorTraps = {
    get (target, prop) {
        if (!$673c1b416bac7a54$var$advanceMethodProps.includes(prop)) return target[prop];
        let cachedFunc = $673c1b416bac7a54$var$methodMap[prop];
        if (!cachedFunc) cachedFunc = $673c1b416bac7a54$var$methodMap[prop] = function(...args) {
            $673c1b416bac7a54$var$advanceResults.set(this, $673c1b416bac7a54$var$ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
        };
        return cachedFunc;
    }
};
async function* $673c1b416bac7a54$var$iterate(...args) {
    // tslint:disable-next-line:no-this-assignment
    let cursor = this;
    if (!(cursor instanceof IDBCursor)) cursor = await cursor.openCursor(...args);
    if (!cursor) return;
    cursor;
    const proxiedCursor = new Proxy(cursor, $673c1b416bac7a54$var$cursorIteratorTraps);
    $673c1b416bac7a54$var$ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
    // Map this double-proxy back to the original, so other cursor methods work.
    $673c1b416bac7a54$var$reverseTransformCache.set(proxiedCursor, $673c1b416bac7a54$export$debb760848ca95a(cursor));
    while(cursor){
        yield proxiedCursor;
        // If one of the advancing methods was not called, call continue().
        cursor = await ($673c1b416bac7a54$var$advanceResults.get(proxiedCursor) || cursor.continue());
        $673c1b416bac7a54$var$advanceResults.delete(proxiedCursor);
    }
}
function $673c1b416bac7a54$var$isIteratorProp(target, prop) {
    return prop === Symbol.asyncIterator && $673c1b416bac7a54$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore,
        IDBCursor
    ]) || prop === 'iterate' && $673c1b416bac7a54$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore
    ]);
}
$673c1b416bac7a54$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get (target, prop, receiver) {
            if ($673c1b416bac7a54$var$isIteratorProp(target, prop)) return $673c1b416bac7a54$var$iterate;
            return oldTraps.get(target, prop, receiver);
        },
        has (target, prop) {
            return $673c1b416bac7a54$var$isIteratorProp(target, prop) || oldTraps.has(target, prop);
        }
    }));

});

parcelRegister("53V2s", function(module, exports) {

$parcel$export(module.exports, "BaseEventsStore", () => $3af97a43c3b54710$export$5eb8a3e463d06ffe);

var $gPQg5 = parcelRequire("gPQg5");
var $3af97a43c3b54710$export$5eb8a3e463d06ffe = /** @class */ function() {
    function BaseEventsStore(args) {
        var _this = this;
        var _a, _b, _c;
        this.minInterval = (0, $gPQg5.MIN_INTERVAL);
        this.maxInterval = (0, $gPQg5.MAX_INTERVAL);
        this.maxPersistedEventsSize = (0, $gPQg5.MAX_EVENT_LIST_SIZE_IN_BYTES);
        this.interval = this.minInterval;
        this._timeAtLastSplit = Date.now(); // Initialize this so we have a point of comparison when events are recorded
        /**
         * Determines whether to send the events list to the backend and start a new
         * empty events list, based on the size of the list as well as the last time sent
         * @param nextEventString
         * @returns boolean
         */ this.shouldSplitEventsList = function(events, nextEventString) {
            var sizeOfNextEvent = new Blob([
                nextEventString
            ]).size;
            var sizeOfEventsList = new Blob(events).size;
            if (sizeOfEventsList + sizeOfNextEvent >= _this.maxPersistedEventsSize) return true;
            if (Date.now() - _this.timeAtLastSplit > _this.interval && events.length) {
                _this.interval = Math.min(_this.maxInterval, _this.interval + _this.minInterval);
                _this._timeAtLastSplit = Date.now();
                return true;
            }
            return false;
        };
        this.loggerProvider = args.loggerProvider;
        this.minInterval = (_a = args.minInterval) !== null && _a !== void 0 ? _a : this.minInterval;
        this.maxInterval = (_b = args.maxInterval) !== null && _b !== void 0 ? _b : this.maxInterval;
        this.maxPersistedEventsSize = (_c = args.maxPersistedEventsSize) !== null && _c !== void 0 ? _c : this.maxPersistedEventsSize;
    }
    Object.defineProperty(BaseEventsStore.prototype, "timeAtLastSplit", {
        get: function() {
            return this._timeAtLastSplit;
        },
        enumerable: false,
        configurable: true
    });
    return BaseEventsStore;
}();

});

parcelRegister("9elZm", function(module, exports) {

$parcel$export(module.exports, "RecordingStatus", () => $6b867a5b3bcaa742$export$324f12ab8f3589ca);
var $6b867a5b3bcaa742$export$324f12ab8f3589ca;
(function(RecordingStatus) {
    RecordingStatus["RECORDING"] = "recording";
    RecordingStatus["SENT"] = "sent";
})($6b867a5b3bcaa742$export$324f12ab8f3589ca || ($6b867a5b3bcaa742$export$324f12ab8f3589ca = {}));

});


parcelRegister("gxFrz", function(module, exports) {

$parcel$export(module.exports, "InMemoryEventsStore", () => $c0afe04073f1a3f3$export$b4e5e8beb6c66bd7);

var $3VFsf = parcelRequire("3VFsf");

var $53V2s = parcelRequire("53V2s");
var $c0afe04073f1a3f3$export$b4e5e8beb6c66bd7 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(InMemoryEventsStore, _super);
    function InMemoryEventsStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.finalizedSequences = {};
        _this.sequences = {};
        _this.sequenceId = 0;
        return _this;
    }
    InMemoryEventsStore.prototype.resetCurrentSequence = function(sessionId) {
        this.sequences[sessionId] = [];
    };
    InMemoryEventsStore.prototype.addSequence = function(sessionId) {
        var sequenceId = this.sequenceId++;
        var events = (0, $3VFsf.__spreadArray)([], (0, $3VFsf.__read)(this.sequences[sessionId]), false);
        this.finalizedSequences[sequenceId] = {
            sessionId: sessionId,
            events: events
        };
        this.resetCurrentSequence(sessionId);
        return {
            sequenceId: sequenceId,
            events: events,
            sessionId: sessionId
        };
    };
    InMemoryEventsStore.prototype.getSequencesToSend = function() {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    Object.entries(this.finalizedSequences).map(function(_a) {
                        var _b = (0, $3VFsf.__read)(_a, 2), sequenceId = _b[0], _c = _b[1], sessionId = _c.sessionId, events = _c.events;
                        return {
                            sequenceId: Number(sequenceId),
                            sessionId: sessionId,
                            events: events
                        };
                    })
                ];
            });
        });
    };
    InMemoryEventsStore.prototype.storeCurrentSequence = function(sessionId) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_a) {
                if (!this.sequences[sessionId]) return [
                    2 /*return*/ ,
                    undefined
                ];
                return [
                    2 /*return*/ ,
                    this.addSequence(sessionId)
                ];
            });
        });
    };
    InMemoryEventsStore.prototype.addEventToCurrentSequence = function(sessionId, event) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var sequenceReturn;
            return (0, $3VFsf.__generator)(this, function(_a) {
                if (!this.sequences[sessionId]) this.resetCurrentSequence(sessionId);
                if (this.shouldSplitEventsList(this.sequences[sessionId], event)) sequenceReturn = this.addSequence(sessionId);
                this.sequences[sessionId].push(event);
                return [
                    2 /*return*/ ,
                    sequenceReturn
                ];
            });
        });
    };
    InMemoryEventsStore.prototype.storeSendingEvents = function(sessionId, events) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_a) {
                this.finalizedSequences[this.sequenceId] = {
                    sessionId: sessionId,
                    events: events
                };
                return [
                    2 /*return*/ ,
                    this.sequenceId++
                ];
            });
        });
    };
    InMemoryEventsStore.prototype.cleanUpSessionEventsStore = function(_sessionId, sequenceId) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_a) {
                if (sequenceId !== undefined) delete this.finalizedSequences[sequenceId];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return InMemoryEventsStore;
}((0, $53V2s.BaseEventsStore));

});


parcelRegister("kIB3M", function(module, exports) {

$parcel$export(module.exports, "MultiEventManager", () => $f154aa0c5d10a519$export$d906945cd180d1ab);

var $3VFsf = parcelRequire("3VFsf");
/**
 * "Registers" events managers internally. When an event is added this class routes the event to the correct
 * manager. For all send or flush methods this will invoke the event for all registered managers.
 */ var $f154aa0c5d10a519$export$d906945cd180d1ab = /** @class */ function() {
    function MultiEventManager() {
        var managers = [];
        for(var _i = 0; _i < arguments.length; _i++)managers[_i] = arguments[_i];
        var managersMap = new Map();
        managers.forEach(function(t) {
            managersMap.set(t.name, t.manager);
        });
        this.managers = managersMap;
    }
    MultiEventManager.prototype.sendStoredEvents = function(opts) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var promises;
            return (0, $3VFsf.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        promises = [];
                        this.managers.forEach(function(manager) {
                            promises.push(manager.sendStoredEvents(opts));
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(promises)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MultiEventManager.prototype.addEvent = function(_a) {
        var _b;
        var sessionId = _a.sessionId, event = _a.event, deviceId = _a.deviceId;
        (_b = this.managers.get(event.type)) === null || _b === void 0 || _b.addEvent({
            sessionId: sessionId,
            event: event,
            deviceId: deviceId
        });
    };
    MultiEventManager.prototype.sendCurrentSequenceEvents = function(_a) {
        var sessionId = _a.sessionId, deviceId = _a.deviceId;
        this.managers.forEach(function(manager) {
            manager.sendCurrentSequenceEvents({
                sessionId: sessionId,
                deviceId: deviceId
            });
        });
    };
    MultiEventManager.prototype.flush = function(useRetry) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var promises;
            return (0, $3VFsf.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        promises = [];
                        this.managers.forEach(function(manager) {
                            promises.push(manager.flush(useRetry));
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(promises)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return MultiEventManager;
}();

});

parcelRegister("edqg3", function(module, exports) {

$parcel$export(module.exports, "clickNonBatcher", () => $a596a5db4ff64516$export$3fd370c4dbdebccf);
$parcel$export(module.exports, "clickBatcher", () => $a596a5db4ff64516$export$a0b659d7219e12ce);
$parcel$export(module.exports, "clickHook", () => $a596a5db4ff64516$export$6007c24c8d913c4d);

var $3VFsf = parcelRequire("3VFsf");

var $7E6lu = parcelRequire("7E6lu");

var $aoGcY = parcelRequire("aoGcY");

var $hmZbw = parcelRequire("hmZbw");

var $gOnHi = parcelRequire("gOnHi");
var $a596a5db4ff64516$var$HOUR_IN_MILLISECONDS = 3600000;
var $a596a5db4ff64516$export$3fd370c4dbdebccf = function(_a) {
    var version = _a.version, events = _a.events;
    var clickEvents = [];
    events.forEach(function(evt) {
        var record = JSON.parse(evt);
        record.count = 1;
        if (record.type === 'click') clickEvents.push(record);
    });
    return {
        version: version,
        events: clickEvents
    };
};
var $a596a5db4ff64516$export$a0b659d7219e12ce = function(_a) {
    var version = _a.version, events = _a.events;
    var clickEvents = [];
    events.forEach(function(evt) {
        var record = JSON.parse(evt);
        if (record.type === 'click') clickEvents.push(record);
    });
    var reduced = clickEvents.reduce(function(prev, curr) {
        var x = curr.x, y = curr.y, selector = curr.selector, timestamp = curr.timestamp;
        // round down to nearest hour.
        var hour = timestamp - timestamp % $a596a5db4ff64516$var$HOUR_IN_MILLISECONDS;
        var k = "".concat(x, ":").concat(y, ":").concat(selector !== null && selector !== void 0 ? selector : '', ":").concat(hour);
        if (!prev[k]) prev[k] = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, curr), {
            timestamp: hour,
            count: 1
        });
        else prev[k].count += 1;
        return prev;
    }, {});
    return {
        version: version,
        events: Object.values(reduced)
    };
};
var $a596a5db4ff64516$export$6007c24c8d913c4d = function(logger, _a) {
    var eventsManager = _a.eventsManager, sessionId = _a.sessionId, deviceIdFn = _a.deviceIdFn;
    return function(e) {
        if (e.type !== (0, $7E6lu.MouseInteractions).Click) return;
        var globalScope = (0, $gOnHi.getGlobalScope)();
        if (!globalScope) return;
        var location = globalScope.location, innerHeight = globalScope.innerHeight, innerWidth = globalScope.innerWidth;
        // it only makes sense to send events if a pageUrl exists
        if (!location) return;
        var x = e.x, y = e.y;
        if (x === undefined || y === undefined) return;
        var node = (0, $aoGcY.record).mirror.getNode(e.id);
        var selector;
        if (node) try {
            selector = (0, $hmZbw.finder)(node);
        } catch (err) {
            logger.debug('error resolving selector from finder');
        }
        var _a = (0, $aoGcY.utils).getWindowScroll(globalScope), scrollX = _a.left, scrollY = _a.top;
        var event = {
            x: x + scrollX,
            y: y + scrollY,
            selector: selector,
            viewportHeight: innerHeight,
            viewportWidth: innerWidth,
            pageUrl: location.href,
            timestamp: Date.now(),
            type: 'click'
        };
        var deviceId = deviceIdFn();
        if (deviceId) eventsManager.addEvent({
            sessionId: sessionId,
            event: {
                type: 'interaction',
                data: JSON.stringify(event)
            },
            deviceId: deviceId
        });
    };
};

});
parcelRegister("7E6lu", function(module, exports) {

$parcel$export(module.exports, "MouseInteractions", () => $591130f54ce2c538$export$d87e674dba09af70);
var $591130f54ce2c538$export$3d7865934588d77e = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($591130f54ce2c538$export$3d7865934588d77e || {});
var $591130f54ce2c538$export$24bb3ebc067ff5e1 = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($591130f54ce2c538$export$24bb3ebc067ff5e1 || {});
var $591130f54ce2c538$export$d87e674dba09af70 = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($591130f54ce2c538$export$d87e674dba09af70 || {});
var $591130f54ce2c538$export$496741b331796238 = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($591130f54ce2c538$export$496741b331796238 || {});
var $591130f54ce2c538$export$eefcd8ea59422f9d = /* @__PURE__ */ ((CanvasContext2)=>{
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
})($591130f54ce2c538$export$eefcd8ea59422f9d || {});
var $591130f54ce2c538$export$737e227e26e615d9 = /* @__PURE__ */ ((MediaInteractions2)=>{
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
})($591130f54ce2c538$export$737e227e26e615d9 || {});
var $591130f54ce2c538$export$7b5ca317a0cad55c = /* @__PURE__ */ ((ReplayerEvents2)=>{
    ReplayerEvents2["Start"] = "start";
    ReplayerEvents2["Pause"] = "pause";
    ReplayerEvents2["Resume"] = "resume";
    ReplayerEvents2["Resize"] = "resize";
    ReplayerEvents2["Finish"] = "finish";
    ReplayerEvents2["FullsnapshotRebuilded"] = "fullsnapshot-rebuilded";
    ReplayerEvents2["LoadStylesheetStart"] = "load-stylesheet-start";
    ReplayerEvents2["LoadStylesheetEnd"] = "load-stylesheet-end";
    ReplayerEvents2["SkipStart"] = "skip-start";
    ReplayerEvents2["SkipEnd"] = "skip-end";
    ReplayerEvents2["MouseInteraction"] = "mouse-interaction";
    ReplayerEvents2["EventCast"] = "event-cast";
    ReplayerEvents2["CustomEvent"] = "custom-event";
    ReplayerEvents2["Flush"] = "flush";
    ReplayerEvents2["StateChange"] = "state-change";
    ReplayerEvents2["PlayBack"] = "play-back";
    ReplayerEvents2["Destroy"] = "destroy";
    return ReplayerEvents2;
})($591130f54ce2c538$export$7b5ca317a0cad55c || {});
var $591130f54ce2c538$export$f06e977173f1857c = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($591130f54ce2c538$export$f06e977173f1857c || {});

});

parcelRegister("hmZbw", function(module, exports) {

$parcel$export(module.exports, "finder", () => $ca53f3c970ec600a$export$ae58c3420da023e7);
/* istanbul ignore file */ 
var $3VFsf = parcelRequire("3VFsf");
var $ca53f3c970ec600a$var$config;
var $ca53f3c970ec600a$var$rootDocument;
var $ca53f3c970ec600a$var$start;
function $ca53f3c970ec600a$export$ae58c3420da023e7(input, options) {
    $ca53f3c970ec600a$var$start = new Date();
    if (input.nodeType !== Node.ELEMENT_NODE) throw new Error("Can't generate CSS selector for non-element node type.");
    if ('html' === input.tagName.toLowerCase()) return 'html';
    var defaults = {
        root: document.body,
        idName: function(_name) {
            return true;
        },
        className: function(_name) {
            return true;
        },
        tagName: function(_name) {
            return true;
        },
        attr: function(_name, _value) {
            return false;
        },
        seedMinLength: 1,
        optimizedMinLength: 2,
        threshold: 1000,
        maxNumberOfTries: 10000,
        timeoutMs: undefined
    };
    $ca53f3c970ec600a$var$config = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, defaults), options);
    $ca53f3c970ec600a$var$rootDocument = $ca53f3c970ec600a$var$findRootDocument($ca53f3c970ec600a$var$config.root, defaults);
    var path = $ca53f3c970ec600a$var$bottomUpSearch(input, 'all', function() {
        return $ca53f3c970ec600a$var$bottomUpSearch(input, 'two', function() {
            return $ca53f3c970ec600a$var$bottomUpSearch(input, 'one', function() {
                return $ca53f3c970ec600a$var$bottomUpSearch(input, 'none');
            });
        });
    });
    if (path) {
        var optimized = $ca53f3c970ec600a$var$sort($ca53f3c970ec600a$var$optimize(path, input));
        if (optimized.length > 0) path = optimized[0];
        return $ca53f3c970ec600a$var$selector(path);
    } else throw new Error("Selector was not found.");
}
function $ca53f3c970ec600a$var$findRootDocument(rootNode, defaults) {
    if (rootNode.nodeType === Node.DOCUMENT_NODE) return rootNode;
    if (rootNode === defaults.root) return rootNode.ownerDocument;
    return rootNode;
}
function $ca53f3c970ec600a$var$bottomUpSearch(input, limit, fallback) {
    var path = null;
    var stack = [];
    var current = input;
    var i = 0;
    var _loop_1 = function() {
        var e_1, _a;
        var elapsedTime = new Date().getTime() - $ca53f3c970ec600a$var$start.getTime();
        if ($ca53f3c970ec600a$var$config.timeoutMs !== undefined && elapsedTime > $ca53f3c970ec600a$var$config.timeoutMs) throw new Error("Timeout: Can't find a unique selector after ".concat(elapsedTime, "ms"));
        var level = $ca53f3c970ec600a$var$maybe($ca53f3c970ec600a$var$id(current)) || $ca53f3c970ec600a$var$maybe.apply(void 0, (0, $3VFsf.__spreadArray)([], (0, $3VFsf.__read)($ca53f3c970ec600a$var$attr(current)), false)) || $ca53f3c970ec600a$var$maybe.apply(void 0, (0, $3VFsf.__spreadArray)([], (0, $3VFsf.__read)($ca53f3c970ec600a$var$classNames(current)), false)) || $ca53f3c970ec600a$var$maybe($ca53f3c970ec600a$var$tagName(current)) || [
            $ca53f3c970ec600a$var$any()
        ];
        var nth = $ca53f3c970ec600a$var$index(current);
        if (limit == 'all') {
            if (nth) level = level.concat(level.filter($ca53f3c970ec600a$var$dispensableNth).map(function(node) {
                return $ca53f3c970ec600a$var$nthChild(node, nth);
            }));
        } else if (limit == 'two') {
            level = level.slice(0, 1);
            if (nth) level = level.concat(level.filter($ca53f3c970ec600a$var$dispensableNth).map(function(node) {
                return $ca53f3c970ec600a$var$nthChild(node, nth);
            }));
        } else if (limit == 'one') {
            var _b = (0, $3VFsf.__read)(level = level.slice(0, 1), 1), node = _b[0];
            if (nth && $ca53f3c970ec600a$var$dispensableNth(node)) level = [
                $ca53f3c970ec600a$var$nthChild(node, nth)
            ];
        } else if (limit == 'none') {
            level = [
                $ca53f3c970ec600a$var$any()
            ];
            if (nth) level = [
                $ca53f3c970ec600a$var$nthChild(level[0], nth)
            ];
        }
        try {
            for(var level_1 = (e_1 = void 0, (0, $3VFsf.__values)(level)), level_1_1 = level_1.next(); !level_1_1.done; level_1_1 = level_1.next()){
                var node = level_1_1.value;
                node.level = i;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (level_1_1 && !level_1_1.done && (_a = level_1.return)) _a.call(level_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        stack.push(level);
        if (stack.length >= $ca53f3c970ec600a$var$config.seedMinLength) {
            path = $ca53f3c970ec600a$var$findUniquePath(stack, fallback);
            if (path) return "break";
        }
        current = current.parentElement;
        i++;
    };
    while(current){
        var state_1 = _loop_1();
        if (state_1 === "break") break;
    }
    if (!path) path = $ca53f3c970ec600a$var$findUniquePath(stack, fallback);
    if (!path && fallback) return fallback();
    return path;
}
function $ca53f3c970ec600a$var$findUniquePath(stack, fallback) {
    var e_2, _a;
    var paths = $ca53f3c970ec600a$var$sort($ca53f3c970ec600a$var$combinations(stack));
    if (paths.length > $ca53f3c970ec600a$var$config.threshold) return fallback ? fallback() : null;
    try {
        for(var paths_1 = (0, $3VFsf.__values)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var candidate = paths_1_1.value;
            if ($ca53f3c970ec600a$var$unique(candidate)) return candidate;
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return null;
}
function $ca53f3c970ec600a$var$selector(path) {
    var node = path[0];
    var query = node.name;
    for(var i = 1; i < path.length; i++){
        var level = path[i].level || 0;
        if (node.level === level - 1) query = "".concat(path[i].name, " > ").concat(query);
        else query = "".concat(path[i].name, " ").concat(query);
        node = path[i];
    }
    return query;
}
function $ca53f3c970ec600a$var$penalty(path) {
    return path.map(function(node) {
        return node.penalty;
    }).reduce(function(acc, i) {
        return acc + i;
    }, 0);
}
function $ca53f3c970ec600a$var$unique(path) {
    var css = $ca53f3c970ec600a$var$selector(path);
    switch($ca53f3c970ec600a$var$rootDocument.querySelectorAll(css).length){
        case 0:
            throw new Error("Can't select any node with this selector: ".concat(css));
        case 1:
            return true;
        default:
            return false;
    }
}
function $ca53f3c970ec600a$var$id(input) {
    var elementId = input.getAttribute('id');
    if (elementId && $ca53f3c970ec600a$var$config.idName(elementId)) return {
        name: '#' + CSS.escape(elementId),
        penalty: 0
    };
    return null;
}
function $ca53f3c970ec600a$var$attr(input) {
    var attrs = Array.from(input.attributes).filter(function(attr) {
        return $ca53f3c970ec600a$var$config.attr(attr.name, attr.value);
    });
    return attrs.map(function(attr) {
        return {
            name: "[".concat(CSS.escape(attr.name), "=\"").concat(CSS.escape(attr.value), "\"]"),
            penalty: 0.5
        };
    });
}
function $ca53f3c970ec600a$var$classNames(input) {
    var names = Array.from(input.classList).filter($ca53f3c970ec600a$var$config.className);
    return names.map(function(name) {
        return {
            name: '.' + CSS.escape(name),
            penalty: 1
        };
    });
}
function $ca53f3c970ec600a$var$tagName(input) {
    var name = input.tagName.toLowerCase();
    if ($ca53f3c970ec600a$var$config.tagName(name)) return {
        name: name,
        penalty: 2
    };
    return null;
}
function $ca53f3c970ec600a$var$any() {
    return {
        name: '*',
        penalty: 3
    };
}
function $ca53f3c970ec600a$var$index(input) {
    var parent = input.parentNode;
    if (!parent) return null;
    var child = parent.firstChild;
    if (!child) return null;
    var i = 0;
    while(child){
        if (child.nodeType === Node.ELEMENT_NODE) i++;
        if (child === input) break;
        child = child.nextSibling;
    }
    return i;
}
function $ca53f3c970ec600a$var$nthChild(node, i) {
    return {
        name: node.name + ":nth-child(".concat(i, ")"),
        penalty: node.penalty + 1
    };
}
function $ca53f3c970ec600a$var$dispensableNth(node) {
    return node.name !== 'html' && !node.name.startsWith('#');
}
function $ca53f3c970ec600a$var$maybe() {
    var level = [];
    for(var _i = 0; _i < arguments.length; _i++)level[_i] = arguments[_i];
    var list = level.filter($ca53f3c970ec600a$var$notEmpty);
    if (list.length > 0) return list;
    return null;
}
function $ca53f3c970ec600a$var$notEmpty(value) {
    return value !== null && value !== undefined;
}
function $ca53f3c970ec600a$var$combinations(stack, path) {
    var _a, _b, node, e_3_1;
    var e_3, _c;
    if (path === void 0) path = [];
    return (0, $3VFsf.__generator)(this, function(_d) {
        switch(_d.label){
            case 0:
                if (!(stack.length > 0)) return [
                    3 /*break*/ ,
                    9
                ];
                _d.label = 1;
            case 1:
                _d.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _a = (0, $3VFsf.__values)(stack[0]), _b = _a.next();
                _d.label = 2;
            case 2:
                if (!!_b.done) return [
                    3 /*break*/ ,
                    5
                ];
                node = _b.value;
                return [
                    5 /*yield**/ ,
                    (0, $3VFsf.__values)($ca53f3c970ec600a$var$combinations(stack.slice(1, stack.length), path.concat(node)))
                ];
            case 3:
                _d.sent();
                _d.label = 4;
            case 4:
                _b = _a.next();
                return [
                    3 /*break*/ ,
                    2
                ];
            case 5:
                return [
                    3 /*break*/ ,
                    8
                ];
            case 6:
                e_3_1 = _d.sent();
                e_3 = {
                    error: e_3_1
                };
                return [
                    3 /*break*/ ,
                    8
                ];
            case 7:
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                } finally{
                    if (e_3) throw e_3.error;
                }
                return [
                    7 /*endfinally*/ 
                ];
            case 8:
                return [
                    3 /*break*/ ,
                    11
                ];
            case 9:
                return [
                    4 /*yield*/ ,
                    path
                ];
            case 10:
                _d.sent();
                _d.label = 11;
            case 11:
                return [
                    2 /*return*/ 
                ];
        }
    });
}
function $ca53f3c970ec600a$var$sort(paths) {
    return (0, $3VFsf.__spreadArray)([], (0, $3VFsf.__read)(paths), false).sort(function(a, b) {
        return $ca53f3c970ec600a$var$penalty(a) - $ca53f3c970ec600a$var$penalty(b);
    });
}
function $ca53f3c970ec600a$var$optimize(path, input, scope) {
    var i, newPath, newPathKey;
    if (scope === void 0) scope = {
        counter: 0,
        visited: new Map()
    };
    return (0, $3VFsf.__generator)(this, function(_a) {
        switch(_a.label){
            case 0:
                if (!(path.length > 2 && path.length > $ca53f3c970ec600a$var$config.optimizedMinLength)) return [
                    3 /*break*/ ,
                    5
                ];
                i = 1;
                _a.label = 1;
            case 1:
                if (!(i < path.length - 1)) return [
                    3 /*break*/ ,
                    5
                ];
                if (scope.counter > $ca53f3c970ec600a$var$config.maxNumberOfTries) return [
                    2 /*return*/ 
                ]; // Okay At least I tried!
                scope.counter += 1;
                newPath = (0, $3VFsf.__spreadArray)([], (0, $3VFsf.__read)(path), false);
                newPath.splice(i, 1);
                newPathKey = $ca53f3c970ec600a$var$selector(newPath);
                if (scope.visited.has(newPathKey)) return [
                    2 /*return*/ 
                ];
                if (!($ca53f3c970ec600a$var$unique(newPath) && $ca53f3c970ec600a$var$same(newPath, input))) return [
                    3 /*break*/ ,
                    4
                ];
                return [
                    4 /*yield*/ ,
                    newPath
                ];
            case 2:
                _a.sent();
                scope.visited.set(newPathKey, true);
                return [
                    5 /*yield**/ ,
                    (0, $3VFsf.__values)($ca53f3c970ec600a$var$optimize(newPath, input, scope))
                ];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4:
                i++;
                return [
                    3 /*break*/ ,
                    1
                ];
            case 5:
                return [
                    2 /*return*/ 
                ];
        }
    });
}
function $ca53f3c970ec600a$var$same(path, input) {
    return $ca53f3c970ec600a$var$rootDocument.querySelector($ca53f3c970ec600a$var$selector(path)) === input;
}

});


parcelRegister("5TuVb", function(module, exports) {

$parcel$export(module.exports, "ScrollWatcher", () => $44aa132285331484$export$26a0771bc3e5874c);

var $aoGcY = parcelRequire("aoGcY");

var $a2RVi = parcelRequire("a2RVi");

var $gOnHi = parcelRequire("gOnHi");
var $44aa132285331484$var$getWindowHeight = (0, $aoGcY.utils).getWindowHeight, $44aa132285331484$var$getWindowWidth = (0, $aoGcY.utils).getWindowWidth;
/**
 * This is intended to watch and update max scroll activity when loaded for a particular page.
 * A new instance should be created if the page URL changes, since by default it does not reset
 * it's max scroll state. It is intended to send very few and very small events utilizing the
 * Beacon API.
 * @see {@link BeaconTransport} for more details on Beacon API usage.
 */ var $44aa132285331484$export$26a0771bc3e5874c = /** @class */ function() {
    function ScrollWatcher(transport) {
        var _this = this;
        this.timestamp = Date.now();
        this.hook = function(e) {
            _this.update(e);
        };
        this.send = function(deviceIdFn) {
            return function(_) {
                var deviceId = deviceIdFn();
                var globalScope = (0, $gOnHi.getGlobalScope)();
                if (globalScope && deviceId) _this.transport.send(deviceId, {
                    version: 1,
                    events: [
                        {
                            maxScrollX: _this._maxScrollX,
                            maxScrollY: _this._maxScrollY,
                            maxScrollWidth: _this._maxScrollWidth,
                            maxScrollHeight: _this._maxScrollHeight,
                            viewportHeight: $44aa132285331484$var$getWindowHeight(),
                            viewportWidth: $44aa132285331484$var$getWindowWidth(),
                            pageUrl: globalScope.location.href,
                            timestamp: _this.timestamp,
                            type: 'scroll'
                        }
                    ]
                });
            };
        };
        this._maxScrollX = 0;
        this._maxScrollY = 0;
        this._maxScrollWidth = $44aa132285331484$var$getWindowWidth();
        this._maxScrollHeight = $44aa132285331484$var$getWindowHeight();
        this.transport = transport;
    }
    ScrollWatcher.default = function(context, config) {
        return new ScrollWatcher(new (0, $a2RVi.BeaconTransport)(context, config));
    };
    Object.defineProperty(ScrollWatcher.prototype, "maxScrollX", {
        get: function() {
            return this._maxScrollX;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScrollWatcher.prototype, "maxScrollY", {
        get: function() {
            return this._maxScrollY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScrollWatcher.prototype, "maxScrollWidth", {
        get: function() {
            return this._maxScrollWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScrollWatcher.prototype, "maxScrollHeight", {
        get: function() {
            return this._maxScrollHeight;
        },
        enumerable: false,
        configurable: true
    });
    ScrollWatcher.prototype.update = function(e) {
        var now = Date.now();
        if (e.x > this._maxScrollX) {
            var width = $44aa132285331484$var$getWindowWidth();
            this._maxScrollX = e.x;
            var maxScrollWidth = e.x + width;
            if (maxScrollWidth > this._maxScrollWidth) this._maxScrollWidth = maxScrollWidth;
            this.timestamp = now;
        }
        if (e.y > this._maxScrollY) {
            var height = $44aa132285331484$var$getWindowHeight();
            this._maxScrollY = e.y;
            var maxScrollHeight = e.y + height;
            if (maxScrollHeight > this._maxScrollHeight) this._maxScrollHeight = maxScrollHeight;
            this.timestamp = now;
        }
    };
    return ScrollWatcher;
}();

});
parcelRegister("a2RVi", function(module, exports) {

$parcel$export(module.exports, "BeaconTransport", () => $7503eb48c9b125c0$export$8b06bdd3dd99b6af);

var $gOnHi = parcelRequire("gOnHi");

var $6Wtbz = parcelRequire("6Wtbz");
/**
 * For very small payloads it's preferable to use the [Beacon API](https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API).
 * While it doesn't provide 100% guarantees on sends, it greatly helps with overall reliability and page load performance. As
 * the Beacon API has a potential to fail due to size constraints we want to fall back to XHR if need be. This is mostly to
 * be used with 'pagehide' or 'beforeunload' events.
 *
 * Note there are only 3 CORS safelisted Content-Types you can send:
 *
 * - application/x-www-form-urlencoded
 * - multipart/form-data
 * - text/plain
 *
 * If we do not send one of these, some browsers like Chrome may not send this at all. Also we incur the overhead of a preflight
 * request. In our case we will add no additional content-type header. If you are trying to ping a server that requires this
 * header, you may want to use the regular fetch API or a different mechanism.
 */ var $7503eb48c9b125c0$export$8b06bdd3dd99b6af = /** @class */ function() {
    function BeaconTransport(context, config) {
        var globalScope = (0, $gOnHi.getGlobalScope)();
        if (globalScope && globalScope.navigator && typeof globalScope.navigator.sendBeacon === 'function') this.sendBeacon = function(pageUrl, payload) {
            try {
                if (globalScope.navigator.sendBeacon(pageUrl, JSON.stringify(payload))) return true;
            } catch (e) {
            // not logging error, since it would be hard to view and just adds overhead.
            }
            return false;
        };
        else this.sendBeacon = function() {
            return false;
        };
        this.sendXhr = function(pageUrl, payload) {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', pageUrl, true);
            xhr.setRequestHeader('Accept', '*/*');
            xhr.send(JSON.stringify(payload));
            return true;
        };
        this.basePageUrl = (0, $6Wtbz.getServerUrl)(config.serverZone, config.trackServerUrl);
        this.apiKey = config.apiKey;
        this.context = context;
    }
    BeaconTransport.prototype.send = function(deviceId, payload) {
        var _a = this.context, sessionId = _a.sessionId, type = _a.type;
        var urlParams = new URLSearchParams({
            device_id: deviceId,
            session_id: String(sessionId),
            type: String(type),
            api_key: this.apiKey
        });
        var pageUrl = "".concat(this.basePageUrl, "?").concat(urlParams.toString());
        // ideally send using the beacon API, but there is a chance it may fail, possibly due to a payload
        // size limit. in this case, try best effort to send using xhr.
        this.sendBeacon(pageUrl, payload) || this.sendXhr(pageUrl, payload);
    };
    return BeaconTransport;
}();

});


parcelRegister("iTUaV", function(module, exports) {

$parcel$export(module.exports, "SessionIdentifiers", () => $dc28f04930322c80$export$1a7b87342272b18e);

var $6Wtbz = parcelRequire("6Wtbz");
var $dc28f04930322c80$export$1a7b87342272b18e = /** @class */ function() {
    function SessionIdentifiers(_a) {
        var sessionId = _a.sessionId, deviceId = _a.deviceId;
        this.deviceId = deviceId;
        this.sessionId = sessionId;
        if (sessionId && deviceId) this.sessionReplayId = (0, $6Wtbz.generateSessionReplayId)(sessionId, deviceId);
    }
    return SessionIdentifiers;
}();

});

parcelRegister("dnOCI", function(module, exports) {

$parcel$export(module.exports, "EventCompressor", () => $9be4b11d0fa89ca6$export$ec932205488c2455);

var $gOnHi = parcelRequire("gOnHi");
parcelRequire("89adE");
var $7YeL1 = parcelRequire("7YeL1");
var $9be4b11d0fa89ca6$var$DEFAULT_TIMEOUT = 2000;
var $9be4b11d0fa89ca6$export$ec932205488c2455 = /** @class */ function() {
    function EventCompressor(eventsManager, config, deviceId, workerScriptInternal) {
        var _this = this;
        var _a, _b, _c;
        this.taskQueue = [];
        this.isProcessing = false;
        this.compressEvent = function(event) {
            var packedEvent = (0, $7YeL1.pack)(event);
            return JSON.stringify(packedEvent);
        };
        this.addCompressedEventToManager = function(compressedEvent, sessionId) {
            if (_this.eventsManager && _this.deviceId) _this.eventsManager.addEvent({
                event: {
                    type: 'replay',
                    data: compressedEvent
                },
                sessionId: sessionId,
                deviceId: _this.deviceId
            });
        };
        this.addCompressedEvent = function(event, sessionId) {
            if (_this.worker) // This indirectly compresses the event.
            _this.worker.postMessage({
                event: event,
                sessionId: sessionId
            });
            else {
                var compressedEvent = _this.compressEvent(event);
                _this.addCompressedEventToManager(compressedEvent, sessionId);
            }
        };
        this.terminate = function() {
            var _a;
            (_a = _this.worker) === null || _a === void 0 || _a.terminate();
        };
        var globalScope = (0, $gOnHi.getGlobalScope)();
        this.canUseIdleCallback = globalScope && 'requestIdleCallback' in globalScope;
        this.eventsManager = eventsManager;
        this.config = config;
        this.deviceId = deviceId;
        this.timeout = ((_a = config.performanceConfig) === null || _a === void 0 ? void 0 : _a.timeout) || $9be4b11d0fa89ca6$var$DEFAULT_TIMEOUT;
        // These two lines will be changed at compile time.
        var replace = {};
        // This next line is going to be ridiculously hard to cover in unit tests, ignoring.
        /* istanbul ignore next */ var workerScript = (_b = replace.COMPRESSION_WEBWORKER_BODY) !== null && _b !== void 0 ? _b : workerScriptInternal;
        if (((_c = this.config.experimental) === null || _c === void 0 ? void 0 : _c.useWebWorker) && globalScope && globalScope.Worker && workerScript) {
            config.loggerProvider.log('[Experimental] Enabling web worker for compression');
            var worker = new Worker(URL.createObjectURL(new Blob([
                workerScript
            ], {
                type: 'application/javascript'
            })));
            worker.onerror = function(e) {
                config.loggerProvider.error(e);
            };
            worker.onmessage = function(e) {
                var _a = e.data, compressedEvent = _a.compressedEvent, sessionId = _a.sessionId;
                _this.addCompressedEventToManager(compressedEvent, sessionId);
            };
            this.worker = worker;
        }
    }
    // Schedule processing during idle time
    EventCompressor.prototype.scheduleIdleProcessing = function() {
        var _this = this;
        if (!this.isProcessing) {
            this.isProcessing = true;
            requestIdleCallback(function(idleDeadline) {
                _this.processQueue(idleDeadline);
            }, {
                timeout: this.timeout
            });
        }
    };
    // Add an event to the task queue if idle callback is supported or compress the event directly
    EventCompressor.prototype.enqueueEvent = function(event, sessionId) {
        var _a;
        if (this.canUseIdleCallback && ((_a = this.config.performanceConfig) === null || _a === void 0 ? void 0 : _a.enabled)) {
            this.config.loggerProvider.debug('Enqueuing event for processing during idle time.');
            this.taskQueue.push({
                event: event,
                sessionId: sessionId
            });
            this.scheduleIdleProcessing();
        } else {
            this.config.loggerProvider.debug('Processing event without idle callback.');
            this.addCompressedEvent(event, sessionId);
        }
    };
    // Process the task queue during idle time
    EventCompressor.prototype.processQueue = function(idleDeadline) {
        var _this = this;
        // Process tasks while there's idle time or until the max number of tasks is reached
        while(this.taskQueue.length > 0 && (idleDeadline.timeRemaining() > 0 || idleDeadline.didTimeout)){
            var task = this.taskQueue.shift();
            if (task) {
                var event_1 = task.event, sessionId = task.sessionId;
                this.addCompressedEvent(event_1, sessionId);
            }
        }
        // If there are still tasks in the queue, schedule the next idle callback
        if (this.taskQueue.length > 0) requestIdleCallback(function(idleDeadline) {
            _this.processQueue(idleDeadline);
        }, {
            timeout: this.timeout
        });
        else this.isProcessing = false;
    };
    return EventCompressor;
}();

});
parcelRegister("89adE", function(module, exports) {

$parcel$export(module.exports, "pack", () => (parcelRequire("7YeL1")).pack);

var $7YeL1 = parcelRequire("7YeL1");

var $dFICc = parcelRequire("dFICc");

});
parcelRegister("7YeL1", function(module, exports) {

$parcel$export(module.exports, "pack", () => $5cd99588e360c872$export$2a703dbb0cb35339);

var $lXbAX = parcelRequire("lXbAX");
const $5cd99588e360c872$export$2a703dbb0cb35339 = (event)=>{
    const _e = {
        ...event,
        v: (0, $lXbAX.M)
    };
    return (0, $lXbAX.s)((0, $lXbAX.z)((0, $lXbAX.a)(JSON.stringify(_e))), true);
};

});
parcelRegister("lXbAX", function(module, exports) {

$parcel$export(module.exports, "z", () => $ffb81a36f3c0682b$export$df995fae86a55f06);
$parcel$export(module.exports, "u", () => $ffb81a36f3c0682b$export$3b14a55fb2447963);
$parcel$export(module.exports, "a", () => $ffb81a36f3c0682b$export$407448d2b89b1813);
$parcel$export(module.exports, "s", () => $ffb81a36f3c0682b$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "M", () => $ffb81a36f3c0682b$export$3a1a48c8f6ef640e);
var $ffb81a36f3c0682b$var$u8 = Uint8Array, $ffb81a36f3c0682b$var$u16 = Uint16Array, $ffb81a36f3c0682b$var$u32 = Uint32Array;
var $ffb81a36f3c0682b$var$fleb = new $ffb81a36f3c0682b$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
var $ffb81a36f3c0682b$var$fdeb = new $ffb81a36f3c0682b$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
var $ffb81a36f3c0682b$var$clim = new $ffb81a36f3c0682b$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
var $ffb81a36f3c0682b$var$freb = function(eb, start) {
    var b = new $ffb81a36f3c0682b$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    var r = new $ffb81a36f3c0682b$var$u32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return [
        b,
        r
    ];
};
var $ffb81a36f3c0682b$var$_a = $ffb81a36f3c0682b$var$freb($ffb81a36f3c0682b$var$fleb, 2), $ffb81a36f3c0682b$var$fl = $ffb81a36f3c0682b$var$_a[0], $ffb81a36f3c0682b$var$revfl = $ffb81a36f3c0682b$var$_a[1];
$ffb81a36f3c0682b$var$fl[28] = 258, $ffb81a36f3c0682b$var$revfl[258] = 28;
var $ffb81a36f3c0682b$var$_b = $ffb81a36f3c0682b$var$freb($ffb81a36f3c0682b$var$fdeb, 0), $ffb81a36f3c0682b$var$fd = $ffb81a36f3c0682b$var$_b[0], $ffb81a36f3c0682b$var$revfd = $ffb81a36f3c0682b$var$_b[1];
var $ffb81a36f3c0682b$var$rev = new $ffb81a36f3c0682b$var$u16(32768);
for(var $ffb81a36f3c0682b$var$i = 0; $ffb81a36f3c0682b$var$i < 32768; ++$ffb81a36f3c0682b$var$i){
    var $ffb81a36f3c0682b$var$x = ($ffb81a36f3c0682b$var$i & 43690) >>> 1 | ($ffb81a36f3c0682b$var$i & 21845) << 1;
    $ffb81a36f3c0682b$var$x = ($ffb81a36f3c0682b$var$x & 52428) >>> 2 | ($ffb81a36f3c0682b$var$x & 13107) << 2;
    $ffb81a36f3c0682b$var$x = ($ffb81a36f3c0682b$var$x & 61680) >>> 4 | ($ffb81a36f3c0682b$var$x & 3855) << 4;
    $ffb81a36f3c0682b$var$rev[$ffb81a36f3c0682b$var$i] = (($ffb81a36f3c0682b$var$x & 65280) >>> 8 | ($ffb81a36f3c0682b$var$x & 255) << 8) >>> 1;
}
var $ffb81a36f3c0682b$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    var i = 0;
    var l = new $ffb81a36f3c0682b$var$u16(mb);
    for(; i < s; ++i)++l[cd[i] - 1];
    var le = new $ffb81a36f3c0682b$var$u16(mb);
    for(i = 0; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        co = new $ffb81a36f3c0682b$var$u16(1 << mb);
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)if (cd[i]) {
            var sv = i << 4 | cd[i];
            var r_1 = mb - cd[i];
            var v = le[cd[i] - 1]++ << r_1;
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)co[$ffb81a36f3c0682b$var$rev[v] >>> rvb] = sv;
        }
    } else {
        co = new $ffb81a36f3c0682b$var$u16(s);
        for(i = 0; i < s; ++i)co[i] = $ffb81a36f3c0682b$var$rev[le[cd[i] - 1]++] >>> 15 - cd[i];
    }
    return co;
};
var $ffb81a36f3c0682b$var$flt = new $ffb81a36f3c0682b$var$u8(288);
for(var $ffb81a36f3c0682b$var$i = 0; $ffb81a36f3c0682b$var$i < 144; ++$ffb81a36f3c0682b$var$i)$ffb81a36f3c0682b$var$flt[$ffb81a36f3c0682b$var$i] = 8;
for(var $ffb81a36f3c0682b$var$i = 144; $ffb81a36f3c0682b$var$i < 256; ++$ffb81a36f3c0682b$var$i)$ffb81a36f3c0682b$var$flt[$ffb81a36f3c0682b$var$i] = 9;
for(var $ffb81a36f3c0682b$var$i = 256; $ffb81a36f3c0682b$var$i < 280; ++$ffb81a36f3c0682b$var$i)$ffb81a36f3c0682b$var$flt[$ffb81a36f3c0682b$var$i] = 7;
for(var $ffb81a36f3c0682b$var$i = 280; $ffb81a36f3c0682b$var$i < 288; ++$ffb81a36f3c0682b$var$i)$ffb81a36f3c0682b$var$flt[$ffb81a36f3c0682b$var$i] = 8;
var $ffb81a36f3c0682b$var$fdt = new $ffb81a36f3c0682b$var$u8(32);
for(var $ffb81a36f3c0682b$var$i = 0; $ffb81a36f3c0682b$var$i < 32; ++$ffb81a36f3c0682b$var$i)$ffb81a36f3c0682b$var$fdt[$ffb81a36f3c0682b$var$i] = 5;
var $ffb81a36f3c0682b$var$flm = /* @__PURE__ */ $ffb81a36f3c0682b$var$hMap($ffb81a36f3c0682b$var$flt, 9, 0), $ffb81a36f3c0682b$var$flrm = /* @__PURE__ */ $ffb81a36f3c0682b$var$hMap($ffb81a36f3c0682b$var$flt, 9, 1);
var $ffb81a36f3c0682b$var$fdm = /* @__PURE__ */ $ffb81a36f3c0682b$var$hMap($ffb81a36f3c0682b$var$fdt, 5, 0), $ffb81a36f3c0682b$var$fdrm = /* @__PURE__ */ $ffb81a36f3c0682b$var$hMap($ffb81a36f3c0682b$var$fdt, 5, 1);
var $ffb81a36f3c0682b$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
var $ffb81a36f3c0682b$var$bits = function(d, p, m) {
    var o = p / 8 >> 0;
    return (d[o] | d[o + 1] << 8) >>> (p & 7) & m;
};
var $ffb81a36f3c0682b$var$bits16 = function(d, p) {
    var o = p / 8 >> 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >>> (p & 7);
};
var $ffb81a36f3c0682b$var$shft = function(p) {
    return (p / 8 >> 0) + (p & 7 && 1);
};
var $ffb81a36f3c0682b$var$slc = function(v, s, e) {
    if (e == null || e > v.length) e = v.length;
    var n = new (v instanceof $ffb81a36f3c0682b$var$u16 ? $ffb81a36f3c0682b$var$u16 : v instanceof $ffb81a36f3c0682b$var$u32 ? $ffb81a36f3c0682b$var$u32 : $ffb81a36f3c0682b$var$u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
var $ffb81a36f3c0682b$var$inflt = function(dat, buf, st) {
    var sl = dat.length;
    var noBuf = !buf || st;
    var noSt = !st || st.i;
    if (!st) st = {};
    if (!buf) buf = new $ffb81a36f3c0682b$var$u8(sl * 3);
    var cbuf = function(l2) {
        var bl = buf.length;
        if (l2 > bl) {
            var nbuf = new $ffb81a36f3c0682b$var$u8(Math.max(bl * 2, l2));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    var tbts = sl * 8;
    do {
        if (!lm) {
            st.f = final = $ffb81a36f3c0682b$var$bits(dat, pos, 1);
            var type = $ffb81a36f3c0682b$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                var s = $ffb81a36f3c0682b$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) throw "unexpected EOF";
                    break;
                }
                if (noBuf) cbuf(bt + l);
                buf.set(dat.subarray(s, t), bt);
                st.b = bt += l, st.p = pos = t * 8;
                continue;
            } else if (type == 1) lm = $ffb81a36f3c0682b$var$flrm, dm = $ffb81a36f3c0682b$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                var hLit = $ffb81a36f3c0682b$var$bits(dat, pos, 31) + 257, hcLen = $ffb81a36f3c0682b$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $ffb81a36f3c0682b$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                var ldt = new $ffb81a36f3c0682b$var$u8(tl);
                var clt = new $ffb81a36f3c0682b$var$u8(19);
                for(var i = 0; i < hcLen; ++i)clt[$ffb81a36f3c0682b$var$clim[i]] = $ffb81a36f3c0682b$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                var clb = $ffb81a36f3c0682b$var$max(clt), clbmsk = (1 << clb) - 1;
                if (!noSt && pos + tl * (clb + 7) > tbts) break;
                var clm = $ffb81a36f3c0682b$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$ffb81a36f3c0682b$var$bits(dat, pos, clbmsk)];
                    pos += r & 15;
                    var s = r >>> 4;
                    if (s < 16) ldt[i++] = s;
                    else {
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $ffb81a36f3c0682b$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $ffb81a36f3c0682b$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $ffb81a36f3c0682b$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                lbt = $ffb81a36f3c0682b$var$max(lt);
                dbt = $ffb81a36f3c0682b$var$max(dt);
                lm = $ffb81a36f3c0682b$var$hMap(lt, lbt, 1);
                dm = $ffb81a36f3c0682b$var$hMap(dt, dbt, 1);
            } else throw "invalid block type";
            if (pos > tbts) throw "unexpected EOF";
        }
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var mxa = lbt + dbt + 18;
        while(noSt || pos + mxa < tbts){
            var c = lm[$ffb81a36f3c0682b$var$bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) throw "unexpected EOF";
            if (!c) throw "invalid length/literal";
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lm = null;
                break;
            } else {
                var add = sym - 254;
                if (sym > 264) {
                    var i = sym - 257, b = $ffb81a36f3c0682b$var$fleb[i];
                    add = $ffb81a36f3c0682b$var$bits(dat, pos, (1 << b) - 1) + $ffb81a36f3c0682b$var$fl[i];
                    pos += b;
                }
                var d = dm[$ffb81a36f3c0682b$var$bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) throw "invalid distance";
                pos += d & 15;
                var dt = $ffb81a36f3c0682b$var$fd[dsym];
                if (dsym > 3) {
                    var b = $ffb81a36f3c0682b$var$fdeb[dsym];
                    dt += $ffb81a36f3c0682b$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) throw "unexpected EOF";
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = pos, st.b = bt;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    return bt == buf.length ? buf : $ffb81a36f3c0682b$var$slc(buf, 0, bt);
};
var $ffb81a36f3c0682b$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
var $ffb81a36f3c0682b$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
var $ffb81a36f3c0682b$var$hTree = function(d, mb) {
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return [
        new $ffb81a36f3c0682b$var$u8(0),
        0
    ];
    if (s == 1) {
        var v = new $ffb81a36f3c0682b$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [
            v,
            1
        ];
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    var tr = new $ffb81a36f3c0682b$var$u16(maxSym + 1);
    var mbt = $ffb81a36f3c0682b$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        var i = 0, dt = 0;
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [
        new $ffb81a36f3c0682b$var$u8(tr),
        mbt
    ];
};
var $ffb81a36f3c0682b$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($ffb81a36f3c0682b$var$ln(n.l, l, d + 1), $ffb81a36f3c0682b$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
var $ffb81a36f3c0682b$var$lc = function(c) {
    var s = c.length;
    while(s && !c[--s]);
    var cl = new $ffb81a36f3c0682b$var$u16(++s);
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return [
        cl.subarray(0, cli),
        s
    ];
};
var $ffb81a36f3c0682b$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
var $ffb81a36f3c0682b$var$wfblk = function(out, pos, dat) {
    var s = dat.length;
    var o = $ffb81a36f3c0682b$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
var $ffb81a36f3c0682b$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $ffb81a36f3c0682b$var$wbits(out, p++, final);
    ++lf[256];
    var _a2 = $ffb81a36f3c0682b$var$hTree(lf, 15), dlt = _a2[0], mlb = _a2[1];
    var _b2 = $ffb81a36f3c0682b$var$hTree(df, 15), ddt = _b2[0], mdb = _b2[1];
    var _c = $ffb81a36f3c0682b$var$lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = $ffb81a36f3c0682b$var$lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new $ffb81a36f3c0682b$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)lcfreq[lclt[i] & 31]++;
    for(var i = 0; i < lcdt.length; ++i)lcfreq[lcdt[i] & 31]++;
    var _e = $ffb81a36f3c0682b$var$hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$ffb81a36f3c0682b$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $ffb81a36f3c0682b$var$clen(lf, $ffb81a36f3c0682b$var$flt) + $ffb81a36f3c0682b$var$clen(df, $ffb81a36f3c0682b$var$fdt) + eb;
    var dtlen = $ffb81a36f3c0682b$var$clen(lf, dlt) + $ffb81a36f3c0682b$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $ffb81a36f3c0682b$var$clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen) return $ffb81a36f3c0682b$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $ffb81a36f3c0682b$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $ffb81a36f3c0682b$var$hMap(dlt, mlb, 0), ll = dlt, dm = $ffb81a36f3c0682b$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $ffb81a36f3c0682b$var$hMap(lct, mlcb, 0);
        $ffb81a36f3c0682b$var$wbits(out, p, nlc - 257);
        $ffb81a36f3c0682b$var$wbits(out, p + 5, ndc - 1);
        $ffb81a36f3c0682b$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$ffb81a36f3c0682b$var$wbits(out, p + 3 * i, lct[$ffb81a36f3c0682b$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $ffb81a36f3c0682b$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $ffb81a36f3c0682b$var$wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
            }
        }
    } else lm = $ffb81a36f3c0682b$var$flm, ll = $ffb81a36f3c0682b$var$flt, dm = $ffb81a36f3c0682b$var$fdm, dl = $ffb81a36f3c0682b$var$fdt;
    for(var i = 0; i < li; ++i)if (syms[i] > 255) {
        var len = syms[i] >>> 18 & 31;
        $ffb81a36f3c0682b$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
        if (len > 7) $ffb81a36f3c0682b$var$wbits(out, p, syms[i] >>> 23 & 31), p += $ffb81a36f3c0682b$var$fleb[len];
        var dst = syms[i] & 31;
        $ffb81a36f3c0682b$var$wbits16(out, p, dm[dst]), p += dl[dst];
        if (dst > 3) $ffb81a36f3c0682b$var$wbits16(out, p, syms[i] >>> 5 & 8191), p += $ffb81a36f3c0682b$var$fdeb[dst];
    } else $ffb81a36f3c0682b$var$wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
    $ffb81a36f3c0682b$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
var $ffb81a36f3c0682b$var$deo = /* @__PURE__ */ new $ffb81a36f3c0682b$var$u32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
var $ffb81a36f3c0682b$var$dflt = function(dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new $ffb81a36f3c0682b$var$u8(pre + s + 5 * (1 + Math.floor(s / 7e3)) + post);
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) for(var i = 0; i <= s; i += 65535){
        var e = i + 65535;
        if (e < s) pos = $ffb81a36f3c0682b$var$wfblk(w, pos, dat.subarray(i, e));
        else {
            w[i] = lst;
            pos = $ffb81a36f3c0682b$var$wfblk(w, pos, dat.subarray(i, s));
        }
    }
    else {
        var opt = $ffb81a36f3c0682b$var$deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        var prev = new $ffb81a36f3c0682b$var$u16(32768), head = new $ffb81a36f3c0682b$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i2) {
            return (dat[i2] ^ dat[i2 + 1] << bs1_1 ^ dat[i2 + 2] << bs2_1) & msk_1;
        };
        var syms = new $ffb81a36f3c0682b$var$u32(25e3);
        var lf = new $ffb81a36f3c0682b$var$u16(288), df = new $ffb81a36f3c0682b$var$u16(32);
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for(; i < s; ++i){
            var hv = hsh(i);
            var imod = i & 32767;
            var pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            if (wi <= i) {
                var rem = s - i;
                if ((lc_1 > 7e3 || li > 24576) && rem > 423) {
                    pos = $ffb81a36f3c0682b$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                if (nl > maxn) break;
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j + 32768 & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti + 32768 & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod + 32768 & 32767;
                    }
                }
                if (d) {
                    syms[li++] = 268435456 | $ffb81a36f3c0682b$var$revfl[l] << 18 | $ffb81a36f3c0682b$var$revfd[d];
                    var lin = $ffb81a36f3c0682b$var$revfl[l] & 31, din = $ffb81a36f3c0682b$var$revfd[d] & 31;
                    eb += $ffb81a36f3c0682b$var$fleb[lin] + $ffb81a36f3c0682b$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = $ffb81a36f3c0682b$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
    }
    return $ffb81a36f3c0682b$var$slc(o, 0, pre + $ffb81a36f3c0682b$var$shft(pos) + post);
};
var $ffb81a36f3c0682b$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            var n = a, m = b;
            var l = d.length;
            for(var i = 0; i != l;){
                var e = Math.min(i + 5552, l);
                for(; i < e; ++i)n += d[i], m += n;
                n %= 65521, m %= 65521;
            }
            a = n, b = m;
        },
        d: function() {
            return (a >>> 8 << 16 | (b & 255) << 8 | b >>> 8) + ((a & 255) << 23) * 2;
        }
    };
};
var $ffb81a36f3c0682b$var$dopt = function(dat, opt, pre, post, st) {
    return $ffb81a36f3c0682b$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st);
};
var $ffb81a36f3c0682b$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
var $ffb81a36f3c0682b$var$zlh = function(c, o) {
    var lv = o.level, fl2 = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl2 << 6 | (fl2 ? 32 - 2 * fl2 : 1);
};
var $ffb81a36f3c0682b$var$zlv = function(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) throw "invalid zlib data";
    if (d[1] & 32) throw "invalid zlib data: preset dictionaries not supported";
};
function $ffb81a36f3c0682b$export$df995fae86a55f06(data, opts) {
    if (opts === void 0) opts = {};
    var a = $ffb81a36f3c0682b$var$adler();
    a.p(data);
    var d = $ffb81a36f3c0682b$var$dopt(data, opts, 2, 4);
    return $ffb81a36f3c0682b$var$zlh(d, opts), $ffb81a36f3c0682b$var$wbytes(d, d.length - 4, a.d()), d;
}
function $ffb81a36f3c0682b$export$3b14a55fb2447963(data, out) {
    return $ffb81a36f3c0682b$var$inflt(($ffb81a36f3c0682b$var$zlv(data), data.subarray(2, -4)), out);
}
function $ffb81a36f3c0682b$export$407448d2b89b1813(str, latin1) {
    var l = str.length;
    if (!latin1 && typeof TextEncoder != "undefined") return new TextEncoder().encode(str);
    var ar = new $ffb81a36f3c0682b$var$u8(str.length + (str.length >>> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $ffb81a36f3c0682b$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >>> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >>> 18), w(128 | c >>> 12 & 63), w(128 | c >>> 6 & 63), w(128 | c & 63);
        else w(224 | c >>> 12), w(128 | c >>> 6 & 63), w(128 | c & 63);
    }
    return $ffb81a36f3c0682b$var$slc(ar, 0, ai);
}
function $ffb81a36f3c0682b$export$2408f22a0fab9ae5(dat, latin1) {
    var r = "";
    if (!latin1 && typeof TextDecoder != "undefined") return new TextDecoder().decode(dat);
    for(var i = 0; i < dat.length;){
        var c = dat[i++];
        if (c < 128 || latin1) r += String.fromCharCode(c);
        else if (c < 224) r += String.fromCharCode((c & 31) << 6 | dat[i++] & 63);
        else if (c < 240) r += String.fromCharCode((c & 15) << 12 | (dat[i++] & 63) << 6 | dat[i++] & 63);
        else c = ((c & 15) << 18 | (dat[i++] & 63) << 12 | (dat[i++] & 63) << 6 | dat[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
    }
    return r;
}
const $ffb81a36f3c0682b$export$3a1a48c8f6ef640e = "v1";

});


parcelRegister("dFICc", function(module, exports) {

var $lXbAX = parcelRequire("lXbAX");
const $9f41b656af6b07b6$export$417857010dc9287f = (raw)=>{
    if (typeof raw !== "string") return raw;
    try {
        const e = JSON.parse(raw);
        if (e.timestamp) return e;
    } catch (error) {}
    try {
        const e = JSON.parse((0, $lXbAX.s)((0, $lXbAX.u)((0, $lXbAX.a)(raw, true))));
        if (e.v === (0, $lXbAX.M)) return e;
        throw new Error(`These events were packed with packer ${e.v} which is incompatible with current packer ${(0, $lXbAX.M)}.`);
    } catch (error) {
        console.error(error);
        throw new Error("Unknown data format.");
    }
};

});



parcelRegister("KxY8j", function(module, exports) {

$parcel$export(module.exports, "NetworkObservers", () => $08bea581a1d255ac$export$b2bf56fcc2219a8e);

var $3VFsf = parcelRequire("3VFsf");

var $gOnHi = parcelRequire("gOnHi");
var $08bea581a1d255ac$export$b2bf56fcc2219a8e = /** @class */ function() {
    function NetworkObservers() {
        this.fetchObserver = null;
    }
    NetworkObservers.prototype.start = function(eventCallback) {
        this.eventCallback = eventCallback;
        this.observeFetch();
    };
    NetworkObservers.prototype.stop = function() {
        var _a;
        (_a = this.fetchObserver) === null || _a === void 0 || _a.call(this);
        this.fetchObserver = null;
        this.eventCallback = undefined;
    };
    NetworkObservers.prototype.notifyEvent = function(event) {
        var _a;
        (_a = this.eventCallback) === null || _a === void 0 || _a.call(this, event);
    };
    NetworkObservers.prototype.observeFetch = function() {
        var _this = this;
        var globalScope = (0, $gOnHi.getGlobalScope)();
        if (!globalScope) return;
        var originalFetch = globalScope.fetch;
        if (!originalFetch) return;
        globalScope.fetch = function(input, init) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var startTime, requestEvent, response, endTime, headers_1, error_1, endTime, typedError;
                return (0, $3VFsf.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            startTime = Date.now();
                            requestEvent = {
                                timestamp: startTime,
                                type: 'fetch',
                                method: (init === null || init === void 0 ? void 0 : init.method) || 'GET',
                                url: input.toString(),
                                requestHeaders: init === null || init === void 0 ? void 0 : init.headers
                            };
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4 /*yield*/ ,
                                originalFetch(input, init)
                            ];
                        case 2:
                            response = _a.sent();
                            endTime = Date.now();
                            requestEvent.status = response.status;
                            requestEvent.duration = endTime - startTime;
                            headers_1 = {};
                            response.headers.forEach(function(value, key) {
                                headers_1[key] = value;
                            });
                            requestEvent.responseHeaders = headers_1;
                            this.notifyEvent(requestEvent);
                            return [
                                2 /*return*/ ,
                                response
                            ];
                        case 3:
                            error_1 = _a.sent();
                            endTime = Date.now();
                            requestEvent.duration = endTime - startTime;
                            typedError = error_1;
                            requestEvent.error = {
                                name: typedError.name || 'UnknownError',
                                message: typedError.message || 'An unknown error occurred'
                            };
                            this.notifyEvent(requestEvent);
                            throw error_1;
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.fetchObserver = function() {
            globalScope.fetch = originalFetch;
        };
    };
    return NetworkObservers;
}();

});

parcelRegister("bcxTD", function(module, exports) {

let $827b1bca2c7cfc26$var$load = (parcelRequire("28QjX"))(4);
module.exports = $827b1bca2c7cfc26$var$load("ejkLZ").then(()=>parcelRequire('kOh5S'));

});




const $f92ba51f7e46c4ce$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $f92ba51f7e46c4ce$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';



$parcel$global.rlb("3ieqR")
//# sourceMappingURL=amplitude-session-replay.fa1b97f6.js.map
